// src/pages/workout/condition_guide/MSKExerciseGuide/data/videos.js
export const VIDEOS_BY_ITEM = {
    "straight-neck": [
        {
            id: "Static/Static-S-0004",
            title: "사각근 자가근막이완-공(Scalene Self Myofascial Release, ball)",
            thumb: "/assets/thumbs/Static-S-0004.png",
            guide: [
                "테니스공 또는 마사지볼을 이용하여 사각근을 30초~1분 내외로 마사지한다.",
                "양쪽 모두 실시하고 3회씩 반복한다. ",
            ],
        },
        {
            id: "TP/TP-0018",
            title: "승모근 자가근막이완-쎄라케인(Trapezius Self Myofascial Release, theracane)",
            thumb: "/assets/thumbs/TP-0018.png",
            guide: [
                "목을 한 쪽 방향으로 기울이고 근육이완 도구(쎄라케인)를 반대방향 승모근 위치에 두고 3~5초간 압박이완 한다.",
                "5~10회 반복하고 반대쪽도 실시한다. ",
            ],

        },
        {
            id: "Static/Static-S-0003",
            title: "후두하근 자가근막이완-공(Suboccipital muscle Self Myofascial Release, ball)",
            thumb: "/assets/thumbs/Static-S-0003.png",
            guide: [
                "땅콩볼을 후두부에 두고 바로 누워 후두하근을 30초~1분 이내로 압박이완 한다.(3회 반복) "
            ]
        },
        {
            id: "FR/FR-0007",
            title: "소흉근 자가근막이완-폼롤러(Pectoralis Miner Self Myofascial Release, foam roller)",
            thumb: "/assets/thumbs/FR-0007.png",
            guide: [
                "팔과 가슴 사이에 폼롤러를 두고 엎드린다. ",
                "앞쪽으로 가슴부위를 압박하면서 폼롤러를 30초~1분 내외로 굴린다. ",
                "3~5회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            id: "Static/Static-F-0095(edit)",
            title: "소흉근 자가근막이완-공(Pectoralis Minor Self Myofascial Release, ball)",
            thumb: "/assets/thumbs/Static-F-0095.png",
            guide: [
                "테니스공 또는 마사지볼을 가슴과 쇄골 사이에 두고 벽에 기대 앞으로 밀면서 압박이완 한다.",
                "30초~1분 이내로 3~5회 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            id: "Stretch-0002",
            title: "흉쇄유돌근 스트레치-목 신전(SCM stretch, Neck extension)",
            thumb: "/assets/thumbs/Stretch-0002.png",
            guide: [
                "척추를 바로 세우고 앉아 목을 뒤로 젖히고 10~15초간 유지하고, 3세트 반복한다."
            ]
        },
        {
            id: "Stretch-0001",
            title: "후경부근육 스트레치-목 굴곡(Posterior Cervical Muscle stretch, Neck flexion)",
            thumb: "/assets/thumbs/Stretch-0001.png",
            guide: [
                "척추를 바로 세우고 앉거나 서서 목을 앞으로 굽혀 약 10초 유지한다.(3회 반복)"
            ]
        },
        {
            id: "Stretch-0003",
            title: "승모근 스트레치-목 측굴(Trapezius stretch, Neck side flexion)",
            thumb: "/assets/thumbs/Stretch-0003.png",
            guide: [
                "척추를 바로 세우고 앉거나 서서 목을 옆으로 굽혀서 15초간 유지한다.",
                "양쪽 모두 실시하고 3회씩 반복한다."
            ]
        },
        {
            id: "Stretch-0005",
            title: "전사각근 스트레치(Anterior Scalene stretch)",
            thumb: "/assets/thumbs/Stretch-0005.png",
            guide: [
                "목을 한 쪽으로 기울이고(측굴) 반대방향 위쪽으로 가볍게 회전(상방회전)하여 10초간 유지한다. ",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            id: "Stretch-0006",
            title: "후사각근 스트레치(Posterior Scalene stretch)",
            thumb: "/assets/thumbs/Stretch-0006.png",
            guide: [
                "목을 한 쪽으로 기울이고(측굴) 같은 방향 아래쪽으로 가볍게 회전(하방회전)하여 10초간 유지한다. ",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            id: "Stretch-0007",
            title: "견갑거근 스트레치(Levator Scapulae stretch)",
            thumb: "/assets/thumbs/Stretch-0007.png",
            guide: [
                "목을 옆으로 굽히고(측굴) 앞으로 숙인 후 안쪽으로 살짝 회전하여 15초간 유지한다. ",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            id: "Stretch-0015",
            title: "흉근 스트레치-벽(Pectoralis stretch, wall)",
            thumb: "/assets/thumbs/Stretch-0015.png",
            guide: [
                "한 쪽 팔꿈치를 90°로 굽혀 벽에 대고 몸을 앞으로 밀어 15초간 유지한다. ",
                "3회 반복하고 반대쪽도 실시한다.",
                "같은 방법으로 팔꿈치를 편 상태로 45° 아래로 내려서, 145° 위로 올려서 각각 실시한다."
            ]
        },
        {
            id: "Stretch-0016",
            title: "흉근 스트레치-코너(Pectoralis stretch, corner)",
            thumb: "/assets/thumbs/Stretch-0016.png",
            guide: [
                "코너쪽에 서서 양쪽 팔꿈치를 90°로 굽히고 어깨높이에 맞춰 옆으로 벌려 벽에 기대어 선다.",
                "몸을 앞으로 밀어 15초간 유지하여 3회 반복한다."
            ]
        },
        {
            id: "MS/MS-Lumbar-0009",
            title: "흉추신전 스트레치(Thoracic extension, sitting)",
            thumb: "/assets/thumbs/MS-Lumbar-0009.png",
            guide: [
                "양 팔을 가슴앞에서 팔짱을 끼거나 목 뒤로 깍지를 끼고 의자에 앉아 상체를 뒤로 젖혀 15초간 유지한다.(3회 반복) "
            ]
        },
        {
            id: "Static-S-0015",
            title: "경추굴곡근 스트레치-네 발 기기 자세 목 신전(Posterior Cervical Muscle stretch-Neck extension, Quadruped)",
            thumb: "/assets/thumbs/Static-S-0015.png",
            guide: [
                "네 발 기기 자세로 엎드려 척추를 바르게 정렬한다.",
                "목을 뒤로 젖히고 5초 유지한다.",
                "목을 앞으로 굽히고 5초 유지한다.",
                "목을 옆으로 돌려서 5초 유지한 후 반대쪽으로 실시한다.",
                "각각 3회씩 반복한다.",
            ]
        },
        {
            id: "MS/MS-Neck-0052",
            title: "후경부근육 활성화-밴드를 이용한 목 신전 저항(Posterior cervical muscle activation-Static Neck Extension-Band)",
            thumb: "/assets/thumbs/MS-Neck-0052.png",
            guide: [
                "밴드를 후두에 대고 양 끝을 손으로 잡는다.",
                "목을 뒤로 보내는 힘을 쓰는 동시에 밴드를 앞으로 당기면서 5초간 버틴다.(3~5번 반복)"
            ]
        },
        {
            id: "Static-F-0038",
            title: "경장근 활성화(Longus coli activation-chin tuck)",
            thumb: "/assets/thumbs/Static-F-0038.png",
            guide: [
                "경추를 바로 세워 턱을 수평으로 뒤로 당겨 이중턱을 만들고 5초간 유지한다.",
                "3~5회 반복하여 실시한다."
            ]
        },
        {
            id: "Static-S-0020",
            title: "어깨 올리기(Shoulder Elevation- Shrug)",
            thumb: "/assets/thumbs/Static-S-0020.png",
            guide: [
                "양 쪽 어깨를 들어 올렸다 내린다.10회 3세트 반복한다. "
            ]
        },
        {
            id: "Static-S-0021",
            title: "흉추신전(Thoracic extension- Brugger Exercise)",
            thumb: "/assets/thumbs/Static-S-0021.png",
            guide: [
                "팔꿈치를 굽혀 몸에 붙인 상태로 팔을 옆으로 돌려 등(견갑골 사이)을 수축시켜 5초간 유지한다.",
                "10회 3세트 반복한다."
            ]
        },
        {
            id: "Static-S-0023",
            title: "후경부근육 활성화-엎드려 신전저항 (Posterior cervical muscle activation-Static Neck Extension, prone)",
            thumb: "/assets/thumbs/Static-S-0023.png",
            guide: [
                "벤치에 엎드려 손바닥을 머리 뒤에 댄다.",
                "목을 뒤로 신전시키려는 힘을 쓰고 손으로는 막아 5초간 버틴다.(3~5회 반복)"
            ]
        },
        {
            id: "MS/MS-Neck-0056",
            title: "목 신전근 활성화-짐볼 벽에 대고 머리로 밀기(Posterior cervical muscle activation-Static Neck Extension with ball)",
            thumb: "/assets/thumbs/MS-Neck-0056.png",
            guide: [
                "네 발 기기 자세로 엎드려 정수리쪽에 짐볼을 두고 앞으로 밀어 위로 살짝 들어올리고 5초간 유지한다.(3~5번 반복)"
            ]
        },
        {
            id: "Static-S-0049",
            title: "중부/하부승모근 활성화-엎드려 Y, W, T 자세(Middle/Lower Trapezius activation-Y,W,T’s, prone)",
            thumb: "/assets/thumbs/Static-S-0049.png",
            guide: [
                "매트에 엎드려 팔을 Y, W, T자 형태로 만들어 들어올린다.",
                "10회 3세트 반복한다."
            ]
        },
        {
            id: "Static-S-0025",
            title: "중부/하부승모근 활성화-엎드려 Y, W, T 자세, 짐볼(Middle/Lower Trapezius activation-Y,W,T’s, Stability ball)",
            thumb: "/assets/thumbs/Static-S-0025.png",
            guide: [
                "양손에 덤벨을 들고 짐볼 위에 엎드린다.",
                "가슴을 펴고 팔을 Y, W, T자 형태로 만들어 귀 높이에 맞춰 들어 올려 1~2초간 유지한다.",
                "10회 3세트 반복한다."
            ]
        },
        {
            id: "Static-S-0028",
            title: "양팔 뻗어 어깨 돌리기(Arm circumduction)",
            thumb: "/assets/thumbs/Static-S-0028.png",
            guide: [
                "팔을 옆으로 뻗어 손목을 손등 굽힘시켜 어깨를 앞으로 10회, 뒤로 10회 회전한다.(3~5세트 반복)"
            ]
        },
        {
            id: "Dumbbell-0016",
            title: "스캡션(Scaption)",
            thumb: "/assets/thumbs/Dumbbell-0016.png",
            guide: [
                "양손에 덤벨을 들고 팔을 안으로 30°기울인 상태로 이마 높이까지 들어올린 후 견갑골 사이를 수축시킨다.",
                "10회 3~5세트 반복한다."
            ]
        },
        {
            id: "CB-0016",
            title: "케이블 리버스 플라이(Cable Reverse Fly)",
            thumb: "/assets/thumbs/CB-0016.png",
            guide: [
                "양손으로 케이블을 위에서 잡아 어깨높이 맞춰 뒤로 당긴다.(Reverse fly or Wide Row)",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            id: "Static-F-0108",
            title: "짐볼 기대어 스쿼트, 바이셉 컬 & 오버헤드프레스(Squat, curl & overhead press with ball)",
            thumb: "/assets/thumbs/Static-F-0108.png",
            guide: [
                "짐볼에 등을 기대고 서서 양 손에 덤벨을 든다. ",
                "수직으로 앉았다 일어나면서 팔꿈치를 굽혀 덤벨을 가슴쪽으로 들어 올린(이두근 컬) 후 다시 팔을 위로 뻗어 올린다.(오버헤드 프레스) ",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            id: "Dumbbell-0051",
            title: "크로스오버 스텝업(Cross Over Step up)",
            thumb: "/assets/thumbs/Dumbbell-0051.png",
            guide: [
                "양 손에 덤벨을 들고 오른쪽 다리 옆에 스텝박스를 두고 선다.",
                "왼쪽 다리를 앞으로 교차하여 박스 위에 올리고, 오른쪽 다리도 따라 올려 박스 위에 선다.",
                "왼쪽 다리를 뒤로 교차하여 바닥에 내리고, 오른쪽 다리도 내린 후 반대방향으로 실시한다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            id: "Dumbbell-0048",
            title: "한 발 루마니안 데드리프트 & 컬, 오버헤드프레스(Single-Leg Romanian Deadlift, Single-Arm Curl to Overhead Press)",
            thumb: "/assets/thumbs/Dumbbell-0048.png",
            guide: [
                "한 발로 서서 반대쪽 손에 덤벨을 든다.",
                "무릎을 굽히고 상체를 내리면서 덤벨을 든 팔을 아래로 뻗어 내린다.",
                "시작자세로 돌아오면서 팔꿈치를 굽혔다 위로 펴 올린다.",
                "10~15회 반복 후 반대쪽으로 실시한다. ",
                "2~3세트 반복한다."
            ]
        },
    ],

    "cervical-disc": [
        {
            id: "FR/FR-0001",
            title: "후두하근 자가근막이완-폼롤러(Suboccipital Muscle Self Myofascial Release, foam roller)",
            thumb: "/assets/thumbs/FR-0001.png",
            guide: [
                "뒷목덜미에 폼롤러를 가로로 두고 바로 누워 목을 천천히 좌우로 회전한다.(10회 3세트 반복)",
            ]
        },
        {
            id: "FR/FR-0030",
            title: "흉추신전-폼롤러(Neck extension- Arm angel, foam roller)",
            thumb: "/assets/thumbs/FR-0030.png",
            guide: [
                "폼롤러 위에 누워 다리를 굽히고 손바닥이 위로 향하게 하여 팔을 바닥에 둔다.",
                "손등으로 바닥을 쓸듯이 팔을 머리 위로 올렸다(어깨 외전) 내린다.(어깨 내전)",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            id: "FR/FR-0031",
            title: "흉추회전-폼롤러(Trunk rotation-Arm open)",
            thumb: "/assets/thumbs/FR-0031.png",
            guide: [
                "폼롤러를 목에 베고 옆으로 누워 두 팔을 모아 가슴앞으로 뻗고 다리는 90°로 굽힌다. ",
                "다리를 고정한 채 흉추를 회전하면서 위쪽 팔을 뒤로 보낸다.(수평외전)",
                "10회 2~3세트 반복하고, 반대쪽도 실시한다. "
            ]
        },
        {
            id: "Stretch/Stretch-0002",
            title: "흉쇄유돌근 스트레치-목 신전(SCM stretch, Neck extension)",
            thumb: "/assets/thumbs/Stretch-0002.png",
            guide: [
                "척추를 바로 세우고 앉아 목을 뒤로 젖히고 10~15초간 유지하고, 3세트 반복한다.",
            ]
        },
        {
            id: "Stretch/Stretch-0001",
            title: "후경부근육 스트레치-목 굴곡(Posterior Cervical Muscle stretch, Neck flexion)",
            thumb: "/assets/thumbs/Stretch-0001.png",
            guide: [
                "척추를 바로 세우고 앉거나 서서 목을 앞으로 굽혀 약 10초 유지한다.(3회 반복)",
            ]
        },
        {
            id: "Stretch/Stretch-0003",
            title: "승모근 스트레치-목 측굴(Trapezius stretch, Neck side flexion))",
            thumb: "/assets/thumbs/Stretch-0003.png",
            guide: [
                "척추를 바로 세우고 앉거나 서서 목을 옆으로 굽혀서 15초간 유지한다.",
                "양쪽 모두 실시하고 3회씩 반복한다."
            ]
        },
        {
            id: "Stretch/Stretch-0005",
            title: "전사각근 스트레치(Anterior Scalene stretch)",
            thumb: "/assets/thumbs/Stretch-0005.png",
            guide: [
                "목을 한 쪽으로 기울이고(측굴) 반대방향 위쪽으로 가볍게 회전(상방회전)하여 10초간 유지한다.",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            id: "Stretch/Stretch-0006",
            title: "후사각근 스트레치(Posterior Scalene stretch)",
            thumb: "/assets/thumbs/Stretch-0006.png",
            guide: [
                "목을 한 쪽으로 기울이고(측굴) 같은 방향 아래쪽으로 가볍게 회전(하방회전)하여 10초간 유지한다. ",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            id: "Stretch/Stretch-0007",
            title: "견갑거근 스트레치(Levator Scapulae stretch)",
            thumb: "/assets/thumbs/Stretch-0007.png",
            guide: [
                "목을 옆으로 굽히고(측굴) 앞으로 숙인 후 안쪽으로 살짝 회전하여 15초간 유지한다. ",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            id: "Stretch/Stretch-0015",
            title: "흉근 스트레치-벽(Pectoralis stretch, wall)",
            thumb: "/assets/thumbs/Stretch-0015.png",
            guide: [
                "한 쪽 팔꿈치를 90°로 굽혀 벽에 대고 몸을 앞으로 밀어 15초간 유지한다. ",
                "3회 반복하고 반대쪽도 실시한다.",
                "같은 방법으로 팔꿈치를 편 상태로 45° 아래로 내려서, 145° 위로 올려서 각각 실시한다."
            ]
        },
        {
            id: "Stretch/Stretch-0017",
            title: "흉근 스트레치-짐볼(Pectoralis stretch, Stability ball)",
            thumb: "/assets/thumbs/Stretch-0017.png",
            guide: [
                "네 발 기기 자세로 엎드려 한 쪽 팔을 90°로 굽혀 짐볼 위에 올린다.",
                "짐볼을 가볍게 압박하여 상체를 밑으로 내리고 15초간 유지한다. ",
                "3회 반복하고, 반대쪽도 실시한다. "
            ]
        },
        {
            id: "MS/MS-Neck-0046",
            title: "테이블 흉추신전(Thoracic extension, table)",
            thumb: "/assets/thumbs/MS-Neck-0046.png",
            guide: [
                "테이블에 양쪽 팔꿈치를 대고 무릎을 굽혀 앉는다. 두 팔꿈치는 고정하고 상체를 밑으로 내려 흉추가 신전되도록 한다. ",
                "3~5초간 유지한다. 10~15회 2~3세트 반복한다. ",

            ]
        },
        {
            id: "MS/MS-Neck-0047",
            title: "짐볼 어깨 굴곡 & 외회전(Thoracic extension-shoulder flexion & external rotation)",
            thumb: "/assets/thumbs/MS-Neck-0047.png",
            guide: [
                "양 쪽 손등을 짐볼 위에 올리고 무릎을 세워 앉는다. ",
                "팔꿈치를 편 채로 짐볼을 앞으로 굴리면서 상체를 숙여 3~5초 유지한다.(10~15회 2~3세트 반복)",

            ]
        },
        {
            id: "Static/Static-S-0022",
            title: "경장근 활성화-누워서 목 굴곡저항(Longus coli activation- Static Neck Flexion, supine)",
            thumb: "/assets/thumbs/Static-S-0022.png",
            guide: [
                "벤치에 누워 손바닥을 이마에 댄다.",
                "목을 들어 앞으로 굽히려는 힘을 쓰고 손으로는 막아 5초간 버틴다.(3~5회 반복)",
            ]
        },
        {
            id: "Static/Static-S-0018",
            title: "목 측굴 저항(Static Neck Side Flexion)",
            thumb: "/assets/thumbs/Static-S-0018.png",
            guide: [
                "한 쪽 측두골에 손바닥을 대고 목을 측굴하려는 힘을 쓰고 손으로는 막아 5초간 버틴다.(3~5회 반복)",
            ]
        },
        {
            id: "MS/MS-Neck-0050",
            title: "등척성 목 회전저항(Isometric Neck Rotation)",
            thumb: "/assets/thumbs/MS-Neck-0050.png",
            guide: [
                "한 쪽 측두골에 손바닥을 대고 목을 바깥쪽으로 회전하려는 힘을 쓰고 손으로는 막아 5초간 버틴다.",
                "3~5회 반복하고, 반대쪽도 실시한다. "
            ]
        },
        {
            id: "Static/Static-S-0047",
            title: "경장근 활성화-네발기기자세 턱 당기기(Longus coli activation-Chin Tuck, Quadruped) ",
            thumb: "/assets/thumbs/Static-S-0047.png",
            guide: [
                "네 발기기 자세로 엎드려 턱을 수평으로 뒤로 당겨 이중턱을 만들고 5초간 유지한다.(5~10번 반복)"
            ]
        },
        {
            id: "MS/MS-Neck-0052",
            title: "후경부근육 활성화-밴드를 이용한 목 신전 저항(Posterior cervical muscle activation-Static Neck Extension-Band)",
            thumb: "/assets/thumbs/MS-Neck-0052.png",
            guide: [
                "밴드를 후두에 대고 양 끝을 손으로 잡는다.",
                "목을 뒤로 보내는 힘을 쓰는 동시에 밴드를 앞으로 당기면서 5초간 버틴다.(3~5번 반복)"
            ]
        },
        {
            id: "GolfCon/GolfCon-0005",
            title: "등척성 목 굴곡-짐볼(Isometric Neck flexion, Stability ball)",
            thumb: "/assets/thumbs/GolfCon-0005.png",
            guide: [
                "45cm정도의 짐볼을 벽에 대고 이마로 압박한다.",
                "5초간 유지하고 힘을 풀고 다시 5초간 유지한다.",
                "5~10회 반복한다. "
            ]
        },
        {
            id: "GolfCon/GolfCon-0004",
            title: "등척성 목 신전(Isometric Neck Extension with ball)",
            thumb: "/assets/thumbs/GolfCon-0004.png",
            guide: [
                "머리 뒤와 벽 사이에 짐볼(45cm 정도)을 두고 기대 선다.",
                "목을 뒤쪽으로 가볍게 밀면서 5초간 유지한다.(5~10회 반복)",
            ]
        },
        {
            id: "MS/MS-Neck-0055",
            title: "네발기기자세 등척성 목 굴곡-짐볼(Isometric Neck flexion with Stability ball, Quadruped)",
            thumb: "/assets/thumbs/MS-Neck-0055.png",
            guide: [
                "이마 밑에 짐볼을 두고 네 발 기기 자세로 엎드린다. ",
                "짐볼을 누르면서 목을 가볍게 굽혀 3~5초간 유지한다.(3~5회 반복)",
            ]
        },
        {
            id: "MS/MS-Neck-0056",
            title: "목 신전근 활성화-짐볼 벽에 대고 머리로 밀기(Posterior cervical muscle activation-Static Neck Extension with ball)",
            thumb: "/assets/thumbs/MS-Neck-0056.png",
            guide: [
                "네 발 기기 자세로 엎드려 정수리쪽에 짐볼을 두고 앞으로 밀어 위로 살짝 들어올리고 5초간 유지한다.(3~5번 반복)",
            ]
        },
    ],
    "opf": [
        {
            id: "Static/Static-S-0004",
            title: "사각근 자가근막이완-공(Scalene Self Myofascial Release, ball)",
            thumb: "/assets/thumbs/Static-S-0004.png",
            guide: [
                "테니스공 또는 마사지볼을 이용하여 사각근을 30초~1분 내외로 마사지한다.",
                "양쪽 모두 실시하고 3회씩 반복한다. ",
            ],
        },

        {
            id: "TP/TP-0018",
            title: "승모근 자가근막이완-쎄라케인(Trapezius Self Myofascial Release, theracane)",
            thumb: "/assets/thumbs/TP-0018.png",
            guide: [
                "목을 한 쪽 방향으로 기울이고 근육이완 도구(쎄라케인)를 반대방향 승모근 위치에 두고 3~5초간 압박이완 한다.",
                "5~10회 반복하고 반대쪽도 실시한다. ",
            ],

        },

        {
            id: "Static/Static-S-0003",
            title: "후두하근 자가근막이완-공(Suboccipital muscle Self Myofascial Release, ball)",
            thumb: "/assets/thumbs/Static-S-0003.png",
            guide: [
                "땅콩볼을 후두부에 두고 바로 누워 후두하근을 30초~1분 이내로 압박이완 한다.(3회 반복) "
            ]
        },
        {
            id: "FR/FR-0007",
            title: "소흉근 자가근막이완-폼롤러(Pectoralis Miner Self Myofascial Release, foam roller)",
            thumb: "/assets/thumbs/FR-0007.png",
            guide: [
                "팔과 가슴 사이에 폼롤러를 두고 엎드린다. ",
                "앞쪽으로 가슴부위를 압박하면서 폼롤러를 30초~1분 내외로 굴린다. ",
                "3~5회 반복하고 반대쪽도 실시한다."
            ]
        },

        {
            id: "Static/Static-F-0095(edit)",
            title: "소흉근 자가근막이완-공(Pectoralis Minor Self Myofascial Release, ball)",
            thumb: "/assets/thumbs/Static-F-0095.png",
            guide: [
                "테니스공 또는 마사지볼을 가슴과 쇄골 사이에 두고 벽에 기대 앞으로 밀면서 압박이완 한다.",
                "30초~1분 이내로 3~5회 반복하고, 반대쪽도 실시한다."
            ]
        },

        {
            id: "Stretch-0002",
            title: "흉쇄유돌근 스트레치-목 신전(SCM stretch, Neck extension)",
            thumb: "/assets/thumbs/Stretch-0002.png",
            guide: [
                "척추를 바로 세우고 앉아 목을 뒤로 젖히고 10~15초간 유지하고, 3세트 반복한다."
            ]
        },
        {
            id: "Stretch-0001",
            title: "후경부근육 스트레치-목 굴곡(Posterior Cervical Muscle stretch, Neck flexion)",
            thumb: "/assets/thumbs/Stretch-0001.png",
            guide: [
                "척추를 바로 세우고 앉거나 서서 목을 앞으로 굽혀 약 10초 유지한다.(3회 반복)"
            ]
        },
        {
            id: "Stretch-0003",
            title: "승모근 스트레치-목 측굴(Trapezius stretch, Neck side flexion)",
            thumb: "/assets/thumbs/Stretch-0003.png",
            guide: [
                "척추를 바로 세우고 앉거나 서서 목을 옆으로 굽혀서 15초간 유지한다.",
                "양쪽 모두 실시하고 3회씩 반복한다."
            ]
        },
        {
            id: "Stretch-0005",
            title: "전사각근 스트레치(Anterior Scalene stretch)",
            thumb: "/assets/thumbs/Stretch-0005.png",
            guide: [
                "목을 한 쪽으로 기울이고(측굴) 반대방향 위쪽으로 가볍게 회전(상방회전)하여 10초간 유지한다. ",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            id: "Stretch-0006",
            title: "후사각근 스트레치(Posterior Scalene stretch)",
            thumb: "/assets/thumbs/Stretch-0006.png",
            guide: [
                "목을 한 쪽으로 기울이고(측굴) 같은 방향 아래쪽으로 가볍게 회전(하방회전)하여 10초간 유지한다. ",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            id: "Stretch-0007",
            title: "견갑거근 스트레치(Levator Scapulae stretch)",
            thumb: "/assets/thumbs/Stretch-0007.png",
            guide: [
                "목을 옆으로 굽히고(측굴) 앞으로 숙인 후 안쪽으로 살짝 회전하여 15초간 유지한다. ",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            id: "Stretch-0015",
            title: "흉근 스트레치-벽(Pectoralis stretch, wall)",
            thumb: "/assets/thumbs/Stretch-0015.png",
            guide: [
                "한 쪽 팔꿈치를 90°로 굽혀 벽에 대고 몸을 앞으로 밀어 15초간 유지한다. ",
                "3회 반복하고 반대쪽도 실시한다.",
                "같은 방법으로 팔꿈치를 편 상태로 45° 아래로 내려서, 145° 위로 올려서 각각 실시한다."
            ]
        },
        {
            id: "Stretch-0016",
            title: "흉근 스트레치-코너(Pectoralis stretch, corner)",
            thumb: "/assets/thumbs/Stretch-0016.png",
            guide: [
                "코너쪽에 서서 양쪽 팔꿈치를 90°로 굽히고 어깨높이에 맞춰 옆으로 벌려 벽에 기대어 선다.",
                "몸을 앞으로 밀어 15초간 유지하여 3회 반복한다."
            ]
        },
        {
            id: "Stretch/Stretch-0017",
            title: "흉근 스트레치-짐볼(Pectoralis stretch, Stability ball)",
            thumb: "/assets/thumbs/Stretch-0017.png",
            guide: [
                "네 발 기기 자세로 엎드려 한 쪽 팔을 90°로 굽혀 짐볼 위에 올린다.",
                "짐볼을 가볍게 압박하여 상체를 밑으로 내리고 15초간 유지한다. ",
                "3회 반복하고, 반대쪽도 실시한다. "
            ]
        },

        {
            id: "MS/MS-Lumbar-0009",
            title: "흉추신전 스트레치(Thoracic extension, sitting)",
            thumb: "/assets/thumbs/MS-Lumbar-0009.png",
            guide: [
                "양 팔을 가슴앞에서 팔짱을 끼거나 목 뒤로 깍지를 끼고 의자에 앉아 상체를 뒤로 젖혀 15초간 유지한다.(3회 반복) "
            ]
        },
        {
            id: "Static-S-0015",
            title: "경추굴곡근 스트레치-네 발 기기 자세 목 신전(Posterior Cervical Muscle stretch-Neck extension, Quadruped)",
            thumb: "/assets/thumbs/Static-S-0015.png",
            guide: [
                "네 발 기기 자세로 엎드려 척추를 바르게 정렬한다.",
                "목을 뒤로 젖히고 5초 유지한다.",
                "목을 앞으로 굽히고 5초 유지한다.",
                "목을 옆으로 돌려서 5초 유지한 후 반대쪽으로 실시한다.",
                "각각 3회씩 반복한다.",
            ]
        },

        {
            id: "FR/FR-0001",
            title: "후두하근 자가근막이완-폼롤러(Suboccipital Muscle Self Myofascial Release, foam roller)",
            thumb: "/assets/thumbs/FR-0001.png",
            guide: [
                "뒷목덜미에 폼롤러를 가로로 두고 바로 누워 목을 천천히 좌우로 회전한다.(10회 3세트 반복)",
            ]
        },
        {
            id: "FR/FR-0030",
            title: "흉추신전-폼롤러(Neck extension- Arm angel, foam roller)",
            thumb: "/assets/thumbs/FR-0030.png",
            guide: [
                "폼롤러 위에 누워 다리를 굽히고 손바닥이 위로 향하게 하여 팔을 바닥에 둔다.",
                "손등으로 바닥을 쓸듯이 팔을 머리 위로 올렸다(어깨 외전) 내린다.(어깨 내전)",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            id: "FR/FR-0031",
            title: "흉추회전-폼롤러(Trunk rotation-Arm open)",
            thumb: "/assets/thumbs/FR-0031.png",
            guide: [
                "폼롤러를 목에 베고 옆으로 누워 두 팔을 모아 가슴앞으로 뻗고 다리는 90°로 굽힌다. ",
                "다리를 고정한 채 흉추를 회전하면서 위쪽 팔을 뒤로 보낸다.(수평외전)",
                "10회 2~3세트 반복하고, 반대쪽도 실시한다. "
            ]
        },
        {
            id: "MS/MS-Neck-0046",
            title: "테이블 흉추신전(Thoracic extension, table)",
            thumb: "/assets/thumbs/MS-Neck-0046.png",
            guide: [
                "테이블에 양쪽 팔꿈치를 대고 무릎을 굽혀 앉는다. 두 팔꿈치는 고정하고 상체를 밑으로 내려 흉추가 신전되도록 한다. ",
                "3~5초간 유지한다. 10~15회 2~3세트 반복한다. ",

            ]
        },
        {
            id: "MS/MS-Neck-0047",
            title: "짐볼 어깨 굴곡 & 외회전(Thoracic extension-shoulder flexion & external rotation)",
            thumb: "/assets/thumbs/MS-Neck-0047.png",
            guide: [
                "양 쪽 손등을 짐볼 위에 올리고 무릎을 세워 앉는다. ",
                "팔꿈치를 편 채로 짐볼을 앞으로 굴리면서 상체를 숙여 3~5초 유지한다.(10~15회 2~3세트 반복)",

            ]
        },
    ],
    "neck-rehab-1": [
        {
            id: "FR/FR-0003",
            title: "흉추신전운동-폼롤러(Thoracic Extension exercise, foam roller)",
            thumb: "/assets/thumbs/FR-0003.png",
            guide: [
                "등에 폼롤러를 가로로 두고 누워 엉덩이를 들고 가슴앞으로 팔짱을 낀다. ",
                "다리로 지지하고 가슴을 펴서 폼롤러를 등의 위아래로 번갈아가며 이동시킨다. ",
                "30초~1분 내외로 3~5회 반복한다. ",
            ]
        },
        {
            id: "Static/Static-S-0004",
            title: "사각근 자가근막이완-공(Scalene Self Myofascial Release, ball)",
            thumb: "/assets/thumbs/Static-S-0004.png",
            guide: [
                "테니스공 또는 마사지볼을 이용하여 사각근을 30초~1분 내외로 마사지한다.",
                "양쪽 모두 실시하고 3회씩 반복한다. ",
            ],
        },
        {
            id: "TP/TP-0018",
            title: "승모근 자가근막이완-쎄라케인(Trapezius Self Myofascial Release, theracane)",
            thumb: "/assets/thumbs/TP-0018.png",
            guide: [
                "목을 한 쪽 방향으로 기울이고 근육이완 도구(쎄라케인)를 반대방향 승모근 위치에 두고 3~5초간 압박이완 한다.",
                "5~10회 반복하고 반대쪽도 실시한다. ",
            ],

        },
        {
            id: "Static/Static-S-0003",
            title: "후두하근 자가근막이완-공(Suboccipital muscle Self Myofascial Release, ball)",
            thumb: "/assets/thumbs/Static-S-0003.png",
            guide: [
                "땅콩볼을 후두부에 두고 바로 누워 후두하근을 30초~1분 이내로 압박이완 한다.(3회 반복) "
            ]
        },
        {
            id: "FR/FR-0007",
            title: "흉근 자가근막이완-폼롤러 (Pectorialis Self Myofascial Release, foam roller)",
            thumb: "/assets/thumbs/FR-0007.png",
            guide: [
                "한 쪽 팔과 가슴 사이에 폼롤러를 두고 엎드려 앞쪽으로 흉근을 압박하면서 폼롤러를 30초~1분 내외로 굴린다.",
                "양쪽 모두 실시하고 3~5회씩 반복한다.",
            ],

        },
        {
            id: "TP/TP-0024",
            title: "흉근 자가근막이완-공(Pectorialis Self Myofascial Release, ball)",
            thumb: "/assets/thumbs/TP-0024.png",
            guide: [
                "테니스공 또는 마사지볼을 쇄골 아래쪽에 위치시키고 벽에 기대 가슴으로 밀어 30초~1분 이내로 압박이완 한다. ",
                "양쪽 모두 실시하고 3~5회씩 반복한다.",
            ],

        },
        {
            id: "Stretch-0002",
            title: "흉쇄유돌근 스트레치-목 신전(SCM stretch, Neck extension)",
            thumb: "/assets/thumbs/Stretch-0002.png",
            guide: [
                "척추를 바로 세우고 앉아 목을 뒤로 젖히고 10~15초간 유지하고, 3세트 반복한다."
            ]
        },
        {
            id: "Stretch-0001",
            title: "후경부근육 스트레치-목 굴곡(Posterior Cervical Muscle stretch, Neck flexion)",
            thumb: "/assets/thumbs/Stretch-0001.png",
            guide: [
                "척추를 바로 세우고 앉거나 서서 목을 앞으로 굽혀 약 10초 유지한다.(3회 반복)"
            ]
        },
        {
            id: "Stretch-0003",
            title: "승모근 스트레치-목 측굴(Trapezius stretch, Neck side flexion)",
            thumb: "/assets/thumbs/Stretch-0003.png",
            guide: [
                "척추를 바로 세우고 앉거나 서서 목을 옆으로 굽혀서 15초간 유지한다.",
                "양쪽 모두 실시하고 3회씩 반복한다."
            ]
        },
        {
            id: "Stretch-0005",
            title: "전사각근 스트레치(Anterior Scalene stretch)",
            thumb: "/assets/thumbs/Stretch-0005.png",
            guide: [
                "목을 한 쪽으로 기울이고(측굴) 반대방향 위쪽으로 가볍게 회전(상방회전)하여 10초간 유지한다. ",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            id: "Stretch-0006",
            title: "후사각근 스트레치(Posterior Scalene stretch)",
            thumb: "/assets/thumbs/Stretch-0006.png",
            guide: [
                "목을 한 쪽으로 기울이고(측굴) 같은 방향 아래쪽으로 가볍게 회전(하방회전)하여 10초간 유지한다. ",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            id: "Stretch-0007",
            title: "견갑거근 스트레치(Levator Scapulae stretch)",
            thumb: "/assets/thumbs/Stretch-0007.png",
            guide: [
                "목을 옆으로 굽히고(측굴) 앞으로 숙인 후 안쪽으로 살짝 회전하여 15초간 유지한다. ",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            id: "Stretch-0015",
            title: "흉근 스트레치-벽(Pectoralis stretch, wall)",
            thumb: "/assets/thumbs/Stretch-0015.png",
            guide: [
                "한 쪽 팔꿈치를 90°로 굽혀 벽에 대고 몸을 앞으로 밀어 15초간 유지한다. ",
                "3회 반복하고 반대쪽도 실시한다.",
                "같은 방법으로 팔꿈치를 편 상태로 45° 아래로 내려서, 145° 위로 올려서 각각 실시한다."
            ]
        },
        {
            id: "Stretch-0016",
            title: "흉근 스트레치-코너(Pectoralis stretch, corner)",
            thumb: "/assets/thumbs/Stretch-0016.png",
            guide: [
                "코너쪽에 서서 양쪽 팔꿈치를 90°로 굽히고 어깨높이에 맞춰 옆으로 벌려 벽에 기대어 선다.",
                "몸을 앞으로 밀어 15초간 유지하여 3회 반복한다."
            ]
        },
        {
            id: "MS/MS-Lumbar-0009",
            title: "흉추신전 스트레치(Thoracic extension, sitting)",
            thumb: "/assets/thumbs/MS-Lumbar-0009.png",
            guide: [
                "양 팔을 가슴앞에서 팔짱을 끼거나 목 뒤로 깍지를 끼고 의자에 앉아 상체를 뒤로 젖혀 15초간 유지한다.(3회 반복) "
            ]
        },
    ],

    "neck-rehab-2": [
        {
            id: "FR/FR-0001",
            title: "후두하근 자가근막이완-폼롤러(Suboccipital Muscle Self Myofascial Release, foam roller)",
            thumb: "/assets/thumbs/FR-0001.png",
            guide: [
                "뒷목덜미에 폼롤러를 가로로 두고 바로 누워 목을 천천히 좌우로 회전한다.(10회 3세트 반복)",
            ]
        },

        {
            id: "FR/FR-0030",
            title: "흉추신전-폼롤러(Neck extension- Arm angel, foam roller)",
            thumb: "/assets/thumbs/FR-0030.png",
            guide: [
                "폼롤러 위에 누워 다리를 굽히고 손바닥이 위로 향하게 하여 팔을 바닥에 둔다.",
                "손등으로 바닥을 쓸듯이 팔을 머리 위로 올렸다(어깨 외전) 내린다.(어깨 내전)",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            id: "FR/FR-0031",
            title: "흉추회전-폼롤러(Trunk rotation-Arm open)",
            thumb: "/assets/thumbs/FR-0031.png",
            guide: [
                "폼롤러를 목에 베고 옆으로 누워 두 팔을 모아 가슴앞으로 뻗고 다리는 90°로 굽힌다. ",
                "다리를 고정한 채 흉추를 회전하면서 위쪽 팔을 뒤로 보낸다.(수평외전)",
                "10회 2~3세트 반복하고, 반대쪽도 실시한다. "
            ]
        },

        {
            id: "MS/MS-Neck-0052",
            title: "후경부근육 활성화-밴드를 이용한 목 신전 저항(Posterior cervical muscle activation-Static Neck Extension-Band)",
            thumb: "/assets/thumbs/MS-Neck-0052.png",
            guide: [
                "밴드를 후두에 대고 양 끝을 손으로 잡는다.",
                "목을 뒤로 보내는 힘을 쓰는 동시에 밴드를 앞으로 당기면서 5초간 버틴다.(3~5번 반복)"
            ]
        },
        {
            id: "Static-F-0038",
            title: "경장근 활성화(Longus coli activation-chin tuck)",
            thumb: "/assets/thumbs/Static-F-0038.png",
            guide: [
                "경추를 바로 세워 턱을 수평으로 뒤로 당겨 이중턱을 만들고 5초간 유지한다.",
                "3~5회 반복하여 실시한다."
            ]
        },

        {
            id: "Static-S-0020",
            title: "어깨 올리기(Shoulder Elevation- Shrug)",
            thumb: "/assets/thumbs/Static-S-0020.png",
            guide: [
                "양 쪽 어깨를 들어 올렸다 내린다.10회 3세트 반복한다. "
            ]
        },
        {
            id: "Static-S-0021",
            title: "흉추신전(Thoracic extension- Brugger Exercise)",
            thumb: "/assets/thumbs/Static-S-0021.png",
            guide: [
                "팔꿈치를 굽혀 몸에 붙인 상태로 팔을 옆으로 돌려 등(견갑골 사이)을 수축시켜 5초간 유지한다.",
                "10회 3세트 반복한다."
            ]
        },
        {
            id: "Static-S-0015",
            title: "경추굴곡근 스트레치-네 발 기기 자세 목 신전(Posterior Cervical Muscle stretch-Neck extension, Quadruped)",
            thumb: "/assets/thumbs/Static-S-0015.png",
            guide: [
                "네 발 기기 자세로 엎드려 척추를 바르게 정렬한다.",
                "목을 뒤로 젖히고 5초 유지한다.",
                "목을 앞으로 굽히고 5초 유지한다.",
                "목을 옆으로 돌려서 5초 유지한 후 반대쪽으로 실시한다.",
                "각각 3회씩 반복한다.",
            ]
        },
    ],

    "neck-rehab-3": [
        {
            id: "Stretch/Stretch-0017",
            title: "흉근 스트레치-짐볼(Pectoralis stretch, Stability ball)",
            thumb: "/assets/thumbs/Stretch-0017.png",
            guide: [
                "네 발 기기 자세로 엎드려 한 쪽 팔을 90°로 굽혀 짐볼 위에 올린다.",
                "짐볼을 가볍게 압박하여 상체를 밑으로 내리고 15초간 유지한다. ",
                "3회 반복하고, 반대쪽도 실시한다. "
            ]
        },
        {
            id: "MS/MS-Neck-0046",
            title: "테이블 흉추신전(Thoracic extension, table)",
            thumb: "/assets/thumbs/MS-Neck-0046.png",
            guide: [
                "테이블에 양쪽 팔꿈치를 대고 무릎을 굽혀 앉는다. 두 팔꿈치는 고정하고 상체를 밑으로 내려 흉추가 신전되도록 한다. ",
                "3~5초간 유지한다. 10~15회 2~3세트 반복한다. ",

            ]
        },
        {
            id: "MS/MS-Neck-0047",
            title: "짐볼 어깨 굴곡 & 외회전(Thoracic extension-shoulder flexion & external rotation)",
            thumb: "/assets/thumbs/MS-Neck-0047.png",
            guide: [
                "양 쪽 손등을 짐볼 위에 올리고 무릎을 세워 앉는다. ",
                "팔꿈치를 편 채로 짐볼을 앞으로 굴리면서 상체를 숙여 3~5초 유지한다.(10~15회 2~3세트 반복)",

            ]
        },

        {
            id: "GolfCon/GolfCon-0004",
            title: "등척성 목 신전(Isometric Neck Extension with ball)",
            thumb: "/assets/thumbs/GolfCon-0004.png",
            guide: [
                "머리 뒤와 벽 사이에 짐볼(45cm 정도)을 두고 기대 선다.",
                "목을 뒤쪽으로 가볍게 밀면서 5초간 유지한다.(5~10회 반복)",
            ]
        },

        {
            id: "MS/MS-Neck-0055",
            title: "네발기기자세 등척성 목 굴곡-짐볼(Isometric Neck flexion with Stability ball, Quadruped)",
            thumb: "/assets/thumbs/MS-Neck-0055.png",
            guide: [
                "이마 밑에 짐볼을 두고 네 발 기기 자세로 엎드린다. ",
                "짐볼을 누르면서 목을 가볍게 굽혀 3~5초간 유지한다.(3~5회 반복)",
            ]
        },
        {
            id: "MS/MS-Neck-0056",
            title: "목 신전근 활성화-짐볼 벽에 대고 머리로 밀기(Posterior cervical muscle activation-Static Neck Extension with ball)",
            thumb: "/assets/thumbs/MS-Neck-0056.png",
            guide: [
                "네 발 기기 자세로 엎드려 정수리쪽에 짐볼을 두고 앞으로 밀어 위로 살짝 들어올리고 5초간 유지한다.(3~5번 반복)",
            ]
        },
        {
            id: "Static/Static-S-0022",
            title: "경장근 활성화-누워서 목 굴곡저항(Longus coli activation- Static Neck Flexion, supine)",
            thumb: "/assets/thumbs/Static-S-0022.png",
            guide: [
                "벤치에 누워 손바닥을 이마에 댄다.",
                "목을 들어 앞으로 굽히려는 힘을 쓰고 손으로는 막아 5초간 버틴다.(3~5회 반복)",
            ]
        },
        {
            id: "Static-S-0023",
            title: "후경부근육 활성화-엎드려 신전저항 (Posterior cervical muscle activation-Static Neck Extension, prone)",
            thumb: "/assets/thumbs/Static-S-0023.png",
            guide: [
                "벤치에 엎드려 손바닥을 머리 뒤에 댄다.",
                "목을 뒤로 신전시키려는 힘을 쓰고 손으로는 막아 5초간 버틴다.(3~5회 반복)"
            ]
        },
    ],

    "neck-rehab-4": [
        {
            id: "Static-F-0038",
            title: "경장근 활성화(Longus coli activation-chin tuck)",
            thumb: "/assets/thumbs/Static-F-0038.png",
            guide: [
                "경추를 바로 세워 턱을 수평으로 뒤로 당겨 이중턱을 만들고 5초간 유지한다.",
                "3~5회 반복하여 실시한다."
            ]
        },

        {
            id: "MS/MS-Neck-0052",
            title: "후경부근육 활성화-밴드를 이용한 목 신전 저항(Posterior cervical muscle activation-Static Neck Extension-Band)",
            thumb: "/assets/thumbs/MS-Neck-0052.png",
            guide: [
                "밴드를 후두에 대고 양 끝을 손으로 잡는다.",
                "목을 뒤로 보내는 힘을 쓰는 동시에 밴드를 앞으로 당기면서 5초간 버틴다.(3~5번 반복)"
            ]
        },
        {
            id: "GolfCon/GolfCon-0005",
            title: "등척성 목 굴곡-짐볼(Isometric Neck flexion, Stability ball)",
            thumb: "/assets/thumbs/GolfCon-0005.png",
            guide: [
                "45cm정도의 짐볼을 벽에 대고 이마로 압박한다.",
                "5초간 유지하고 힘을 풀고 다시 5초간 유지한다.",
                "5~10회 반복한다. "
            ]
        },
        {
            id: "Static-S-0049",
            title: "중부/하부승모근 활성화-엎드려 Y, W, T 자세(Middle/Lower Trapezius activation-Y,W,T’s, prone)",
            thumb: "/assets/thumbs/Static-S-0049.png",
            guide: [
                "매트에 엎드려 팔을 Y, W, T자 형태로 만들어 들어올린다.",
                "10회 3세트 반복한다."
            ]
        },
        {
            id: "Static-S-0025",
            title: "중부/하부승모근 활성화-엎드려 Y, W, T 자세, 짐볼(Middle/Lower Trapezius activation-Y,W,T’s, Stability ball)",
            thumb: "/assets/thumbs/Static-S-0025.png",
            guide: [
                "양손에 덤벨을 들고 짐볼 위에 엎드린다.",
                "가슴을 펴고 팔을 Y, W, T자 형태로 만들어 귀 높이에 맞춰 들어 올려 1~2초간 유지한다.",
                "10회 3세트 반복한다."
            ]
        },
        {
            id: "Static-S-0028",
            title: "양팔 뻗어 어깨 돌리기(Arm circumduction)",
            thumb: "/assets/thumbs/Static-S-0028.png",
            guide: [
                "팔을 옆으로 뻗어 손목을 손등 굽힘시켜 어깨를 앞으로 10회, 뒤로 10회 회전한다.(3~5세트 반복)"
            ]
        },
        {
            id: "Dumbbell-0016",
            title: "스캡션(Scaption)",
            thumb: "/assets/thumbs/Dumbbell-0016.png",
            guide: [
                "양손에 덤벨을 들고 팔을 안으로 30°기울인 상태로 이마 높이까지 들어올린 후 견갑골 사이를 수축시킨다.",
                "10회 3~5세트 반복한다."
            ]
        },
        {
            id: "CB-0016",
            title: "케이블 리버스 플라이(Cable Reverse Fly)",
            thumb: "/assets/thumbs/CB-0016.png",
            guide: [
                "양손으로 케이블을 위에서 잡아 어깨높이 맞춰 뒤로 당긴다.(Reverse fly or Wide Row)",
                "10~15회 2~3세트 반복한다."
            ]
        },
    ],


    "rotator-cuff-tear": [
        {
            id: "MS/MS-Shoulder-0001",
            title: "시계추 운동(Pendulum Exercise)",
            thumb: "/assets/thumbs/MS-Shoulder-0001.png",
            guide: [
                "상체를 앞으로 숙여 한 손으로 바닥을 짚고 환측 팔은 아래로 늘어뜨려 덤벨을 든다.",
                "천천히 시계 방향으로 원을 그리거나 앞/뒤, 옆으로 움직여 10회 3세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0006",
            title: "테이블 슬라이드 스트레치(Table Slide stretch) ",
            thumb: "/assets/thumbs/MS-Shoulder-0006.png",
            guide: [
                "환측 손을 테이블 위에 올려 손 밑에 수건을 받친다.",
                "팔을 앞쪽으로 밀어내 광배근이 스트레치 되도록 한다. 10~15회 3세트 반복한다. "
            ]
        },
        {
            id: "MS/MS-Shoulder-0004",
            title: "능동보조 어깨굴곡(Active assist shoulder flexion, wall walks)",
            thumb: "/assets/thumbs/MS-Shoulder-0004.png",
            guide: [
                "벽을 마주 보고 서서 환측 팔을 앞으로 뻗어 벽에 댄다.",
                "환측 팔을 통증 없는 범위까지 천천히 위쪽 방향으로 올려 5초간 유지한다.",
                "10회 3세트 반복한다."
            ]
        },
        {
            id: "Static/Static-P-0006",
            title: "하부승모근 자가근막이완-공(Lower Trapezius Self Myofascial Release, ball)",
            thumb: "/assets/thumbs/Static-P-0006.png",
            guide: [
                "테니스공 또는 마사지볼을 한 쪽 견갑골 아래에 두고 벽에 기대 뒤로 밀면서 30초~1분간 유지한다.",
                "3~5회 반복하고 반대쪽도 실시한다. ",
            ]
        },
        {
            id: "MS/MS-Shoulder-0123",
            title: "싱글 암 오버헤드 익스텐션(Single Arm Overhead Extension)",
            thumb: "/assets/thumbs/MS-Shoulder-0123.png",
            guide: [
                "환측 팔을 145°로 뻗어 올려(어깨굴곡 145°) 벽에 기대고 15초간 유지하여 3세트 반복한다. ",
            ]
        },
        {
            id: "Stretch-0015",
            title: "흉근 스트레치-벽(Pectoralis stretch, wall)",
            thumb: "/assets/thumbs/Stretch-0015.png",
            guide: [
                "한 쪽 팔꿈치를 90°로 굽혀 벽에 대고 몸을 앞으로 밀어 15초간 유지한다. ",
                "3회 반복하고 반대쪽도 실시한다.",
                "같은 방법으로 팔꿈치를 편 상태로 45° 아래로 내려서, 145° 위로 올려서 각각 실시한다."
            ]
        },
        {
            id: "FR/FR-0030",
            title: "흉추신전-폼롤러(Neck extension- Arm angel, foam roller)",
            thumb: "/assets/thumbs/FR-0030.png",
            guide: [
                "폼롤러 위에 누워 다리를 굽히고 손바닥이 위로 향하게 하여 팔을 바닥에 둔다.",
                "손등으로 바닥을 쓸듯이 팔을 머리 위로 올렸다(어깨 외전) 내린다.(어깨 내전)",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0130",
            title: "밴드 저항 신전 스트레치(Anterior Shoulder stretch, band)",
            thumb: "/assets/thumbs/MS-Shoulder-0130.png",
            guide: [
                "케이블을 등지고 서서 한 팔을 뒤로 뻗어 케이블 손잡이를 잡는다.",
                "통증이 없는 범위까지 천천히 몸을 앞으로 기울여 어깨 앞쪽이 스트레치 되도록 한다.",
                "10~15초 유지하고 3세트 반복한다. "
            ]
        },
        {
            id: "MS/MS-Shoulder-0010",
            title: "봉을 이용한 90도 외회전(Shoulder External Rotation 90 degree, pole)",
            thumb: "/assets/thumbs/MS-Shoulder-0010.png",
            guide: [
                "등을 대고 누워 환측 팔을 어깨높이로 벌리고(90° 외전) 팔꿈치를 90°로 굽혀 세운다.",
                "건측 손으로 바(Bar)의 한 쪽을 잡고 반대쪽 끝을 환측 손바닥에 댄다.",
                "환측 손등이 바닥에 가까워지도록 천천히 바를 위로 밀어 올렸다 원위치로 돌아온다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0132",
            title: "양 팔꿈치 잡고 외전/내전 (Shoulder Abduction/Adduction, cradle)",
            thumb: "/assets/thumbs/MS-Shoulder-0132.png",
            guide: [
                "오른쪽 손이 왼쪽 팔꿈치를, 왼쪽 손이 오른쪽 팔꿈치를 감싸도록 팔짱을 끼고 선다. ",
                "상체를 가볍게 앞으로 숙이고 손으로 팔꿈치를 안쪽으로 당긴다.(수평내전/외전)",
                "좌우 번갈아가며 10~15회 실시하고, 3세트 반복한다. ",
            ]
        },
        {
            id: "MS/MS-Shoulder-0133",
            title: "밴드저항 외회전(Shoulder External Rotation ROM, band)",
            thumb: "/assets/thumbs/MS-Shoulder-0133.png",
            guide: [
                "케이블 옆으로 서서 안쪽 팔꿈치를 90°로 굽혀 케이블 손잡이를 잡는다. ",
                "통증이 없는 범위까지 천천히 몸을 바깥쪽으로 돌린다.(어깨 외회전)",
                "10~15초 유지하고, 3세트 반복한다.  ",
            ]
        },
        {
            id: "MS/MS-Shoulder-0008",
            title: "봉을 이용한 어깨 외회전(Shoulder external rotation with stick)",
            thumb: "/assets/thumbs/MS-Shoulder-0008.png",
            guide: [
                "등을 대고 누워 양 팔을 90°도로 굽혀 세운다.",
                "건측 손으로 바(Bar)의 한 쪽을 잡고 반대쪽 끝을 환측 손바닥에 댄다.",
                "환측 손등이 바닥과 가까워지도록 바를 옆으로 밀어 5~10초간 유지하고, 10회 3세트 반복한다.",
            ]
        },
        {
            id: "MS/MS-Shoulder-0135",
            title: "밴드를 이용한 신전(Shoulder Flexion ROM, band-pulley)",
            thumb: "/assets/thumbs/MS-Shoulder-0135.png",
            guide: [
                "밴드를 위에서 고정하여 한 팔을 머리 위로 뻗어 밴드를 잡는다.(어깨 굴곡)",
                "천천히 팔꿈치를 굽혀 밴드를 아래로 당겼다(어깨 신전) 올린다.",
                "10~15회 실시하고, 3세트 반복한다. ",
            ]
        },

        {
            id: "MS/MS-Shoulder-0016",
            title: "한 팔 전인운동(shoulder protraction, supine)",
            thumb: "/assets/thumbs/MS-Shoulder-0016.png",
            guide: [
                "등을 대고 누워 환측 팔을 가슴앞으로 뻗어 최대한 위로 밀어 올렸다 내린다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0017",
            title: "누워 굴곡(Shoulder Flexion, Supine)",
            thumb: "/assets/thumbs/MS-Shoulder-0017.png",
            guide: [
                "등을 대고 누워 참을 수 있는 통증범위까지 팔을 머리 위로 뻗어 올렸다(어깨굴곡) 내린다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0018",
            title: "저항 없이 어깨 굴곡(Shoulder Flexion, unweighted)",
            thumb: "/assets/thumbs/MS-Shoulder-0018.png",
            guide: [
                "팔꿈치를 펴서 통증이 없는 범위까지 팔을 머리 위로 들어 올렸다(어깨 굴곡) 내린다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0019",
            title: "엎드려 어깨 수평외전(Shoulder Horizontal abduction, prone)",
            thumb: "/assets/thumbs/MS-Shoulder-0019.png",
            guide: [
                "침대 가장자리에 엎드려 한 쪽 팔을 어깨와 수직으로 늘어뜨린다.",
                "팔을 수평으로 들어 올렸다 내린다. 10~15회 3세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0020",
            title: "어깨 외전-앉은 자세(Shoulder abduction, sitting)",
            thumb: "/assets/thumbs/MS-Shoulder-0020.png",
            guide: [
                "밴치에 앉아 참을 수 있는 통증범위까지 팔을 옆으로 들어 올렸다(외전) 내린다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0021",
            title: "어깨 내회전-손 뒤로(Shoulder Internal rotation-hand behind back)",
            thumb: "/assets/thumbs/MS-Shoulder-0021.png",
            guide: [
                "환측 팔꿈치를 굽혀 손등을 허리에 댄다.",
                "참을 수 있는 통증 범위까지 손등을 견갑골 쪽으로 올렸다 내린다. 10회 3세트 반복한다."
            ]
        },

        {
            id: "MS/MS-Shoulder-0128",
            title: "어깨 90도 외전 & 외회전(Shoulder 90 degree abduction & external rotation)",
            thumb: "/assets/thumbs/MS-Shoulder-0128.png",
            guide: [
                "등을 대고 누워(또는 벽에 기대어) 팔을 어깨높이로 벌리고(90° 외전) 팔꿈치를 90°로 굽혀 세운다.",
                "참을 수 있는 통증범위까지 천천히 어깨를 외회전하여 손등을 최대한 바닥쪽으로 보낸다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0022",
            title: "등척성 어깨 신전(Isometric Shoulder extension)",
            thumb: "/assets/thumbs/MS-Shoulder-0022.png",
            guide: [
                "벽을 등지고 서서 한 팔을 뒤로 뻗어 벽을 짚고 밀면서 5초간 유지한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0023",
            title: "등척성 어깨 외회전(Isometric shoulder external rotation)",
            thumb: "/assets/thumbs/MS-Shoulder-0023.png",
            guide: [
                "한 팔을 90°로 굽혀 벽에 대고 옆으로 선다.",
                "벽을 밀어내듯 전완(팔꿈치 아래)을 바깥쪽으로 회전(어깨 외회전)하여 5초간 유지한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0024",
            title: "등척성 어깨 내회전(Isometric shoulder internal rotation)",
            thumb: "/assets/thumbs/MS-Shoulder-0024.png",
            guide: [
                "벽 앞으로 서서 한 팔을 90°로 굽혀 손바닥을 벽에 댄다.",
                "벽을 밀어내듯 전완(팔꿈치 아래)을 안쪽으로 회전하여(어깨 내회전) 5초간 유지한다. ",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0025",
            title: "등척성 어깨내전(Isometric shoulder adduction)",
            thumb: "/assets/thumbs/MS-Shoulder-0025.png",
            guide: [
                "팔을 90°로 굽혀 쿠션을 팔 안쪽에 둔다.",
                "팔을 몸통쪽으로 끌어당겨(어깨 내전) 5초간 유지한다. ",
                "10~15회 반복하여 3세트 실시한다.",
            ]
        },
        {
            id: "MS/MS-Shoulder-0026",
            title: "등척성 어깨외전(Isometric shoulder abduction)",
            thumb: "/assets/thumbs/MS-Shoulder-0026.png",
            guide: [
                "팔을 90°로 굽혀 벽과 팔 사이에 쿠션을 둔다.",
                "팔을 바깥쪽으로 밀어(어깨 외전) 5초간 유지한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },

        {
            id: "MS/MS-Shoulder-0027",
            title: "어깨 내회전-덤벨(Shoulder Internal rotation, dumbbell)",
            thumb: "/assets/thumbs/MS-Shoulder-0027.png",
            guide: [
                "환측(통증이 있는 어깨) 팔이 밑으로 가도록 옆으로 눕는다.",
                "팔꿈치를 90°로 굽히고 손으로 덤벨을 잡는다.",
                "상완(팔꿈치 위)을 바닥에 고정한 채 덤벨을 위쪽으로 천천히 들어 올렸다(내회전) 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "Dumbbell/Dumbbell-0009",
            title: "어깨 외회전-덤벨(Shoulder External rotation, dumbbell)",
            thumb: "/assets/thumbs/Dumbbell-0009.png",
            guide: [
                "환측(통증이 있는 어깨) 팔이 위로 가도록 옆으로 눕는다.",
                "팔을 90°로 굽혀 팔꿈치 아래 수건을 받치고 손으로 덤벨을 잡는다.",
                "상완(팔꿈치 위)을 고정한 채 덤벨을 아래로 내렸다 천천히 위로 들어 올린다.(외회전)",
                "10~15회 반복하여 3세트 실시한다. "
            ]
        },
        {
            id: "CB/CB-0021",
            title: "어깨 외회전-케이블(Shoulder External rotation, cable)",
            thumb: "/assets/thumbs/CB-0021.png",
            guide: [
                "케이블 옆으로 서서 바깥쪽 손으로 케이블 손잡이를 잡는다.",
                "케이블을 잡은 팔을 90°로 굽혀 몸 옆에 붙이고 전완(팔꿈치 아래)을 밖으로 회전한다.(어깨 외회전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "CB/CB-0022",
            title: "어깨 내회전-케이블(Shoulder Internal rotation, cable)",
            thumb: "/assets/thumbs/CB-0022.png",
            guide: [
                "케이블 옆으로 서서 안쪽 손으로 손잡이를 잡고 팔꿈치를 90°로 굽혀 몸에 붙인다.",
                "상완(팔꿈치 위)을 고정한 채 전완(팔꿈치 아래)을 안쪽으로 회전(내회전)한다. ",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },

        {
            id: "Dumbbell/Dumbbell-0016",
            title: "스캡션(Scaption)",
            thumb: "/assets/thumbs/Dumbbell-0016.png",
            guide: [
                "양손에 덤벨을 들고 팔을 안으로 30°기울인 상태로 이마 높이까지 들어올린 후 견갑골 사이를 수축시킨다.",
                "10회 3~5세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0178",
            title: "스캡션-엎드려서(Shoulder Flexion 100~145degree, prone)",
            thumb: "/assets/thumbs/MS-Shoulder-0178.png",
            guide: [
                "매트에 엎드려 환측 팔을 110°~145°로 외전하여 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0033",
            title: "엎드려 어깨 신전(Shoulder Extension, dumbbell)",
            thumb: "/assets/thumbs/MS-Shoulder-0033.png",
            guide: [
                "베드 가장자리에 엎드려 한 손으로 덤벨을 잡아 팔을 아래로 늘어뜨린다.",
                "팔을 펴서 등 뒤쪽으로 들어 올렸다(어깨 신전) 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0034",
            title: "네발기기자세 체중이동(Quadruped weight shift)",
            thumb: "/assets/thumbs/MS-Shoulder-0034.png",
            guide: [
                "네 발 기기 자세로 엎드린다.",
                "몸을 앞쪽으로 기울여 체중을 앞으로 이동시켰다 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다.",
            ]
        },
        {
            id: "MS-Lumbar/MS-Lumbar-0154",
            title: "네발기기자세 한 팔 들기(Quadruped Single Arm Raise)",
            thumb: "/assets/thumbs/MS-Lumbar-0154.png",
            guide: [
                "네 발 기기 자세로 엎드려 벽과 엉덩이 사이에 짐볼을 둔다.",
                "엉덩이로 짐볼을 고정한 채 팔을 앞으로 110°~145°로 뻗어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },

        {
            id: "Static/Static-P-0033",
            title: "전거근 활성화(Serratus anterior activation-Window Washer or medicine ball circle)",
            thumb: "/assets/thumbs/Static-P-0033.png",
            guide: [
                "어깨높이에 맞춰 한 팔을 앞으로 뻗어 손바닥으로 메디슨볼을 볍게 누른다.",
                "손바닥으로 누르면서 메디슨볼을 시계방향, 반시계방향으로 돌린다. ",
                "10회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0066",
            title: "네발기기자세 공을 이용한 한 팔 견갑대 전인(Single Arm Scapula Press with ball, Quadruped)",
            thumb: "/assets/thumbs/MS-Shoulder-0066.png",
            guide: [
                "네 발 기기 자세로 엎드려 손바닥으로 쿠션볼을 짚는다.",
                "팔꿈치를 편 채 손바닥으로 쿠션볼을 압박하면서(전인) 5초간 유지한다. ",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0197",
            title: "싱글암 로우(Single Arm Row with band)",
            thumb: "/assets/thumbs/MS-Shoulder-0197.png",
            guide: [
                "어깨높이에 맞춰 팔을 앞으로 뻗어 밴드를 잡는다.",
                "팔꿈치 굽혀 밴드들 등쪽으로 끌어 당겼다 팔꿈치를 펴며 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },




    ],

    "impingement-calcific": [
        {
            id: "MS/MS-Shoulder-0016",
            title: "한 팔 전인운동(shoulder protraction, supine)",
            thumb: "/assets/thumbs/MS-Shoulder-0016.png",
            guide: [
                "등을 대고 누워 환측 팔을 가슴앞으로 뻗어 최대한 위로 밀어 올렸다 내린다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0017",
            title: "누워 굴곡(Shoulder Flexion, Supine)",
            thumb: "/assets/thumbs/MS-Shoulder-0017.png",
            guide: [
                "등을 대고 누워 참을 수 있는 통증범위까지 팔을 머리 위로 뻗어 올렸다(어깨굴곡) 내린다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0018",
            title: "저항 없이 어깨 굴곡(Shoulder Flexion, unweighted)",
            thumb: "/assets/thumbs/MS-Shoulder-0018.png",
            guide: [
                "팔꿈치를 펴서 통증이 없는 범위까지 팔을 머리 위로 들어 올렸다(어깨 굴곡) 내린다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0019",
            title: "엎드려 어깨 수평외전(Shoulder Horizontal abduction, prone)",
            thumb: "/assets/thumbs/MS-Shoulder-0019.png",
            guide: [
                "침대 가장자리에 엎드려 한 쪽 팔을 어깨와 수직으로 늘어뜨린다.",
                "팔을 수평으로 들어 올렸다 내린다. 10~15회 3세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0020",
            title: "어깨 외전-앉은 자세(Shoulder abduction, sitting)",
            thumb: "/assets/thumbs/MS-Shoulder-0020.png",
            guide: [
                "밴치에 앉아 참을 수 있는 통증범위까지 팔을 옆으로 들어 올렸다(외전) 내린다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0021",
            title: "어깨 내회전-손 뒤로(Shoulder Internal rotation-hand behind back)",
            thumb: "/assets/thumbs/MS-Shoulder-0021.png",
            guide: [
                "환측 팔꿈치를 굽혀 손등을 허리에 댄다.",
                "참을 수 있는 통증 범위까지 손등을 견갑골 쪽으로 올렸다 내린다. 10회 3세트 반복한다."
            ]
        },
        {
            id: "FR/FR-0030",
            title: "흉추신전-폼롤러(Neck extension- Arm angel, foam roller)",
            thumb: "/assets/thumbs/FR-0030.png",
            guide: [
                "폼롤러 위에 누워 다리를 굽히고 손바닥이 위로 향하게 하여 팔을 바닥에 둔다.",
                "손등으로 바닥을 쓸듯이 팔을 머리 위로 올렸다(어깨 외전) 내린다.(어깨 내전)",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            id: "Stretch-0015",
            title: "흉근 스트레치-벽(Pectoralis stretch, wall)",
            thumb: "/assets/thumbs/Stretch-0015.png",
            guide: [
                "한 쪽 팔꿈치를 90°로 굽혀 벽에 대고 몸을 앞으로 밀어 15초간 유지한다. ",
                "3회 반복하고 반대쪽도 실시한다.",
                "같은 방법으로 팔꿈치를 편 상태로 45° 아래로 내려서, 145° 위로 올려서 각각 실시한다."
            ]
        },
        {
            id: "FR/FR-0008",
            title: "광배근 자가근막이완-폼롤러(Latissimus Dorsi Self Myofascial Release, foam roller)",
            thumb: "/assets/thumbs/FR-0008.png",
            guide: [
                "겨드랑이 사이에 폼롤러를 두고 옆으로 눕는다. ",
                "옆쪽으로 광배근을 압박하면서 30초~1분 내외로 폼롤러를 위아래로 굴린다.",
                "3~5회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0137",
            title: "밴드를 이용한 광배근 스트레치(Latissimus dorsi stretch, band)",
            thumb: "/assets/thumbs/MS-Shoulder-0137.png",
            guide: [
                "밴드 앞으로 서서 팔을 뻗어 밴드를 잡는다.",
                "밴드의 탄성에 팔을 의지하고 천천히 상체를 앞으로 숙여 광배근을 스트레치 한다.",
                "15~20초 유지하고, 3세트 반복한다."
            ]
        },
        {
            id: "FR/FR-0033",
            title: "폼롤러 오버헤드 익스텐션(Overhead/Extension, Foam Roller)",
            thumb: "/assets/thumbs/FR-0033.png",
            guide: [
                "등 밑에 폼롤러를 가로로 두고 누워 무릎을 굽힌다.",
                "두 팔을 천천히 머리 위로 뻗어 올려 흉추를 신전한다. 10~15회 3세트 반복한다.",
            ]
        },
        {
            id: "FR/FR-0032",
            title: "어깨 90도 외전 외회전(Trunk Rotation Shoulder 90-90 degree, Foam Roller)",
            thumb: "/assets/thumbs/FR-0032.png",
            guide: [
                "폼롤러를 베고 누워 오른팔을 옆으로 벌려 팔꿈치를 90°로 굽히고 손을 폼롤러 밑으로 고정한다. ",
                "오른쪽 무릎을 굽히고 왼손으로 잡아 안쪽 방향으로 당기면서 몸통을 회전한다.",
                "10~15초 유지하고, 3세트 반복한다."
            ]
        },
        {
            id: "Static/Static-F-0095(edit)",
            title: "소흉근 자가근막이완-공(Pectoralis Minor Self Myofascial Release, ball)",
            thumb: "/assets/thumbs/Static-F-0095.png",
            guide: [
                "테니스공 또는 마사지볼을 가슴과 쇄골 사이에 두고 벽에 기대 앞으로 밀면서 압박이완 한다.",
                "30초~1분 이내로 3~5회 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            id: "FR/FR-0007",
            title: "흉근 자가근막이완-폼롤러 (Pectorialis Self Myofascial Release, foam roller)",
            thumb: "/assets/thumbs/FR-0007.png",
            guide: [
                "한 쪽 팔과 가슴 사이에 폼롤러를 두고 엎드려 앞쪽으로 흉근을 압박하면서 폼롤러를 30초~1분 내외로 굴린다.",
                "양쪽 모두 실시하고 3~5회씩 반복한다.",
            ],

        },
        {
            id: "MS/MS-Shoulder-0027",
            title: "어깨 내회전-덤벨(Shoulder Internal rotation, dumbbell)",
            thumb: "/assets/thumbs/MS-Shoulder-0027.png",
            guide: [
                "환측(통증이 있는 어깨) 팔이 밑으로 가도록 옆으로 눕는다.",
                "팔꿈치를 90°로 굽히고 손으로 덤벨을 잡는다.",
                "상완(팔꿈치 위)을 바닥에 고정한 채 덤벨을 위쪽으로 천천히 들어 올렸다(내회전) 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ],

        },
        {
            id: "Dumbbell/Dumbbell-0009",
            title: "어깨 외회전-덤벨(Shoulder External rotation, dumbbell)",
            thumb: "/assets/thumbs/Dumbbell-0009.png",
            guide: [
                "환측(통증이 있는 어깨) 팔이 위로 가도록 옆으로 눕는다.",
                "팔을 90°로 굽혀 팔꿈치 아래 수건을 받치고 손으로 덤벨을 잡는다.",
                "상완(팔꿈치 위)을 고정한 채 덤벨을 아래로 내렸다 천천히 위로 들어 올린다.(외회전)",
                "10~15회 반복하여 3세트 실시한다."
            ],

        },
        {
            id: "CB/CB-0021",
            title: "어깨 외회전-덤벨(Shoulder External rotation, dumbbell)",
            thumb: "/assets/thumbs/CB-0021.png",
            guide: [
                "케이블 옆으로 서서 바깥쪽 손으로 케이블 손잡이를 잡는다.",
                "케이블을 잡은 팔을 90°로 굽혀 몸 옆에 붙이고 전완(팔꿈치 아래)을 밖으로 회전한다.(어깨 외회전)",
                "10~15회 반복하여 3세트 실시한다.",
            ],

        },
        {
            id: "CB/CB-0022",
            title: "어깨 내회전-케이블(Shoulder Internal rotation, cable)",
            thumb: "/assets/thumbs/CB-0022.png",
            guide: [
                "케이블 옆으로 서서 안쪽 손으로 손잡이를 잡고 팔꿈치를 90°로 굽혀 몸에 붙인다.",
                "상완(팔꿈치 위)을 고정한 채 전완(팔꿈치 아래)을 안쪽으로 회전(내회전)한다. ",
                "10~15회 반복하여 3세트 실시한다.",
            ],

        },
        {
            id: "Dumbbell/Dumbbell-0016",
            title: "스캡션(Scaption)",
            thumb: "/assets/thumbs/Dumbbell-0016.png",
            guide: [
                "양손에 덤벨을 들고 팔을 안으로 30°기울인 상태로 이마 높이까지 들어올린 후 견갑골 사이를 수축시킨다.",
                "10회 3~5세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0178",
            title: "스캡션-엎드려서(Shoulder Flexion 100~145degree, prone)",
            thumb: "/assets/thumbs/MS-Shoulder-0178.png",
            guide: [
                "매트에 엎드려 환측 팔을 110°~145°로 외전하여 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0033",
            title: "엎드려 어깨 신전(Shoulder Extension, dumbbell)",
            thumb: "/assets/thumbs/MS-Shoulder-0033.png",
            guide: [
                "베드 가장자리에 엎드려 한 손으로 덤벨을 잡아 팔을 아래로 늘어뜨린다.",
                "팔을 펴서 등 뒤쪽으로 들어 올렸다(어깨 신전) 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0034",
            title: "네발기기자세 체중이동(Quadruped weight shift)",
            thumb: "/assets/thumbs/MS-Shoulder-0034.png",
            guide: [
                "네 발 기기 자세로 엎드린다.",
                "몸을 앞쪽으로 기울여 체중을 앞으로 이동시켰다 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "MS/MS-Lumbar-0154",
            title: "네발기기자세 한 팔 들기(Quadruped Single Arm Raise)",
            thumb: "/assets/thumbs/MS-Lumbar-0154.png",
            guide: [
                "네 발 기기 자세로 엎드려 벽과 엉덩이 사이에 짐볼을 둔다.",
                "엉덩이로 짐볼을 고정한 채 팔을 앞으로 110°~145°로 뻗어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "GB/GB-0008",
            title: "짐볼 푸시업(Stability ball Push up)",
            thumb: "/assets/thumbs/GB-0008.png",
            guide: [
                "양 손으로 짐볼을 짚고 엎드려 머리부터 발까지 사선형태를 만든다.",
                "팔꿈치를 굽혀 몸을 아래로 내렸다 원위치로 돌아온다.(푸쉬업)",
                "10회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "GB/GB-0013",
            title: "짐볼 플랭크(Ball plank) ",
            thumb: "/assets/thumbs/GB-0013.png",
            guide: [
                "팔꿈치를 90°로 굽혀 짐볼 위에 올리고 엎드려 머리부터 발까지 사선형태를 만든다.",
                "20초~1분간 자세를 유지하고, 3세트 실시한다.",
            ]
        },
        {
            id: "GB/GB-0014",
            title: "짐볼 플랭크 & 회전(Prone ball circle)",
            thumb: "/assets/thumbs/GB-0014.png",
            guide: [
                "팔꿈치를 90°로 굽혀 짐볼 위에 올리고 엎드려 머리부터 발까지 사선형태를 만든다.",
                "자세를 유지한 채 팔꿈치를 이용해 짐볼을 좌우로 각각 5회씩 돌려 3세트 반복한다.",
            ]
        },
        {
            id: "MS/MS-Shoulder-0074",
            title: "어깨 드릴(Shoulder Drill)",
            thumb: "/assets/thumbs/MS-Shoulder-0074.png",
            guide: [
                "네 발 기기 자세로 엎드려 오른손으로 메디슨볼을 잡는다.",
                "메디슨볼을 옆으로 굴려 왼 손으로 받고 다시 옆으로 굴려 오른손으로 받는다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "BOSU/BOSU-0022",
            title: "보수볼 플랭크 업 & 다운(Bosu Up & Down)",
            thumb: "/assets/thumbs/BOSU-0022.png",
            guide: [
                "팔꿈치를 90°로 굽혀 보수볼 위에 올리고 엎드려 머리부터 발까지 사선형태를 만든다.",
                "자세를 유지한 채 한 팔씩 팔꿈치를 펴 푸쉬업 자세를 만든다.",
                "다시 한 쪽씩 팔꿈치를 굽혀 플랭크 자세를 만든다. ",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "Dumbbell/Dumbbell-0030",
            title: "푸시업 자세 덤벨로우(Renegade Dumbbell Row)",
            thumb: "/assets/thumbs/Dumbbell-0030.png",
            guide: [
                "양 손으로 덤벨을 잡고 푸쉬업 자세로 엎드린다.",
                "자세를 유지한 채 한 쪽 팔꿈치를 굽혀 덤벨을 등쪽으로 끌어 올린다.",
                "원위치로 돌아와 팔을 바꿔 실시하고, 10~15회 3세트 반복한다.",
            ]
        },
    ],



    "frozen-shoulder": [
        {
            id: "MS/MS-Shoulder-0001",
            title: "시계추 운동(Pendulum Exercise)",
            thumb: "/assets/thumbs/MS-Shoulder-0001.png",
            guide: [
                "상체를 앞으로 숙여 한 손으로 바닥을 짚고 환측 팔은 아래로 늘어뜨려 덤벨을 든다.",
                "천천히 시계 방향으로 원을 그리거나 앞/뒤, 옆으로 움직여 10회 3세트 반복한다."
            ],
        },
        {
            id: "MS/MS-Shoulder-0006",
            title: "테이블 슬라이드 스트레치(Table Slide stretch)",
            thumb: "/assets/thumbs/MS-Shoulder-0006.png",
            guide: [
                "환측 손을 테이블 위에 올려 손 밑에 수건을 받친다.",
                "팔을 앞쪽으로 밀어내 광배근이 스트레치 되도록 한다. 10~15회 3세트 반복한다. "
            ],
        },
        {
            id: "MS/MS-Shoulder-0002",
            title: "능동보조 어깨 굴곡(Active assist shoulder flexion)",
            thumb: "/assets/thumbs/MS-Shoulder-0002.png",
            guide: [
                "등을 대고 누워 팔을 뻗어 건측 손으로 환측 손목을 잡는다.",
                "건측 손으로 환측 팔을 머리 위로 천천히 밀어 올려(어깨굴곡) 5초간 유지한다.",
                "10~15회 3세트 반복한다."
            ],
        },
        {
            id: "MS/MS-Shoulder-0005",
            title:
                "능동보조 어깨 수평내전-후방관절낭 스트레치(Active assist shoulder horizontal adduction-Posterior capsul stretch)",
            thumb: "/assets/thumbs/MS-Shoulder-0005.png",
            guide: [
                "등을 대고 누워 가슴앞에서 건측 손으로 환측 팔꿈치를 잡는다.",
                "건측 손으로 환측 팔꿈치를 천천히 안쪽으로 끌어 당긴다.(수평내전)",
                "10~15초 유지하고, 3세트 반복한다.",

            ],
        },
        {
            id: "MS/MS-Shoulder-0004",
            title:
                "능동보조 어깨굴곡(Active assist shoulder flexion, wall walks)",
            thumb: "/assets/thumbs/MS-Shoulder-0004.png",
            guide: [
                "벽을 마주 보고 서서 환측 팔을 앞으로 뻗어 벽에 댄다.",
                "환측 팔을 통증 없는 범위까지 천천히 위쪽 방향으로 올려 5초간 유지한다.",
                "10회 3세트 반복한다. ",
            ],
        },
        {
            id: "MS/MS-Shoulder-0021",
            title: "어깨 내회전-손 뒤로(Shoulder Internal rotation-hand behind back)",
            thumb: "/assets/thumbs/MS-Shoulder-0021.png",
            guide: [
                "환측 팔꿈치를 굽혀 손등을 허리에 댄다.",
                "참을 수 있는 통증 범위까지 손등을 견갑골 쪽으로 올렸다 내린다. 10회 3세트 반복한다.",

            ],
        },
        {
            id: "Stretch/Stretch-0015",
            title: "흉근 스트레치-벽(Pectoralis stretch, wall)",
            thumb: "/assets/thumbs/Stretch-0015.png",
            guide: [
                "한 쪽 팔꿈치를 90°로 굽혀 벽에 대고 몸을 앞으로 밀어 15초간 유지한다. ",
                "3회 반복하고 반대쪽도 실시한다.",
                "같은 방법으로 팔꿈치를 편 상태로 45° 아래로 내려서, 145° 위로 올려서 각각 실시한다."
            ],
        },
        {
            id: "MS/MS-Shoulder-0007",
            title: "봉을 이용한 어깨 굴곡(Shoulder flexion with stick)",
            thumb: "/assets/thumbs/MS-Shoulder-0007.png",
            guide: [
                "등을 대고 누워 양 손으로 바(Bar)를 잡고 팔꿈치를 편다.",
                "환측 팔을 참을 수 있는 통증 법위까지 천천히 머리 위로 올렸다(어깨 굴곡) 내린다. ",
                "10~15회 3세트 반복한다."
            ],
        },
        {
            id: "MS/MS-Shoulder-0008",
            title: "봉을 이용한 어깨 외회전(Shoulder external rotation with stick)",
            thumb: "/assets/thumbs/MS-Shoulder-0008.png",
            guide: [
                "등을 대고 누워 양 팔을 90°도로 굽혀 세운다.",
                "건측 손으로 바(Bar)의 한 쪽을 잡고 반대쪽 끝을 환측 손바닥에 댄다.",
                "환측 손등이 바닥과 가까워지도록 바를 옆으로 밀어 5~10초간 유지하고, 10회 3세트 반복한다."
            ],
        },
        {
            id: "MS/MS-Shoulder-0009",
            title: "봉을 이용한 어깨 외전(Shoulder abduction with stick)",
            thumb: "/assets/thumbs/MS-Shoulder-0009.png",
            guide: [
                "등을 대고 누워 환측 팔을 옆으로 뻗고 건측 팔꿈치를 굽혀 세워 양 손으로 긴 바(Bar)를 잡는다.",
                "건측 손으로 바를 밀어 내려 환측 팔을 천천히 머리 위로 보내(어깨 외전) 5~10초간 유지한다.",
                "10~15회 3세트 반복한다."
            ],
        },
        {
            id: "MS/MS-Shoulder-0010",
            title:
                "봉을 이용한 90도 외회전(Shoulder External Rotation 90 degree, pole)",
            thumb: "/assets/thumbs/MS-Shoulder-0010.png",
            guide: [
                "등을 대고 누워 환측 팔을 어깨높이로 벌리고(90° 외전) 팔꿈치를 90°로 굽혀 세운다.",
                "건측 손으로 바(Bar)의 한 쪽을 잡고 반대쪽 끝을 환측 손바닥에 댄다.",
                "환측 손등이 바닥에 가까워지도록 천천히 바를 위로 밀어 올렸다 원위치로 돌아온다.",
                "10~15회 3세트 반복한다."
            ],
        },
        {
            id: "MS/MS-Shoulder-0012",
            title: "봉을 이용한 어깨신전(Shoulder extension with stick)",
            thumb: "/assets/thumbs/MS-Shoulder-0012.png",
            guide: [
                "팔을 뒤로 보내 양 손으로 바(Bar)를 잡는다.",
                "팔을 가능한 범위까지 위로 뻗어 올린다(어깨 신전). 10~15회 3세트 반복한다."
            ],
        },
        {
            id: "MS/MS-Shoulder-0013",
            title:
                "봉을 이용한 외전(Shoulder abduction with stick, standing)",
            thumb: "/assets/thumbs/MS-Shoulder-0013.png",
            guide: [
                "건측 손으로 바의 한쪽을 잡고, 반대쪽을 환측 손바닥이 앞을 향하도록 하여 잡는다.",
                "건측 팔로 천천히 바를 밀어 참을 수 있는 통증 범위까지 환측 팔을 옆으로 뻗어 올린다.(외전)",
                "10~15회 3세트 반복한다."
            ],
        },
        {
            id: "MS/MS-Shoulder-0014",
            title:
                "봉을 이용한 어깨 수평내전, 외전(Shoulder Horizontal abduction/adduction with stick)",
            thumb: "/assets/thumbs/MS-Shoulder-0014.png",
            guide: [
                "양 팔을 가슴 앞으로 뻗어 바(Bar)를 잡고 선다.",
                "천천히 한 쪽 방향으로 가능한 최대범위까지 팔을 돌렸다 돌아와 반대쪽으로 실시한다.(수평내전/수평외전) ",
                "10~15회 3세트 반복한다."
            ],
        },
        {
            id: "MS/MS-Shoulder-0015",
            title:
                "봉을 이용한 어깨 내회전-뒤(Shoulder internal rotation with stick, back)",
            thumb: "/assets/thumbs/MS-Shoulder-0015.png",
            guide: [
                "팔을 뒤로 보내 환측 팔을 아래로, 건측 팔을 위로 올려 바(Bar)를 세로로 잡고 선다.",
                "바를 위로 당겨 환측 손을 참을 수 있는 통증범위까지 위로 끌어 올린다.(어깨 내회전)",
                "10~15회 3세트 반복한다."
            ],
        },
        {
            id: "MS/MS-Shoulder-0063",
            title:
                "테이블 짐볼 어깨굴곡(Table Stability ball shoulder flexion)",
            thumb: "/assets/thumbs/MS-Shoulder-0063.png",
            guide: [
                "테이블에 짐볼을 두고 환측 팔꿈치를 굽혀 손을 짐볼 위에 올린다. ",
                "상체를 가볍게 숙이고 팔꿈치를 펴면서 짐볼을 앞으로 굴렸다 시작위치로 돌아온다.",
                "10~15회 3세트 반복한다. "
            ],
        },
        {
            id: "MS/MS-Shoulder-0064",
            title:
                "테이블 짐볼 어깨굴곡 스쿼트(Table Stability ball shoulder flexion Squat)",
            thumb: "/assets/thumbs/MS-Shoulder-0064.png",
            guide: [
                "테이블에 짐볼을 두고 서서 양 손을 짐볼 위에 올린다.",
                "무릎을 굽혀 앉으면서 팔을 뻗어 짐볼을 앞으로 밀어냈다 시작위치로 돌아온다.",
                "10~15회 3세트 반복한다."
            ],
        },
        {
            id: "MS/MS-Shoulder-0186",
            title:
                "네발기기 자세 밴드전인(Quadruped Scapular press with band)",
            thumb: "/assets/thumbs/MS-Shoulder-0186.png",
            guide: [
                "네 발 기기 자세로 엎드려 밴드를 등 뒤에 걸고 양 끝을 손으로 고정한다.",
                "팔꿈치를 편 채 어깨를 내렸다 올린다. 10~15회 반복하여 3세트 실시한다."
            ],
        },
        {
            id: "MS/MS-Shoulder-0066",
            title:
                "네발기기자세 공을 이용한 한 팔 견갑대 전인(Single Arm Scapula Press with ball, Quadruped)",
            thumb: "/assets/thumbs/MS-Shoulder-0066.png",
            guide: [
                "네 발 기기 자세로 엎드려 손바닥으로 쿠션볼을 짚는다.",
                "팔꿈치를 편 채 손바닥으로 쿠션볼을 압박하면서(전인) 5초간 유지한다. ",
                "10~15회 반복하여 3세트 실시한다."
            ],
        },
        {
            id: "MS/MS-Shoulder-0067",
            title: "누워 메디신볼 회전(Medicine ball circle, supine)",
            thumb: "/assets/thumbs/MS-Shoulder-0067.png",
            guide: [
                "누워 환측에 메디신 볼을 어깨에서 수직으로 잡고 알파벳 또는 이름을 그리거나 오른쪽 왼쪽으로 각각 10회씩 원을 그린다. ",
                "3세트 반복한다. "
            ],
        },
        {
            id: "CB/CB-0021",
            title: "어깨 외회전-케이블(Shoulder External rotation, cable)",
            thumb: "/assets/thumbs/CB-0021.png",
            guide: [
                "케이블 옆으로 서서 바깥쪽 손으로 케이블 손잡이를 잡는다.",
                "케이블을 잡은 팔을 90°로 굽혀 몸 옆에 붙이고 전완(팔꿈치 아래)을 밖으로 회전한다.(어깨 외회전)",
                "10~15회 반복하여 3세트 실시한다.",
            ],
        },
        {
            id: "MS/MS-Shoulder-0069",
            title:
                "어깨 90도 외전 90도 외회전-덤벨(Shoulder 90 degree abduction & external rotation)",
            thumb: "/assets/thumbs/MS-Shoulder-0069.png",
            guide: [
                "덤벨을 들고 의자등에 팔꿈치를 90도 굽혀 팔을 외회전하여 들어올린다. 10회~15회 3세트 반복한다. ",
                "만약 어깨에 힘이 없는 경우 팔꿈치를 의자 등받이에 수건을 대고 걸치고 운동을 수행한다. "
            ],
        },
        {
            id: "Dumbbell-0016",
            title: "스캡션(Scaption)",
            thumb: "/assets/thumbs/Dumbbell-0016.png",
            guide: [
                "양손에 덤벨을 들고 팔을 안으로 30°기울인 상태로 이마 높이까지 들어올린 후 견갑골 사이를 수축시킨다.",
                "10회 3~5세트 반복한다."
            ]
        },
    ],

    "shoulder-instability-sublux": [
        {
            id: "MS/MS-Shoulder-0071",
            title: "짐볼 벽 대고 한 팔 회전(Single Arm Scapula Circles with Stability ball, Wall)",
            thumb: "/assets/thumbs/MS-Shoulder-0071.png",
            guide: [
                "한 팔을 가슴앞으로 뻗어 손바닥으로 짐볼을 짚어 가볍게 누른다.",
                "팔꿈치를 편 채 짐볼을 좌/우로 각각 10회씩 돌리고, 3세트 반복한다."
            ]
        },
        {
            id: "GB/GB-0015",
            title: "짐볼 굴리기(Forward ball roll)",
            thumb: "/assets/thumbs/GB-0015.png",
            guide: [
                "짐볼에 팔꿈치를 굽혀 어깨와 수직으로 하고 무릎을 굽혀 앉는 자세를 유지한다. ",
                "짐볼을 앞으로 밀어내면서 상체와 허리 골반이 일직선이 되도록 한다. 다시 처음 시작 자세로 돌아온다. ",
                "10~15회 2~3세트 반복한다. "
            ]
        },
        {
            id: "Static-S-0025",
            title: "중부/하부승모근 활성화-엎드려 Y, W, T 자세, 짐볼(Middle/Lower Trapezius activation-Y,W,T’s, Stability ball)",
            thumb: "/assets/thumbs/Static-S-0025.png",
            guide: [
                "양손에 덤벨을 들고 짐볼 위에 엎드린다.",
                "가슴을 펴고 팔을 Y, W, T자 형태로 만들어 귀 높이에 맞춰 들어 올려 1~2초간 유지한다.",
                "10회 3세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0074",
            title: "어깨 드릴(Shoulder Drill)",
            thumb: "/assets/thumbs/MS-Shoulder-0074.png",
            guide: [
                "네 발 기기 자세로 엎드려 오른손으로 메디슨볼을 잡는다.",
                "메디슨볼을 옆으로 굴려 왼 손으로 받고 다시 옆으로 굴려 오른손으로 받는다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0075",
            title: "메디신볼 밸런스(Medicine ball balance)",
            thumb: "/assets/thumbs/MS-Shoulder-0075.png",
            guide: [
                "메디신 볼을 어깨와 수직 높이로 두 손으로 잡고 다리를 뻗어 업드린다(푸시업자세). 10초 ~15초간 유지하고 3세트 반복한다. "
            ]
        },
        {
            id: "CB/CB-0017",
            title: "싱글암 벤트오버 케이블 로우(Bent over Single Arm Cable Row)",
            thumb: "/assets/thumbs/CB-0017.png",
            guide: [
                "한 손으로 케이블을 잡고 팔을 앞으로 뻗는다. 케이블 잡은 반대쪽 다리가 케이블 잡은 다리보다 앞에 놓이게 교차해서 서고 무릎은 약간 굽힌다. 케이블이 가슴의 아래에 다다를 때까지 케이블을 등 쪽으로 당긴다. 처음 자세로 돌아간다. ",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            id: "Band/Band-0013",
            title: "밴드 어깨 수평외전(Horizontal abduction with band)",
            thumb: "/assets/thumbs/Band-0013.png",
            guide: [
                "밴드를 양손에 쥐고 어깨 너비 정도로 팔을 펼쳐 앞으로 들어 올려준다. 견갑골을 쥐어 짜면서 밴드를 바깥쪽으로 탄성이 느껴질 정도로 늘려준다. 처음 자세로 돌아온다. 10~15회 2~3세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0198",
            title: "네발기기 자세 한 팔 견갑대 전인(Single Arm Scapula Press in Quadruped, band)",
            thumb: "/assets/thumbs/MS-Shoulder-0198.png",
            guide: [
                "네발기기 자세에서 밴드를 등으로 돌려 환측 손에 밴드를 고정한다. ",
                "상체를 바닥쪽으로 내렸다 올린다. 이때 팔이 굽혀지면 안된다. 10~15회 3세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0079",
            title: "시티드 프레스업(Seated press up)",
            thumb: "/assets/thumbs/MS-Shoulder-0079.png",
            guide: [
                "벤치나 테이블 끝에서 두 팔로 벤치(테이블)을 지지하면서 몸을 들어 올린다. ",
                "5~10초 유지한다. 3세트 반복한다. "
            ]
        },
        {
            id: "MS/MS-Shoulder-0080",
            title: "워블보드 서클(Wooble circle)",
            thumb: "/assets/thumbs/MS-Shoulder-0080.png",
            guide: [
                "어깨를 바닥에서 수직으로 하고 두 손으로 워블보드(Wooble board, 바닥이 원형으로 된 운동기구)를 잡고 엎드린다(근력에 따라 무릎을 굽히거나 무릎을 편다). ",
                "워블보드를 오른쪽으로 10회, 왼쪽으로 10회 돌린다. 2~3세트 반복한다. "
            ]
        },
        {
            id: "BOSU/BOSU-0009",
            title: "플랭크 자세 보수볼 회전(Bosu plank around the clock)",
            thumb: "/assets/thumbs/BOSU-0009.png",
            guide: [
                "보수볼 바닥을 위로 하고 두 손으로 보수볼을 잡고 엎드린다(근력에 따라 무릎을 굽혀 엎드린다). ",
                "보수볼을 오른쪽으로 10회 왼쪽으로 10회 돌린다. 2~3세트 반복한다. "
            ]
        },
        {
            id: "MS/MS-Shoulder-0019",
            title: "엎드려 어깨 수평외전(Shoulder Horizontal abduction, prone)",
            thumb: "/assets/thumbs/MS-Shoulder-0019.png",
            guide: [
                "침대 가장자리에 엎드려 한 쪽 팔을 어깨와 수직으로 늘어뜨린다.",
                "팔을 수평으로 들어 올렸다 내린다. 10~15회 3세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0083",
            title: "블레이드 흔들기(Blade Oscillation)",
            thumb: "/assets/thumbs/MS-Shoulder-0083.png",
            guide: [
                "환측 손에 블레이드(진동을 시킬 수 있는 운동기구)를 들고 125도 어깨를 외전한 후 블레이드를 흔든다. ",
                "10초~30초 유지하고 3세트 반복한다. "
            ]
        },
        {
            id: "MS/MS-Shoulder-0084",
            title: "플랭크 자세 견갑대 전인(Plank protraction)",
            thumb: "/assets/thumbs/MS-Shoulder-0084.png",
            guide: [
                "어깨를 바닥과 수직으로 한 후 발을 뻗어 엎드린다(푸시업 자세). ",
                "등 위에 긴 봉을 올려놓고 상체를 바닥 쪽으로 내렸다 올린다(전인). 이때 봉이 등에서 떨어지지 않도록 주의한다. ",
                "10회~15회 3세트 반복한다. "
            ]
        },
        {
            id: "CB/CB-0019",
            title: "케이블 어깨 PNF D1 패턴 운동",
            thumb: "/assets/thumbs/CB-0019.png",
            guide: [
                "케이블 옆으로 서서 안쪽 손으로 케이블 손잡이를 아래쪽에서 잡고 어깨를 외회전하여 팔을 45°로 옆으로 벌린다.(외전) ",
                "팔꿈치를 편 채 어깨를 내회전하여 케이블을 머리 위 대각선 방향으로 당겨 올린다.(내전)",
                "어깨를 외전하면서 팔을 내려 시작위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "CB/CB-0020",
            title: "케이블 어깨 PNF D2 패턴 운동",
            thumb: "/assets/thumbs/CB-0020.png",
            guide: [
                "케이블 옆으로 서서 바깥쪽 손으로 케이블 손잡이를 잡고 어깨를 내회전하여 팔을 45° 안쪽으로 뻗는다.(내전)",
                "팔꿈치를 편 채 어깨를 외회전하여 팔을 머리 위 대각선 방향으로 들어 올린다.(외전)",
                "어깨를 내회전하면서 팔을 내려 시작위치로 돌아온다.",
                "10~15회 반복하여 2세트 실시한다."
            ]
        }
    ],
    "functional-shoulder": [
        {
            id: "Static/Static-P-0033",
            title: "메디신볼 벽에 대고 회전운동(Medicine Ball Circle)",
            thumb: "/assets/thumbs/Static-P-0033.png",
            guide: [
                "어깨높이에 맞춰 한 팔을 앞으로 뻗어 손바닥으로 메디슨볼을 볍게 누른다.",
                "손바닥으로 누르면서 메디슨볼을 시계방향, 반시계방향으로 돌린다. ",
                "10회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0071",
            title: "짐볼 벽 대고 한 팔 회전(Single Arm Scapula Circles with Stability ball, Wall)",
            thumb: "/assets/thumbs/MS-Shoulder-0071.png",
            guide: [
                "한 팔을 가슴앞으로 뻗어 손바닥으로 짐볼을 짚어 가볍게 누른다.",
                "팔꿈치를 편 채 짐볼을 좌/우로 각각 10회씩 돌리고, 3세트 반복한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0236",
            title: "플랭크자세 워블보드 안정화 운동(Wobble board stabilization exercises)",
            thumb: "/assets/thumbs/MS-Shoulder-0236.png",
            guide: [
                "짐볼 위 골반을 대고 엎드린다.",
                "양 팔을 어깨와 수직이 되도록 아래로 뻗어 두 손으로 워블보드를 잡고 다리를 편다.",
                "균형을 유지하면서 워블보드를 오른쪽과 왼쪽으로 회전시킨다.",
                "각 방향으로 10회씩 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0237",
            "title": "네발기기자세 메디신 볼 주고받기(Ball Catch, Quadruped)",
            "thumb": "/assets/thumbs/MS-Shoulder-0237.png",
            "guide": [
                "네 발 기기 자세로 엎드려 한 손으로 메디슨볼을 든다.",
                "자세를 유지한 채 메디슨볼을 던져 반대쪽 손으로 받은 후 다시 던져 받는다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0238",
            "title": "앉아 메디신볼 주고받기(Ball Catch, sitting)",
            "thumb": "/assets/thumbs/MS-Shoulder-0238.png",
            "guide": [
                "한 손에 메디슨볼을 들고 팔꿈치를 90° 굽혀 어깨높이에 맞춰 옆으로 벌리고(90°외전) 앉는다.",
                "자세를 유지한 채 메디슨볼을 던져주고 다시 받는다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0239",
            "title": "누워 메디신볼 던지고 받기(Ball Catch, supine)",
            "thumb": "/assets/thumbs/MS-Shoulder-0239.png",
            "guide": [
                "등을 대고 누워 한 손에 메디슨볼을 들고 가슴높이에서 볼을 위로 던졌다 받는다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0241",
            "title": "앉아 뒤로 공 던져주고 받기(Ball Catch, back)",
            "thumb": "/assets/thumbs/MS-Shoulder-0241.png",
            "guide": [
                "양쪽 무릎을 바닥에 대고 앉아 한 발을 앞으로 보내고 반대쪽 손에 공을 잡는다.",
                "어깨 위 뒤쪽으로 공을 던져주고 몸통을 반대쪽으로 돌려 공을 다시 받는다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MB/MB-0002",
            "title": "메디신볼 머리위에서 던지기(Medicine ball Overhead Toss)",
            "thumb": "/assets/thumbs/MB-0002.png",
            "guide": [
                "다리를 어깨넓이로 벌려 짐볼 위에 앉는다.",
                "양 손으로 메디슨 볼을 잡고 팔을 머리 위로 올려 공을 앞으로 던지고 받는다.",
                "10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "CB/CB-0019",
            "title": "케이블 어깨 PNF D1 패턴 운동",
            "thumb": "/assets/thumbs/CB-0019.png",
            "guide": [
                "케이블 옆으로 서서 안쪽 손으로 케이블 손잡이를 아래쪽에서 잡고 어깨를 외회전하여 팔을 45°로 옆으로 벌린다.(외전)",
                "팔꿈치를 편 채 어깨를 내회전하여 케이블을 머리 위 대각선 방향으로 당겨 올린다.(내전)",
                "어깨를 외전하면서 팔을 내려 시작위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "CB/CB-0020",
            "title": "케이블 어깨 PNF D2 패턴 운동",
            "thumb": "/assets/thumbs/CB-0020.png",
            "guide": [
                "케이블 옆으로 서서 바깥쪽 손으로 케이블 손잡이를 잡고 어깨를 내회전하여 팔을 45° 안쪽으로 뻗는다.(내전)",
                "팔꿈치를 편 채 어깨를 외회전하여 팔을 머리 위 대각선 방향으로 들어 올린다.(외전)",
                "어깨를 내회전하면서 팔을 내려 시작위치로 돌아온다.",
                "10~15회 반복하여 2세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0244",
            "title": "바퀴의자에 플랭크자세로 걷기(Hand Walking on Treadmill/Stool)",
            "thumb": "/assets/thumbs/MS-Shoulder-0244.png",
            "guide": [
                "바퀴가 달린 의자에 배를 대고 엎드린다.",
                "어깨와 수직이 되도록 양 팔을 아래로 내려 손으로 바닥을 짚고 다리를 편다.(푸시업자세)",
                "몸을 수평으로 유지한 채 손을 이용해 공간이 허락되는 범위(약 5m)까지 앞으로 이동하여 3회 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0067",
            "title": "누워 메디신볼 회전(Medicine ball circle, supine)",
            "thumb": "/assets/thumbs/MS-Shoulder-0067.png",
            "guide": [
                "누워 환측에 메디신 볼을 어깨에서 수직으로 잡고 알파벳 또는 이름을 그리거나 오른쪽 왼쪽으로 각각 10회씩 원을 그린다.",
                "3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0014",
            "title": "벽에 기대어 밴드저항 월 슬라이드(Band Wall Slide)",
            "thumb": "/assets/thumbs/Band-0014.png",
            "guide": [
                "팔꿈치를 굽혀 가슴높이에서 양 손에 링밴드를 끼우고 팔을 벌려 벽에 기댄다.",
                "자세를 유지한 채 천천히 팔꿈치를 펴면서 가볍게 벽을 쓸듯이 팔을 머리 위로 올렸다 내린다.",
                "3~5회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0248",
            "title": "벽에 기대어 밴드저항 스파아더맨운동(Spider man, band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0248.png",
            "guide": [
                "루프밴드를 양 손에 끼우고 팔꿈치를 굽혀 팔을 벽에 기댄다.",
                "양 팔을 가볍게 벌린 상태로 한 손씩 차례로 번갈아 가며 벽을 타고 올라갔다 내려온다.",
                "10회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0009",
            "title": "보수볼 서클(BOSU circle)",
            "thumb": "/assets/thumbs/BOSU-0009.png",
            "guide": [
                "보수볼을 거꾸로 두고 팔을 가슴앞으로 뻗어 양 쪽 가장자리를 짚고 엎드린다.",
                "두 다리를 뻗어 머리부터 발까지 사선형태를 유지한 채 보수볼을 시계방향, 반시계방향으로 각각 5번씩 돌린다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0250",
            "title": "블레이더를 이용한 어깨 외회전/내회전 안정화 운동(Blade Oscillation external roation/internal rotation position)",
            "thumb": "/assets/thumbs/MS-Shoulder-0250.png",
            "guide": [
                "팔꿈치를 굽혀 블레이더를 세로로 잡고 좌우로 흔든다.",
                "팔꿈치를 굽힌 채 어깨를 90° 외전하여 블레이더를 수평으로 잡고 상하로 흔든다.",
                "각각 10~15초씩 실시하여 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0251",
            "title": "블레이더를 이용한 어깨 굴곡 안정화 운동(Blade Oscillation flexion position)",
            "thumb": "/assets/thumbs/MS-Shoulder-0251.png",
            "guide": [
                "한 손에 블레이드를 옆으로 잡고 선다.",
                "팔꿈치를 편 채 블레이드를 위아래로 흔들면서 팔을 45° 각도로 머리 위로 들어 올렸다(어깨굴곡) 내린다.",
                "10회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0206",
            "title": "밴드 프론트 스프린터(Front sprinter, band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0206.png",
            "guide": [
                "밴드를 등지고 서서 팔꿈치를 굽혀 밴드를 잡고 상체를 가볍게 앞으로 기울인다.",
                "팔꿈치를 굽힌 채 달리기 하듯 팔을 가슴앞으로 들어 올렸다 등 뒤로 보낸다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0232",
            "title": "볼 바운드 캐치(Ball Bounce and Catch - Single Arm, wall)",
            "thumb": "/assets/thumbs/MS-Shoulder-0232.png",
            "guide": [
                "벽을 보고 서서 한 손으로 볼을 잡아 팔꿈치를 90° 굽히고 어깨높이에 맞춰 옆으로 벌린다.(90° 외전)",
                "공을 벽을 향해 던졌다 받는다. 10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0233",
            "title": "외회전 신장성 볼 드롭(Shoulder External Rotator Ball Drops, eccentric)",
            "thumb": "/assets/thumbs/MS-Shoulder-0233.png",
            "guide": [
                "한 손에 공을 들고 서서 팔꿈치를 90° 굽혀 어깨높이에 맞춰 옆으로 벌린다.(90°외전)",
                "무릎을 굽히고 상체를 가볍게 앞으로 기울여 공을 바닥으로 떨어뜨렸다 공중에서 다시 잡는다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
    ],
    "throwers-shoulder": [
        {
            "id": "CB/CB-0019",
            "title": "케이블 어깨 PNF D1 패턴 운동",
            "thumb": "/assets/thumbs/CB-0019.png",
            "guide": [
                "케이블 옆으로 서서 안쪽 손으로 케이블 손잡이를 아래쪽에서 잡고 어깨를 외회전하여 팔을 45°로 옆으로 벌린다.(외전)",
                "팔꿈치를 편 채 어깨를 내회전하여 케이블을 머리 위 대각선 방향으로 당겨 올린다.(내전)",
                "어깨를 외전하면서 팔을 내려 시작위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "CB/CB-0020",
            "title": "케이블 어깨 PNF D2 패턴 운동",
            "thumb": "/assets/thumbs/CB-0020.png",
            "guide": [
                "케이블 옆으로 서서 바깥쪽 손으로 케이블 손잡이를 잡고 어깨를 내회전하여 팔을 45° 안쪽으로 뻗는다.(내전)",
                "팔꿈치를 편 채 어깨를 외회전하여 팔을 머리 위 대각선 방향으로 들어 올린다.(외전)",
                "어깨를 내회전하면서 팔을 내려 시작위치로 돌아온다.",
                "10~15회 반복하여 2세트 실시한다."
            ]
        },
        {
            "id": "CB/CB-0021",
            "title": "회전근개활성화-어깨 외회전 운동(Rotator cuff activation-External Rotation workout)",
            "thumb": "/assets/thumbs/CB-0021.png",
            "guide": [
                "케이블 옆으로 서서 바깥쪽 손으로 케이블 손잡이를 잡는다.",
                "케이블을 잡은 팔을 90°로 굽혀 몸 옆에 붙이고 전완(팔꿈치 아래)을 밖으로 회전한다.(어깨 외회전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "CB/CB-0022",
            "title": "어깨 내회전-케이블(Shoulder Internal rotation, cable)",
            "thumb": "/assets/thumbs/CB-0022.png",
            "guide": [
                "케이블 옆으로 서서 안쪽 손으로 손잡이를 잡고 팔꿈치를 90°로 굽혀 몸에 붙인다.",
                "상완(팔꿈치 위)을 고정한 채 전완(팔꿈치 아래)을 안쪽으로 회전(내회전)한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "CB/CB-0024",
            "title": "90도 어깨 외전 & 외회전-밴드(90 Degree Shoulder Abduction & External Rotation, Band)",
            "thumb": "/assets/thumbs/CB-0024.png",
            "guide": [
                "밴드 앞으로 서서 한 손으로 밴드를 잡는다.",
                "밴드를 잡은 팔을 어깨높이에 맞춰 옆으로 뻗어(90° 외전) 팔꿈치를 90°로 굽힌다.",
                "팔꿈치 위치를 고정한 채 밴드를 뒤쪽으로 끌어 당긴다.(어깨 외회전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0057",
            "title": "90도 외전 90도 어깨 내회전(Shoulder 90 degree abduction & internal rotation)",
            "thumb": "/assets/thumbs/GolfCon-0057(편집).png",
            "guide": [
                "케이블을 등지고 서서 한 손에 케이블(밴드)을 잡고 팔꿈치를 90°로 굽혀 어깨높이로 들어 올린다.(90° 외전)",
                "상완(위 팔)을 고정한 채 전완(아래 팔)을 앞쪽으로 90° 회전시킨다.(90° 내회전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0200",
            "title": "밴드 어깨 외전(Shoulder Abduction, band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0200.png",
            "guide": [
                "밴드 또는 케이블을 옆에서 잡고 선다. 팔을 벌려 옆으로 들어 올린다(어깨외전).",
                "10회 3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0016",
            "title": "스캡션(Scaption)",
            "thumb": "/assets/thumbs/Dumbbell-0016.png",
            "guide": [
                "양 손에 덤벨을 들고 팔을 벌려(양 팔의 각도 약 120°) 손을 이마높이까지 들어 올린 후 견갑골 사이를 수축시켰다 푼다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0019",
            "title": "엎드려 어깨 수평외전(Shoulder Horizontal abduction, prone)",
            "thumb": "/assets/thumbs/MS-Shoulder-0019.png",
            "guide": [
                "침대 가장자리에 엎드려 한 쪽 팔을 어깨와 수직으로 늘어뜨린다.",
                "팔을 수평으로 들어 올렸다 내린다. 10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0194",
            "title": "네발기기자세 밴드저항 한 팔 들기-밴드(Quadruped Single Arm Raise, band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0194.png",
            "guide": [
                "네 발 기기 자세로 엎드려 무릎으로 밴드를 고정하고 한 손으로 밴드를 잡는다.",
                "밴드를 잡은 팔을 110°~145° 범위 내에서 위로 뻗어 올린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0079",
            "title": "시티드 프레스업(Seated press up)",
            "thumb": "/assets/thumbs/MS-Shoulder-0079.png",
            "guide": [
                "벤치나 테이블 끝에서 두 팔로 벤치(테이블)을 지지하면서 몸을 들어 올린다.",
                "5~10초 유지한다. 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0263",
            "title": "엎드려 노젓기(prone rowing)",
            "thumb": "/assets/thumbs/MS-Shoulder-0263.png",
            "guide": [
                "베드 가장자리에 엎드려 한 손으로 덤벨을 들어 팔을 아래로 내린다.",
                "노를 젓듯 팔꿈치를 90°로 굽혀 덤벨을 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0213",
            "title": "푸시업(Push Up)",
            "thumb": "/assets/thumbs/MS-Shoulder-0213.png",
            "guide": [
                "팔을 어깨와 수직으로 뻗어 바닥을 짚고 엎드려 다리를 편다.",
                "머리부터 발까지 사선형태를 유지한 채 팔꿈치를 굽혀 몸을 아래로 내렸다 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "Dumbbell/Dumbbell-0002",
            title: "팔꿈치 굴곡-덤벨(Elbow Flexion-dumbbell)",
            thumb: "/assets/thumbs/Dumbbell-0002.png",
            guide: []
        },
        {
            "id": "Dumbbell/Dumbbell-0002",
            "title": "팔꿈치 굴곡-덤벨(Elbow Flexion-dumbbell)",
            "thumb": "/assets/thumbs/Dumbbell-0002.png",
            "guide": [
                "엄지손가락이 위로 향하게 하여 양 손에 덤벨을 들고 선다.",
                "팔꿈치를 굽혀 덤벨을 가슴까지 들어 올린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0023",
            "title": "손목 굴곡-덤벨(wrist curl, dumbbell)",
            "thumb": "/assets/thumbs/Dumbbell-0023.png",
            "guide": [
                "손바닥이 위를 향하게 하여 양 손에 덤벨을 들고 팔을 고정한다.",
                "손목에 힘을 빼 덤벨을 천천히 풀어 준 뒤(신전) 주먹을 쥐듯 손바닥으로 덤벨을 감싸며 손목을 말아 올린다.(굴곡)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0025",
            "title": "팔꿈치 회외, 외내-덤벨(Elbow Supination/Pronation, dumbbell)",
            "thumb": "/assets/thumbs/Dumbbell-0025.png",
            "guide": [
                "엄지손가락이 위로 향하도록 하여 덤벨을 들고 벤치나 테이블에 전완(아래팔)을 고정한다.",
                "손바닥이 위로 향하도록 손목을 밖으로 돌린다.(회외)",
                "다시 손바닥이 아래로 향하도록 손목을 안으로 돌린다.(회내)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0270",
            "title": "엎드려 어깨 외회전 90도 외전 90도(Shoulder External rotation 90degree abduction prone)",
            "thumb": "/assets/thumbs/MS-Shoulder-0270.png",
            "guide": [
                "한 손에 덤벨을 들고 베드 가장자리에 엎드린다.",
                "팔꿈치를 90° 굽힌 후 어깨높이에 맞춰 팔을 몸통 옆으로 90° 들어 올린다.(외전)",
                "상완(위 팔)을 고정한 채 어깨를 회전하여 덤벨을 등쪽으로 들어 올린다.(외회전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0158",
            "title": "옆으로 누워 어깨 외회전(Sidelying Shoulder External Rotation)",
            "thumb": "/assets/thumbs/MS-Shoulder-0158.png",
            "guide": [
                "옆으로 누워 위쪽 팔꿈치를 90°로 굽혀 허리에 붙인다.",
                "상완을 몸에 붙이고 팔꿈치 각도를 유지한 채 전완(팔꿈치 아래)을 바깥방향으로 회전한다.(어깨 외회전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0033",
            "title": "엎드려 어깨 신전(Shoulder Extension, dumbbell)",
            "thumb": "/assets/thumbs/MS-Shoulder-0033.png",
            "guide": [
                "베드 가장자리에 엎드려 한 손으로 덤벨을 잡아 팔을 아래로 늘어뜨린다.",
                "팔을 펴서 등 뒤쪽으로 들어 올렸다(어깨 신전) 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
    ],
    "postop-shoulder-rehab-1": [
        {
            "id": "MS/MS-Shoulder-0001",
            "title": "시계추 운동(Pendulum Exercise)",
            "thumb": "/assets/thumbs/MS-Shoulder-0001.png",
            "guide": [
                "상체를 앞으로 숙여 한 손으로 바닥을 짚고 환측 팔은 아래로 늘어뜨려 덤벨을 든다.",
                "천천히 시계 방향으로 원을 그리거나 앞/뒤, 옆으로 움직여 10회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0006",
            "title": "테이블 슬라이드 스트레치(Table Slide stretch)",
            "thumb": "/assets/thumbs/MS-Shoulder-0006.png",
            "guide": [
                "환측 손을 테이블 위에 올려 손 밑에 수건을 받친다.",
                "팔을 앞쪽으로 밀어내 광배근이 스트레치 되도록 한다. 10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0004",
            "title": "능동보조 어깨굴곡(Active assist shoulder flexion, wall walks)",
            "thumb": "/assets/thumbs/MS-Shoulder-0004.png",
            "guide": [
                "벽을 마주 보고 서서 환측 팔을 앞으로 뻗어 벽에 댄다.",
                "환측 팔을 통증 없는 범위까지 천천히 위쪽 방향으로 올려 5초간 유지한다.",
                "10회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0002",
            "title": "능동보조 어깨 굴곡(Active assist shoulder flexion)",
            "thumb": "/assets/thumbs/MS-Shoulder-0002.png",
            "guide": [
                "등을 대고 누워 팔을 뻗어 건측 손으로 환측 손목을 잡는다.",
                "건측 손으로 환측 팔을 머리 위로 천천히 밀어 올려(어깨굴곡) 5초간 유지한다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0003",
            "title": "능동보조 어깨 외회전(Active assist shoulder external rotation)",
            "thumb": "/assets/thumbs/MS-Shoulder-0003.png",
            "guide": [
                "환측 팔을  90° 정도 굽혀 테이블 위에 올린다.",
                "상완(팔꿈치 위)을 고정한 채 전완(팔꿈치 아래)을 바깥쪽으로 최대한 회전시켜 5초간 유지한다.",
                "10회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0005",
            "title": "능동보조 어깨 수평내전-후방관절낭 스트레치(Active assist shoulder horizontal adduction-Posterior capsul stretch)",
            "thumb": "/assets/thumbs/MS-Shoulder-0005.png",
            "guide": [
                "등을 대고 누워 가슴앞에서 건측 손으로 환측 팔꿈치를 잡는다.",
                "건측 손으로 환측 팔꿈치를 천천히 안쪽으로 끌어 당긴다.(수평내전)",
                "10~15초 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Static/Static-P-0006",
            "title": "하부승모근 자가근막이완-공(Lower Trapezius Self Myofascial Release, ball)",
            "thumb": "/assets/thumbs/Static-P-0006.png",
            "guide": [
                "테니스공 또는 마사지볼을 한 쪽 견갑골 아래에 두고 벽에 기대 뒤로 밀면서 30초~1분간 유지한다.",
                "3~5회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "TP/TP-0059",
            "title": "전거근 스트레치(Serratus Anterior stretch)",
            "thumb": "/assets/thumbs/TP-0059.png",
            "guide": [
                "벤치에 앉아 한 쪽 팔을 뒤로 뻗어 벤치 가장자리를 잡고 몸통을 내회전 한다.",
                "15초간 유지하여 3회 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "FR/FR-0030",
            "title": "폼롤러 흉부신전(Thoracic extension-Snow angel, Foam Roller)",
            "thumb": "/assets/thumbs/FR-0030.png",
            "guide": [
                "폼롤러 위에 누워 다리를 굽히고 손바닥이 위로 향하게 하여 양 팔을 바닥에 둔다.",
                "손등으로 바닥을 쓸듯이 팔을 머리 위로 올렸다(어깨 외전) 내린다.(어깨 내전)",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0015",
            "title": "흉근 스트레치, 벽(Pectoralis stretch, wall)",
            "thumb": "/assets/thumbs/Stretch-0015.png",
            "guide": [
                "팔을 90°로 굽혀 벽에 대고 상체를 앞으로 밀어 15초 유지한다.",
                "3회 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0128",
            "title": "어깨 90도 외전 & 외회전(Shoulder 90 degree abduction & external rotation)",
            "thumb": "/assets/thumbs/MS-Shoulder-0128.png",
            "guide": [
                "등을 대고 누워(또는 벽에 기대어) 팔을 어깨높이로 벌리고(90° 외전) 팔꿈치를 90°로 굽혀 세운다.",
                "참을 수 있는 통증범위까지 천천히 어깨를 외회전하여 손등을 최대한 바닥쪽으로 보낸다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0132",
            "title": "양 팔꿈치 잡고 외전/내전 (Shoulder Abduction/Adduction, cradle)",
            "thumb": "/assets/thumbs/MS-Shoulder-0132.png",
            "guide": [
                "오른쪽 손이 왼쪽 팔꿈치를, 왼쪽 손이 오른쪽 팔꿈치를 감싸도록 팔짱을 끼고 선다.",
                "상체를 가볍게 앞으로 숙이고 손으로 팔꿈치를 안쪽으로 당긴다.(수평내전/외전)",
                "좌우 번갈아가며 10~15회 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0130",
            "title": "밴드 저항 신전 스트레치(Anterior Shoulder stretch, band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0130.png",
            "guide": [
                "케이블을 등지고 서서 한 팔을 뒤로 뻗어 케이블 손잡이를 잡는다.",
                "통증이 없는 범위까지 천천히 몸을 앞으로 기울여 어깨 앞쪽이 스트레치 되도록 한다.",
                "10~15초 유지하고 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0010",
            "title": "봉을 이용한 90도 외회전(Shoulder External Rotation 90 degree, pole)",
            "thumb": "/assets/thumbs/MS-Shoulder-0010.png",
            "guide": [
                "등을 대고 누워 환측 팔을 어깨높이로 벌리고(90° 외전) 팔꿈치를 90°로 굽혀 세운다.",
                "건측 손으로 바(Bar)의 한 쪽을 잡고 반대쪽 끝을 환측 손바닥에 댄다.",
                "환측 손등이 바닥에 가까워지도록 천천히 바를 위로 밀어 올렸다 원위치로 돌아온다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0129",
            "title": "팔꿈치 잡고 굴곡/신전(Shoulder Flexion-Extension, cradle)",
            "thumb": "/assets/thumbs/MS-Shoulder-0129.png",
            "guide": [
                "오른손으로 왼쪽 팔꿈치를, 왼손으로 오른쪽 팔꿈치를 잡는다.",
                "팔꿈치를 머리 위로 들어 올렸다(굴곡) 내린다.(신전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0133",
            "title": "밴드저항 등척성 어깨외회전(Isometric Shoulder External Rotation with band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0133.png",
            "guide": [
                "한 쪽 팔꿈치를 90°로 굽혀 밴드를 옆으로 잡는다.",
                "팔꿈치를 유지한 채 천천히 몸통을 밴드 반대쪽으로 돌려 5초간 유지한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0008",
            "title": "봉을 이용한 어깨 외회전(Shoulder external rotation with stick)",
            "thumb": "/assets/thumbs/MS-Shoulder-0008.png",
            "guide": [
                "등을 대고 누워 양 팔을 90°도로 굽혀 세운다.",
                "건측 손으로 바(Bar)의 한 쪽을 잡고 반대쪽 끝을 환측 손바닥에 댄다.",
                "환측 손등이 바닥과 가까워지도록 바를 옆으로 밀어 5~10초간 유지하고, 10회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0135",
            "title": "밴드를 이용한 신전(Shoulder Flexion ROM, band-pulley)",
            "thumb": "/assets/thumbs/MS-Shoulder-0135.png",
            "guide": [
                "밴드를 위에서 고정하여 한 팔을 머리 위로 뻗어 밴드를 잡는다.(어깨 굴곡)",
                "천천히 팔꿈치를 굽혀 밴드를 아래로 당겼다(어깨 신전) 올린다.",
                "10~15회 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0008",
            "title": "광배근 자가근막이완(Latissimus dorsi Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0008.png",
            "guide": [
                "겨드랑이 사이에 폼롤러를 두고 옆으로 눕는다. 옆쪽으로 광배근을 압박하면서 30초~1분 내외로 폼롤러를 위아래로 굴린다. 3~5회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0137",
            "title": "밴드를 이용한 광배근 스트레치(Latissimus dorsi stretch, band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0137.png",
            "guide": [
                "밴드 앞으로 서서 팔을 뻗어 밴드를 잡는다.",
                "밴드의 탄성에 팔을 의지하고 천천히 상체를 앞으로 숙여 광배근을 스트레치 한다.",
                "15~20초 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0033",
            "title": "폼롤러 오버헤드 익스텐션(Overhead/Extension, Foam Roller)",
            "thumb": "/assets/thumbs/FR-0033.png",
            "guide": [
                "폼롤러를 수평(가로)으로 두고 등으로 기대어 눕는다. 양 팔을 머리 위로 뻗어 바닥 쪽으로 내리면서 흉추를 신전한다. 10초 유지하고 3회 반복한다."
            ]
        },
        {
            "id": "FR/FR-0032",
            "title": "어깨 90도 외전 외회전(Trunk Rotation Shoulder 90-90 degree, Foam Roller)",
            "thumb": "/assets/thumbs/FR-0032.png",
            "guide": [
                "폼롤러를 베고 누워 오른팔을 옆으로 벌려 팔꿈치를 90°로 굽히고 손을 폼롤러 밑으로 고정한다.",
                "오른쪽 무릎을 굽히고 왼손으로 잡아 안쪽 방향으로 당기면서 몸통을 회전한다.",
                "10~15초 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0029",
            "title": "소흉근 자가근막이완-공(Pectoralis Minor Self Myofascial Release, ball)",
            "thumb": "/assets/thumbs/TP-0029.mp4_000003258.png",
            "guide": [
                "테니스공 또는 마사지볼을 가슴과 쇄골 사이에 두고 벽에 기대 앞으로 밀면서 압박이완 한다.",
                "30초~1분 이내로 3~5회 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "FR/FR-0007",
            "title": "대흉근/소흉근 자가근막이완(Pectoralis Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0007.png",
            "guide": [
                "한 쪽 팔과 가슴 사이에 폼롤러를 두고 엎드려 앞쪽으로 흉근을 압박하면서 폼롤러를 30초~1분 내외로 굴린다. 양쪽 모두 실시하고 3~5회씩 반복한다."
            ]
        },
        {
            "id": "FR/FR-0009",
            "title": "전거근 자가근막이완(Serratus anterior Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0009.png",
            "guide": [
                "팔과 옆구리 사이에 폼롤러를 두고 엎드린다. 앞쪽으로 전거근을 압박하면서 30초~1분간 폼롤러를 위아래로 굴린다. 3~5회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0014",
            "title": "극하근 스트레치(Infraspinatus stretch-sidelying)",
            "thumb": "/assets/thumbs/Stretch-0014.png",
            "guide": [
                "옆으로 누워 아래쪽 팔을 가슴 앞으로 보낸다.",
                "아래쪽 팔꿈치를 굽혀 손바닥이 앞을 향하도록 수직으로 세우고 반대쪽 손으로 손등을 잡아 아래로 밀어 내린다.",
                "15초 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0020",
            "title": "네발기기자세 어깨 수평내전(Horizontal adduction, Quadruped-Thread The Needle)",
            "thumb": "/assets/thumbs/Stretch-0020.png",
            "guide": [
                "네 발 기기 자세로 엎드려 한 쪽 팔을 어깨가 바닥에 닿을 때까지 안쪽으로 뻗는다.(수평내전)",
                "15초간 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0180",
            "title": "엎드려 견갑골 외전 슬라이드(Prone Scapula Press - Abduction Slide)",
            "thumb": "/assets/thumbs/MS-Shoulder-0180.png",
            "guide": [
                "바닥에 엎드려 환측 손바닥 아래에 잘 미끄러질 수 있는 수건을 둔다.",
                "팔꿈치를 편 채 견딜 수 있는 통증 범위까지 팔을 머리 위쪽으로 밀어 올린다.(외전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0181",
            "title": "밴드 보조 오버헤드 굴곡(Overhead Assisted Shoulder Flexion with band, Supine)",
            "thumb": "/assets/thumbs/MS-Shoulder-0181.png",
            "guide": [
                "머리 위쪽으로 밴드를 두고 누워 한 쪽 손으로 밴드를 잡는다.",
                "팔꿈치를 굽혀 밴드를 아래로 당긴 후 팔꿈치를 편다.",
                "밴드의 탄성을 이용해 천천히 팔을 가능한 범위까지 위로 들어 올린다.(어깨 굴곡)",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0182",
            "title": "누워 밴드 보조 오버헤드 외전(Overhead Assisted Shoulder Abduction with band, Supine)",
            "thumb": "/assets/thumbs/MS-Shoulder-0182.png",
            "guide": [
                "머리 위쪽으로 밴드를 두고 누워 한 손으로 밴드를 잡는다.",
                "팔꿈치를 굽혀 밴드를 당긴 후 팔꿈치를 편다.",
                "밴드의 탄성을 이용해 천천히 팔을 가능한 범위까지 옆으로 뻗어 올린다.(어깨 외전)",
                "10~15회 3세트 반복한다."
            ]
        },
    ],
    "postop-shoulder-rehab-2": [
        {
            "id": "MS/MS-Shoulder-0022",
            "title": "등척성 어깨 신전(Isometric Shoulder extension)",
            "thumb": "/assets/thumbs/MS-Shoulder-0022.png",
            "guide": [
                "벽을 등지고 서서 한 팔을 뒤로 뻗어 벽을 짚고 밀면서 5초간 유지한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0024",
            "title": "등척성 어깨 내회전(Isometric shoulder internal rotation)",
            "thumb": "/assets/thumbs/MS-Shoulder-0024.png",
            "guide": [
                "벽 앞으로 서서 한 팔을 90°로 굽혀 손바닥을 벽에 댄다.",
                "벽을 밀어내듯 전완(팔꿈치 아래)을 안쪽으로 회전하여(어깨 내회전) 5초간 유지한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0025",
            "title": "등척성 어깨내전(Isometric shoulder adduction)",
            "thumb": "/assets/thumbs/MS-Shoulder-0025.png",
            "guide": [
                "팔을 90°로 굽혀 쿠션을 팔 안쪽에 둔다.",
                "팔을 몸통쪽으로 끌어당겨(어깨 내전) 5초간 유지한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0026",
            "title": "등척성 어깨외전(Isometric shoulder abduction)",
            "thumb": "/assets/thumbs/MS-Shoulder-0026.png",
            "guide": [
                "팔을 90°로 굽혀 벽과 팔 사이에 쿠션을 둔다.",
                "팔을 바깥쪽으로 밀어(어깨 외전) 5초간 유지한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0152",
            "title": "무게 없이 한 팔 벤트오버 로우(Single Arm Bent over Row, unweighted)",
            "thumb": "/assets/thumbs/MS-Shoulder-0152.png",
            "guide": [
                "무릎을 가볍게 굽히고 상체를 앞으로 기울이고 선다.(테이블에 한 손을 짚어도 좋다)",
                "한 팔을 아래로 뻗은 후 팔꿈치를 굽혀 등쪽으로 팔을 당겨 올렸다 내린다.",
                "10~15회 3세트 반복한다."
            ]
        },

        {
            "id": "MS/MS-Shoulder-0016",
            "title": "한 팔 전인운동(shoulder protraction, supine)",
            "thumb": "/assets/thumbs/MS-Shoulder-0016.png",
            "guide": [
                "등을 대고 누워 환측 팔을 가슴앞으로 뻗어 최대한 위로 밀어 올렸다 내린다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0154",
            "title": "무게 없이 한 팔 체스트프레스(Single Arm Chest Press, unweighted supine)",
            "thumb": "/assets/thumbs/MS-Shoulder-0154.png",
            "guide": [
                "등을 대고 누워 양 팔을 가슴 앞으로 뻗는다.",
                "팔꿈치를 90°로 굽혀 팔꿈치를 바닥쪽으로 끌어내렸다 올린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0108",
            "title": "옆으로 누워 팔꿈치 90도 굴곡 외전(Sidelying Abduction, short lever)",
            "thumb": "/assets/thumbs/MS-Shoulder-0108.png",
            "guide": [
                "옆으로 누워 위쪽 팔꿈치를 90°로 굽혀 몸 옆에 붙인다.",
                "팔꿈치를 90°로 유지한 채 천천히 팔을 어깨 위쪽으로 들어 올렸다(어깨 외전) 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },

        {
            "id": "MS/MS-Shoulder-0017",
            "title": "누워 굴곡(Shoulder Flexion, Supine)",
            "thumb": "/assets/thumbs/MS-Shoulder-0017.png",
            "guide": [
                "등을 대고 누워 참을 수 있는 통증범위까지 팔을 머리 위로 뻗어 올렸다(어깨굴곡) 내린다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0018",
            "title": "저항없이 어깨 굴곡(Shoulder Flexion, unweighted)",
            "thumb": "/assets/thumbs/MS-Shoulder-0018.png",
            "guide": [
                "어깨 관절운동범위(Range Of Motion)까지 천천히 팔을 머리 위쪽으로 뻗어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0158",
            "title": "옆으로 누워 어깨 외회전(Sidelying Shoulder External Rotation)",
            "thumb": "/assets/thumbs/MS-Shoulder-0158.png",
            "guide": [
                "옆으로 누워 위쪽 팔꿈치를 90°로 굽혀 허리에 붙인다.",
                "상완을 몸에 붙이고 팔꿈치 각도를 유지한 채 전완(팔꿈치 아래)을 바깥방향으로 회전한다.(어깨 외회전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0159",
            "title": "누워 수평내전/외전(Shoulder Horizontal Ab/Adduction, Supine)",
            "thumb": "/assets/thumbs/MS-Shoulder-0159.png",
            "guide": [
                "등을 대고 누워 양 팔을 가슴앞으로 뻗는다.",
                "팔꿈치를 편 채 양 팔을 천천히 바닥쪽으로 내렸다(외전) 들어 올린다.(내전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0160",
            "title": "어깨 외전 90도(Shoulder Abduction 90 deg, unweighted)",
            "thumb": "/assets/thumbs/MS-Shoulder-0160.png",
            "guide": [
                "팔을 펴서 옆으로 90°까지 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },

        {
            "id": "MS/MS-Shoulder-0105",
            "title": "밴드저항 한 팔 후인(Single Arm Scapular Retraction with band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0105.png",
            "guide": [
                "가슴 높이로 팔을 앞으로 뻗어 밴드를 잡는다.",
                "팔꿈치를 편 채 밴드를 등쪽으로 당겼다(후인) 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0033",
            "title": "엎드려 어깨 신전(Shoulder Extension, dumbbell)",
            "thumb": "/assets/thumbs/MS-Shoulder-0033.png",
            "guide": [
                "베드 가장자리에 엎드려 한 손으로 덤벨을 잡아 팔을 아래로 늘어뜨린다.",
                "팔을 펴서 등 뒤쪽으로 들어 올렸다(어깨 신전) 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0034",
            "title": "네발기기자세 체중이동(Quadruped weight shift)",
            "thumb": "/assets/thumbs/MS-Shoulder-0034.png",
            "guide": [
                "네 발 기기 자세로 엎드린다.",
                "몸을 앞쪽으로 기울여 체중을 앞으로 이동시켰다 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0154",
            "title": "네발기기자세 한 팔 들기(Quadruped Single Arm Raise)",
            "thumb": "/assets/thumbs/MS-Lumbar-0154.png",
            "guide": [
                "네 발 기기 자세로 엎드려 벽과 엉덩이 사이에 짐볼을 둔다.",
                "엉덩이로 짐볼을 고정한 채 팔을 앞으로 110°~145°로 뻗어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },

        {
            "id": "MS/MS-Shoulder-0067",
            "title": "누워 메디신볼 회전(Medicine ball circle, supine)",
            "thumb": "/assets/thumbs/MS-Shoulder-0067.png",
            "guide": [
                "누워 환측에 메디신 볼을 어깨에서 수직으로 잡고 알파벳 또는 이름을 그리거나 오른쪽 왼쪽으로 각각 10회씩 원을 그린다.",
                "3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0104",
            "title": "한 팔 신장성 로우(Single Arm Row with band, eccentric)",
            "thumb": "/assets/thumbs/MS-Shoulder-0104.png",
            "guide": [
                "환측 팔을 가슴 앞으로 뻗어 밴드를 잡고 건측 손으로 밴드를 몸쪽으로 끌어 당긴다.",
                "건측 손을 떼고 환측 팔로 밴드의 탄성을 유지하면서 천천히 팔꿈치를 편다.",
                "10~15회 반복 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0106",
            "title": "바를 잡고 한 팔 전인(Single Arm Scapular Row, bar)",
            "thumb": "/assets/thumbs/MS-Shoulder-0106.png",
            "guide": [
                "손으로 바를 잡고 서서 팔꿈치를 편 채 어깨를 뒤로 밀어 5초간 유지한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0107",
            "title": "엎드려 한 팔 풀다운(Single Arm Skydive)",
            "thumb": "/assets/thumbs/MS-Shoulder-0107.png",
            "guide": [
                "바닥에 엎드려 한 쪽 팔을 펴서 최대한 골반 아래쪽으로 끌어 내려 5초간 유지한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0197",
            "title": "싱글암 로우(Single Arm Row with band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0197.png",
            "guide": [
                "어깨높이에 맞춰 팔을 앞으로 뻗어 밴드를 잡는다.",
                "팔꿈치 굽혀 밴드들 등쪽으로 끌어 당겼다 팔꿈치를 펴며 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },

        {
            "id": "Static/Static-P-0033",
            "title": "전거근 활성화(Serratus anterior activation-Window Washer or medicine ball circle)",
            "thumb": "/assets/thumbs/Static-P-0033.png",
            "guide": [
                "어깨높이에 맞춰 팔을 앞으로 뻗어 메디슨볼을 가볍게 누르면서 시계방향, 반시계방향으로 돌린다.",
                "10번씩 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0115",
            "title": "신장성 어깨외전(Shouder Abduction with band, eccentric",
            "thumb": "/assets/thumbs/MS-Shoulder-0115.png",
            "guide": [
                "환측 손으로 밴드를 잡고 건측 손으로 밴드를 옆으로 끌어올려 환측 어깨를 외전시킨다.",
                "건측 손을 떼고 환측 팔로 밴드의 탄성을 유지하면서 천천히 팔을 아래로 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0116",
            "title": "밴드 어깨신전(Shoulder Extension with band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0116.png",
            "guide": [
                "팔을 몸 옆으로 내려 밴드를 잡는다.",
                "상체를 가볍게 앞으로 기울이고 팔꿈치를 편 채 밴드를 뒤쪽으로 끌어 당긴다.(어깨 신전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0133",
            "title": "밴드저항 등척성 어깨외회전(Isometric Shoulder External Rotation with band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0133.png",
            "guide": [
                "한 쪽 팔꿈치를 90°로 굽혀 밴드를 옆으로 잡는다.",
                "팔꿈치를 유지한 채 천천히 몸통을 밴드 반대쪽으로 돌려 5초간 유지한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },

        {
            "id": "MS/MS-Shoulder-0027",
            "title": "어깨 내회전-덤벨(Shoulder Internal rotation, dumbbell)",
            "thumb": "/assets/thumbs/MS-Shoulder-0027.png",
            "guide": [
                "환측(통증이 있는 어깨) 팔이 밑으로 가도록 옆으로 눕는다.",
                "팔꿈치를 90°로 굽히고 손으로 덤벨을 잡는다.",
                "상완(팔꿈치 위)을 바닥에 고정한 채 덤벨을 위쪽으로 천천히 들어 올렸다(내회전) 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0009",
            "title": "어깨 외회전-덤벨(Shoulder External rotation, dumbbell)",
            "thumb": "/assets/thumbs/Dumbbell-0009.png",
            "guide": [
                "환측(통증이 있는 어깨) 팔이 위로 가도록 옆으로 눕는다.",
                "팔을 90°로 굽혀 팔꿈치 아래 수건을 받치고 손으로 덤벨을 잡는다.",
                "상완(팔꿈치 위)을 고정한 채 덤벨을 아래로 내렸다 천천히 위로 들어 올린다.(외회전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "CB/CB-0021",
            title: "어깨 외회전-케이블(Shoulder External rotation, cable)",
            thumb: "/assets/thumbs/CB-0021.png",
            guide: []
        },
        {
            "id": "CB/CB-0021",
            "title": "어깨 외회전-케이블(Shoulder External rotation, cable)",
            "thumb": "/assets/thumbs/CB-0021.png",
            "guide": [
                "케이블 옆으로 서서 바깥쪽 손으로 케이블 손잡이를 잡는다.",
                "케이블을 잡은 팔을 90°로 굽혀 몸 옆에 붙이고 전완(팔꿈치 아래)을 밖으로 회전한다.(어깨 외회전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0016",
            "title": "스캡션(Scaption)",
            "thumb": "/assets/thumbs/Dumbbell-0016.png",
            "guide": [
                "양 손에 덤벨을 들고 선다.",
                "가슴 앞에서 넓은 V자(양 손의 각도 약 120°) 형태로 팔을 이마 높이까지 들어 올린다.",
                "견갑골에 힘을 주었다 풀고 팔을 내려 시작위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },

        {
            "id": "MS/MS-Shoulder-0178",
            "title": "하부승모근 활성화(lower trapezius activation, Lower trapezius raise)",
            "thumb": "/assets/thumbs/MS-Shoulder-0178.png",
            "guide": [
                "바닥에 엎드려 한 쪽 팔을 125° 외전시켜 들어 올린다.",
                "10회 2~3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0066",
            "title": "네발기기자세 공을 이용한 한 팔 견갑대 전인(Single Arm Scapula Press with ball, Quadruped)",
            "thumb": "/assets/thumbs/MS-Shoulder-0066.png",
            "guide": [
                "네 발 기기 자세로 엎드려 손바닥으로 쿠션볼을 짚는다.",
                "팔꿈치를 편 채 손바닥으로 쿠션볼을 압박하면서(전인) 5초간 유지한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0174",
            "title": "누워 볼 받치고 등척성 어깨외회전(Shoulder External Rotation Isometric with ball, Supine)",
            "thumb": "/assets/thumbs/MS-Shoulder-0174.png",
            "guide": [
                "바닥에 등을 대고 누워 팔을 옆으로 뻗어 팔꿈치를 90°로 굽힌 후 손등 아래 쿠션볼을 놓는다.",
                "손등으로 쿠션볼을 바닥쪽으로 밀면서 5초간 유지한다.",
                "10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0176",
            "title": "엎드려 두 팔 풀다운(Skydive)",
            "thumb": "/assets/thumbs/MS-Shoulder-0176.png",
            "guide": [
                "바닥에 엎드려 두 팔을 골반 아래쪽으로 끌어 당기듯 내려 5초간 유지한다.",
                "10회 반복하여 3세트 실시한다."
            ]
        },
        {
            id: "MS/MS-Shoulder-0071",
            title: "짐볼 벽 대고 한 팔 회전(Single Arm Scapula Circles with Stability ball, Wall)",
            thumb: "/assets/thumbs/MS-Shoulder-0071.png",
            guide: [
                "한 팔을 가슴앞으로 뻗어 손바닥으로 짐볼을 짚어 가볍게 누른다.",
                "팔꿈치를 편 채 짐볼을 좌/우로 각각 10회씩 돌리고, 3세트 반복한다."
            ]
        }
    ],

    "postop-shoulder-rehab-3": [
        {
            "id": "FitBW/FitBW-0004",
            "title": "새사냥개 운동(Bird dog exercise)",
            "thumb": "/assets/thumbs/FitBW-0004.png",
            "guide": [
                "네 발 기기 자세로 엎드린다.",
                "오른쪽 팔을 귀높이로 뻗어 올리고, 왼쪽 다리를 엉덩이 높이로 뻗어 올려 20초간 유지한다.",
                "손발을 바꿔 실시하고 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0193",
            "title": "등척성 한 팔 벽밀기(Single Arm Press, wall)",
            "thumb": "/assets/thumbs/MS-Shoulder-0193.png",
            "guide": [
                "벽을 마주보고 서서 한 팔을 가슴앞으로 뻗어 손바닥으로 벽을 짚는다.",
                "팔꿈치를 굽히면서 몸을 앞으로 기울여 5~10초간 유지한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0194",
            "title": "네발기기자세 밴드저항 한 팔 들기-밴드(Quadruped Single Arm Raise, band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0194.png",
            "guide": [
                "네 발 기기 자세로 엎드려 무릎으로 밴드를 고정하고 한 손으로 밴드를 잡는다.",
                "밴드를 잡은 팔을 110°~145° 범위 내에서 위로 뻗어 올린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0183",
            "title": "누워 밴드저항 90도 외전 외회전(Shoulder External Rotation 90 deg with band, Supine)",
            "thumb": "/assets/thumbs/MS-Shoulder-0183.png",
            "guide": [
                "등을 대고 누워 팔을 어깨높이에 맞춰 옆으로 뻗어(90°외전) 팔꿈치를 90°로 굽혀 세우고 밴드를 잡는다.",
                "밴드를 잡은 손의 손등이 바닥에 닿도록 밴드를 당긴다.(90° 외회전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0184",
            "title": "폴롤러에서 덤벨 45도 내회전/외회전(Shoulder Int/Ext Rotation 45 deg with dumbbell, Foam Roller)",
            "thumb": "/assets/thumbs/MS-Shoulder-0184.png",
            "guide": [
                "폼롤러를 세로로 두고 누워 팔을 몸옆에 붙이고 팔꿈치를 90°로 굽혀 덤벨을 잡는다.",
                "팔꿈치를 몸에 고정한 채 덤벨을 천천히 바닥쪽으로 내렸다 올린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0185",
            "title": "누워 짐볼 벽에 두고 등척성 푸시(Isometric Ball To Wall Press, supine)",
            "thumb": "/assets/thumbs/MS-Shoulder-0185.png",
            "guide": [
                "벽쪽에 머리를 두고 누워 한 팔을 위로 뻗어 손과 벽 사이에 짐볼을 둔다.",
                "팔꿈치를 편 채 손으로 짐볼을 벽쪽으로 밀면서 5초간 유지한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0186",
            "title": "네발기기 자세 밴드전인(Quadruped Scapular press with band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0186.png",
            "guide": [
                "네 발 기기 자세로 엎드려 밴드를 등 뒤에 걸고 양 끝을 손으로 고정한다.",
                "팔꿈치를 편 채 어깨를 내렸다 올린다. 10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0187",
            "title": "보수볼 무릎굽혀 푸시업(Knee Push Up, BOSU)",
            "thumb": "/assets/thumbs/MS-Shoulder-0187.png",
            "guide": [
                "보수볼 바닥을 위로 가게 하여 양 손으로 짚고 엎드려 무릎을 굽힌다.",
                "머리부터 무릎까지 사선형태를 유지한 채 팔꿈치를 굽혀 몸을 아래로 내렸다 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다.",
                "※ 근력에 따라 무릎을 펴고 수행한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0188",
            "title": "엎드려 견갑하근 리프트(Subscapular Lifts, prone)",
            "thumb": "/assets/thumbs/MS-Shoulder-0188.png",
            "guide": [
                "바닥에 엎드려 한 팔을 뒤로 보내 팔꿈치를 굽혀 손등을 허리에 댄다.",
                "팔 전체를 허리에서 띄운다. 10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0189",
            "title": "누워 밴드저항 한 팔 전인(Supine Single Arm Scapula Press, band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0189.png",
            "guide": [
                "등을 대고 누워 바닥쪽에 밴드를 고정하여 손으로 밴드를 잡는다.",
                "밴드를 잡은 팔을 가슴앞으로 뻗어 팔꿈치를 편 채 밴드를 밀어 올린다.(전인)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0190",
            "title": "누워 한 팔 케틀벨 전인(Supine Single Arm Press, Kettlebell)",
            "thumb": "/assets/thumbs/MS-Shoulder-0190.png",
            "guide": [
                "등을 대고 누워 손으로 캐틀벨을 잡아 팔을 가슴앞으로 뻗는다.",
                "팔꿈치를 편 채 케틀벨을 위로 밀어 올린다.(전인)",
                "10~15회 반복하여 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0194",
            "title": "중부, 하부승모근 활성화-네발기기자세 밴드 Y자세(Lower Trapezius activation- Quadruped Band Y Position)",
            "thumb": "/assets/thumbs/MS-Shoulder-0194.png",
            "guide": [
                "한 손에 밴드를 잡고 네 발 기기 자세로 엎드려 팔을 대각선 방향으로 뻗어 귀높이로 올린다.",
                "10회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0195",
            "title": "싱글암 덤벨 체스트프레스-폼롤러(Single Arm Dumbbell Chest Press, Foam Roller)",
            "thumb": "/assets/thumbs/MS-Shoulder-0195.png",
            "guide": [
                "폼롤러 위에 누워 한 손으로 캐틀벨을 잡는다.",
                "팔꿈치를 굽혀 캐틀벨을 가슴높이까지 내렸다 팔을 가슴앞으로 뻗어 올린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "CB/CB-0017",
            "title": "싱글암 벤트오버 케이블 로우(Bent over Single Arm Cable Row)",
            "thumb": "/assets/thumbs/CB-0017.png",
            "guide": [
                "무릎을 굽히고 서서 상체를 앞으로 숙이고 한 쪽 팔을 뻗어 아래쪽에서 케이블을 잡는다.",
                "팔꿈치를 굽혀 등쪽으로 케이블을 끌어 올렸다 내린다.",
                "10~15회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0197",
            "title": "싱글암 로우(Single Arm Row with band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0197.png",
            "guide": [
                "어깨높이에 맞춰 팔을 앞으로 뻗어 밴드를 잡는다.",
                "팔꿈치 굽혀 밴드들 등쪽으로 끌어 당겼다 팔꿈치를 펴며 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0198",
            "title": "네발기기 자세 한 팔 견갑대 전인(Single Arm Scapula Press in Quadruped, band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0198.png",
            "guide": [
                "네발기기 자세에서 밴드를 등으로 돌려 환측 손에 밴드를 고정한다.",
                "상체를 바닥쪽으로 내렸다 올린다. 이때 팔이 굽혀지면 안된다. 10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0199",
            "title": "싱글암 밴드 업라이트 Y자세(Single Arm Upright Ys band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0199.png",
            "guide": [
                "케이블 앞으로 서서 한 손으로 케이블 손잡이를 잡는다.",
                "팔꿈치를 편 채 팔을 125°~145°(Y자 형태) 각도로 머리 위로 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0200",
            "title": "밴드 어깨 외전(Shoulder Abduction, band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0200.png",
            "guide": [
                "밴드 또는 케이블을 옆에서 잡고 선다. 팔을 벌려 옆으로 들어 올린다(어깨외전).",
                "10회 3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0014",
            "title": "벽에 기대어 밴드저항 월 슬라이드(Band Wall Slide)",
            "thumb": "/assets/thumbs/Band-0014.png",
            "guide": [
                "팔꿈치를 굽혀 가슴높이에서 양 손에 링밴드를 끼우고 팔을 벌려 벽에 기댄다.",
                "자세를 유지한 채 천천히 팔꿈치를 펴면서 가볍게 벽을 쓸듯이 팔을 머리 위로 올렸다 내린다.",
                "3~5회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0202",
            "title": "밴드 어깨 내전(Shoulder Adduction, band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0202.png",
            "guide": [
                "밴드 옆으로 서서 안쪽 팔을 옆으로 벌려 밴드를 잡는다.(외전)",
                "팔꿈치를 편 채 밴드를 몸쪽으로 끌어 내린다.(내전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0203",
            "title": "45도 어깨 외전 & 90도 어깨 외회전(45 Degree Shoulder Abduction & 90 degree Shoulder External Rotation, band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0203.png",
            "guide": [
                "밴드 옆으로 서서 바깥쪽 손으로 밴드를 잡는다.",
                "밴드를 잡은 팔을 옆으로 약간 벌리고(45° 외전) 팔꿈치를 90°로 굽힌다.",
                "팔의 각도를 유지한 채 밴드를 바깥쪽으로 당긴다.(90° 외회전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0207",
            "title": "폼롤러에서 덤벨 어깨 90도 외전 & 외회전(Shoulder External Rotation 90 degree, Foam Roller)",
            "thumb": "/assets/thumbs/MS-Shoulder-0207.png",
            "guide": [
                "폼롤러 위에 누워 손에 덤벨을 든다.",
                "덤벨을 든 팔을 어깨높이에 맞춰 옆으로 뻗어(90°외전) 팔꿈치를 90°로 굽혀 세운다.",
                "팔꿈치 각도를 90°로 유지한 채 손등이 바닥에 가까워 지도록 천천히 내렸다(외회전) 올린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0208",
            "title": "밴드 45도 내회전(Shoulder Internal Rotation 45 Degree, band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0208.png",
            "guide": [
                "밴드를 등지고 서서 한 손으로 밴드를 잡는다.",
                "밴드를 잡은 팔을 옆으로 약간 벌려(45° 외전) 팔꿈치를 90°로 굽힌다.",
                "팔의 각도를 유지한 채 밴드를 앞쪽으로 당긴다.(내회전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0114",
            "title": "밴드저항 한 팔 풀다운(Single Arm Vertical Pull Down)",
            "thumb": "/assets/thumbs/MS-Shoulder-0114.png",
            "guide": [
                "머리 위로 팔을 뻗어 밴드를 잡는다.",
                "팔꿈치를 편 채 밴드를 아래쪽으로 끌어 내렸다(어깨 신전) 시작 위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0211",
            "title": "어깨 내회전 외회전 진동(Shoulder Int-Ext Oscillations 90 Deg)",
            "thumb": "/assets/thumbs/MS-Shoulder-0211.png",
            "guide": [
                "한 손에 밴드를 잡고 선다.",
                "밴드를 잡은 팔을 어깨높이에 맞춰 옆으로 뻗어 팔꿈치를 90°로 굽힌다.",
                "팔꿈치 각도를 90°로 유지한 채 어깨를 앞뒤로 짧고 빠르게 움직인다.(진동)",
                "10~15초 유지하여 3~5세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0212",
            "title": "누워 오버헤드 어깨 외전(Overhead Shoulder Abduction with band, Supine)",
            "thumb": "/assets/thumbs/MS-Shoulder-0212.png",
            "guide": [
                "등을 대고 누워 다리쪽으로 밴드를 고정하여 손으로 잡는다.",
                "팔꿈치를 편 채 밴드를 당기면서 손등으로 바닥을 쓸며 팔을 머리 위쪽으로 끌어 올린다.(외전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0213",
            "title": "푸시업(Push Up)",
            "thumb": "/assets/thumbs/MS-Shoulder-0213.png",
            "guide": [
                "팔을 어깨와 수직으로 뻗어 바닥을 짚고 엎드려 다리를 편다.",
                "머리부터 발까지 사선형태를 유지한 채 팔꿈치를 굽혀 몸을 아래로 내렸다 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "CB/CB-0018",
            "title": "싱글암 케이블 리버스 플라이(Single Arm Cable reverse fly-Horizontal abduction)",
            "thumb": "/assets/thumbs/CB-0018.png",
            "guide": [
                "한 손(또는 양손)으로 케이블을 아래쪽에서 잡고 상체를 가볍게 앞으로 기울인다.",
                "팔을 어깨높이에 맞춰 옆으로 뻗으면서 케이블을 뒤로 당긴다.(Reverse Fly)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0215",
            "title": "서서 짐볼 굴리기(90 Degree Shoulder Abduction Ball circle)",
            "thumb": "/assets/thumbs/MS-Shoulder-0215.png",
            "guide": [
                "벽을 마주보고 서서 한 팔을 어깨높이에 맞춰 옆으로 뻗어 팔꿈치를 90°로 굽힌다.",
                "벽에 짐볼을 대고 손바닥으로 고정하여 가볍게 압박하면서 좌우로 각각 10회씩 돌린다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0016",
            "title": "스캡션(Scaption)",
            "thumb": "/assets/thumbs/Dumbbell-0016.png",
            "guide": [
                "양 손에 덤벨을 들고 팔을 벌려(양 팔의 각도 약 120°) 손을 이마높이까지 들어 올린 후 견갑골 사이를 수축시켰다 푼다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0013",
            "title": "밴드 어깨 수평외전(Horizontal abduction with band)",
            "thumb": "/assets/thumbs/Band-0013.png",
            "guide": [
                "밴드를 양손에 쥐고 어깨 너비 정도로 팔을 펼쳐 앞으로 들어 올려준다. 견갑골을 쥐어 짜면서 밴드를 바깥쪽으로 탄성이 느껴질 정도로 늘려준다. 처음 자세로 돌아온다. 10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0180",
            "title": "엎드려 견갑골 외전 슬라이드(Prone Scapula Press - Abduction Slide)",
            "thumb": "/assets/thumbs/MS-Shoulder-0180.png",
            "guide": [
                "바닥에 엎드려 환측 손바닥 아래에 잘 미끄러질 수 있는 수건을 둔다.",
                "팔꿈치를 편 채 견딜 수 있는 통증 범위까지 팔을 머리 위쪽으로 밀어 올린다.(외전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0219",
            "title": "플랭크 자세에서 전인(Scapula Press -Full Plank)",
            "thumb": "/assets/thumbs/MS-Shoulder-0219.png",
            "guide": [
                "팔꿈치를 90°로 굽혀 어깨와 수직으로 바닥을 짚고 엎드려 다리를 편다.(플랭크 자세)",
                "머리부터 발까지 수평형태를 유지한 채 몸을 바닥쪽으로 내렸다(전인) 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "TRX/TRX-0004",
            "title": "TRX 로우(TRX Scapula Row)",
            "thumb": "/assets/thumbs/TRX-0004.png",
            "guide": [
                "팔을 가슴앞으로 뻗어 TRX 손잡이를 잡고 몸 전체를 뒤로 기울여 머리부터 발까지 사선형태를 만든다.",
                "팔을 몸 옆에 붙여 팔꿈치를 굽히면서 몸을 끌어 올렸다 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다.",
                "※ 초기에는 TRX길이를 짧게 하여(몸이 가볍게 기운 상태) 낮은 강도로 운동하고, 근력에 따라 길이를 늘린다."
            ]
        },
    ],


    "postop-shoulder-rehab-4": [
        {
            "id": "CB/CB-0024",
            "title": "어깨 90도 외전 90도 외회전(shoulder external rotation 90degree abduction)",
            "thumb": "/assets/thumbs/CB-0024.png",
            "guide": [
                "한 손에 케이블(밴드)을 앞에서 잡고 팔꿈치를 90°로 굽혀 어깨높이로 들어 올린다.(90° 외전)",
                "상완(위 팔)을 고정한 채 전완(아래 팔)을 뒤쪽으로 90° 회전시킨다.(90° 외회전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0205",
            "title": "밴드 프론트 프레스(Front Press)",
            "thumb": "/assets/thumbs/MS-Shoulder-0205.png",
            "guide": [
                "밴드를 등지고 서서 팔꿈치를 굽혀 밴드를 잡는다.",
                "팔을 앞으로 밀면서 밴드를 당겨 팔을 머리 위로 뻗어 올렸다 시작위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0206",
            "title": "밴드 프론트 스프린터(Front sprinter, band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0206.png",
            "guide": [
                "밴드를 등지고 서서 팔꿈치를 굽혀 밴드를 잡고 상체를 가볍게 앞으로 기울인다.",
                "팔꿈치를 굽힌 채 달리기 하듯 팔을 가슴앞으로 들어 올렸다 등 뒤로 보낸다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0222",
            "title": "싱글암 TRX 신장성 풀(Single Arm Eccentric TRX Pull)",
            "thumb": "/assets/thumbs/MS-Shoulder-0222.png",
            "guide": [
                "양 팔을 가슴 앞으로 뻗어 TRX 손잡이를 잡고 몸을 살짝 뒤로 기울인다.",
                "양쪽 팔꿈치를 굽혀 몸을 끌어 올린 후 한 쪽 팔꿈치를 펴서 힘을 뺀다.",
                "반대쪽 팔꿈치를 천천히 펴 체중저항을 유지하면서 원위치로 돌아온다.",
                "팔을 번갈아 가며 10~15회 반복하고, 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0224",
            "title": "밴드 대각선 어깨굴곡(Band Diagonals Shoulder flexion)",
            "thumb": "/assets/thumbs/MS-Shoulder-0224.png",
            "guide": [
                "팔을 대각선 방향 아래로 뻗어 밴드를 골반 앞에서 잡는다.",
                "팔꿈치를 90° 굽혀 어깨높이에 맞춰 옆으로 벌리면서(90° 외전) 팔을 들어 올린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0226",
            "title": "프론트 프레스II(Front Press lateral, band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0226.png",
            "guide": [
                "밴드를 등지고 서서 한 손으로 밴드를 잡아 팔꿈치를 굽힌다.",
                "팔꿈치를 펴면서 팔을 머리 위로 뻗어 올렸다 팔꿈치를 굽히면서 처음위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0227",
            "title": "밴드 어깨 수평 외회전(Horizontal Shoulder external rotation, band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0227.png",
            "guide": [
                "밴드를 옆에 두고 팔꿈치를 90도 굽히고 90도 어깨를 굴곡하여 잡는다.",
                "팔꿈치 90도를 유지하면서 어깨를 안에서 밖으로 외회전한다. 10회~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0208",
            "title": "밴드 45도 내회전(Shoulder Internal Rotation 45 Degree, band)",
            "thumb": "/assets/thumbs/MS-Shoulder-0208.png",
            "guide": [
                "밴드를 등지고 서서 한 손으로 밴드를 잡는다.",
                "밴드를 잡은 팔을 옆으로 약간 벌려(45° 외전) 팔꿈치를 90°로 굽힌다.",
                "팔의 각도를 유지한 채 밴드를 앞쪽으로 당긴다.(내회전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Band/Band-0026",
            "title": "밴드 푸시업(Band Push Up)",
            "thumb": "/assets/thumbs/Band-0026.png",
            "guide": [
                "양 팔을 어깨와 수직이 되도록 뻗어 손바닥으로 바닥을 짚고 엎드려 다리를 편다.",
                "밴드를 등에 두르고 두 손으로 양 끝을 고정한다.",
                "팔꿈치를 굽혀 상체를 내렸다 밴드의 저항을 느끼며 팔꿈치를 펴 원위치로 돌아온다.",
                "10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "KB/KB-0014",
            "title": "케틀벨 푸시 프레스(Kettlebell Push Press)",
            "thumb": "/assets/thumbs/KB-0014.png",
            "guide": [
                "한 손에 캐틀벨을 들고 팔꿈치를 90°로 굽혀 어깨높이에 맞춰 옆으로 벌리고(90°외전) 선다.",
                "무릎을 굽혀 앉았다 일어나면서 팔을 머리 위로 뻗어 올린다.",
                "10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "TRX/TRX-0001",
            "title": "TRX 푸시업(TRX Push Up)",
            "thumb": "/assets/thumbs/TRX-0001.png",
            "guide": [
                "TRX를 등지고 서서 양 팔을 가슴앞으로 뻗어 손잡이를 잡은 후 몸을 앞으로 기울인다.",
                "팔을 어깨넓이로 유지한 채 팔꿈치를 굽혀 몸을 아래로 내렸다 팔을 펴서 시작위치로 돌아온다.",
                "10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0232",
            "title": "볼 바운드 캐치(Ball Bounce and Catch - Single Arm, wall)",
            "thumb": "/assets/thumbs/MS-Shoulder-0232.png",
            "guide": [
                "벽을 보고 서서 한 손으로 볼을 잡아 팔꿈치를 90° 굽히고 어깨높이에 맞춰 옆으로 벌린다.(90° 외전)",
                "공을 벽을 향해 던졌다 받는다. 10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0233",
            "title": "외회전 신장성 볼 드롭(Shoulder External Rotator Ball Drops, eccentric)",
            "thumb": "/assets/thumbs/MS-Shoulder-0233.png",
            "guide": [
                "한 손에 공을 들고 서서 팔꿈치를 90° 굽혀 어깨높이에 맞춰 옆으로 벌린다.(90°외전)",
                "무릎을 굽히고 상체를 가볍게 앞으로 기울여 공을 바닥으로 떨어뜨렸다 공중에서 다시 잡는다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
    ],


    "herniation": [
        {
            "id": "Stretch/Stretch-0028",
            "title": "골반이동(Pelvic Shift)",
            "thumb": "/assets/thumbs/Stretch-0028.png",
            "guide": [
                "벽 옆에 서서 안쪽 다리를 뒤로 보내고 팔꿈치를 굽혀 벽에 댄다.",
                "골반을 벽 쪽으로 밀어내 15초간 유지한다.",
                "원위치로 돌아와 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0137",
            "title": "엎드려 골반이동(Pelvic Shift, prone)",
            "thumb": "/assets/thumbs/MS-Lumbar-0137.png",
            "guide": [
                "팔꿈치를 굽히고 엎드려 양쪽 다리를 일자로 뻗는다.",
                "다리를 편 채 골반을 좌우로 가볍게 움직인다. 10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0035",
            "title": "허리 신전운동(Back Extension, standing)",
            "thumb": "/assets/thumbs/Stretch-0035.png",
            "guide": [
                "손으로 허리를 잡고 서서 천천히 골반을 앞으로 밀어내면서 허리를 뒤로 젖힌다.(신전)",
                "15초 유지하고, 3회 반복한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0046",
            "title": "엎드려 팔꿈치 굽혀 허리신전(Prone on elbow Back extension)",
            "thumb": "/assets/thumbs/PilatesMat-0046.png",
            "guide": [
                "엎드려 팔꿈치를 굽힌 상태에서 천천히 상체만 들어 올린다. 10초~15초 유지한다. 2~3세트 반복하다."
            ]
        },

        {
            "id": "Static/Static-S-0087",
            "title": "골반 기울기 운동(Pelvic Tilt exercise)",
            "thumb": "/assets/thumbs/Static-S-0087.png",
            "guide": [
                "등을 대고 누워 바닥에 붙이듯 골반을 뒤로 돌려(후방 전위) 5초간 유지한다.",
                "10회 3세트 반복한다."
            ]
        },
        {
            "id": "PilatesMat2/Single Leg Slide",
            "title": "누워 교차하여 다리 밑으로 밀기(Alternative Leg Slide)",
            "thumb": "/assets/thumbs/Single Leg Slide.png",
            "guide": [
                "바로 누워 무릎을 굽히고 양 팔은 몸통 옆 바닥에 둔다.",
                "골반을 고정한 상태로 한 쪽 뒤꿈치로 바닥을 쓸듯이 밀어내려 다리를 폈다 원위치로 돌아온다.",
                "다리를 바꿔 같은 방법으로 실시하고, 10~15회 3세트 반복한다."
            ]
        },

        {
            "id": "Stretch/Stretch-0026",
            "title": "한쪽 무릎 굽혀 가슴 쪽 당기기(Single Knee to Chest, Hip Flexor & Extensor Stretch) 10-15초 유지.",
            "thumb": "/assets/thumbs/Stretch-0026.png",
            "guide": [
                "등을 대고 누워 양 쪽 다리를 편다.",
                "한 쪽 다리를 굽혀 무릎 앞으로 깍지를 껴 무릎을 가슴쪽으로 당기고 10~15초간 유지한다.",
                "반대쪽 다리도 같은 방법으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0041",
            "title": "고관절 굴곡근 스트레치(Hip flexor stretch, kneeling)",
            "thumb": "/assets/thumbs/Stretch-0041.png",
            "guide": [
                "무릎을 굽혀 오른쪽 다리를 뒤로 보내고, 왼쪽 발을 앞으로 보내 바닥을 밟는다.",
                "오른팔을 위로 뻗어 상체와 함께 왼쪽으로 측굴 후 몸통을 오른쪽으로 회전하고 골반을 뒤로 기울인다.(후방전위)",
                "15초간 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0008",
            "title": "서서 고관절 스트레치(Hip Flexor Stretch, standing)",
            "thumb": "/assets/thumbs/MS-Lumbar-0008.png",
            "guide": [
                "벤치를 앞에 두고 서서 한 발을 벤치에 올려 무릎을 굽힌다.",
                "몸을 앞으로 기울여 10~15초간 유지한 후 원위치로 돌아온다.",
                "다리를 바꿔 같은 방법으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0009",
            "title": "수건을 이용한 허리신전 가동화(Towel Self Mobilization)",
            "thumb": "/assets/thumbs/MS-Lumbar-0009.png",
            "guide": [
                "의자에 등을 대고 앉아 수건을 말아 등 상부에 받친다.",
                "의자 등받이에 기댄 채 천천히 허리를 뒤로 젖혀(신전) 10초간 유지하고, 10회 3세트 반복한다."
            ]
        },
        {
            "id": "Static/Static-S-0064",
            "title": "코어강화 운동-정적 데드버그운동(Core activation-Static Dead Bug exercise)",
            "thumb": "/assets/thumbs/Static-S-0064.png",
            "guide": [
                "한 쪽 무릎을 가슴쪽으로 올리려는 힘을 쓰고 반대손으로 저항하여 버티고, 동시에 반대쪽 팔과 다리는 바닥과 수평하게 뻗는다.",
                "5~10초간 유지한 후 팔과 다리를 바꿔 실시한다.(3~5세트 반복)"
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0024",
            "title": "코어 활성화-데드버그(Core activation-Dead Bug exercise)",
            "thumb": "/assets/thumbs/PilatesMat-0024.mp4_000006291.png",
            "guide": [
                "바로 누워  팔을 가슴 앞으로 펴고 무릎을 90°로 굽혀서 들어 올린다.",
                "허리가 뜨지 않도록 복부의 긴장을 유지하여 한 쪽 팔과 반대쪽 다리를 아래로 뻗어 내린다.",
                "원위치로 돌아와 팔과 다리를 바꿔 실시한다.(10회 3세트 반복)"
            ]
        },
        {
            "id": "FR/FR-0027",
            "title": "폼롤러에 누워 데드버그(Supine Dead bug on foam roller)",
            "thumb": "/assets/thumbs/FR-0027.png",
            "guide": [
                "폼롤러에 등을 대고 누워 팔을 몸 옆 바닥에 두고 무릎은 굽혀 발로 바닥을 딛는다.",
                "무릎을 굽힌 상태로 오른쪽 다리를 왼쪽 팔과 함께 90°로 들어 올렸다 내린다.",
                "팔과 다리를 번갈아 가며 10회 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0012",
            "title": "수정된 싯업(Modified Sit up)",
            "thumb": "/assets/thumbs/MS-Lumbar-0012.png",
            "guide": [
                "바로 누워 한 쪽 다리를 펴고 반대쪽 다리는 구부린다.",
                "한 손으로 목을 받치고(또는 몸 옆으로 팔을 펴서 지지하고), 편 다리쪽 손은 허리 밑 공간에 넣는다.",
                "정면을 응시하여 상체를 30° 내외로 세우고 3초간 유지한다.",
                "10회 반복하고, 팔다리를 바꿔 실시한다.(2~3세트 실시)"
            ]
        },
        {
            "id": "GB/GB-0011",
            "title": "짐볼 새사냥개 운동(Bird Dog Arm Lift, Stability ball)",
            "thumb": "/assets/thumbs/GB-0011.png",
            "guide": [
                "짐볼에 엎드려 네발기기 자세를 만든다. 한 팔(오른팔)을 들고 반대쪽 다리(왼쪽 다리)를 뒤로 뻗어 들어 올린다.",
                "5초 유지하고 팔과 다리를 바꿔 같은 방법으로 실시한다. 10회 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0004",
            "title": "새사냥개 운동(Bird dog exercise)",
            "thumb": "/assets/thumbs/FitBW-0004.png",
            "guide": [
                "네 발 기기 자세로 엎드린다.",
                "오른쪽 팔을 귀높이로 뻗어 올리고, 왼쪽 다리를 엉덩이 높이로 뻗어 올려 20초간 유지한다.",
                "원위치로 돌아와 팔과 다리를 바꿔 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0048",
            "title": "엎드려 팔 다리 교차하기(Alternate arm and leg lift)",
            "thumb": "/assets/thumbs/PilatesMat-0048.png",
            "guide": [
                "바닥에 엎드려 양쪽 팔과 다리를 위 아래로 뻗는다.",
                "상체를 가볍게 들어올린 상태에서 오른쪽 팔과 왼쪽 다리를 들어올렸다 내리면서 왼쪽 팔과 오른쪽 다리를 들어 올린다.",
                "10회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "GB/GB-0001",
            "title": "대둔근 활성화(Glute maximus activation-Stability ball Wall Squat)",
            "thumb": "/assets/thumbs/GB-0001.png",
            "guide": [
                "벽과 등 사이에 짐볼을 두고 기대어 선다.",
                "무릎을 굽혀 엉덩이를 수직으로 내렸다 무릎을 펴며 올라온다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0022",
            "title": "브릿지운동(Glute Bridge)",
            "thumb": "/assets/thumbs/PilatesMat-0022.png",
            "guide": [
                "등을 대고 바로 누워 무릎을 굽힌다.",
                "둔근을 수축시켜 골반을 들어올려 어깨부터 무릎까지 사선을 만들고 10초간 유지한다.(3회 반복)",
                "(이 때 발목을 족배굴곡(발등 굽힘)하면 더 효과적이다.)"
            ]
        },
        {
            "id": "GB/GB-0009",
            "title": "짐볼에 엎드려 허리신전운동(Back extension on Stability ball)",
            "thumb": "/assets/thumbs/GB-0009.png",
            "guide": [
                "짐볼 위에 엎드려 다리를 펴고 팔꿈치는 굽혀 손을 귀 뒤에 댄다.",
                "가슴을 펴면서 상체를 들어 올렸다(허리신전) 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Band/Band-0021",
            "title": "대둔근 & 중둔근 활성화-밴드저항 브릿지 (Glute maximus, medius activation- Hip external rotation/Glute bridge)",
            "thumb": "/assets/thumbs/Band-0021.png",
            "guide": [
                "무릎을 굽혀 밴드를 묶고 눕는다.",
                "양쪽 무릎을 옆으로 벌린 후 엉덩이를 들어 올려 5초간 유지한다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0075",
            "title": "싱글레그 밸런스(Single Leg Balance)",
            "thumb": "/assets/thumbs/MS-Lumbar-0075.png",
            "guide": [
                "서서 한 발을 들고 15초~30초 이상 유지한다. 발을 바꿔 같은 방법으로 실시한다.",
                "3세트 반복한다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0018",
            "title": "토구 밸런스(Togu balance)",
            "thumb": "/assets/thumbs/GolfCon-0018.mp4_000005291.png",
            "guide": [
                "토구(Togu) 위에 한 발로 서서 무릎을 가볍게 굽히고 10~30초간 균형을 유지한다.",
                "3세트 반복하고, 발을 바꿔 같은 방법으로 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0115",
            "title": "누워서 골반 올리고 내리기(Hip Hike, supine)",
            "thumb": "/assets/thumbs/MS-Lumbar-0115.png",
            "guide": [
                "등을 대고 누워 양쪽 다리를 일자로 편다.",
                "다리를 펴고 골반을 바닥에 붙인 상태로 한 쪽 골반을 위로 끌어 올린다.",
                "원위치로 돌아와 반대쪽으로 실시하고, 10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0116",
            "title": "서서 골반 올리고 내리기(Hip Hike, Standing)",
            "thumb": "/assets/thumbs/MS-Lumbar-0116.png",
            "guide": [
                "스텝박스 가장자리에 한 다리로 올라선다.",
                "지지한 다리의 무릎을 편 채 반대쪽 골반을 내려 발을 바닥쪽으로 내렸다 다시 골반을 끌어 올린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0024",
            "title": "코어 활성화-데드버그(Core activation-Dead Bug exercise)",
            "thumb": "/assets/thumbs/PilatesMat-0024.mp4_000006291.png",
            "guide": [
                "바로 누워  팔을 가슴 앞으로 펴고 무릎을 90°로 굽혀서 들어 올린다.",
                "허리가 뜨지 않도록 복부의 긴장을 유지하여 한 쪽 팔과 반대쪽 다리를 아래로 뻗어 내린다.",
                "원위치로 돌아와 팔과 다리를 바꿔 실시한다.(10회 3세트 반복)"
            ]
        },
    ]
    ,
    "stenosis": [
        {
            "id": "Stretch/Stretch-0026",
            "title": "한쪽 무릎 굽혀 가슴 쪽 당기기(Single Knee to Chest, Hip Flexor & Extensor Stretch) 10-15초 유지.",
            "thumb": "/assets/thumbs/Stretch-0026.png",
            "guide": [
                "등을 대고 누워 양 쪽 다리를 편다.",
                "한 쪽 다리를 굽혀 무릎 앞으로 깍지를 껴 무릎을 가슴쪽으로 당기고 10~15초간 유지한다.",
                "반대쪽 다리도 같은 방법으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0029",
            "title": "누워 두 무릎 가슴 쪽 당기기(Double Knee to Chest)",
            "thumb": "/assets/thumbs/Stretch-0029.png",
            "guide": [
                "두 다리를 뻗고 눕는다. 두 발의 무릎을 90도 세운다.",
                "두 손을 무릎 뒤쪽 또는 무릎에 두고 무릎을 가슴까지 천천히 당겨 올린다.",
                "3초~5초 유지. 10회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0081",
            "title": "서서 한쪽 무릎 가슴 쪽 당기기(Single Knee to chest, standing)",
            "thumb": "/assets/thumbs/Stretch-0081.png",
            "guide": [
                "서서 한쪽 무릎을 굽히고 두 손으로 무릎을 가슴 쪽으로 당긴다.",
                "10초 유지하고 발을 바꿔 실시한다. 3세트 반복한다."
            ]
        },
        {
            "id": "Static/Static-S-0087",
            "title": "복부압박(Abdominal Bracing, supine)",
            "thumb": "/assets/thumbs/Static-S-0087.png",
            "guide": [
                "등을 대고 누워 바닥에 붙이듯 골반을 뒤로 돌려(후방 전위) 5초간 유지한다.",
                "10회 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0021",
            "title": "기도 스트레치(Prayer Stretch)",
            "thumb": "/assets/thumbs/Stretch-0021.png",
            "guide": [
                "네 발 기기 자세로 엎드린다.",
                "엉덩이를 뒤로 보내고 상체를 아래로 내려 15초간 유지하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0009",
            "title": "누워 무릎 바닥내리기(Knee Side to Side-Trunk rotation)",
            "thumb": "/assets/thumbs/PilatesMat-0009.png",
            "guide": [
                "등을 대고 누워 양쪽 무릎을 굽혀 세운다.",
                "무릎을 굽힌 채 두 다리를 한쪽 방향으로 회전시켜 무릎을 바닥 가까이 내린다.",
                "원위치로 돌아와 같은 방법으로 반대쪽으로도 실시하고, 10회 2~3세트 반복한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0053",
            "title": "옆으로 누워 몸통 돌리기(Side lying trunk Rotation)",
            "thumb": "/assets/thumbs/PilatesMat-0053.png",
            "guide": [
                "옆으로 누워 양 팔을 가슴앞으로 뻗고 무릎은 굽힌다.",
                "골반을 고정한 채 흉추를 회전하면서 위쪽 팔을 등쪽으로 천천히 넘겨 3초간 유지한다.",
                "10회 반복 후 반대쪽으로 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0025",
            "title": "고양이 등 스트레치(Cat Stretch)",
            "thumb": "/assets/thumbs/Stretch-0025.png",
            "guide": [
                "네 발 기기 자세로 엎드린다.",
                "등을 최대한 둥글게 만들어 15초간 유지하고, 3회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0041",
            "title": "고관절 굴곡근 스트레치(Hip flexor stretch, kneeling)",
            "thumb": "/assets/thumbs/Stretch-0041.png",
            "guide": [
                "무릎을 굽혀 오른쪽 다리를 뒤로 보내고, 왼쪽 발을 앞으로 보내 바닥을 밟는다.",
                "오른팔을 위로 뻗어 상체와 함께 왼쪽으로 측굴 후 몸통을 오른쪽으로 회전하고 골반을 뒤로 기울인다.(후방전위)",
                "15초간 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0008",
            "title": "서서 고관절 스트레치(Hip Flexor Stretch, standing)",
            "thumb": "/assets/thumbs/MS-Lumbar-0008.png",
            "guide": [
                "벤치를 앞에 두고 서서 한 발을 벤치에 올려 무릎을 굽힌다.",
                "몸을 앞으로 기울여 10~15초간 유지한 후 원위치로 돌아온다.",
                "다리를 바꿔 같은 방법으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0055",
            "title": "햄스트링 스트레치-누워서(Hamstring stretch, supine)",
            "thumb": "/assets/thumbs/Stretch-0055.png",
            "guide": [
                "다리를 펴고 바로 누워 양 손으로 한 쪽 다리의 허벅지를 잡아 몸쪽으로 끌어 당긴다.",
                "15초간 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다.",
                "※ 발목을 족배굴곡하면 햄스트링이 더 강하게 스트레치 된다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0028",
            "title": "싱글레그 스트레치(Single Leg Stretch)",
            "thumb": "/assets/thumbs/PilatesMat-0028.png",
            "guide": [
                "등을 대고 누워 무릎을 굽혀 들어 올린다.",
                "상체를 가볍게 들고 한 쪽 무릎을 가슴쪽으로 가볍게 당기면서 반대쪽 다리는 수평으로 뻗는다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 10회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0031",
            "title": "짐볼 허그(Stability ball Hug)",
            "thumb": "/assets/thumbs/MS-Lumbar-0031.png",
            "guide": [
                "짐볼을 몸앞에 두고 앉아 편안하게 짐볼을 안고 5초간 유지하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0032",
            "title": "정적 근신경이완-발목 굽혀펴기(Static Nerve Glide, ankle flexion/extension)",
            "thumb": "/assets/thumbs/MS-Lumbar-0032.png",
            "guide": [
                "의자에 바로 앉아 한쪽 다리를 수평으로 뻗어 발목을 발등쪽으로 굽혔다 편다.",
                "10~15회 반복 후 다리를 바꿔 같은 방법으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0033",
            "title": "정적 근신경이완-굴곡 & 신전(Static Nerve Glide, Trunk flexion & extension with leg)",
            "thumb": "/assets/thumbs/MS-Lumbar-0033.png",
            "guide": [
                "의자에 앉아 무릎을 90°로 굽히고 상체를 살짝 앞으로 굽힌다.",
                "상체를 세우면서 한 쪽 무릎을 수평으로 폈다 시작위치로 돌아온다.",
                "10회 반복 후 다리를 바꿔 같은 방법으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0010",
            "title": "짐볼 네발기기자세에서 한 다리 들기(Bird Dog Leg Lift, Stability ball)",
            "thumb": "/assets/thumbs/GB-0010.png",
            "guide": [
                "짐볼에 엎드려 네발기기 자세를 만든다. 한 다리 뒤로 뻗어 들어 올린다.",
                "10회 반복하고 발을 바꿔 같은 방법으로 실시한다. 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0011",
            "title": "짐볼 새사냥개 운동(Bird Dog Arm Lift, Stability ball)",
            "thumb": "/assets/thumbs/GB-0011.png",
            "guide": [
                "짐볼에 엎드려 네발기기 자세를 만든다. 한 팔(오른팔)을 들고 반대쪽 다리(왼쪽 다리)를 뒤로 뻗어 들어 올린다.",
                "5초 유지하고 팔과 다리를 바꿔 같은 방법으로 실시한다. 10회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0036",
            "title": "무릎 올려 가슴까지 당기기-스텝박스(Double Knee to chest on step, step)",
            "thumb": "/assets/thumbs/MS-Lumbar-0036.png",
            "guide": [
                "20~30cm 높이의 박스에 무릎을 굽혀 발을 올려놓는다.",
                "발을 떼고 무릎을 올려 가슴까지 당긴다. 처음 시작 위치로 돌아간다. 10회~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0002",
            "title": "짐볼 안고 벽 기대어 스쿼트(Stability ball Hug Wall Squat)",
            "thumb": "/assets/thumbs/GB-0002.png",
            "guide": [
                "짐볼 2개를 하나는 가슴에 안고 하나는 벽에 대고 기댄다.",
                "천천히 무릎을 굽혀 앉는다(스쿼트). 처음 시작 위치로 돌아간다. 10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0003",
            "title": "짐볼 안고 스쿼트(Stability ball Hug Squat)",
            "thumb": "/assets/thumbs/GB-0003.png",
            "guide": [
                "짐볼을 안고 천천히 무릎을 굽혀 앉는다(스쿼트). 처음 시작 위치로 돌아간다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Static/Static-S-0064",
            "title": "코어강화 운동-정적 데드버그운동(Core activation-Static Dead Bug exercise)",
            "thumb": "/assets/thumbs/Static-S-0064.png",
            "guide": [
                "한 쪽 무릎을 가슴쪽으로 올리려는 힘을 쓰고 반대손으로 저항하여 버티고, 동시에 반대쪽 팔과 다리는 바닥과 수평하게 뻗는다.",
                "5~10초간 유지한 후 팔과 다리를 바꿔 실시한다.(3~5세트 반복)"
            ]
        },
    ],

    "facet-syndrome": [
        {
            "id": "Static/Static-S-0087",
            "title": "골반후방전위(Posterior pelvic tilt)",
            "thumb": "/assets/thumbs/Static-S-0087.png",
            "guide": [
                "바닥에 누워 바닥에 붙이듯 골반을 뒤로 돌려(후방 전위시켜) 5초간 유지한다.",
                "10회 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0021",
            "title": "기도 스트레치(Prayer Stretch)",
            "thumb": "/assets/thumbs/Stretch-0021.png",
            "guide": [
                "네 발 기기 자세로 엎드린다.",
                "엉덩이를 뒤로 보내고 상체를 아래로 내려 15초간 유지하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0029",
            "title": "누워 두 무릎 가슴 쪽 당기기(Double Knee to Chest)",
            "thumb": "/assets/thumbs/Stretch-0029.png",
            "guide": [
                "두 다리를 뻗고 눕는다. 두 발의 무릎을 90도 세운다.",
                "두 손을 무릎 뒤쪽 또는 무릎에 두고 무릎을 가슴까지 천천히 당겨 올린다.",
                "3초~5초 유지. 10회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0041",
            "title": "고관절 굴곡근 스트레치(Hip Flexor stretch)",
            "thumb": "/assets/thumbs/Stretch-0041.png",
            "guide": [
                "무릎을 굽혀 오른쪽 다리를 뒤로 보내고, 왼쪽 발을 앞으로 보내 바닥을 밟는다.",
                "오른팔을 위로 뻗어 상체와 함께 왼쪽으로 측굴 후 몸통을 오른쪽으로 회전하고 골반을 뒤로 기울인다.(후방전위)",
                "15초간 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0022",
            "title": "광배근 스트레치-짐볼(Latissimus Dorsi stretch, Stability ball)",
            "thumb": "/assets/thumbs/Stretch-0022.png",
            "guide": [
                "네 발 기기 자세로 엎드려 한 손을 짐볼 위에 올린다.",
                "팔을 외회전시켜 팔꿈치를 펴면서 짐볼을 앞으로 밀어내서 15초 유지한다.",
                "3회 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0024",
            "title": "앉아 요추기립근 스트레치(Lumbar Erector Spinae stretch-Forward Bending Fold)",
            "thumb": "/assets/thumbs/Stretch-0024.png",
            "guide": [
                "의자 끝에 앉아 양쪽 무릎을 어깨 넓이보다 넓게 벌린다.",
                "무릎 사이로 상체를 숙여 15초간 유지한다.(3회 반복)"
            ]
        },
        {
            "id": "Stretch/Stretch-0025",
            "title": "고양이 등 스트레치(Cat Stretch)",
            "thumb": "/assets/thumbs/Stretch-0025.png",
            "guide": [
                "네 발 기기 자세로 엎드린다.",
                "등을 최대한 둥글게 만들어 5초간 유지하고, 10세트 반복한다"
            ]
        },
        {
            "id": "Stretch/Stretch-0025",
            "title": "고양이 등 스트레치(Cat Stretch)",
            "thumb": "/assets/thumbs/Stretch-0025.png",
            "guide": [
                "네 발 기기 자세로 엎드린다.",
                "등을 최대한 둥글게 만들어 15초간 유지하고, 3회 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0031",
            "title": "짐볼 허그(Stability ball Hug)",
            "thumb": "/assets/thumbs/MS-Lumbar-0031.png",
            "guide": [
                "짐볼을 몸앞에 두고 앉아 편안하게 짐볼을 안고 5초간 유지하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Static/Static-S-0088",
            "title": "코어 활성화-플랭크(Core activation-Plank)",
            "thumb": "/assets/thumbs/Static-S-0088.png",
            "guide": [
                "팔꿈치를 90°로 굽혀 어깨와 수직으로 바닥을 지지하고 엎드린다.",
                "다리를 뻗어 머리부터 발까지 수평을 만들어 30초간 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Static/Static-S-0064",
            "title": "코어강화 운동-정적 데드버그운동(Core activation-Static Dead Bug exercise)",
            "thumb": "/assets/thumbs/Static-S-0064.png",
            "guide": [
                "한 쪽 무릎을 가슴쪽으로 올리려는 힘을 쓰고 반대손으로 저항하여 버티고, 동시에 반대쪽 팔과 다리는 바닥과 수평하게 뻗는다.",
                "5~10초간 유지한 후 팔과 다리를 바꿔 실시한다.(3~5세트 반복)"
            ]
        },
        {
            "id": "FitBW/FitBW-0005",
            "title": "대둔근 활성화-한발 브릿지(Glute maximus activation-Single Leg Bridge)",
            "thumb": "/assets/thumbs/FitBW-0005.png",
            "guide": [
                "무릎을 굽혀 한 쪽 발로 지지하고 누워 골반이 기울지 않게 유지하면서 엉덩이를 들어 올린다.",
                "이 때 바닥을 지지한 발을 족배굴곡(발등 굽힘)하여 강도를 높일 수 있다.",
                "10~15회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0025",
            "title": "짐볼 브릿지(Glute Bridge, Stability ball)",
            "thumb": "/assets/thumbs/GolfCon-0025.png",
            "guide": [
                "바닥에 등을 대고 누워 다리를 펴서 짐볼 위에 올린다.",
                "둔근을 수축시키면서 골반을 들어 올려 발부터 어깨까지 사선을 만들어 10초간 유지한다.",
                "10회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Static/Static-S-0131",
            "title": "고관절 외회전 운동(Hip external rotator activation-Clamshell with Band)",
            "thumb": "/assets/thumbs/Static-S-0131.png",
            "guide": [
                "두 다리에 밴드를 걸고 옆으로 누워 발을 붙인 상태로 무릎을 옆으로 벌린다.(고관절 외회전)",
                "10회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0016",
            "title": "이상근 활성화-무릎으로 공 조이기(Piriformis activation-Ball Squeeze, sitting)",
            "thumb": "/assets/thumbs/PilatesMat-0016.png",
            "guide": [
                "눕거나 앉아서 무릎 사이에 쿠션볼을 두고 5초간 압박한다.(3~5회 반복)",
                "* 영상처럼 Bridge 자세에서 실시할 수 있다."
            ]
        },
        {
            "id": "Band/Band-0033",
            "title": "밴드저항 사이드워킹(Sidewalking with Band)",
            "thumb": "/assets/thumbs/Band-0033.png",
            "guide": [
                "무릎 아래 또는 발목에 밴드를 걸어 저항을 느끼며 오른쪽으로 5~10보, 왼쪽으로 5~10보씩 옆으로 걷는다.(3회 3세트 반복)"
            ]
        },
        {
            "id": "GB/GB-0001",
            "title": "대둔근 활성화(Glute maximus activation-Stability ball Wall Squat)",
            "thumb": "/assets/thumbs/GB-0001.png",
            "guide": [
                "벽과 등 사이에 짐볼을 두고 기대어 선다.",
                "무릎을 굽혀 엉덩이를 수직으로 내렸다 무릎을 펴며 올라온다.",
                "10~15회 3세트 반복한다."
            ]
        }
    ],

    "sciatica": [
        {
            "id": "Stretch/Stretch-0035",
            "title": "서서 허리 신전운동(Back extension, standing)",
            "thumb": "/assets/thumbs/Stretch-0035.png",
            "guide": [
                "서서 허리에 손을 두고 천천히 골반을 앞으로 내밀면서 허리를 뒤로 젖힌다(신전).",
                "10초~15초 유지한다. 2~3세트 반복한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0046",
            "title": "엎드려 팔꿈치 굽혀 허리신전(Prone on elbow Back extension)",
            "thumb": "/assets/thumbs/PilatesMat-0046.png",
            "guide": [
                "엎드려 팔꿈치를 굽힌 상태에서 천천히 상체만 들어 올린다. 10초~15초 유지한다. 2~3세트 반복하다."
            ]
        },
        {
            "id": "Stretch/Stretch-0030",
            "title": "엎드려 팔 뻗어 허리신전(Prone Back extension)",
            "thumb": "/assets/thumbs/Stretch-0030.png",
            "guide": [
                "엎드려 팔꿈치를 편 상태에서 상체만 들어 올린다. 10초~15초 유지하고 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0055",
            "title": "햄스트링 스트레치-누워서(Hamstring stretch, supine)",
            "thumb": "/assets/thumbs/Stretch-0055.png",
            "guide": [
                "바로 누워 양 손으로 한 쪽 다리의 허벅지를 잡아 몸쪽으로 끌어당기고 무릎을 편다.",
                "15초간 유지하고 양쪽 모두 3회씩 반복하여 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0032",
            "title": "정적 근신경이완-발목 굽혀펴기(Static Nerve Glide, ankle flexion/extension)",
            "thumb": "/assets/thumbs/MS-Lumbar-0032.png",
            "guide": [
                "의자에 바로 앉아 한쪽 다리를 수평으로 뻗어 발목을 발등쪽으로 굽혔다 편다.",
                "10~15회 반복 후 다리를 바꿔 같은 방법으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0033",
            "title": "정적 근신경이완-굴곡 & 신전(Static Nerve Glide, Trunk flexion & extension with leg)",
            "thumb": "/assets/thumbs/MS-Lumbar-0033.png",
            "guide": [
                "의자에 앉아 무릎을 90°로 굽히고 상체를 살짝 앞으로 굽힌다.",
                "상체를 세우면서 한 쪽 무릎을 수평으로 폈다 시작위치로 돌아온다.",
                "10회 반복 후 다리를 바꿔 같은 방법으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0064",
            "title": "정적 근신경이완-목 굴곡 & 발목신전/목 신전 & 발목굴곡(Static Nerve Glide, Neck & ankle flexion)",
            "thumb": "/assets/thumbs/MS-Lumbar-0064.png",
            "guide": [
                "의자에 앉아 무릎을 90°로 굽힌다.",
                "한 발을 앞으로 보내 발목을 바닥쪽으로 굽히면서(족저굴곡) 목과 상체를 앞으로 기울인다.",
                "발목을 발등쪽으로 굽히면서(족배굴곡) 상체를 펴고 목을 뒤로 젖힌다.(신전)",
                "10회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0026",
            "title": "요추기립근 스트레치-누워 무릎 가슴쪽 당기기(Lumbar Erector Spinae stretch-Single Knee to chest, supine)",
            "thumb": "/assets/thumbs/Stretch-0026.png",
            "guide": [
                "다리를 펴고 바로 누워 한 쪽 무릎을 굽혀 두 손으로 가슴까지 당겨 15초간 유지한다.",
                "3회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0009",
            "title": "수건을 이용한 허리신전 가동화(Towel Self Mobilization)",
            "thumb": "/assets/thumbs/MS-Lumbar-0009.png",
            "guide": [
                "의자에 등을 대고 앉아 수건을 말아 등 상부에 받친다.",
                "의자 등받이에 기댄 채 천천히 허리를 뒤로 젖혀(신전) 10초간 유지하고, 10회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0154",
            "title": "네발기기자세 한 팔 들기(Quadruped Single Arm Raise)",
            "thumb": "/assets/thumbs/MS-Lumbar-0154.png",
            "guide": [
                "네 발 기기 자세로 엎드려 벽과 엉덩이 사이에 짐볼을 둔다.",
                "엉덩이로 짐볼을 고정한 채 팔을 앞으로 110°~145°로 뻗어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "PilatesMat2/Single Leg Slide",
            "title": "누워 교차하여 다리 밑으로 밀기(Alternative Leg Slide)",
            "thumb": "/assets/thumbs/Single Leg Slide.png",
            "guide": [
                "바로 누워 무릎을 굽히고 양 팔은 몸통 옆 바닥에 둔다.",
                "골반을 고정한 상태로 한 쪽 뒤꿈치로 바닥을 쓸듯이 밀어내려 다리를 폈다 원위치로 돌아온다.",
                "다리를 바꿔 같은 방법으로 실시하고, 10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0012",
            "title": "수정된 싯업(Modified Sit up)",
            "thumb": "/assets/thumbs/MS-Lumbar-0012.png",
            "guide": [
                "바로 누워 한 쪽 다리를 펴고 반대쪽 다리는 구부린다.",
                "한 손으로 목을 받치고(또는 몸 옆으로 팔을 펴서 지지하고), 편 다리쪽 손은 허리 밑 공간에 넣는다.",
                "정면을 응시하여 상체를 30° 내외로 세우고 3초간 유지한다.",
                "10회 반복하고, 팔다리를 바꿔 실시한다.(2~3세트 실시)"
            ]
        },
        {
            "id": "FitBW/FitBW-0004",
            "title": "새사냥개 운동(Bird dog exercise)",
            "thumb": "/assets/thumbs/FitBW-0004.png",
            "guide": [
                "네 발 기기 자세로 엎드린다.",
                "오른쪽 팔을 귀높이로 뻗어 올리고, 왼쪽 다리를 엉덩이 높이로 뻗어 올려 20초간 유지한다.",
                "원위치로 돌아와 팔과 다리를 바꿔 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0048",
            "title": "엎드려 팔 다리 교차하기(Alternate arm and leg lift)",
            "thumb": "/assets/thumbs/PilatesMat-0048.png",
            "guide": [
                "바닥에 엎드려 양쪽 팔과 다리를 위 아래로 뻗는다.",
                "상체를 가볍게 들어올린 상태에서 오른쪽 팔과 왼쪽 다리를 들어올렸다 내리면서 왼쪽 팔과 오른쪽 다리를 들어 올린다.",
                "10회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "GB/GB-0001",
            "title": "대둔근 활성화(Glute maximus activation-Stability ball Wall Squat)",
            "thumb": "/assets/thumbs/GB-0001.png",
            "guide": [
                "벽과 등 사이에 짐볼을 두고 기대어 선다.",
                "무릎을 굽혀 엉덩이를 수직으로 내렸다 무릎을 펴며 올라온다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0025",
            "title": "짐볼 브릿지(Glute Bridge, Stability ball)",
            "thumb": "/assets/thumbs/GolfCon-0025.png",
            "guide": [
                "바닥에 등을 대고 누워 다리를 펴서 짐볼 위에 올린다.",
                "둔근을 수축시키면서 골반을 들어 올려 발부터 어깨까지 사선을 만들어 10초간 유지한다.",
                "10회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "GB/GB-0009",
            "title": "짐볼에 엎드려 허리신전운동(Back extension on Stability ball)",
            "thumb": "/assets/thumbs/GB-0009.png",
            "guide": [
                "짐볼 위에 엎드려 다리를 펴고 팔꿈치는 굽혀 손을 귀 뒤에 댄다.",
                "가슴을 펴면서 상체를 들어 올렸다(허리신전) 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0075",
            "title": "싱글레그 밸런스(Single Leg Balance)",
            "thumb": "/assets/thumbs/MS-Lumbar-0075.png",
            "guide": [
                "서서 한 발을 들고 15초~30초 이상 유지한다. 발을 바꿔 같은 방법으로 실시한다.",
                "3세트 반복한다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0018",
            "title": "토구 밸런스(Togu balance)",
            "thumb": "/assets/thumbs/GolfCon-0018(편집).png",
            "guide": [
                "토구(Togu) 위에 한 발로 서서 무릎을 가볍게 굽히고 10~30초간 균형을 유지한다.",
                "3세트 반복하고, 발을 바꿔 같은 방법으로 실시한다."
            ]
        },
    ],

    "lumbar-rehab-1": [
        {
            "id": "MS/MS-Lumbar-0126",
            "title": "천장관절 견인(SI Joint Distractions, Quadruped)",
            "thumb": "/assets/thumbs/MS-Lumbar-0126.png",
            "guide": [
                "네 발 기기 자세로 엎드려 한 쪽 발목에 탄력밴드를 고정한다.",
                "밴드를 건 다리를 수평으로 뻗어 올려 밴드의 탄성에 의해 다리가 뒤로 견인되도록 한다.",
                "10회 2~3세트 반복 후 다리를 바꿔 같은 방법으로 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0127",
            "title": "요추견인-폼롤러(Back Block Traction, foam roller)",
            "thumb": "/assets/thumbs/MS-Lumbar-0127.png",
            "guide": [
                "폼롤러 위에 누워 다리를 뻗는다.",
                "양 팔을 머리 위로 뻗어 올려 몸 전체가 늘어나도록(견인) 한다.",
                "10~15초 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0025",
            "title": "고양이 등 스트레치(Cat Stretch)",
            "thumb": "/assets/thumbs/Stretch-0025.png",
            "guide": [
                "네 발 기기 자세로 엎드린다.",
                "등을 최대한 둥글게 만들어 15초간 유지하고, 3회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0021",
            "title": "기도 스트레치(Prayer Stretch)",
            "thumb": "/assets/thumbs/Stretch-0021.png",
            "guide": [
                "네 발 기기 자세로 엎드린다.",
                "엉덩이를 뒤로 보내고 상체를 아래로 내려 15초간 유지하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0130",
            "title": "요추굴곡(Lumbar Flexion, standing - 1 leg)",
            "thumb": "/assets/thumbs/MS-Lumbar-0130.png",
            "guide": [
                "벤치를 앞으로 두고 서서 한 발을 벤치 위에 올려 무릎을 굽힌다.",
                "상체를 천천히 앞으로 숙이면서 복부를 수축하여 허리를 동그랗게 만든다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0009",
            "title": "누워 무릎 바닥내리기(Knee Side to Side-Trunk rotation)",
            "thumb": "/assets/thumbs/PilatesMat-0009.png",
            "guide": [
                "등을 대고 누워 양쪽 무릎을 굽혀 세운다.",
                "무릎을 굽힌 채 두 다리를 한쪽 방향으로 회전시켜 무릎을 바닥 가까이 내린다.",
                "원위치로 돌아와 같은 방법으로 반대쪽으로도 실시하고, 10회 2~3세트 반복한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0046",
            "title": "엎드려 팔꿈치 굽혀 허리신전(Prone on elbow Back extension)",
            "thumb": "/assets/thumbs/PilatesMat-0046.png",
            "guide": [
                "엎드려 팔꿈치를 굽힌 상태에서 천천히 상체만 들어 올린다. 10초~15초 유지한다. 2~3세트 반복하다."
            ]
        },
        {
            "id": "Stretch/Stretch-0030",
            "title": "엎드려 팔 뻗어 허리신전(Prone Back extension)",
            "thumb": "/assets/thumbs/Stretch-0030.png",
            "guide": [
                "엎드려 팔꿈치를 편 상태에서 상체만 들어 올린다. 10초~15초 유지하고 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0035",
            "title": "서서 허리 신전운동(Back extension, standing)",
            "thumb": "/assets/thumbs/Stretch-0035.png",
            "guide": [
                "서서 허리에 손을 두고 천천히 골반을 앞으로 내밀면서 허리를 뒤로 젖힌다(신전).",
                "10초~15초 유지한다. 2~3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0028",
            "title": "골반이동(Pelvic Shift)",
            "thumb": "/assets/thumbs/Stretch-0028.png",
            "guide": [
                "벽 옆에 서서 안쪽 다리를 뒤로 보내고 팔꿈치를 굽혀 벽에 댄다.",
                "골반을 벽 쪽으로 밀어내 15초간 유지한다.",
                "원위치로 돌아와 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0137",
            "title": "엎드려 골반이동(Pelvic Shift, prone)",
            "thumb": "/assets/thumbs/MS-Lumbar-0137.png",
            "guide": [
                "팔꿈치를 굽히고 엎드려 양쪽 다리를 일자로 뻗는다.",
                "다리를 편 채 골반을 좌우로 가볍게 움직인다. 10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0092",
            "title": "네발기기자세 엉덩이 움직이기-개 꼬리 운동(Dog Tail Wags, Quadruped)",
            "thumb": "/assets/thumbs/MS-Lumbar-0092.png",
            "guide": [
                "네 발 기기 자세로 엎드려 엉덩이를 좌우로 가볍게 회전시킨다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0139",
            "title": "짐볼 앉아 골반기울기(Stability ball Pelvic tilt)",
            "thumb": "/assets/thumbs/MS-Lumbar-0139.png",
            "guide": [
                "짐볼에 앉아 상체를 세운 채 골반을 앞뒤로 기울인다. 10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "Static/Static-S-0087",
            "title": "골반 기울기 운동(Pelvic Tilt exercise)",
            "thumb": "/assets/thumbs/Static-S-0087.png",
            "guide": [
                "등을 대고 누워 바닥에 붙이듯 골반을 뒤로 돌려(후방 전위) 5초간 유지한다.",
                "10회 3세트 반복한다."
            ]
        },
        {
            "id": "Static/Static-S-0081",
            "title": "요추신전근 자가근막이완-공(Lumbar Erector Spinea Self Myofascial Release, ball)",
            "thumb": "/assets/thumbs/Static-S-0081.png",
            "guide": [
                "땅콩볼 또는 마사지볼 위에 허리를 대고 누워 30초~1분 이내로 압박이완 한다.(3~5회 반복)"
            ]
        },
        {
            "id": "PilatesMat2/Single Leg Slide",
            "title": "누워 교차하여 다리 밑으로 밀기(Alternative Leg Slide)",
            "thumb": "/assets/thumbs/Single Leg Slide.png",
            "guide": [
                "바로 누워 무릎을 굽히고 양 팔은 몸통 옆 바닥에 둔다.",
                "골반을 고정한 상태로 한 쪽 뒤꿈치로 바닥을 쓸듯이 밀어내려 다리를 폈다 원위치로 돌아온다.",
                "다리를 바꿔 같은 방법으로 실시하고, 10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0026",
            "title": "한쪽 무릎 굽혀 가슴 쪽 당기기(Single Knee to Chest, Hip Flexor & Extensor Stretch)",
            "thumb": "/assets/thumbs/Stretch-0026.png",
            "guide": [
                "등을 대고 누워 양 쪽 다리를 편다.",
                "한 쪽 다리를 굽혀 무릎 앞으로 깍지를 껴 무릎을 가슴쪽으로 당기고 10~15초간 유지한다.",
                "반대쪽 다리도 같은 방법으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0029",
            "title": "누워 두 무릎 가슴 쪽 당기기(Double Knee to Chest)",
            "thumb": "/assets/thumbs/Stretch-0029.png",
            "guide": [
                "바로 누워 손으로 양쪽 무릎을 잡아 가슴까지 당긴다.",
                "15초유지하여 3회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0055",
            "title": "햄스트링 스트레치-누워서(Hamstring stretch, supine)",
            "thumb": "/assets/thumbs/Stretch-0055.png",
            "guide": [
                "다리 펴고 누워 양 손으로 한 쪽 다리의 허벅지를 잡아 몸쪽으로 끌어당기고 15초 유지한다.",
                "양쪽 다리를 번갈아 가며 3회씩 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0032",
            "title": "정적 근신경이완-발목 굽혀펴기(Static Nerve Glide, ankle flexion/extension)",
            "thumb": "/assets/thumbs/MS-Lumbar-0032.png",
            "guide": [
                "의자에 바로 앉아 한쪽 다리를 수평으로 뻗어 발목을 발등쪽으로 굽혔다 편다.",
                "10~15회 반복 후 다리를 바꿔 같은 방법으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Static/Static-S-0087",
            "title": "복부압박(Abdominal Bracing, supine)",
            "thumb": "/assets/thumbs/Static-S-0087.png",
            "guide": [
                "등을 대고 누워 바닥에 붙이듯 골반을 뒤로 돌려(후방 전위) 5초간 유지한다.",
                "10회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0108",
            "title": "누워 무릎 굽혀 들어 올리기(Leg Float, supine)",
            "thumb": "/assets/thumbs/MS-Lumbar-0108.png",
            "guide": [
                "등을 대고 누워 무릎을 세운다.",
                "한 쪽 다리를 허벅지 높이로 펴 올렸다 무릎을 굽혀 뒤꿈치를 바닥에 내려놓으며 동시에 반대쪽 다리를 편다.",
                "다리를 교차시켜 10~15회 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0009",
            "title": "네발기기자세 복부압박(Quadruped Abdominal Hollowing & Bracing)",
            "thumb": "/assets/thumbs/GolfCon-0009.png",
            "guide": [
                "네 발 기기 자세로 엎드려 복부를 최대한 당겨 납작하게 만든다.(abdominal hollowing)",
                "시작 자세로 돌아와 다시 복부에 힘을 주어 최대한 압력을 유지한다.(abdominal bracing)",
                "10회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Shoulder-0034",
            "title": "네발기기자세 체중이동(Quadruped weight shift)",
            "thumb": "/assets/thumbs/MS-Shoulder-0034.png",
            "guide": [
                "네 발 기기 자세로 엎드린다.",
                "몸을 앞쪽으로 기울여 체중을 앞으로 이동시켰다 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0055",
            "title": "옆으로 누워 고관절 외회전운동(Sidelying Hip external rotation-Clamshell)",
            "thumb": "/assets/thumbs/PilatesMat-0055.png",
            "guide": [
                "머리에 쿠션을 대고 옆으로 누워 다리를 모아 무릎을 90° 정도로 구부린다.",
                "골반을 고정한 채 두 발은 붙이고 위 쪽 다리를 서서히 벌려 무릎사이가 멀어지도록 한다.",
                "10~15회 2~3세트 반복하고, 반대쪽으로 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0075",
            "title": "싱글레그 밸런스(Single Leg Balance)",
            "thumb": "/assets/thumbs/MS-Lumbar-0075.png",
            "guide": [
                "서서 한 발을 들고 15초~30초 이상 유지한다. 발을 바꿔 같은 방법으로 실시한다.",
                "3세트 반복한다."
            ]
        }
    ],
    "lumbar-rehab-2": [
        {
            "id": "MS/MS-Lumbar-0154",
            "title": "네발기기자세 한 팔 들기(Quadruped Single Arm Raise)",
            "thumb": "/assets/thumbs/MS-Lumbar-0154.png",
            "guide": [
                "네 발 기기 자세로 엎드려 벽과 엉덩이 사이에 짐볼을 둔다.",
                "엉덩이로 짐볼을 고정한 채 팔을 앞으로 110°~145°로 뻗어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "PilatesMat2/Single Leg Slide",
            "title": "누워 교차하여 다리 밑으로 밀기(Alternative Leg Slide)",
            "thumb": "/assets/thumbs/Single Leg Slide.png",
            "guide": [
                "바로 누워 무릎을 굽히고 양 팔은 몸통 옆 바닥에 둔다.",
                "골반을 고정한 상태로 한 쪽 뒤꿈치로 바닥을 쓸듯이 밀어내려 다리를 폈다 원위치로 돌아온다.",
                "다리를 바꿔 같은 방법으로 실시하고, 10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0108",
            "title": "누워 무릎 들고 교차하여 뒤꿈치 닿기(Alternative heel touch, supine)",
            "thumb": "/assets/thumbs/MS-Lumbar-0108.png",
            "guide": [
                "무릎을 굽히고 바로 누워 한 쪽 다리를 반대쪽 허벅지 높이로 뻗어 올린다.",
                "무릎을 굽혀 뒤꿈치로 바닥을 닿으면서 동시에 반대쪽 다리를 뻗어 올린다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0115",
            "title": "누워서 골반 올리고 내리기(Hip Hike, supine)",
            "thumb": "/assets/thumbs/MS-Lumbar-0115.png",
            "guide": [
                "등을 대고 누워 양쪽 다리를 일자로 편다.",
                "다리를 펴고 골반을 바닥에 붙인 상태로 한 쪽 골반을 위로 끌어 올린다.",
                "원위치로 돌아와 반대쪽으로 실시하고, 10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0014",
            "title": "네발기기자세 봉 등 위에 올리기(Horse stance vertical, Quadruped)",
            "thumb": "/assets/thumbs/GolfCon-0014(편집).png",
            "guide": [
                "네 발 기기 자세로 엎드려 등 위에 긴 바(bar)를 올린다.",
                "오른쪽 손과 왼쪽 무릎을 바닥에서 5cm 정도 띄우고 5~10초 유지한다.",
                "3회 반복하고, 반대쪽으로 실시한다."
            ]
        },
        {
            "id": "Static/Static-S-0131",
            "title": "고관절 외회전 운동(Hip external rotator activation-Clamshell with Band)",
            "thumb": "/assets/thumbs/Static-S-0131.png",
            "guide": [
                "두 다리에 밴드를 걸고 옆으로 누워 발을 붙인 상태로 무릎을 옆으로 벌린다.(고관절 외회전)",
                "10회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0022",
            "title": "브릿지운동(Glute Bridge)",
            "thumb": "/assets/thumbs/PilatesMat-0022.png",
            "guide": [
                "등을 대고 바로 누워 무릎을 굽힌다.",
                "둔근을 수축시켜 골반을 들어올려 어깨부터 무릎까지 사선을 만들고 10초간 유지한다.(3회 반복)",
                "(이 때 발목을 족배굴곡(발등 굽힘)하면 더 효과적이다.)"
            ]
        },
        {
            "id": "MS/MS-Lumbar-0161",
            "title": "보수볼 허리 신전(Back Extension-BOSU)",
            "thumb": "/assets/thumbs/MS-Lumbar-0161.png",
            "guide": [
                "보수볼에 배를 대고 엎드려 다리를 뻗는다.",
                "상체를 가볍게 들어 올리고 1~3초간 자세를 유지한다.",
                "10회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0016",
            "title": "무릎 사이 공 조이면서 브릿지(Pillow squeeze bridge)",
            "thumb": "/assets/thumbs/PilatesMat-0016.png",
            "guide": [
                "바닥에 등을 대고 누워 무릎을 굽히고 어깨넓이로 벌려 양 무릎사이에 쿠션볼(또는 베개)을 끼운다.",
                "골반을 들어 올리면서 다리 사이의 공을 조이고 힘을 빼면서 시작자세로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0195",
            "title": "폼롤러에 누워 메디신볼 오버헤드프레스(Supine Overhead press on foam roller)",
            "thumb": "/assets/thumbs/MS-Lumbar-0195.png",
            "guide": [
                "폼롤러 위에 누워 팔을 가슴앞으로 뻗어 양 손으로 메디슨볼을 잡는다.",
                "팔을 머리 위로 들어 올렸다 내린다.(오버헤드프레스)",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0068",
            "title": "네발기기자세 고관절 신전(Hip Extension, Quadruped)",
            "thumb": "/assets/thumbs/PilatesMat-0068.png",
            "guide": [
                "네 발 기기 자세로 엎드려 자세를 유지한 채 한 쪽 다리를 펴서 엉덩이 높이로 들어 올린다.",
                "시작자세로 돌아와 다시 반대쪽 다리를 펴서 들어 올린다.",
                "양쪽 다리를 번갈아 가며 10~15반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0166",
            "title": "밴드저항 데드버그 다리들어내리기(Dead Bugs and Band Pull)",
            "thumb": "/assets/thumbs/MS-Lumbar-0166.png",
            "guide": [
                "바로 누워 무릎을 90°로 굽혀 들고 양 팔을 가슴앞으로 뻗는다.(Dead Bug 자세)",
                "밴드를 머리 위쪽에서 걸어 한 손으로 잡아 밴드의 탄성에 저항하면서 반대쪽 다리를 바닥쪽으로 뻗어 내린다.",
                "10~15회 반복 후 손과 다리를 바꿔 같은 방법으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0072",
            "title": "푸시업자세 플랭크(Pushup Plank)",
            "thumb": "/assets/thumbs/PilatesMat-0072.png",
            "guide": [
                "네 발 기기 자세로 엎드린다.",
                "양쪽 무릎을 펴서 머리부터 발까지 사선형태를 만든다.(푸시업 자세)",
                "15~30초 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0187",
            "title": "무릎대고 사이드플랭크 & 외전 (Knee Side Plank & Abduction)",
            "thumb": "/assets/thumbs/MS-Lumbar-0187.png",
            "guide": [
                "옆으로 누워 아래쪽 팔을 굽혀 어깨와 수직이 되도록 바닥을 지지하고 무릎을 굽힌다.",
                "골반을 들어 올리고 위쪽 다리를 골반높이로 펴서(외전) 10초간 유지한 후 시작자세로 돌아온다.",
                "3~5회 반복한다."
            ]
        },
        {
            "id": "GB/GB-0004",
            "title": "짐볼 레그리프트(Sitting on stability ball Leg Lift)",
            "thumb": "/assets/thumbs/GB-0004.png",
            "guide": [
                "짐볼에 앉아 한 쪽 다리를 들고 5초간 균형을 유지한 후 다리를 바꿔 실시한다.",
                "다리를 교대하며 10~15회 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0026",
            "title": "폼롤러에서 한 다리 들어 내리기(Leg Float, foam roller)",
            "thumb": "/assets/thumbs/FR-0026.png",
            "guide": [
                "폼롤러에 등을 대고 누워 양 쪽 무릎을 굽혀 발을 바닥에 둔다.",
                "가슴앞으로 팔짱을 끼고 한 쪽 다리를 들어 5~10초간 균형을 유지한다.",
                "다리를 바꿔 같은 방법으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0041",
            "title": "밸런스패드 글쓰기(Single leg Balance pad)",
            "thumb": "/assets/thumbs/MS-Ankle-0041.png",
            "guide": [
                "밸런스 패드 위에 한 발로 선다. 다른 다리의 무릎을 가볍게 굽히고 균형을 유지하면서 알파벳 또는 이름을 쓴다.",
                "다리를 바꿔 같은 방법으로 실시한다."
            ]
        },
        {
            "id": "GB/GB-0001",
            "title": "대둔근 활성화(Glute maximus activation-Stability ball Wall Squat)",
            "thumb": "/assets/thumbs/GB-0001.png",
            "guide": [
                "벽과 등 사이에 짐볼을 두고 기대어 선다.",
                "무릎을 굽혀 엉덩이를 수직으로 내렸다 무릎을 펴며 올라온다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0012",
            "title": "골반 기울기(Hip Hinge)",
            "thumb": "/assets/thumbs/GolfCon-0012(편집).png",
            "guide": [
                "무릎을 살짝 굽히고 상체를 앞으로 기울여 선다.(골프 어드레스 자세)",
                "골반을 천천히 앞으로 기울였다(전방전위) 뒤로 기울인다.(후방전위)",
                "10~15회 3세트 반복한다."
            ]
        }
    ],

    "lumbar-rehab-3": [
        {
            "id": "MS/MS-Lumbar-0012",
            "title": "수정된 싯업(Modified Sit up)",
            "thumb": "/assets/thumbs/MS-Lumbar-0012.png",
            "guide": [
                "바로 누워 한 쪽 다리를 펴고 반대쪽 다리는 구부린다.",
                "한 손으로 목을 받치고(또는 몸 옆으로 팔을 펴서 지지하고), 편 다리쪽 손은 허리 밑 공간에 넣는다.",
                "정면을 응시하여 상체를 30° 내외로 세우고 3초간 유지한다.",
                "10회 반복하고, 팔다리를 바꿔 실시한다.(2~3세트 실시)"
            ]
        },
        {
            "id": "FitBW/FitBW-0004",
            "title": "새사냥개 운동(Bird dog exercise)",
            "thumb": "/assets/thumbs/FitBW-0004.png",
            "guide": [
                "네 발 기기 자세로 엎드린다.",
                "오른쪽 팔을 귀높이로 뻗어 올리고, 왼쪽 다리를 엉덩이 높이로 뻗어 올려 20초간 유지한다.",
                "원위치로 돌아와 팔과 다리를 바꿔 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0048",
            "title": "엎드려 팔 다리 교차하기(Alternate arm and leg lift)",
            "thumb": "/assets/thumbs/PilatesMat-0048.png",
            "guide": [
                "바닥에 엎드려 양쪽 팔과 다리를 위 아래로 뻗는다.",
                "상체를 가볍게 들어올린 상태에서 오른쪽 팔과 왼쪽 다리를 들어올렸다 내리면서 왼쪽 팔과 오른쪽 다리를 들어 올린다.",
                "10회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0186",
            "title": "사이드플랭크 고관절 외회전(Side Plank Clamshell)",
            "thumb": "/assets/thumbs/MS-Lumbar-0186.png",
            "guide": [
                "옆으로 누워 아래쪽 팔을 굽혀 어깨와 수직이 되도록 바닥을 지지하고 무릎을 굽힌다.",
                "골반을 들어 올린 상태에서 발목을 붙이고 위쪽 무릎을 위로 들어 올렸다(고관절 외회전) 내린다.",
                "10~15회 반복하고 시작자세로 돌아온다. 3세트 실시한다."
            ]
        },
        {
            "id": "Band/Band-0021",
            "title": "대둔근 & 중둔근 활성화-밴드저항 브릿지 (Glute maximus, medius activation- Hip external rotation/Glute bridge)",
            "thumb": "/assets/thumbs/Band-0021.png",
            "guide": [
                "무릎을 굽혀 밴드를 묶고 눕는다.",
                "양쪽 무릎을 옆으로 벌린 후 엉덩이를 들어 올려 5초간 유지한다.",
                "10~15회 3세트 반복한다."
            ]
        },
        // {
        //     "id": "Kneetag/KneetagSidetosideFeetUp",
        //     "title": "고관절 90도 슬관절 90도 조절된 몸통회전(Controlled Rotations -table top)",
        //     "thumb": "/assets/thumbs/KneetagSidetosideFeetUp.png",
        //     "guide": [
        //         "등을 대고 누워 무릎을 90°로 굽혀 90°로 들어 올린다.",
        //         "두 다리를 붙인 채 한 쪽 방향으로 천천히 넘겨 무릎을 바닥과 가까워지도록 내린다.",
        //         "시작 위치로 돌아와 반대방향으로 실시하고, 10회 2~3세트 반복한다."
        //     ]
        // },
        {
            "id": "Static/Static-S-0088",
            "title": "코어 활성화-플랭크(Core activation-Plank)",
            "thumb": "/assets/thumbs/Static-S-0088.png",
            "guide": [
                "팔꿈치를 90°로 굽혀 어깨와 수직으로 바닥을 지지하고 엎드린다.",
                "다리를 뻗어 머리부터 발까지 수평을 만들어 30초간 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0050",
            "title": "네발기기자세 고관절 신전(Hip Extension-Quadruped, Dumbbell)",
            "thumb": "/assets/thumbs/Dumbbell-0050.png",
            "guide": [
                "네 발 기기 자세로 엎드려 한 쪽 무릎 뒤에 덤벨을 올린다.",
                "무릎을 90°로 유지한 채 다리를 엉덩이 높이로 들어 올린다.(고관절 신전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "GB/GB-0015",
            "title": "짐볼 굴리기(Forward ball roll)",
            "thumb": "/assets/thumbs/GB-0015.png",
            "guide": [
                "짐볼에 팔꿈치를 굽혀 어깨와 수직으로 하고 무릎을 굽혀 앉는 자세를 유지한다.",
                "짐볼을 앞으로 밀어내면서 상체와 허리 골반이 일직선이 되도록 한다. 다시 처음 시작 자세로 돌아온다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0116",
            "title": "서서 골반 올리고 내리기(Hip Hike, Standing)",
            "thumb": "/assets/thumbs/MS-Lumbar-0116.png",
            "guide": [
                "스텝박스 가장자리에 한 다리로 올라선다.",
                "지지한 다리의 무릎을 편 채 반대쪽 골반을 내려 발을 바닥쪽으로 내렸다 다시 골반을 끌어 올린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0181",
            "title": "봉을 이용한 힙 힌지(Hip Hinge with stick)",
            "thumb": "/assets/thumbs/MS-Lumbar-0181.png",
            "guide": [
                "등에 긴 바(Bar)를 수직으로 세워 양 손으로 위 아래를 잡고 선다.",
                "무릎을 굽히고 골반을 기울이면서 상체를 앞으로 숙였다 원위치로 돌아온다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0183",
            "title": "벽 기대고 플랭크에서 사이드 플랭크(Plank to Side Plank, standing)",
            "thumb": "/assets/thumbs/MS-Lumbar-0183.png",
            "guide": [
                "팔꿈치를 수직으로 굽혀 벽에 기대고 선다.",
                "한 쪽 팔꿈치를 벽에서 떼어 몸통과 함께 바깥쪽으로 회전한다.",
                "10~15회 반복 후 팔을 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0188",
            "title": "싱글암 사이드 데드리프트(Single Arm side Kettlebell Deadlift)",
            "thumb": "/assets/thumbs/MS-Lumbar-0188.png",
            "guide": [
                "한 손에 케틀벨을 들고 선다.",
                "무릎을 굽히고 상체를 앞으로 숙여 케틀벨이 바닥에 닿을 정도로 내렸다 무릎을 펴며 올라온다.",
                "상체를 직접적으로 숙이는 것이 아니라 고관절(hinge joint)을 이용해 상체가 자연스럽게 숙여지도록 한다.",
                "10~15회 반복하여 3세트 실시한다.",
                "※ 케틀벨을 든 팔이 내려가는 정도는 바닥에서 약 20~30cm까지로 스텝박스 등을 활용한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0194",
            "title": "사이드플랭크 다리들기(Side Plank Glute Leg Raise)",
            "thumb": "/assets/thumbs/MS-Lumbar-0194.png",
            "guide": [
                "옆으로 누워 아래쪽 팔을 굽혀 어깨와 수직이 되도록 바닥을 지지하고 다리를 편다.",
                "바닥으로부터 골반을 든 상태에서 위쪽 다리를 위로 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0025",
            "title": "짐볼 브릿지(Glute Bridge, Stability ball)",
            "thumb": "/assets/thumbs/GolfCon-0025.png",
            "guide": [
                "바닥에 등을 대고 누워 다리를 펴서 짐볼 위에 올린다.",
                "둔근을 수축시키면서 골반을 들어 올려 발부터 어깨까지 사선을 만들어 10초간 유지한다.",
                "10회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "GB/GB-0013",
            "title": "짐볼 플랭크(Ball plank)",
            "thumb": "/assets/thumbs/GB-0013.png",
            "guide": [
                "팔꿈치를 90°로 굽혀 짐볼 위에 올리고 엎드려 머리부터 발까지 사선형태를 만든다.",
                "20초~1분간 자세를 유지하고, 3세트 실시한다."
            ]
        },
        {
            "id": "GB/GB-0009",
            "title": "짐볼에 엎드려 허리신전운동(Back extension on Stability ball)",
            "thumb": "/assets/thumbs/GB-0009.png",
            "guide": [
                "짐볼 위에 엎드려 다리를 펴고 팔꿈치는 굽혀 손을 귀 뒤에 댄다.",
                "가슴을 펴면서 상체를 들어 올렸다(허리신전) 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        }
    ],

    "lumbar-rehab-4":
        [
            {
                "id": "MS/MS-Ankle-0108",
                "title": "메디신볼 들고 토구에서 한발서기(Single leg balance on togu)",
                "thumb": "/assets/thumbs/MS-Ankle-0108.png",
                "guide": [
                    "토구(Togu) 위에 한 발로 서서 두 손으로 메디슨볼을 든다.",
                    "지지한 다리의 무릎을 가볍게 굽히고 팔을 앞으로 뻗어 20~30초간 균형을 유지한다.",
                    "3~5세트 반복 후 다리를 바꿔 같은 방법으로 실시한다."
                ]
            },
            {
                "id": "PilatesMat/PilatesMat-0034",
                "title": "한발 브릿지(Single Leg Glute Bridge, leg straight)",
                "thumb": "/assets/thumbs/PilatesMat-0034.png",
                "guide": [
                    "바닥에 등을 대고 누워 양 팔은 가슴앞으로 뻗고 무릎을 세운다.",
                    "골반을 들어 올려 어깨부터 무릎까지 사선을 만든다.",
                    "골반의 높이와 수평을 유지한 채 한 쪽 다리를 펴서 가슴쪽으로 뻗어 올렸다 내린다.",
                    "5~10회 반복 후 다리를 바꿔 같은 방법으로 실시한다. 2~3세트 실시한다."
                ]
            },
            {
                "id": "GolfCon/GolfCon-0025",
                "title": "짐볼 브릿지(Glute Bridge, Stability ball)",
                "thumb": "/assets/thumbs/GolfCon-0025.png",
                "guide": [
                    "바닥에 등을 대고 누워 다리를 펴서 짐볼 위에 올린다.",
                    "둔근을 수축시키면서 골반을 들어 올려 발부터 어깨까지 사선을 만들어 10초간 유지한다.",
                    "10회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Ankle-0044",
                "title": "한 발 힙 힌지(Single Leg Hip hinge)",
                "thumb": "/assets/thumbs/MS-Ankle-0044.png",
                "guide": [
                    "한 발로 지지하고 선다.",
                    "지지한 다리의 무릎을 굽히고 들고 있는 다리는 뒤로 보내 균형을 유지한 후 시작자세로 돌아온다.",
                    "10~15회 반복하여 3세트 실시한다.",
                    "※ 상체는 고관절(hinge joint)에 의해 자연스럽게 앞으로 숙여지도록 한다."
                ]
            },
            {
                "id": "MS/MS-Lumbar-0193",
                "title": "밴드저항 사이드플랭크 고관절 외회전(Side Plank Clamshell, band)",
                "thumb": "/assets/thumbs/MS-Lumbar-0193.png",
                "guide": [
                    "옆으로 누워 아래쪽 팔을 굽혀 어깨와 수직이 되도록 바닥을 지지하고 무릎을 굽혀 밴드로 고정한다.",
                    "골반을 들어 올린 후 발목을 붙인 채 위쪽 무릎을 위로 벌렸다(고관절 외회전) 내린다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Lumbar-0194",
                "title": "사이드플랭크 다리들기(Side Plank Glute Leg Raise)",
                "thumb": "/assets/thumbs/MS-Lumbar-0194.png",
                "guide": [
                    "옆으로 누워 아래쪽 팔을 굽혀 어깨와 수직이 되도록 바닥을 지지하고 다리를 편다.",
                    "바닥으로부터 골반을 든 상태에서 위쪽 다리를 위로 들어 올렸다 내린다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Lumbar-0195",
                "title": "폼롤러에 누워 메디신볼 오버헤드프레스(Supine Overhead press on foam roller)",
                "thumb": "/assets/thumbs/MS-Lumbar-0195.png",
                "guide": [
                    "폼롤러 위에 누워 팔을 가슴앞으로 뻗어 양 손으로 메디슨볼을 잡는다.",
                    "팔을 머리 위로 들어 올렸다 내린다.(오버헤드프레스)",
                    "10~15회 3세트 반복한다."
                ]
            },
            {
                "id": "FR/FR-0027",
                "title": "폼롤러에 누워 데드버그(Supine Dead bug on foam roller)",
                "thumb": "/assets/thumbs/FR-0027.png",
                "guide": [
                    "폼롤러에 등을 대고 누워 팔을 몸 옆 바닥에 두고 무릎은 굽혀 발로 바닥을 딛는다.",
                    "무릎을 굽힌 상태로 오른쪽 다리를 왼쪽 팔과 함께 90°로 들어 올렸다 내린다.",
                    "팔과 다리를 번갈아 가며 10회 실시하고, 2~3세트 반복한다."
                ]
            },
            {
                "id": "MS/MS-Lumbar-0197",
                "title": "짐볼에 발 올려 몸통회전(Trunk rotation, leg on Stability ball)",
                "thumb": "/assets/thumbs/MS-Lumbar-0197.png",
                "guide": [
                    "등을 대고 누워 무릎을 90°로 굽혀 짐볼 위에 올린다.",
                    "몸통을 안정되게 유지한 채 천천히 짐볼을 한쪽 방향으로 회전한다.",
                    "시작위치로 돌아와 반대방향으로 회전한다.10회 2~3세트 반복한다."
                ]
            },
            {
                "id": "MS/MS-Lumbar-0198",
                "title": "플랭크 & 사이드플랭크(Plank to Side Plank)",
                "thumb": "/assets/thumbs/MS-Lumbar-0198.png",
                "guide": [
                    "팔꿈치를 90°로 굽혀 플랭크 자세로 엎드려 머리부터 발까지 사선형태를 만든다.",
                    "팔꿈치를 굽힌 상태로 한 팔을 바닥에서 떼고 몸통과 함께 바깥쪽으로 회전한 후 원위치로 돌아온다.",
                    "10회 반복 후 반대쪽으로 실시하고, 2~3세트 반복한다."
                ]
            },
            {
                "id": "PilatesMat/PilatesMat-0088",
                "title": "사이드 플랭크(벤드) 몸통회전(Side plank & trunk rotation)",
                "thumb": "/assets/thumbs/PilatesMat-0088.png",
                "guide": [
                    "팔을 양 옆으로 뻗어 한 팔로 바닥을 지지하고 옆으로 누워 골반을 위로 들어 올린다.",
                    "위 쪽 팔을 머리 위로 뻗어 올리면서 몸통을 위쪽으로 더 끌어 올렸다 원위치로 돌아온다.",
                    "다시 몸통을 바닥쪽으로 회전하면서 위쪽 팔을 몸통 안쪽으로 길게 밀어 넣는다.",
                    "5~10회 반복하여 2~3세트 실시한다."
                ]
            },
            {
                "id": "GB/GB-0021",
                "title": "짐볼 다리뻗어 데드버그(Gymball Straight Leg Dead Bug)",
                "thumb": "/assets/thumbs/GB-0021.png",
                "guide": [
                    "바로 누워 오른쪽 팔과 왼쪽 다리를 위로 들어 짐볼을 고정하고, 반대쪽 팔과 다리는 일자로 뻗는다.",
                    "짐볼을 같은 위치에 고정한 채 팔과 다리를 교체하여 짐볼을 고정하고 반대쪽 팔과 다리는 일자로 뻗는다.",
                    "10~15회 2~3세트 반복한다."
                ]
            },
            {
                "id": "KB/KB-0002",
                "title": "케틀벨 루마니안 데드리프트(Romanian Deadlift, Kettlebell)",
                "thumb": "/assets/thumbs/KB-0002.png",
                "guide": [
                    "두 손으로 케틀벨을 들고 선다.",
                    "무릎을 굽히고 상체를 앞으로 숙여 케틀벨이 바닥에 닿을 정도로 내렸다 무릎을 펴며 올라온다.",
                    "상체를 직접적으로 숙이는 것이 아니라 고관절(hinge joint)을 이용해 상체가 자연스럽게 숙여지도록 한다.",
                    "10~15회 반복하여 3세트 실시한다.",
                    "※ 케틀벨을 든 팔이 내려가는 정도는 바닥에서 약 20~30cm까지로 스텝박스 등을 활용한다."
                ]
            },
            {
                "id": "CB/CB-0032",
                "title": "런지 투 로우(Lunge to Row)",
                "thumb": "/assets/thumbs/CB-0032.png",
                "guide": [
                    "한 손에 케이블을 잡고 반대쪽 다리를 앞으로 보내 무릎을 굽혀 앉는다.",
                    "무릎을 펴 일어나면서 팔꿈치를 굽혀 케이블을 등쪽으로 당긴다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MB/MB-0024",
                "title": "메디신 볼 우드춉(Wood chop exercise, medicine ball)",
                "thumb": "/assets/thumbs/MB-0024.png",
                "guide": [
                    "두 손으로 덤벨이나 메디슨 볼을 잡고 서서 팔을 바깥쪽 대각선 방향으로 뻗어 올린다.",
                    "무릎을 굽히며 팔을 대각선 안쪽 대각선 방향으로 뻗어 내린다.",
                    "10~15회 반복 후 반대쪽으로 실시한다.",
                    "2~3세트 반복한다."
                ]
            },
            {
                "id": "MS/MS-Knee-0196",
                "title": "보수볼 스쿼트(BOSU Squat)",
                "thumb": "/assets/thumbs/MS-Knee-0196.png",
                "guide": [
                    "보수볼 바닥이 위로 가게 하여 두 발로 올라선다.",
                    "균형을 유지하면서 무릎을 굽히면서 앉았다 펴면서 일어난다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "KB/KB-0016",
                "title": "싱글레그 데드리프트(Single Leg Deadlift)",
                "thumb": "/assets/thumbs/KB-0016.png",
                "guide": [
                    "한 발로 서서 반대쪽 손에 케틀벨을 들고 팔을 아래로 내린다.",
                    "바닥을 지지한 다리를 가볍게 굽히고 상체를 앞으로 기울이면서 반대쪽 다리는 엉덩이 높이까지 뒤로 뻗는다.",
                    "단, 상체는 고관절(hinge joint)의 움직임에 의해 자연스럽게 숙여지도록 한다.",
                    "10~15회 반복하여 3세트 실시한다.",
                    "※ 케틀벨을 든 팔이 내려가는 정도는 바닥에서 약 20~30cm까지로 스텝박스 등을 활용한다."
                ]
            },
            {
                "id": "GB/GB-0014",
                "title": "짐볼 플랭크 & 회전(Prone ball circle)",
                "thumb": "/assets/thumbs/GB-0014.png",
                "guide": [
                    "팔꿈치를 90°로 굽혀 짐볼 위에 올리고 엎드려 머리부터 발까지 사선형태를 만든다.",
                    "자세를 유지한 채 팔꿈치를 이용해 짐볼을 좌우로 각각 5회씩 돌려 3세트 반복한다."
                ]
            },
            {
                "id": "FitBW/FitBW-0005",
                "title": "대둔근 활성화-한발 브릿지(Glute maximus activation-Single Leg Bridge)",
                "thumb": "/assets/thumbs/FitBW-0005.png",
                "guide": [
                    "무릎을 굽혀 한 쪽 발로 지지하고 누워 골반이 기울지 않게 유지하면서 엉덩이를 들어 올린다.",
                    "이 때 바닥을 지지한 발을 족배굴곡(발등 굽힘)하여 강도를 높일 수 있다.",
                    "10~15회 3세트 반복하고, 반대쪽도 실시한다."
                ]
            },
            {
                "id": "GB/GB-0026",
                "title": "짐볼 토 터치(Toe tap on stability ball)",
                "thumb": "/assets/thumbs/GB-0026.png",
                "guide": [
                    "등을 대고 누워 오른쪽 팔과 왼쪽 다리를 위로 뻗어 손과 다리 사이에 짐볼을 고정한다.",
                    "짐볼을 고정한 상태로 상체를 들어 올렸다 시작위치로 돌아온다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "GB/GB-0033",
                "title": "한발 들고 짐볼 스쿼트(Single Leg Squat with Stability ball)",
                "thumb": "/assets/thumbs/GB-0033.png",
                "guide": [
                    "벽과 등 사이에 짐볼을 대고 기대어 선다.",
                    "한 발을 들고 지지한 다리의 무릎을 굽혀 앉았다 일어난다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            }
        ],

    "medial-epicondylitis":
        [
            {
                "id": "Stretch/Stretch-0067",
                "title": "손바닥모아 스트레치-손목 신전(Prayer extension Stretch)",
                "thumb": "/assets/thumbs/Stretch-0067.png",
                "guide": [
                    "팔꿈치를 굽혀 가슴높이에서 양 손바닥을 맞댄다.",
                    "손바닥을 밀착한 채 팔을 밑으로 내려 10~15초간 유지하고, 3세트 반복한다."
                ]
            },
            {
                "id": "Stretch/Stretch-0068",
                "title": "손등모아 스트레치-손목 굴곡 (Reverse prayer flexion Stretch)",
                "thumb": "/assets/thumbs/Stretch-0068.png",
                "guide": [
                    "팔꿈치를 굽혀 손등을 맞댄다.",
                    "손등을 붙인채 팔을 가슴앞으로 올려 15초간 유지하고, 3세트 반복한다."
                ]
            },
            {
                "id": "Stretch/Stretch-0070",
                "title": "엄지손가락 스트레치(Thumb Stretch)",
                "thumb": "/assets/thumbs/Stretch-0070.png",
                "guide": [
                    "한 팔을 중립상태로 만들어 가슴앞으로 뻗는다.",
                    "엄지손가락을 네 손가락으로 감싼 후 손목을 바닥쪽으로 굽혀 10~15초 유지한다.",
                    "같은 방법으로 팔을 바꿔 실시하고, 3세트 반복한다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0004",
                "title": "척측편위 스트레치(ulna deviation stretch)",
                "thumb": "/assets/thumbs/MS-Elbow-0004.png",
                "guide": [
                    "팔을 중립으로 하여 전완을 고정한 상태에서 손목을 위아래로 최대한 굽혔다 편다.",
                    "10~15회 3세트 반복한다."
                ]
            },
            {
                "id": "Stretch/Stretch-0069",
                "title": "손목 굴곡/신전 스트레치(Wrist flexion/extension stretch)",
                "thumb": "/assets/thumbs/Stretch-0069.png",
                "guide": [
                    "한 팔을 가슴앞으로 뻗어 반대쪽 손으로 손바닥을 감싸 손등쪽으로 당겨(신전) 5초간 유지한다.",
                    "원위치로 돌아와 손등을 감싸 바닥쪽으로 당겨(굴곡) 5초간 유지한다.",
                    "10회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0007",
                "title": "밴드저항 척측편위 운동(Ulna deviation exercise, band)",
                "thumb": "/assets/thumbs/MS-Elbow-0007.png",
                "guide": [
                    "팔꿈치를 굽혀 의자 팔걸이에 전완(아래 팔)을 고정하고 손으로 밴드를 잡는다.",
                    "엄지손가락이 위로 향하도록 하여 손목을 새끼손가락쪽으로 굽힌다.",
                    "10~15회 반복하여 3세트 실시한다. 점진적으로 밴의 저항을 늘린다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0008",
                "title": "밴드저항 요측편위 운동(Radius deviation exercise, band)",
                "thumb": "/assets/thumbs/MS-Elbow-0008.png",
                "guide": [
                    "팔꿈치를 굽혀 의자 팔걸이에 전완(아래팔)을 고정하고 손으로 밴드를 잡는다.",
                    "엄지손가락이 위로 향하도록 하여 손목을 엄지손가락쪽으로 굽혔다 힘을 뺀다.",
                    "10~15회 반복하여 3세트 실시한다. 점진적으로 밴드의 저항을 늘린다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0009",
                "title": "밴드저항 손목굴곡/신전운동(Wrist Flexion/Extension exercise, band)",
                "thumb": "/assets/thumbs/MS-Elbow-0009.png",
                "guide": [
                    "팔꿈치를 굽혀 의자 팔걸이에 전완(아래팔)을 고정하고 손으로 밴드를 잡는다.",
                    "손바닥이 위로 향하도록 하여 밴드를 당겨 천천히 손목을 말아 올렸다 풀어 내린다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "Dumbbell/Dumbbell-0025",
                "title": "팔꿈치 회내/회외 운동-덤벨(Elbow Pronation/Supination exercise, dumbbell)",
                "thumb": "/assets/thumbs/Dumbbell-0025.png",
                "guide": [
                    "엄지손가락이 위로 향하도록 하여 덤벨을 들고 벤치나 테이블에 전완(아래팔)을 고정한다.",
                    "손바닥이 위로 향하도록 손목을 밖으로 돌린다.(회외)",
                    "다시 손바닥이 아래로 향하도록 손목을 안으로 돌린다.(회내)",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0011",
                "title": "밴드저항 팔꿈치 굴곡운동(Elbow Flexion exercise, band)",
                "thumb": "/assets/thumbs/MS-Elbow-0011.png",
                "guide": [
                    "발로 밴드를 고정하여 양 손으로 끝을 잡고 선다.",
                    "손바닥이 위를 향하도록 하여 팔꿈치를 구부려 밴드를 가슴쪽으로 당겨 올렸다 내린다.",
                    "10~15회 반복하여 3세트 실시한다.",
                    "※ 근력이나 목적에 따라 한 손으로 진행한다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0012",
                "title": "수건 쥐어짜기(Elbow Towel Twists)",
                "thumb": "/assets/thumbs/MS-Elbow-0012.png",
                "guide": [
                    "양 팔을 어깨넓이로 벌려 가슴앞으로 뻗어 손으로 수건을 잡는다.",
                    "빨래를 짜듯 한 손은 안쪽으로, 다른 손은 바깥쪽으로 돌린다.",
                    "방향을 번갈아가며 10~15회 반복하고, 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0013",
                "title": "테니스공 움켜쥐기(Gripping exercise)",
                "thumb": "/assets/thumbs/MS-Elbow-0013.png",
                "guide": [
                    "손바닥에 테니스공을 두고 손가락의 힘을 이용해 힘껏 움켜쥐고 5초간 유지한다.",
                    "손가락의 힘을 풀고 3~5초간 쉰다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "FitBW/FitBW-0003",
                "title": "Wrist Roller 운동(Wrist roller exercise)",
                "thumb": "/assets/thumbs/FitBW-0003.png",
                "guide": [
                    "5kg 이내의 원반에 줄을 묶어 둥근 막대에 고정한다.",
                    "양쪽 팔을 가슴앞으로 뻗어 막대끝을 잡고 손목을 이용해 줄을 감아올렸다 풀어내려 3~5회 반복한다.",
                    "* 줄길이 :  완전히 풀었을 때 무릎 또는 허벅지 위치",
                    "* 원반무게 : 근력에 따라 1~5kg까지"
                ]
            },
            {
                "id": "MS/MS-Elbow-0015",
                "title": "밴드저항 팔꿈치 신전(Elbow Extension, band)",
                "thumb": "/assets/thumbs/MS-Elbow-0015.png",
                "guide": [
                    "팔꿈치를 굽혀 밴드를 잡는다.",
                    "밴드의 저항을 느끼면서 팔꿈치를 펴면서 밴드를 아래쪽으로 당긴다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            }
        ],
    "lateral-epicondylitis": [
        {
            "id": "Stretch/Stretch-0067",
            "title": "손바닥모아 스트레치-손목 신전(Prayer extension Stretch)",
            "thumb": "/assets/thumbs/Stretch-0067.png",
            "guide": [
                "팔꿈치를 굽혀 가슴높이에서 양 손바닥을 맞댄다.",
                "손바닥을 밀착한 채 팔을 밑으로 내려 10~15초간 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0068",
            "title": "손등모아 스트레치-손목 굴곡 (Reverse prayer flexion Stretch)",
            "thumb": "/assets/thumbs/Stretch-0068.png",
            "guide": [
                "팔꿈치를 굽혀 손등을 맞댄다.",
                "손등을 붙인채 팔을 가슴앞으로 올려 15초간 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0070",
            "title": "엄지손가락 스트레치(Thumb Stretch)",
            "thumb": "/assets/thumbs/Stretch-0070.png",
            "guide": [
                "한 팔을 중립상태로 만들어 가슴앞으로 뻗는다.",
                "엄지손가락을 네 손가락으로 감싼 후 손목을 바닥쪽으로 굽혀 10~15초 유지한다.",
                "같은 방법으로 팔을 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Elbow-0004",
            "title": "척측편위 스트레치(ulna deviation stretch)",
            "thumb": "/assets/thumbs/MS-Elbow-0004.png",
            "guide": [
                "팔을 중립으로 하여 전완을 고정한 상태에서 손목을 위아래로 최대한 굽혔다 편다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0069",
            "title": "손목 굴곡/신전 스트레치(Wrist flexion/extension stretch)",
            "thumb": "/assets/thumbs/Stretch-0069.png",
            "guide": [
                "한 팔을 가슴앞으로 뻗어 손목을 손등쪽으로 굽히고 반대쪽 손으로 손바닥을 밀어 10~15초간 유지한다.",
                "손목을 바닥쪽으로 굽혀 반대쪽 손으로 손등을 밀어 10~15초간 유지한다.",
                "3세트 반복 후 팔을 바꿔 실시한다."
            ]
        },
        {
            "id": "MS/MS-Elbow-0079",
            "title": "테이블 손목 굴곡 스트레치(Wrist extension stretch, table)",
            "thumb": "/assets/thumbs/MS-Elbow-0079.png",
            "guide": [
                "팔을 중립상태로 펴서 주먹을 쥐고 상체를 앞으로 숙여 손으로 테이블을 짚는다.",
                "손등이 바닥에 닿도록 손목을 굴곡하여 5초간 유지하고, 10회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Elbow-0018",
            "title": "손목 굴곡/신전 운동(Wrist flexion/extension exercise)",
            "thumb": "/assets/thumbs/MS-Elbow-0018.png",
            "guide": [
                "전완(팔꿈치 아래)을 받치고 앉는다.",
                "손목을 바닥쪽으로 굽혔다가(굴곡) 손등쪽으로 편다.(신전)",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Elbow-0007",
            "title": "밴드저항 척측편위 운동(Ulna deviation exercise, band)",
            "thumb": "/assets/thumbs/MS-Elbow-0007.png",
            "guide": [
                "팔꿈치를 굽혀 의자 팔걸이에 전완(아래 팔)을 고정하고 손으로 밴드를 잡는다.",
                "엄지손가락이 위로 향하도록 하여 손목을 새끼손가락쪽으로 굽힌다.",
                "10~15회 반복하여 3세트 실시한다. 점진적으로 밴의 저항을 늘린다."
            ]
        },
        {
            "id": "MS/MS-Elbow-0008",
            "title": "밴드저항 요측편위 운동(Radius deviation exercise, band)",
            "thumb": "/assets/thumbs/MS-Elbow-0008.png",
            "guide": [
                "팔꿈치를 굽혀 의자 팔걸이에 전완(아래팔)을 고정하고 손으로 밴드를 잡는다.",
                "엄지손가락이 위로 향하도록 하여 손목을 엄지손가락쪽으로 굽혔다 힘을 뺀다.",
                "10~15회 반복하여 3세트 실시한다. 점진적으로 밴드의 저항을 늘린다."
            ]
        },
        {
            "id": "MS/MS-Elbow-0009",
            "title": "밴드저항 손목굴곡/신전운동(Wrist Flexion/Extension exercise, band)",
            "thumb": "/assets/thumbs/MS-Elbow-0009.png",
            "guide": [
                "팔꿈치를 굽혀 의자 팔걸이에 전완(아래팔)을 고정하고 손으로 밴드를 잡는다.",
                "손바닥이 위로 향하도록 하여 밴드를 당겨 천천히 손목을 말아 올렸다 풀어 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0025",
            "title": "팔꿈치 회내/회외 운동-덤벨(Elbow Pronation/Supination exercise, dumbbell)",
            "thumb": "/assets/thumbs/Dumbbell-0025.png",
            "guide": [
                "엄지손가락이 위로 향하도록 하여 덤벨을 들고 벤치나 테이블에 전완(아래팔)을 고정한다.",
                "손바닥이 위로 향하도록 손목을 밖으로 돌린다.(회외)",
                "다시 손바닥이 아래로 향하도록 손목을 안으로 돌린다.(회내)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0023",
            "title": "손목 굴곡-덤벨(wrist curl, dumbbell)",
            "thumb": "/assets/thumbs/Dumbbell-0023.png",
            "guide": [
                "손바닥이 위를 향하게 하여 양 손에 덤벨을 들고 팔을 고정한다.",
                "손목에 힘을 빼 덤벨을 천천히 풀어 준 뒤(신전) 주먹을 쥐듯 손바닥으로 덤벨을 감싸며 손목을 말아 올린다.(굴곡)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Elbow-0011",
            "title": "밴드저항 팔꿈치 굴곡운동(Elbow Flexion exercise, band)",
            "thumb": "/assets/thumbs/MS-Elbow-0011.png",
            "guide": [
                "발로 밴드를 고정하여 양 손으로 끝을 잡고 선다.",
                "손바닥이 위를 향하도록 하여 팔꿈치를 구부려 밴드를 가슴쪽으로 당겨 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다.",
                "※ 근력이나 목적에 따라 한 손으로 진행한다."
            ]
        },
        {
            "id": "MS/MS-Elbow-0012",
            "title": "수건 쥐어짜기(Elbow Towel Twists)",
            "thumb": "/assets/thumbs/MS-Elbow-0012.png",
            "guide": [
                "양 팔을 어깨넓이로 벌려 가슴앞으로 뻗어 손으로 수건을 잡는다.",
                "빨래를 짜듯 한 손은 안쪽으로, 다른 손은 바깥쪽으로 돌린다.",
                "방향을 번갈아가며 10~15회 반복하고, 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Elbow-0013",
            "title": "테니스공 움켜쥐기(Gripping exercise)",
            "thumb": "/assets/thumbs/MS-Elbow-0013.png",
            "guide": [
                "손바닥에 테니스공을 두고 손가락의 힘을 이용해 힘껏 움켜쥐고 5초간 유지한다.",
                "손가락의 힘을 풀고 3~5초간 쉰다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0003",
            "title": "Wrist Roller 운동(Wrist roller exercise)",
            "thumb": "/assets/thumbs/FitBW-0003.png",
            "guide": [
                "5kg 이내의 원반을 줄에 묶어 둥근막대 중앙에 줄의 반대쪽을 고정한다.",
                "팔을 어깨넓이로 벌려 가슴앞으로 뻗어 양 손으로 막대를 잡는다.",
                "손목을 이용해 줄을 감아올렸다 풀어내린다. 3~5회 반복한다.",
                "※ 줄의 길이 :  완전히 풀었을 때 무릎 또는 허벅지 위치",
                "※ 원반의 무게 : 근력에 따라 1~5kg까지"
            ]
        },
        {
            "id": "CB/CB-0003",
            "title": "밴드저항 어깨굴곡(Shoulder flexion with band)",
            "thumb": "/assets/thumbs/CB-0003.png",
            "guide": [
                "밴드(또는 케이블)를 등지고 서서 양 손으로 잡는다.",
                "팔꿈치를 편 채 밴드를 어깨쪽으로 당겨 올렸다 내린다.",
                "10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Elbow-0015",
            "title": "밴드저항 팔꿈치 신전(Elbow Extension, band)",
            "thumb": "/assets/thumbs/MS-Elbow-0015.png",
            "guide": [
                "팔꿈치를 굽혀 밴드를 잡는다.",
                "밴드의 저항을 느끼면서 팔꿈치를 펴면서 밴드를 아래쪽으로 당긴다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        }
    ],
    "mcl-surgery-rehab":
        [
            {
                "id": "MS/MS-Elbow-0013",
                "title": "테니스공 움켜쥐기(Gripping exercise)",
                "thumb": "/assets/thumbs/MS-Elbow-0013.png",
                "guide": [
                    "손바닥에 테니스공을 두고 손가락의 힘을 이용해 힘껏 움켜쥐고 5초간 유지한다.",
                    "손가락의 힘을 풀고 3~5초간 쉰다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0017",
                "title": "밴드저항 손가락 신전(Finger Extension)",
                "thumb": "/assets/thumbs/MS-Elbow-0017.png",
                "guide": [
                    "링밴드를 손가락 전체에 두르고 손가락을 펴서(신전) 밴드를 밀어낸다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0018",
                "title": "손목 굴곡/신전 운동(Wrist flexion/extension exercise)",
                "thumb": "/assets/thumbs/MS-Elbow-0018.png",
                "guide": [
                    "전완(팔꿈치 아래)을 받치고 앉는다.",
                    "손목을 바닥쪽으로 굽혔다가(굴곡) 손등쪽으로 편다.(신전)",
                    "10~15회 3세트 반복한다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0019",
                "title": "팔꿈치 회외 회내(Elbow supination/pronation)",
                "thumb": "/assets/thumbs/MS-Elbow-0019.png",
                "guide": [
                    "팔꿈치를 굽혀 엄지손가락이 위로 향하게 하여 전완(아래팔)을 고정한다.",
                    "손바닥이 위로 향하도록 팔을 밖으로 돌린다.(회외)",
                    "손바닥이 아래로 향하도록 팔을 안으로 돌린다.(회내)",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Shoulder-0022",
                "title": "등척성 어깨 신전(Isometric Shoulder extension)",
                "thumb": "/assets/thumbs/MS-Shoulder-0022.png",
                "guide": [
                    "벽을 등지고 서서 한 팔을 뒤로 뻗어 벽을 짚고 밀면서 5초간 유지한다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Shoulder-0023",
                "title": "등척성 어깨 외회전(Isometric shoulder external rotation)",
                "thumb": "/assets/thumbs/MS-Shoulder-0023.png",
                "guide": [
                    "한 팔을 90°로 굽혀 벽에 대고 옆으로 선다.",
                    "벽을 밀어내듯 전완(팔꿈치 아래)을 바깥쪽으로 회전(어깨 외회전)하여 5초간 유지한다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Shoulder-0024",
                "title": "등척성 어깨 내회전(Isometric shoulder internal rotation)",
                "thumb": "/assets/thumbs/MS-Shoulder-0024.png",
                "guide": [
                    "벽 앞으로 서서 한 팔을 90°로 굽혀 손바닥을 벽에 댄다.",
                    "벽을 밀어내듯 전완(팔꿈치 아래)을 안쪽으로 회전하여(어깨 내회전) 5초간 유지한다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Shoulder-0026",
                "title": "등척성 어깨외전(Isometric shoulder abduction)",
                "thumb": "/assets/thumbs/MS-Shoulder-0026.png",
                "guide": [
                    "팔을 90°로 굽혀 벽과 팔 사이에 쿠션을 둔다.",
                    "팔을 바깥쪽으로 밀어(어깨 외전) 5초간 유지한다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Shoulder-0025",
                "title": "등척성 어깨내전(Isometric shoulder adduction)",
                "thumb": "/assets/thumbs/MS-Shoulder-0025.png",
                "guide": [
                    "팔을 90°로 굽혀 쿠션을 팔 안쪽에 둔다.",
                    "팔을 몸통쪽으로 끌어당겨(어깨 내전) 5초간 유지한다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0024",
                "title": "등척성 팔꿈치 굴곡/신전(Isometric elbow flexion/extension)",
                "thumb": "/assets/thumbs/MS-Elbow-0024.png",
                "guide": [
                    "한 쪽 팔을 엄지손가락이 위로 향하도록 하여 팔꿈치를 살짝 굽혀 고정한다.",
                    "1. 고정한 팔은 굽히는 힘을 쓰고(굴곡) 반대쪽 손으로 위쪽에서 저항하면서 5초간 유지한다.",
                    "2. 고정한 팔은 팔꿈치를 펴는 힘을 쓰고(신전) 반대쪽 손으로 아래쪽에서 저항하면서 5초간 유지한다.",
                    "각각 10회씩 반복하여 2~3세트 실시한다."
                ]
            },
            {
                "id": "Dumbbell/Dumbbell-0023",
                "title": "손목 굴곡-덤벨(wrist curl, dumbbell)",
                "thumb": "/assets/thumbs/Dumbbell-0023.png",
                "guide": [
                    "손바닥이 위를 향하게 하여 양 손에 덤벨을 들고 팔을 고정한다.",
                    "손목에 힘을 빼 덤벨을 천천히 풀어 준 뒤(신전) 주먹을 쥐듯 손바닥으로 덤벨을 감싸며 손목을 말아 올린다.(굴곡)",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "Dumbbell/Dumbbell-0025",
                "title": "팔꿈치 회내/회외 운동-덤벨(Elbow Pronation/Supination exercise, dumbbell)",
                "thumb": "/assets/thumbs/Dumbbell-0025.png",
                "guide": [
                    "엄지손가락이 위로 향하도록 하여 덤벨을 들고 벤치나 테이블에 전완(아래팔)을 고정한다.",
                    "손바닥이 위로 향하도록 손목을 밖으로 돌린다.(회외)",
                    "다시 손바닥이 아래로 향하도록 손목을 안으로 돌린다.(회내)",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0027",
                "title": "팔꿈치 굴곡운동-맨손(Elbow flexion exercise, Free Hand)",
                "thumb": "/assets/thumbs/MS-Elbow-0027.png",
                "guide": [
                    "상완(팔꿈치 위)을 몸옆에 붙이고 팔꿈치를 굽혔다 편다.",
                    "15회 3세트 반복한다."
                ]
            },
            {
                "id": "CB/CB-0022",
                "title": "어깨 내회전-케이블(Shoulder Internal rotation, cable)",
                "thumb": "/assets/thumbs/CB-0022.png",
                "guide": [
                    "케이블 옆으로 서서 안쪽 손으로 손잡이를 잡고 팔꿈치를 90°로 굽혀 몸에 붙인다.",
                    "상완(팔꿈치 위)을 고정한 채 전완(팔꿈치 아래)을 안쪽으로 회전(내회전)한다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "Dumbbell/Dumbbell-0009",
                "title": "어깨 외회전-덤벨(Shoulder External rotation, dumbbell)",
                "thumb": "/assets/thumbs/Dumbbell-0009.png",
                "guide": [
                    "환측(통증이 있는 어깨) 팔이 위로 가도록 옆으로 눕는다.",
                    "팔을 90°로 굽혀 팔꿈치 아래 수건을 받치고 손으로 덤벨을 잡는다.",
                    "상완(팔꿈치 위)을 고정한 채 덤벨을 아래로 내렸다 천천히 위로 들어 올린다.(외회전)",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Shoulder-0133",
                "title": "밴드저항 외회전(Shoulder External Rotation ROM, band)",
                "thumb": "/assets/thumbs/MS-Shoulder-0133.png",
                "guide": [
                    "케이블 옆으로 서서 안쪽 팔꿈치를 90°로 굽혀 케이블 손잡이를 잡는다.",
                    "통증이 없는 범위까지 천천히 몸을 바깥쪽으로 돌린다.(어깨 외회전)",
                    "10~15초 유지하고, 3세트 반복한다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0011",
                "title": "밴드저항 팔꿈치 굴곡운동(Elbow Flexion exercise, band)",
                "thumb": "/assets/thumbs/MS-Elbow-0011.png",
                "guide": [
                    "발로 밴드를 고정하여 양 손으로 끝을 잡고 선다.",
                    "손바닥이 위를 향하도록 하여 팔꿈치를 구부려 밴드를 가슴쪽으로 당겨 올렸다 내린다.",
                    "10~15회 반복하여 3세트 실시한다.",
                    "※ 근력이나 목적에 따라 한 손으로 진행한다."
                ]
            },
            {
                "id": "CB/CB-0003",
                "title": "밴드저항 어깨굴곡(Shoulder flexion with band)",
                "thumb": "/assets/thumbs/CB-0003.png",
                "guide": [
                    "밴드(또는 케이블)를 등지고 서서 양 손으로 잡는다.",
                    "팔꿈치를 편 채 밴드를 어깨쪽으로 당겨 올렸다 내린다.",
                    "10~15회 반복하여 2~3세트 실시한다."
                ]
            },
            {
                "id": "Dumbbell/Dumbbell-0016",
                "title": "스캡션(Scaption)",
                "thumb": "/assets/thumbs/Dumbbell-0016.png",
                "guide": [
                    "양 손에 덤벨을 들고 팔을 벌려(양 팔의 각도 약 120°) 손을 이마높이까지 들어 올린 후 견갑골 사이를 수축시켰다 푼다.",
                    "10~15회 3세트 반복한다."
                ]
            },
            {
                "id": "Dumbbell/Dumbbell-0014",
                "title": "어깨외전-덤벨(Shoulder abduction, dumbbell)",
                "thumb": "/assets/thumbs/Dumbbell-0014.png",
                "guide": [
                    "양 손에 덤벨을 들고 팔을 몸 옆으로 벌려 들어 올렸다(어깨외전) 내린다.",
                    "10회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "Dumbbell/Dumbbell-0024",
                "title": "척측 & 요측 편위운동(ulna & radius deviation exercise)",
                "thumb": "/assets/thumbs/Dumbbell-0024.png",
                "guide": [
                    "엄지손가락을 위로 향하게 하여 양 손으로 덤벨을 잡아 벤치에 전완(아래팔)을 고정한다.",
                    "손목에 힘을 풀어 덤벨을 천천히 아래로 내린(척골측위) 뒤 손목을 이용해 다시 위로 들어 올린다.(요골측위)",
                    "10~15회 반복하여 2~3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Shoulder-0116",
                "title": "밴드 어깨신전(Shoulder Extension with band)",
                "thumb": "/assets/thumbs/MS-Shoulder-0116.png",
                "guide": [
                    "팔을 몸 옆으로 내려 밴드를 잡는다.",
                    "상체를 가볍게 앞으로 기울이고 팔꿈치를 편 채 밴드를 뒤쪽으로 끌어 당긴다.(어깨 신전)",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0015",
                "title": "밴드저항 팔꿈치 신전(Elbow Extension, band)",
                "thumb": "/assets/thumbs/MS-Elbow-0015.png",
                "guide": [
                    "팔꿈치를 굽혀 밴드를 잡는다.",
                    "밴드의 저항을 느끼면서 팔꿈치를 펴면서 밴드를 아래쪽으로 당긴다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "FitBW/FitBW-0002",
                "title": "트라이셉 딥스(Triceps dips)",
                "thumb": "/assets/thumbs/FitBW-0002.png",
                "guide": [
                    "양 손을 뒤로 보내 벤치의 가장자리를 잡는다.",
                    "팔꿈치를 굽혀 몸을 아래로 내렸다 팔꿈치를 펴면서 올라온다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "Static/Static-P-0031",
                "title": "푸시업 플러스(Push up plus)",
                "thumb": "/assets/thumbs/Static-P-0031.png",
                "guide": [
                    "푸쉬업 자세로 엎드려 팔꿈치를 편 채 몸을 아래로 내렸다 올린다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "GolfCon/GolfCon-0086",
                "title": "볼 토스(Toss Ball)",
                "thumb": "/assets/thumbs/GolfCon-0086(편집).png",
                "guide": [
                    "메디슨볼이나 무게가 있는 공을 환측 손을 이용하여 옆쪽으로 회전하듯이 던져주고 받는다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Shoulder-0244",
                "title": "바퀴의자에 플랭크자세로 걷기(Hand Walking on Treadmill/Stool)",
                "thumb": "/assets/thumbs/MS-Shoulder-0244.png",
                "guide": [
                    "바퀴가 달린 의자에 배를 대고 엎드린다.",
                    "어깨와 수직이 되도록 양 팔을 아래로 내려 손으로 바닥을 짚고 다리를 편다.(푸시업자세)",
                    "몸을 수평으로 유지한 채 손을 이용해 공간이 허락되는 범위(약 5m)까지 앞으로 이동하여 3회 반복한다."
                ]
            },
            {
                "id": "MS/MS-Shoulder-0075",
                "title": "메디신볼 밸런스(Medicine ball balance)",
                "thumb": "/assets/thumbs/MS-Shoulder-0075.png",
                "guide": [
                    "메디신 볼을 어깨와 수직 높이로 두 손으로 잡고 다리를 뻗어 업드린다(푸시업자세). 10초 ~15초간 유지하고 3세트 반복한다."
                ]
            },
            {
                "id": "MS/MS-Shoulder-0128",
                "title": "어깨 90도 외전 & 외회전(Shoulder 90 degree abduction & external rotation)",
                "thumb": "/assets/thumbs/MS-Shoulder-0128.png",
                "guide": [
                    "등을 대고 누워(또는 벽에 기대어) 팔을 어깨높이로 벌리고(90° 외전) 팔꿈치를 90°로 굽혀 세운다.",
                    "참을 수 있는 통증범위까지 천천히 어깨를 외회전하여 손등을 최대한 바닥쪽으로 보낸다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            }
        ],
    "elbow-fracture-rehab":
        [
            {
                "id": "MS/MS-Elbow-0013",
                "title": "테니스공 움켜쥐기(Gripping exercise)",
                "thumb": "/assets/thumbs/MS-Elbow-0013.png",
                "guide": [
                    "손바닥에 테니스공을 두고 손가락의 힘을 이용해 힘껏 움켜쥐고 5초간 유지한다.",
                    "손가락의 힘을 풀고 3~5초간 쉰다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0018",
                "title": "손목 굴곡/신전 운동(Wrist flexion/extension exercise)",
                "thumb": "/assets/thumbs/MS-Elbow-0018.png",
                "guide": [
                    "전완(팔꿈치 아래)을 받치고 앉는다.",
                    "손목을 바닥쪽으로 굽혔다가(굴곡) 손등쪽으로 편다.(신전)",
                    "10~15회 3세트 반복한다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0017",
                "title": "밴드저항 손가락 신전(Finger Extension)",
                "thumb": "/assets/thumbs/MS-Elbow-0017.png",
                "guide": [
                    "링밴드를 손가락 전체에 두르고 손가락을 펴서(신전) 밴드를 밀어낸다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0024",
                "title": "등척성 팔꿈치 굴곡/신전(Isometric elbow flexion/extension)",
                "thumb": "/assets/thumbs/MS-Elbow-0024.png",
                "guide": [
                    "한 쪽 팔을 엄지손가락이 위로 향하도록 하여 팔꿈치를 살짝 굽혀 고정한다.",
                    "1. 고정한 팔은 굽히는 힘을 쓰고(굴곡) 반대쪽 손으로 위쪽에서 저항하면서 5초간 유지한다.",
                    "2. 고정한 팔은 팔꿈치를 펴는 힘을 쓰고(신전) 반대쪽 손으로 아래쪽에서 저항하면서 5초간 유지한다.",
                    "각각 10회씩 반복하여 2~3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0027",
                "title": "팔꿈치 굴곡운동-맨손(Elbow flexion exercise, Free Hand)",
                "thumb": "/assets/thumbs/MS-Elbow-0027.png",
                "guide": [
                    "상완(팔꿈치 위)을 몸옆에 붙이고 팔꿈치를 굽혔다 편다.",
                    "15회 3세트 반복한다."
                ]
            },
            {
                "id": "Dumbbell/Dumbbell-0023",
                "title": "손목 굴곡-덤벨(wrist curl, dumbbell)",
                "thumb": "/assets/thumbs/Dumbbell-0023.png",
                "guide": [
                    "손바닥이 위를 향하게 하여 양 손에 덤벨을 들고 팔을 고정한다.",
                    "손목에 힘을 빼 덤벨을 천천히 풀어 준 뒤(신전) 주먹을 쥐듯 손바닥으로 덤벨을 감싸며 손목을 말아 올린다.(굴곡)",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Shoulder-0022",
                "title": "등척성 어깨 신전(Isometric Shoulder extension)",
                "thumb": "/assets/thumbs/MS-Shoulder-0022.png",
                "guide": [
                    "벽을 등지고 서서 한 팔을 뒤로 뻗어 벽을 짚고 밀면서 5초간 유지한다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Shoulder-0023",
                "title": "등척성 어깨 외회전(Isometric shoulder external rotation)",
                "thumb": "/assets/thumbs/MS-Shoulder-0023.png",
                "guide": [
                    "한 팔을 90°로 굽혀 벽에 대고 옆으로 선다.",
                    "벽을 밀어내듯 전완(팔꿈치 아래)을 바깥쪽으로 회전(어깨 외회전)하여 5초간 유지한다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Shoulder-0024",
                "title": "등척성 어깨 내회전(Isometric shoulder internal rotation)",
                "thumb": "/assets/thumbs/MS-Shoulder-0024.png",
                "guide": [
                    "벽 앞으로 서서 한 팔을 90°로 굽혀 손바닥을 벽에 댄다.",
                    "벽을 밀어내듯 전완(팔꿈치 아래)을 안쪽으로 회전하여(어깨 내회전) 5초간 유지한다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Shoulder-0026",
                "title": "등척성 어깨외전(Isometric shoulder abduction)",
                "thumb": "/assets/thumbs/MS-Shoulder-0026.png",
                "guide": [
                    "팔을 90°로 굽혀 벽과 팔 사이에 쿠션을 둔다.",
                    "팔을 바깥쪽으로 밀어(어깨 외전) 5초간 유지한다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0019",
                "title": "팔꿈치 회외 회내(Elbow supination/pronation)",
                "thumb": "/assets/thumbs/MS-Elbow-0019.png",
                "guide": [
                    "팔꿈치를 굽혀 엄지손가락이 위로 향하게 하여 전완(아래팔)을 고정한다.",
                    "손바닥이 위로 향하도록 팔을 밖으로 돌린다.(회외)",
                    "손바닥이 아래로 향하도록 팔을 안으로 돌린다.(회내)",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "CB/CB-0003",
                "title": "밴드저항 어깨굴곡(Shoulder flexion with band)",
                "thumb": "/assets/thumbs/CB-0003.png",
                "guide": [
                    "밴드(또는 케이블)를 등지고 서서 양 손으로 잡는다.",
                    "팔꿈치를 편 채 밴드를 어깨쪽으로 당겨 올렸다 내린다.",
                    "10~15회 반복하여 2~3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0011",
                "title": "밴드저항 팔꿈치 굴곡운동(Elbow Flexion exercise, band)",
                "thumb": "/assets/thumbs/MS-Elbow-0011.png",
                "guide": [
                    "발로 밴드를 고정하여 양 손으로 끝을 잡고 선다.",
                    "손바닥이 위를 향하도록 하여 팔꿈치를 구부려 밴드를 가슴쪽으로 당겨 올렸다 내린다.",
                    "10~15회 반복하여 3세트 실시한다.",
                    "※ 근력이나 목적에 따라 한 손으로 진행한다."
                ]
            },
            {
                "id": "MS/MS-Shoulder-0116",
                "title": "밴드 어깨신전(Shoulder Extension with band)",
                "thumb": "/assets/thumbs/MS-Shoulder-0116.png",
                "guide": [
                    "팔을 몸 옆으로 내려 밴드를 잡는다.",
                    "상체를 가볍게 앞으로 기울이고 팔꿈치를 편 채 밴드를 뒤쪽으로 끌어 당긴다.(어깨 신전)",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Elbow-0015",
                "title": "밴드저항 팔꿈치 신전(Elbow Extension, band)",
                "thumb": "/assets/thumbs/MS-Elbow-0015.png",
                "guide": [
                    "팔꿈치를 굽혀 밴드를 잡는다.",
                    "밴드의 저항을 느끼면서 팔꿈치를 펴면서 밴드를 아래쪽으로 당긴다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "Dumbbell/Dumbbell-0025",
                "title": "팔꿈치 회내/회외 운동-덤벨(Elbow Pronation/Supination exercise, dumbbell)",
                "thumb": "/assets/thumbs/Dumbbell-0025.png",
                "guide": [
                    "엄지손가락이 위로 향하도록 하여 덤벨을 들고 벤치나 테이블에 전완(아래팔)을 고정한다.",
                    "손바닥이 위로 향하도록 손목을 밖으로 돌린다.(회외)",
                    "다시 손바닥이 아래로 향하도록 손목을 안으로 돌린다.(회내)",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "FitBW/FitBW-0002",
                "title": "트라이셉 딥스(Triceps dips)",
                "thumb": "/assets/thumbs/FitBW-0002.png",
                "guide": [
                    "양 손을 뒤로 보내 벤치의 가장자리를 잡는다.",
                    "팔꿈치를 굽혀 몸을 아래로 내렸다 팔꿈치를 펴면서 올라온다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "Static/Static-P-0031",
                "title": "푸시업 플러스(Push up plus)",
                "thumb": "/assets/thumbs/Static-P-0031.png",
                "guide": [
                    "푸쉬업 자세로 엎드려 팔꿈치를 편 채 몸을 아래로 내렸다 올린다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "GolfCon/GolfCon-0086",
                "title": "볼 토스(Toss Ball)",
                "thumb": "/assets/thumbs/GolfCon-0086(편집).png",
                "guide": [
                    "메디슨볼이나 무게가 있는 공을 환측 손을 이용하여 옆쪽으로 회전하듯이 던져주고 받는다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            },
            {
                "id": "MS/MS-Shoulder-0244",
                "title": "바퀴의자에 플랭크자세로 걷기(Hand Walking on Treadmill/Stool)",
                "thumb": "/assets/thumbs/MS-Shoulder-0244.png",
                "guide": [
                    "바퀴가 달린 의자에 배를 대고 엎드린다.",
                    "어깨와 수직이 되도록 양 팔을 아래로 내려 손으로 바닥을 짚고 다리를 편다.(푸시업자세)",
                    "몸을 수평으로 유지한 채 손을 이용해 공간이 허락되는 범위(약 5m)까지 앞으로 이동하여 3회 반복한다."
                ]
            },
            {
                "id": "MS/MS-Shoulder-0075",
                "title": "메디신볼 밸런스(Medicine ball balance)",
                "thumb": "/assets/thumbs/MS-Shoulder-0075.png",
                "guide": [
                    "메디신 볼을 어깨와 수직 높이로 두 손으로 잡고 다리를 뻗어 업드린다(푸시업자세). 10초 ~15초간 유지하고 3세트 반복한다."
                ]
            },
            {
                "id": "MS/MS-Shoulder-0128",
                "title": "어깨 90도 외전 & 외회전(Shoulder 90 degree abduction & external rotation)",
                "thumb": "/assets/thumbs/MS-Shoulder-0128.png",
                "guide": [
                    "등을 대고 누워(또는 벽에 기대어) 팔을 어깨높이로 벌리고(90° 외전) 팔꿈치를 90°로 굽혀 세운다.",
                    "참을 수 있는 통증범위까지 천천히 어깨를 외회전하여 손등을 최대한 바닥쪽으로 보낸다.",
                    "10~15회 반복하여 3세트 실시한다."
                ]
            }
        ],

    "patellofemoral-pain-syndrome": [
        {
            "id": "MS/MS-Knee-0002",
            "title": "슬개골 가동화(patella mobilization)",
            "thumb": "/assets/thumbs/MS-Knee-0002.png",
            "guide": [
                "허벅지 힘을 빼고 무릎을 편다.",
                "손가락 또는 손바닥을 이용하여 무릎뼈(슬개골)을 오른쪽, 왼쪽, 위, 아래로 움직여 준다.",
                "3~5분 동안 반복하여 실시한다."
            ]
        },
        {
            "id": "MS/MSKnee-0003",
            "title": "Q 세트(Quad Sets)",
            "thumb": "/assets/thumbs/MS-Knee-0003.png",
            "guide": [
                "무릎을 펴고 앉아 허벅지에 힘을 주고 5초간 유지한 후 힘을 뺀다.",
                "10~15회 10세트 반복한다."
            ]
        },

        {
            "id": "FR/FR-0012",
            "title": "대퇴근막장근 자가근막이완-폼롤러(TFL Self Myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0012.png",
            "guide": [
                "옆으로 골반 쪽에 폼롤러들 두고 골반 아래 대퇴근막장근을 압박이완 한다. 30초~1분내외 3회반복한다. 양쪽 모두 수행한다"
            ]
        },
        {
            "id": "TP/TP-0127",
            "title": "외측광근 자가근막이완-폼롤러(Vastus Lateralis self myofascial release, foam roller)",
            "thumb": "/assets/thumbs/TP-0127.png",
            "guide": [
                "대퇴부 바깥쪽이 밑으로 가도록 옆으로 누워 무릎과 골반 중간에 폼롤러를 두고 위아래로 굴린다.",
                "30초~1분 내외로 압박한 후 다리를 바꿔 같은 방법으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0014",
            "title": "대퇴이두근 자가근막이완-폼롤러(Biceps Femoris Self Myofascial Release-foam roller)",
            "thumb": "/assets/thumbs/FR-0014.png",
            "guide": [
                "대퇴부 안쪽에 폼롤러를 가로로 두고 앉아 엉덩이를 들고 30초~1분 내외로 폼롤러를 위아래로 굴린다.(3~5회 반복)"
            ]
        },
        {
            "id": "Stretch/Stretch-0052",
            "title": "대퇴부 신전 스트레치-서서(Quadriceps stretch, standing)",
            "thumb": "/assets/thumbs/Stretch-0052.png",
            "guide": [
                "다리를 어깨넓이로 벌리고 선다.",
                "한 발을 뒤로 보내 같은 쪽 손으로 발등을 잡아 엉덩이 쪽으로 당긴다.",
                "10~15초 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0042",
            "title": "서서 대퇴근막장근 스트레치(TFL stretch, stand)",
            "thumb": "/assets/thumbs/Stretch-0042.png",
            "guide": [
                "한 쪽 다리를 뒤로 보내고 같은 쪽 팔을 위로 뻗어 올려 몸과 함께 반대방향으로 측굴하여 15초간 유지한다.",
                "3회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0055",
            "title": "햄스트링 스트레치-누워서(Hamstring stretch, supine)",
            "thumb": "/assets/thumbs/Stretch-0055.png",
            "guide": [
                "바로 누워 양 손으로 한 쪽 다리의 허벅지를 잡아 몸쪽으로 끌어당기고 무릎을 편다.",
                "15초간 유지하고 양쪽 모두 3회씩 반복하여 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0061",
            "title": "비복근 스트레치(Gastrocnemius stretch)",
            "thumb": "/assets/thumbs/Stretch-0061.png",
            "guide": [
                "벽에 양 손을 짚고 기대어 선다.",
                "한 발을 앞으로 보내 무릎을 구부리고, 뒤쪽 다리는 무릎을 펴고 뒤꿈치를 바닥에 붙여 15초간 유지한다.",
                "양쪽 모두 실시하고 3회씩 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0062",
            "title": "가자미근 스트레치(Soleus stretch)",
            "thumb": "/assets/thumbs/Stretch-0062.png",
            "guide": [
                "손으로 벽을 짚거나 Bar를 잡고 선다.",
                "한 쪽 다리를 뒤로 보내 뒤꿈치를 붙인상태에서 무릎을 최대한 굽혀 가자미근을 스트레칭한다.",
                "15초간 유지하여 3회 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0041",
            "title": "고관절 굴곡근 스트레치(Hip Flexor stretch)",
            "thumb": "/assets/thumbs/Stretch-0041.png",
            "guide": [
                "무릎을 굽혀 오른쪽 다리를 뒤로 보내고, 왼쪽 발을 앞으로 보내 바닥을 밟는다.",
                "오른팔을 위로 뻗어 상체와 함께 왼쪽으로 측굴 후 몸통을 오른쪽으로 회전하고 골반을 뒤로 기울인다.(후방전위)",
                "15초간 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MSKnee-0013",
            "title": "다리 뻗어 들어올리기(Straight Leg Raise)",
            "thumb": "/assets/thumbs/MS-Knee-0013.png",
            "guide": [
                "바닥에 등을 대고 누워 한 쪽 무릎을 세우고 반대쪽 다리는 뻗는다.",
                "뻗은 다리의 발목을 발등쪽으로 굽히고(족배굴곡) 발가락은 발바닥쪽으로 굽힌 상태로 다리를 위로 들어 올렸다 내린다.",
                "15~20회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "KB/KB-0016",
            "title": "대둔근 활성화(Glute maximus activation-Single Leg Deadlift with kettlebell)",
            "thumb": "/assets/thumbs/KB-0016.png",
            "guide": [
                "한 발로 지지하고 서서 반대쪽 손에 케틀벨을 든다.",
                "지지한 다리의 무릎을 굽히고 반대 다리를 뒤로 뻗으면서 케틀벨이 바닥에 닿을 정도로 상체를 내린다.",
                "10회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },

        {
            "id": "PilatesMat/PilatesMat-0056",
            "title": "옆으로 누워 고관절 외전(Hip abduction, side lying)",
            "thumb": "/assets/thumbs/PilatesMat-0056.png",
            "guide": [
                "옆으로 누워 위쪽 다리를 펴서 옆으로 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "CB/CB-0036",
            "title": "밴드저항 고관절 외전(Hip Abduction with band, Standing)",
            "thumb": "/assets/thumbs/CB-0036.png",
            "guide": [
                "옆으로 서서 바깥쪽 다리의 발목에 밴드를 걸고 다리를 옆으로 들어 올린다.(외전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0057",
            "title": "옆으로 누워 고관절 내전(Hip adduction, sidelying)",
            "thumb": "/assets/thumbs/PilatesMat-0057.png",
            "guide": [
                "다리를 펴고 옆으로 누워 위쪽 다리를 앞으로 보내 무릎을 굽혀 90°로 세운다.",
                "아래쪽 다리를 위로 들어올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Static/Static-S-0131",
            "title": "고관절 외회전 운동(Hip external rotator activation-Clamshell with Band)",
            "thumb": "/assets/thumbs/Static-S-0131.png",
            "guide": [
                "두 다리에 밴드를 걸고 옆으로 누워 발을 붙인 상태로 무릎을 옆으로 벌린다.(고관절 외회전)",
                "10회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "FMS/FMS-OH-0018",
            "title": "서서 무릎 신전(Terminal Knee Extension, standing)",
            "thumb": "/assets/thumbs/FMS-OH-0018.png",
            "guide": [
                "한 쪽 다리를 가볍게 굽혀 앞으로 보내고 무릎 뒤에 밴드를 고정한다.",
                "밴드를 고정한 다리의 무릎을 쭉 펴고 1~2초간 멈췄다 힘을 빼며 시작자세로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0010",
            "title": "싱글레그 밸런스 리치(Single leg balance reach)",
            "thumb": "/assets/thumbs/FitFunction-0010.png",
            "guide": [
                "한 발로 균형을 잡고 서서 무릎을 굽히면서 들고 있는 다리를 여러 방향으로 뻗어 바닥 또는 콘(cone)을 터치하고 돌아온다.",
                "2회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0051",
            "title": "크로스오버 스텝업(Cross Over Step up)",
            "thumb": "/assets/thumbs/Dumbbell-0051.png",
            "guide": [
                "양 손에 덤벨을 들고 오른쪽 다리 옆에 스텝박스를 두고 선다.",
                "왼쪽 다리를 앞으로 교차하여 박스 위에 올리고, 오른쪽 다리도 따라 올려 박스 위에 선다.",
                "왼쪽 다리를 뒤로 교차하여 바닥에 내리고, 오른쪽 다리도 내린 후 반대방향으로 실시한다.",
                "10~15회 3세트 반복한다."
            ]
        },
    ],
    "knee-arthroscopy-rehab": [
        {
            "id": "MS/MS-Knee-0022",
            "title": "뒤꿈치 당기기(Heel Slide)",
            "thumb": "/assets/thumbs/MS-Knee-0022.png",
            "guide": [
                "다리를 펴고 누워 바닥을 쓸 듯 한 쪽 뒤꿈치를 엉덩이쪽으로 천천히 당겼다 내린다.",
                "10~15회 10세트 반복하여 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0003",
            "title": "Q 세트(Quad Sets)",
            "thumb": "/assets/thumbs/MS-Knee-0003.png",
            "guide": [
                "무릎을 펴고 앉아 허벅지에 힘을 주고 5초간 유지한 후 힘을 뺀다.",
                "10~15회 10세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0013",
            "title": "다리 뻗어 들어올리기(Straight Leg Raise)",
            "thumb": "/assets/thumbs/MS-Knee-0013.png",
            "guide": [
                "바닥에 등을 대고 누워 한 쪽 무릎을 세우고 반대쪽 다리는 뻗는다.",
                "뻗은 다리의 발목을 발등쪽으로 굽히고(족배굴곡) 발가락은 발바닥쪽으로 굽힌 상태로 다리를 위로 들어 올렸다 내린다.",
                "15~20회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0022",
            "title": "브릿지운동(Glute Bridge)",
            "thumb": "/assets/thumbs/PilatesMat-0022.png",
            "guide": [
                "엉덩이를 수축하여 골반을 들어 올려 어깨에서 무릎까지 일직선이 되도록 만든다.",
                "5초~10초간 유지한다. 3~5세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0026",
            "title": "서서 다리 들어올리기(Straight Leg Raise, Standing)",
            "thumb": "/assets/thumbs/MS-Knee-0026.png",
            "guide": [
                "서서 환측 다리를 앞으로 뻗어 위로 들어 올리고 5초간 유지한 후 천천히 시작 위치로 돌아온다.",
                "10회 2~3세트 반복한다.",
                "※ 자력으로 서기 힘들 경우 벽을 짚거나 지지할 수 있는 것을 잡고 선다."
            ]
        },
        {
            "id": "Stretch/Stretch-0055",
            "title": "햄스트링 스트레치-누워서(Hamstring stretch, supine)",
            "thumb": "/assets/thumbs/Stretch-0055.png",
            "guide": [
                "다리 펴고 누워 양 손으로 한 쪽 다리의 허벅지를 잡아 몸쪽으로 끌어당기고 15초 유지한다.",
                "양쪽 다리를 번갈아 가며 3회씩 반복한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0056",
            "title": "옆으로 누워 고관절 외전(Hip abduction, side lying)",
            "thumb": "/assets/thumbs/PilatesMat-0056.png",
            "guide": [
                "옆으로 누워 위쪽 다리를 펴서 옆으로 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0057",
            "title": "내전근 활성화-옆으로 누워 무릎세워 다리올리기(Adductor activation-Sidelying adductor exercise)",
            "thumb": "/assets/thumbs/PilatesMat-0057.png",
            "guide": [
                "옆으로 누워 위쪽 다리를 앞으로 보내 무릎을 90°로 세운다.",
                "아래쪽 다리를 펴서 들어 올린다.",
                "10회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Static/Static-S-0131",
            "title": "고관절 외회전 운동(Hip external rotator activation-Clamshell with Band)",
            "thumb": "/assets/thumbs/Static-S-0131.png",
            "guide": [
                "두 다리에 밴드를 걸고 옆으로 누워 발을 붙인 상태로 무릎을 옆으로 벌린다.(고관절 외회전)",
                "10회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "FMS/FMS-OH-0017",
            "title": "내측광근(VMO) 활성화(Vastus Medialis Oblique activation-Terminal Knee Extension, sitting)",
            "thumb": "/assets/thumbs/FMS-OH-0017.png",
            "guide": [
                "무릎 뒤(오금)에 공(배구공 크기)을 놓고 무릎을 쭉 펴서 대퇴부 근육을 수축시킨다.",
                "10~15회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0032",
            "title": "미니 스쿼트(Mini Squat, with Chair)",
            "thumb": "/assets/thumbs/MS-Knee-0032.png",
            "guide": [
                "다리를 어깨넓이로 벌리고 서서 양 손으로 의자 등받이를 잡는다.",
                "무릎을 가볍게 굽혀(15~30cm) 앉아 5~10초간 유지한다.",
                "10~15회 반복하여 2~3세트 실시한다.",
                "※ 90° 이상 무릎을 굽히지 않도록 한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0052",
            "title": "대퇴부 신전 스트레치-서서(Quadriceps stretch, standing)",
            "thumb": "/assets/thumbs/Stretch-0052.png",
            "guide": [
                "한 쪽 무릎을 굽혀 뒤쪽에서 손으로 발목을 잡아 당기며 15초 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0034",
            "title": "한쪽 무릎 굽혀 체중지지하기(Knee Bend, Single Leg)",
            "thumb": "/assets/thumbs/MS-Knee-0034.png",
            "guide": [
                "의자 등받이를 잡고 서서 한 쪽 다리(건측)를 뒤로 보내거나 살짝 든다.",
                "앞에 있는 다리(환측)에 체중을 실어 무릎을 가볍게 굽힌다.",
                "10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0035",
            "title": "앉아 무릎 펴기(Terminal Knee Extension, Sitting)",
            "thumb": "/assets/thumbs/MS-Knee-0035.png",
            "guide": [
                "의자에 앉아 한 쪽 다리의 무릎 뒤쪽에 공을 놓는다.",
                "공 위에 올린 다리를 쭉 펴서 5초간 유지한 후 힘을 풀며 천천히 시작 위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0036",
            "title": "벽 기대고 햄스트링 스트레치(Hamstring Stretch, Supine at Wall)",
            "thumb": "/assets/thumbs/MS-Knee-0036.png",
            "guide": [
                "바닥에 등을 대고 누워 한 쪽 다리를 펴서 벽에 기댄다.",
                "햄스트링의 상태에 따라 벽 위로 밀어올리면서 무릎을 편다.",
                "5초간 유지하고, 10세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0037",
            "title": "앞으로 계단오르기(Front Step up)",
            "thumb": "/assets/thumbs/MS-Knee-0037.png",
            "guide": [
                "계단을 오르듯 한 발씩 스텝박스 위에 올라 섰다 뒤로 내려온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0037",
            "title": "앞으로 계단오르기(Front Step up)",
            "thumb": "/assets/thumbs/MS-Knee-0037.png",
            "guide": [
                "계단을 오르듯 한 발씩 스텝박스 위에 올라 섰다 뒤로 내려온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0038",
            "title": "옆으로 계단 오르기(Lateral step up)",
            "thumb": "/assets/thumbs/MS-Knee-0038.png",
            "guide": [
                "스텝박스를 옆에 두고 선다.",
                "안 쪽 발부터 스텝박스 위에 올라 섰다가 바깥쪽 다리부터 내려온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0039",
            "title": "고정식 자전거운동(Stationary Bike)",
            "thumb": "/assets/thumbs/MS-Knee-0039.png",
            "guide": [
                "자전거를 탈 정도의 무릎 관절 각도가 나오면 무릎을 폈을 때 다리의 각도를 145°~160° 내외로 유지하면서 자전거를 탄다.",
                "5~20분까지 점진적으로 시간을 늘린다."
            ]
        },
        {
            "id": "GB/GB-0001",
            "title": "대둔근 활성화(Glute maximus activation-Stability ball Wall Squat)",
            "thumb": "/assets/thumbs/GB-0001.png",
            "guide": [
                "벽과 등 사이에 짐볼을 두고 기대어 선다.",
                "무릎을 굽혀 엉덩이를 수직으로 내렸다 무릎을 펴며 올라온다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0041",
            "title": "계단 내리기(Step Down)",
            "thumb": "/assets/thumbs/MS-Knee-0041.png",
            "guide": [
                "스텝박스 위에 서서 한 발을 내려 바닥을 밟았다 다시 올라선다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0008",
            "title": "뒤꿈치 들기(Heel raise)",
            "thumb": "/assets/thumbs/FitBW-0008.png",
            "guide": [
                "무릎을 편 채 발가락 끝으로 지지하여 뒤꿈치를 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0043",
            "title": "능동보조 뒤꿈치 당기기(Active assist hamstring curl)",
            "thumb": "/assets/thumbs/MS-Knee-0043.png",
            "guide": [
                "다리를 펴고 누워 건측 다리를 환측 발등에 올린다.",
                "건측 다리의 도움을 받아 환측 다리의 무릎을 굽혀 뒤꿈치를 엉덩이 쪽으로 끌어당겼다 내린다.",
                "10~15회 3세트 반복 실시한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0001",
            "title": "싱글레그 밸런스 리치(Single leg balance reach)",
            "thumb": "/assets/thumbs/FitFunction-0001.png",
            "guide": [
                "한 발로 균형을 잡고 선다.",
                "지지한 다리의 무릎을 굽히면서 들고 있는 다리를 여러 방향으로 뻗어 바닥을 터치한다.",
                "3~5회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "CB/CB-0036",
            "title": "밴드저항 고관절 외전(Hip Abduction with band, Standing)",
            "thumb": "/assets/thumbs/CB-0036.png",
            "guide": [
                "옆으로 서서 바깥쪽 다리의 발목에 밴드를 걸고 다리를 옆으로 들어 올린다.(외전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
    ],

    "meniscus-surgery-rehab": [
        {
            "id": "MS/MS-Knee-0003",
            "title": "Q 세트(Quad Sets)",
            "thumb": "/assets/thumbs/MS-Knee-0003.png",
            "guide": [
                "무릎을 펴고 앉아 허벅지에 힘을 주고 5초간 유지한 후 힘을 뺀다.",
                "10~15회 10세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0048",
            "title": "발목 펌프운동(Ankle Pump Exercise)",
            "thumb": "/assets/thumbs/MS-Knee-0048.png",
            "guide": [
                "다리를 펴고 앉는다.",
                "다리를 편 채 발목을 발등쪽으로 굽혔다(족배굴곡) 발바닥쪽으로 굽힌다.(족저굴곡)",
                "10회 10세트 반복하여 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0049",
            "title": "뒤꿈치 수건받치고 무릎신전(Heel drop)",
            "thumb": "/assets/thumbs/MS-Knee-0049.png",
            "guide": [
                "수건을 말아 발목 밑에 받치고 무릎을 펴 10초 유지하고, 5~10세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0022",
            "title": "뒤꿈치 당기기(Heel Slide)",
            "thumb": "/assets/thumbs/MS-Knee-0022.png",
            "guide": [
                "다리를 펴고 누워 바닥을 쓸 듯 한 쪽 뒤꿈치를 엉덩이쪽으로 천천히 당겼다 내린다.",
                "10~15회 10세트 반복하여 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0013",
            "title": "다리 뻗어 들어올리기(Straight Leg Raise)",
            "thumb": "/assets/thumbs/MS-Knee-0013.png",
            "guide": [
                "바닥에 등을 대고 누워 한 쪽 무릎을 세우고 반대쪽 다리는 뻗는다.",
                "뻗은 다리의 발목을 발등쪽으로 굽히고(족배굴곡) 발가락은 발바닥쪽으로 굽힌 상태로 다리를 위로 들어 올렸다 내린다.",
                "15~20회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0056",
            "title": "옆으로 누워 고관절 외전(Hip abduction, side lying)",
            "thumb": "/assets/thumbs/PilatesMat-0056.png",
            "guide": [
                "옆으로 누워 위쪽 다리를 펴서 옆으로 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0057",
            "title": "옆으로 누워 고관절 내전(Hip adduction, sidelying)",
            "thumb": "/assets/thumbs/PilatesMat-0057.png",
            "guide": [
                "다리를 펴고 옆으로 누워 위쪽 다리를 앞으로 보내 무릎을 굽혀 90°로 세운다.",
                "아래쪽 다리를 위로 들어올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0026",
            "title": "서서 다리 들어올리기(Straight Leg Raise, Standing)",
            "thumb": "/assets/thumbs/MS-Knee-0026.png",
            "guide": [
                "서서 환측 다리를 앞으로 뻗어 위로 들어 올리고 5초간 유지한 후 천천히 시작 위치로 돌아온다.",
                "10회 2~3세트 반복한다.",
                "※ 자력으로 서기 힘들 경우 벽을 짚거나 지지할 수 있는 것을 잡고 선다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0041",
            "title": "밸런스패드 글쓰기(Single leg Balance pad)",
            "thumb": "/assets/thumbs/MS-Ankle-0041.png",
            "guide": [
                "밸런스 패드 위에 한 발로 선다. 다른 다리의 무릎을 가볍게 굽히고 균형을 유지하면서 알파벳 또는 이름을 쓴다.",
                "다리를 바꿔 같은 방법으로 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0035",
            "title": "앉아 무릎 펴기(Terminal Knee Extension, Sitting)",
            "thumb": "/assets/thumbs/MS-Knee-0035.png",
            "guide": [
                "의자에 앉아 한 쪽 다리의 무릎 뒤쪽에 공을 놓는다.",
                "공 위에 올린 다리를 쭉 펴서 5초간 유지한 후 힘을 풀며 천천히 시작 위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0039",
            "title": "고정식 자전거운동(Stationary Bike)",
            "thumb": "/assets/thumbs/MS-Knee-0039.png",
            "guide": [
                "자전거를 탈 정도의 무릎 관절 각도가 나오면 무릎을 폈을 때 다리의 각도를 145°~160° 내외로 유지하면서 자전거를 탄다.",
                "5~20분까지 점진적으로 시간을 늘린다."
            ]
        },
        {
            "id": "GB/GB-0001",
            "title": "대둔근 활성화(Glute maximus activation-Stability ball Wall Squat)",
            "thumb": "/assets/thumbs/GB-0001.png",
            "guide": [
                "벽과 등 사이에 짐볼을 두고 기대어 선다.",
                "무릎을 굽혀 엉덩이를 수직으로 내렸다 무릎을 펴며 올라온다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0037",
            "title": "앞으로 계단오르기(Front Step up)",
            "thumb": "/assets/thumbs/MS-Knee-0037.png",
            "guide": [
                "계단을 오르듯 한 발씩 스텝박스 위에 올라 섰다 뒤로 내려온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0008",
            "title": "뒤꿈치 들기(Heel raise)",
            "thumb": "/assets/thumbs/FitBW-0008.png",
            "guide": [
                "무릎을 편 채 발가락 끝으로 지지하여 뒤꿈치를 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0043",
            "title": "능동보조 뒤꿈치 당기기(Active assist hamstring curl)",
            "thumb": "/assets/thumbs/MS-Knee-0043.png",
            "guide": [
                "다리를 펴고 누워 건측 다리를 환측 발등에 올린다.",
                "건측 다리의 도움을 받아 환측 다리의 무릎을 굽혀 뒤꿈치를 엉덩이 쪽으로 끌어당겼다 내린다.",
                "10~15회 3세트 반복 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0038",
            "title": "옆으로 계단 오르기(Lateral step up)",
            "thumb": "/assets/thumbs/MS-Knee-0038.png",
            "guide": [
                "스텝박스를 옆에 두고 선다.",
                "안 쪽 발부터 스텝박스 위에 올라 섰다가 바깥쪽 다리부터 내려온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0041",
            "title": "계단 내리기(Step Down)",
            "thumb": "/assets/thumbs/MS-Knee-0041.png",
            "guide": [
                "스텝박스 위에 서서 한 발을 내려 바닥을 밟았다 다시 올라선다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "FMS/FMS-OH-0018",
            "title": "서서 무릎 신전(Terminal Knee Extension, standing)",
            "thumb": "/assets/thumbs/FMS-OH-0018.png",
            "guide": [
                "한 쪽 다리를 가볍게 굽혀 앞으로 보내고 무릎 뒤에 밴드를 고정한다.",
                "밴드를 고정한 다리의 무릎을 쭉 펴고 1~2초간 멈췄다 힘을 빼며 시작자세로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0005",
            "title": "대둔근 활성화-한발 브릿지(Glute maximus activation-Single Leg Bridge)",
            "thumb": "/assets/thumbs/FitBW-0005.png",
            "guide": [
                "무릎을 굽혀 한 쪽 발로 지지하고 누워 골반이 기울지 않게 유지하면서 엉덩이를 들어 올린다.",
                "이 때 바닥을 지지한 발을 족배굴곡(발등 굽힘)하여 강도를 높일 수 있다.",
                "10~15회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Static/Static-S-0131",
            "title": "고관절 외회전 운동(Hip external rotator activation-Clamshell with Band)",
            "thumb": "/assets/thumbs/Static-S-0131.png",
            "guide": [
                "두 다리에 밴드를 걸고 옆으로 누워 발을 붙인 상태로 무릎을 옆으로 벌린다.(고관절 외회전)",
                "10회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "CB/CB-0036",
            "title": "밴드저항 고관절 외전(Hip Abduction with band, Standing)",
            "thumb": "/assets/thumbs/CB-0036.png",
            "guide": [
                "옆으로 서서 바깥쪽 다리의 발목에 밴드를 걸고 다리를 옆으로 들어 올린다.(외전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0001",
            "title": "싱글레그 밸런스 리치(Single leg balance reach)",
            "thumb": "/assets/thumbs/FitFunction-0001.png",
            "guide": [
                "한 발로 균형을 잡고 선다.",
                "지지한 다리의 무릎을 굽히면서 들고 있는 다리를 여러 방향으로 뻗어 바닥을 터치한다.",
                "3~5회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0248",
            "title": "스케이터 스쿼트(Skator squat)",
            "thumb": "/assets/thumbs/MS-Lumbar-0248.png",
            "guide": [
                "한 발을 수건(또는 미끄러질 수 있는 소도구) 위에 올리고 선다.",
                "발을 바닥에서 떼지 않고 수건과 함께 옆으로 밀면서 뻗어내고 반대쪽 무릎은 굽힌다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0011",
            "title": "3방향 밸런스 콘터치(3way balance  & reach)",
            "thumb": "/assets/thumbs/FitFunction-0011.png",
            "guide": [
                "한 발로 서서 무릎을 굽혀 상체를내리고 반대쪽 팔을 뻗어 앞/옆/옆의 콘(cone)을 터치한다.",
                "10회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0017",
            "title": "의자에서 한발들고 일어나기(Single leg chair squat)",
            "thumb": "/assets/thumbs/GolfCon-0017(편집).png",
            "guide": [
                "다리를 90°로 굽히고 의자에 앉아 한 쪽 다리를 들어 무릎을 펴고 양 팔은 가슴 앞으로 뻗는다.",
                "바닥을 지지한 다리의 힘으로 일어섰다 천천히 앉는다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0012",
            "title": "보수볼 밸런스(BOSU Balance)",
            "thumb": "/assets/thumbs/BOSU-0012.png",
            "guide": [
                "보수볼 위에 한 발로 서서 무릎을 가볍게 굽히고 반대쪽 다리를 뒤로 보낸다.",
                "동시에 상체를 앞으로 숙여 20~30초간 자세를 유지한다.",
                "같은 방법으로 다리를 바꿔 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0018",
            "title": "토구 밸런스(Togu balance)",
            "thumb": "/assets/thumbs/GolfCon-0018(편집).png",
            "guide": [
                "토구(Togu) 위에 한 발로 서서 무릎을 가볍게 굽히고 10~30초 균형을 유지한다.",
                "3회 반복하고, 발을 바꿔 같은 방법으로 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0085",
            "title": "밸런스 공 던져 받기(Balance ball toss)",
            "thumb": "/assets/thumbs/MS-Ankle-0085.png",
            "guide": [
                "밸런스 패드(stability pad)에 한 발로 서서 한 손에 테니스공(기타 작은 공)을 잡는다.",
                "균형을 유지하면서 공을 위로 던져 반대쪽 손으로 받는다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
    ],

    "acl-surgery-rehab": [
        {
            "id": "MS/MS-Knee-0003",
            "title": "Q 세트(Quad Sets)",
            "thumb": "/assets/thumbs/MS-Knee-0003.png",
            "guide": [
                "무릎을 펴고 앉아 허벅지에 힘을 주고 5초간 유지한 후 힘을 뺀다.",
                "10~15회 10세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0002",
            "title": "슬개골 가동화(patella mobilization)",
            "thumb": "/assets/thumbs/MS-Knee-0002.png",
            "guide": [
                "허벅지 힘을 빼고 무릎을 편다.",
                "손가락 또는 손바닥을 이용하여 무릎뼈(슬개골)을 오른쪽, 왼쪽, 위, 아래로 움직여 준다.",
                "3~5분 동안 반복하여 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0048",
            "title": "발목 펌프운동(Ankle Pump Exercise)",
            "thumb": "/assets/thumbs/MS-Knee-0048.png",
            "guide": [
                "다리를 펴고 앉는다.",
                "다리를 편 채 발목을 발등쪽으로 굽혔다(족배굴곡) 발바닥쪽으로 굽힌다.(족저굴곡)",
                "10회 10세트 반복하여 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0049",
            "title": "뒤꿈치 수건받치고 무릎신전(Heel drop)",
            "thumb": "/assets/thumbs/MS-Knee-0049.png",
            "guide": [
                "수건을 말아 발목 밑에 받치고 무릎을 펴 10초 유지하고, 5~10세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0022",
            "title": "뒤꿈치 당기기(Heel Slide)",
            "thumb": "/assets/thumbs/MS-Knee-0022.png",
            "guide": [
                "다리를 펴고 누워 바닥을 쓸 듯 한 쪽 뒤꿈치를 엉덩이쪽으로 천천히 당겼다 내린다.",
                "10~15회 10세트 반복하여 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0082",
            "title": "능동보조 뒤꿈치 당기기(Heel Slide, band)",
            "thumb": "/assets/thumbs/MS-Knee-0082.png",
            "guide": [
                "다리를 펴고 누워 한쪽 발목에 밴드를 걸고 같은 방향의 손으로 밴드를 잡는다.",
                "천천히 밴드를 당겨 뒤꿈치를 엉덩이 쪽으로 가능한 범위까지 끌어온다.",
                "10회 10세트 반복하여 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0013",
            "title": "다리 뻗어 들어올리기(Straight Leg Raise)",
            "thumb": "/assets/thumbs/MS-Knee-0013.png",
            "guide": [
                "바닥에 등을 대고 누워 한 쪽 무릎을 세우고 반대쪽 다리는 뻗는다.",
                "뻗은 다리의 발목을 발등쪽으로 굽히고(족배굴곡) 발가락은 발바닥쪽으로 굽힌 상태로 다리를 위로 들어 올렸다 내린다.",
                "15~20회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0026",
            "title": "서서 다리 들어올리기(Straight Leg Raise, Standing)",
            "thumb": "/assets/thumbs/MS-Knee-0026.png",
            "guide": [
                "서서 환측 다리를 앞으로 뻗어 위로 들어 올리고 5초간 유지한 후 천천히 시작 위치로 돌아온다.",
                "10회 2~3세트 반복한다.",
                "※ 자력으로 서기 힘들 경우 벽을 짚거나 지지할 수 있는 것을 잡고 선다."
            ]
        },
        {
            "id": "MS/MS-Knee-0034",
            "title": "한쪽 무릎 굽혀 체중지지하기(Knee Bend, Single Leg)",
            "thumb": "/assets/thumbs/MS-Knee-0034.png",
            "guide": [
                "의자 등받이를 잡고 서서 한 쪽 다리(건측)를 뒤로 보내거나 살짝 든다.",
                "앞에 있는 다리(환측)에 체중을 실어 무릎을 가볍게 굽힌다.",
                "10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0052",
            "title": "대퇴부 신전 스트레치-서서(Quadriceps stretch, standing)",
            "thumb": "/assets/thumbs/Stretch-0052.png",
            "guide": [
                "한 쪽 무릎을 굽혀 뒤쪽에서 손으로 발목을 잡아 당기며 15초 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0055",
            "title": "햄스트링 스트레치-누워서(Hamstring stretch, supine)",
            "thumb": "/assets/thumbs/Stretch-0055.png",
            "guide": [
                "다리를 펴고 바로 누워 양 손으로 한 쪽 다리의 허벅지를 잡아 몸쪽으로 끌어 당긴다.",
                "15초간 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다.",
                "※ 발목을 족배굴곡하면 햄스트링이 더 강하게 스트레치 된다."
            ]
        },
        {
            "id": "MS/MS-Knee-0043",
            "title": "능동보조 뒤꿈치 당기기(Active assist hamstring curl)",
            "thumb": "/assets/thumbs/MS-Knee-0043.png",
            "guide": [
                "다리를 펴고 누워 건측 다리를 환측 발등에 올린다.",
                "건측 다리의 도움을 받아 환측 다리의 무릎을 굽혀 뒤꿈치를 엉덩이 쪽으로 끌어당겼다 내린다.",
                "10~15회 3세트 반복 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0089",
            "title": "능동보조 무릎 굴곡(벽, Active assisted hamstring curl, wall)",
            "thumb": "/assets/thumbs/MS-Knee-0089.png",
            "guide": [
                "등을 대고 누워 양쪽 다리를 위로 뻗어 벽에 기대고 건측 다리를 환측 발목에 올린다.",
                "건측 다리의 도움을 받아 참을 수 있는 통증범위까지 뒤꿈치를 천천히 엉덩이 쪽으로 끌어 내렸다 올린다.",
                "10~15회 반복하고, 3세트 실시한다.",
                "※ 무릎굴곡의 각도가 충분하지 않다면 수시로 반복하여 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0035",
            "title": "앉아 무릎 펴기(Terminal Knee Extension, Sitting)",
            "thumb": "/assets/thumbs/MS-Knee-0035.png",
            "guide": [
                "의자에 앉아 한 쪽 다리의 무릎 뒤쪽에 공을 놓는다.",
                "공 위에 올린 다리를 쭉 펴서 5초간 유지한 후 힘을 풀며 천천히 시작 위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0056",
            "title": "옆으로 누워 고관절 외전(Hip abduction, side lying)",
            "thumb": "/assets/thumbs/PilatesMat-0056.png",
            "guide": [
                "옆으로 누워 위쪽 다리를 펴서 옆으로 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0057",
            "title": "옆으로 누워 고관절 내전(Hip adduction, sidelying)",
            "thumb": "/assets/thumbs/PilatesMat-0057.png",
            "guide": [
                "다리를 펴고 옆으로 누워 위쪽 다리를 앞으로 보내 무릎을 굽혀 90°로 세운다.",
                "아래쪽 다리를 위로 들어올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0152",
            "title": "엎드려 능동보조 무릎 신전(Active assisted knee extension, prone)",
            "thumb": "/assets/thumbs/MS-Knee-0152.png",
            "guide": [
                "무릎 아래쪽이 배드 밖으로 나갈 수 있도록 엎드려 무릎을 굽힌다.",
                "건측 발을 환측 다리의 뒤꿈치에 올리고 힘을 주어 천천히 환측 무릎을 폈다(신전) 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다.",
                "※ 무릎신전이 완전하지 않다면 통증이 없는 범위 내에서 수시로 무릎신전을 반복한다."
            ]
        },
        {
            "id": "CB/CB-0038",
            "title": "밴드저항 고관절 신전(Hip extension with band)",
            "thumb": "/assets/thumbs/CB-0038.png",
            "guide": [
                "한 쪽 발목에 밴드(또는 케이블)를 걸고 선다.",
                "무릎을 편 채 밴드를 당겨 다리를 뒤로 보냈다(고관절 신전) 힘을 빼며 천천히 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0152",
            "title": "모래주머니를 이용한 무릎 굴곡(Hamstring curl with weight)",
            "thumb": "/assets/thumbs/MS-Knee-0152.png",
            "guide": [
                "한 쪽 발목(환측)에 모래주머니(근력에 따라 1~5kg 내외)를 착용하고 엎드린다.",
                "천천히 무릎을 굽혀 엉덩이 쪽으로 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다.",
                "※ 모래주머니가 없을 경우 영상처럼 반대쪽 발을 활용한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0008",
            "title": "뒤꿈치 들기(Heel raise)",
            "thumb": "/assets/thumbs/FitBW-0008.png",
            "guide": [
                "무릎을 편 채 발가락 끝으로 지지하여 뒤꿈치를 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "KB/KB-0016",
            "title": "대둔근 활성화(Glute maximus activation-Single Leg Deadlift with kettlebell)",
            "thumb": "/assets/thumbs/KB-0016.png",
            "guide": [
                "한 발로 지지하고 서서 반대쪽 손에 케틀벨을 든다.",
                "지지한 다리의 무릎을 굽히고 반대 다리를 뒤로 뻗으면서 케틀벨이 바닥에 닿을 정도로 상체를 내린다.",
                "10회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0037",
            "title": "앞으로 계단오르기(Front Step up)",
            "thumb": "/assets/thumbs/MS-Knee-0037.png",
            "guide": [
                "계단을 오르듯 한 발씩 스텝박스 위에 올라 섰다 뒤로 내려온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0039",
            "title": "고정식 자전거운동(Stationary Bike)",
            "thumb": "/assets/thumbs/MS-Knee-0039.png",
            "guide": [
                "자전거를 탈 정도의 무릎 관절 각도가 나오면 무릎을 폈을 때 다리의 각도를 145°~160° 내외로 유지하면서 자전거를 탄다.",
                "5~20분까지 점진적으로 시간을 늘린다."
            ]
        },
        {
            "id": "FMS/FMS-OH-0018",
            "title": "서서 무릎 신전(Terminal Knee Extension, standing)",
            "thumb": "/assets/thumbs/FMS-OH-0018.png",
            "guide": [
                "한 쪽 다리를 가볍게 굽혀 앞으로 보내고 무릎 뒤에 밴드를 고정한다.",
                "밴드를 고정한 다리의 무릎을 쭉 펴고 1~2초간 멈췄다 힘을 빼며 시작자세로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0037",
            "title": "앞으로 계단오르기(Front Step up)",
            "thumb": "/assets/thumbs/MS-Knee-0037.png",
            "guide": [
                "계단을 오르듯 한 발씩 스텝박스 위에 올라 섰다 뒤로 내려온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0038",
            "title": "옆으로 계단 오르기(Lateral step up)",
            "thumb": "/assets/thumbs/MS-Knee-0038.png",
            "guide": [
                "스텝박스를 옆에 두고 선다.",
                "안 쪽 발부터 스텝박스 위에 올라 섰다가 바깥쪽 다리부터 내려온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0041",
            "title": "계단 내리기(Step Down)",
            "thumb": "/assets/thumbs/MS-Knee-0041.png",
            "guide": [
                "스텝박스 위에 서서 한 발을 내려 바닥을 밟았다 다시 올라선다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0001",
            "title": "싱글레그 밸런스 리치(Single leg balance reach)",
            "thumb": "/assets/thumbs/FitFunction-0001.png",
            "guide": [
                "한 발로 균형을 잡고 선다.",
                "지지한 다리의 무릎을 굽히면서 들고 있는 다리를 여러 방향으로 뻗어 바닥을 터치한다.",
                "3~5회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0005",
            "title": "대둔근 활성화-한발 브릿지(Glute maximus activation-Single Leg Bridge)",
            "thumb": "/assets/thumbs/FitBW-0005.png",
            "guide": [
                "무릎을 굽혀 한 쪽 발로 지지하고 누워 골반이 기울지 않게 유지하면서 엉덩이를 들어 올린다.",
                "이 때 바닥을 지지한 발을 족배굴곡(발등 굽힘)하여 강도를 높일 수 있다.",
                "10~15회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Static/Static-S-0131",
            "title": "고관절 외회전 운동(Hip external rotator activation-Clamshell with Band)",
            "thumb": "/assets/thumbs/Static-S-0131.png",
            "guide": [
                "두 다리에 밴드를 걸고 옆으로 누워 발을 붙인 상태로 무릎을 옆으로 벌린다.(고관절 외회전)",
                "10회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0075",
            "title": "싱글레그 밸런스(Single Leg Balance)",
            "thumb": "/assets/thumbs/MS-Lumbar-0075.png",
            "guide": [
                "서서 한 발을 들고 15초~30초 이상 유지한다. 발을 바꿔 같은 방법으로 실시한다.",
                "3세트 반복한다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0018",
            "title": "토구 밸런스(Togu balance)",
            "thumb": "/assets/thumbs/GolfCon-0018(편집).png",
            "guide": [
                "토구(Togu) 위에 한 발로 서서 무릎을 가볍게 굽히고 10~30초간 균형을 유지한다.",
                "3세트 반복하고, 발을 바꿔 같은 방법으로 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0248",
            "title": "스케이터 스쿼트(Skator squat)",
            "thumb": "/assets/thumbs/MS-Lumbar-0248.png",
            "guide": [
                "한 발을 수건(또는 미끄러질 수 있는 소도구) 위에 올리고 선다.",
                "발을 바닥에서 떼지 않고 수건과 함께 옆으로 밀면서 뻗어내고 반대쪽 무릎은 굽힌다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0011",
            "title": "3방향 밸런스 콘터치(3way balance  & reach)",
            "thumb": "/assets/thumbs/FitFunction-0011.png",
            "guide": [
                "한 발로 서서 무릎을 굽혀 상체를내리고 반대쪽 팔을 뻗어 앞/옆/옆의 콘(cone)을 터치한다.",
                "10회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0002",
            "title": "런지(Lunge) 매트릭스",
            "thumb": "/assets/thumbs/FitFunction-0002.png",
            "guide": [
                "한 발을 앞으로 보내 무릎을 굽혀 앉았다 일어선다.(프론트 런지)",
                "한 발을 옆으로 뻗어 내고 무릎을 굽혀 앉았다 일어선다.(사이드 런지)",
                "한 발을 뒤로 보내 무릎을 굽혀 앉았다 일어선다.(리버스 런지)",
                "프론트런지 - 사이드런지 - 리버스런지 동작을 연결하여 3~5회 반복하고, 2~3세트 실시한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0044",
            "title": "한발 스쿼트(Single Leg Squat, dumbbell)",
            "thumb": "/assets/thumbs/Dumbbell-0044.png",
            "guide": [
                "양 손에 덤벨을 들고 한 발로 지지하고 선다.",
                "지지한 다리의 무릎을 굽히고 들고 있는 다리는 뒤로 보내며 앉았다 일어선다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "GB/GB-0033",
            "title": "한발 들고 짐볼 스쿼트(Single Leg Squat with Stability ball)",
            "thumb": "/assets/thumbs/GB-0033.png",
            "guide": [
                "벽과 등 사이에 짐볼을 대고 기대어 선다.",
                "한 발을 들고 지지한 다리의 무릎을 굽혀 앉았다 일어난다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0012",
            "title": "보수볼 밸런스(BOSU Balance)",
            "thumb": "/assets/thumbs/BOSU-0012.png",
            "guide": [
                "보수볼 위에 한 발로 서서 무릎을 가볍게 굽히고 반대쪽 다리를 뒤로 보낸다.",
                "동시에 상체를 앞으로 숙여 20~30초간 자세를 유지한다.",
                "같은 방법으로 다리를 바꿔 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0091",
            "title": "BAPS보드 고유신경촉진 운동(BAPS Board PNF)",
            "thumb": "/assets/thumbs/MS-Ankle-0091.png",
            "guide": [
                "워블보드(Wobble Board) 위에 한 발로 서서 5~10초간 균형을 유지한다.",
                "2~3세트 반복 후 다리를 바꿔 같은 방법으로 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0085",
            "title": "밸런스 공 던져 받기(Balance ball toss)",
            "thumb": "/assets/thumbs/MS-Ankle-0085.png",
            "guide": [
                "밸런스 패드(stability pad)에 한 발로 서서 한 손에 테니스공(기타 작은 공)을 잡는다.",
                "균형을 유지하면서 공을 위로 던져 반대쪽 손으로 받는다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
    ],

    "knee-arthroplasty-rehab": [
        {
            "id": "MS/MS-Knee-0003",
            "title": "Q 세트(Quad Sets)",
            "thumb": "/assets/thumbs/MS-Knee-0003.png",
            "guide": [
                "무릎을 펴고 앉아 허벅지에 힘을 주고 5초간 유지한 후 힘을 뺀다.",
                "10~15회 10세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0048",
            "title": "발목 펌프운동(Ankle Pump Exercise)",
            "thumb": "/assets/thumbs/MS-Knee-0048.png",
            "guide": [
                "다리를 펴고 앉는다.",
                "다리를 편 채 발목을 발등쪽으로 굽혔다(족배굴곡) 발바닥쪽으로 굽힌다.(족저굴곡)",
                "10회 10세트 반복하여 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0022",
            "title": "뒤꿈치 당기기(Heel Slide)",
            "thumb": "/assets/thumbs/MS-Knee-0022.png",
            "guide": [
                "다리를 펴고 누워 바닥을 쓸 듯 한 쪽 뒤꿈치를 엉덩이쪽으로 천천히 당겼다 내린다.",
                "10~15회 10세트 반복하여 실시한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0056",
            "title": "옆으로 누워 고관절 외전(Hip abduction, side lying)",
            "thumb": "/assets/thumbs/PilatesMat-0056.png",
            "guide": [
                "옆으로 누워 위쪽 다리를 펴서 옆으로 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0057",
            "title": "옆으로 누워 고관절 내전(Hip adduction, sidelying)",
            "thumb": "/assets/thumbs/PilatesMat-0057.png",
            "guide": [
                "다리를 펴고 옆으로 누워 위쪽 다리를 앞으로 보내 무릎을 굽혀 90°로 세운다.",
                "아래쪽 다리를 위로 들어올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0082",
            "title": "능동보조 뒤꿈치 당기기(Heel Slide, band)",
            "thumb": "/assets/thumbs/MS-Knee-0082.png",
            "guide": [
                "다리를 펴고 누워 한쪽 발목에 밴드를 걸고 같은 방향의 손으로 밴드를 잡는다.",
                "천천히 밴드를 당겨 뒤꿈치를 엉덩이 쪽으로 가능한 범위까지 끌어온다.",
                "10회 10세트 반복하여 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0013",
            "title": "다리 뻗어 들어올리기(Straight Leg Raise)",
            "thumb": "/assets/thumbs/MS-Knee-0013.png",
            "guide": [
                "바닥에 등을 대고 누워 한 쪽 무릎을 세우고 반대쪽 다리는 뻗는다.",
                "뻗은 다리의 발목을 발등쪽으로 굽히고(족배굴곡) 발가락은 발바닥쪽으로 굽힌 상태로 다리를 위로 들어 올렸다 내린다.",
                "15~20회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0043",
            "title": "능동보조 뒤꿈치 당기기(Active assist hamstring curl)",
            "thumb": "/assets/thumbs/MS-Knee-0043.png",
            "guide": [
                "다리를 펴고 누워 건측 다리를 환측 발등에 올린다.",
                "건측 다리의 도움을 받아 환측 다리의 무릎을 굽혀 뒤꿈치를 엉덩이 쪽으로 끌어당겼다 내린다.",
                "10~15회 3세트 반복 실시한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0008",
            "title": "뒤꿈치 들기(Heel raise)",
            "thumb": "/assets/thumbs/FitBW-0008.png",
            "guide": [
                "무릎을 편 채 발가락 끝으로 지지하여 뒤꿈치를 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0026",
            "title": "서서 다리 들어올리기(Straight Leg Raise, Standing)",
            "thumb": "/assets/thumbs/MS-Knee-0026.png",
            "guide": [
                "서서 환측 다리를 앞으로 뻗어 위로 들어 올리고 5초간 유지한 후 천천히 시작 위치로 돌아온다.",
                "10회 2~3세트 반복한다.",
                "※ 자력으로 서기 힘들 경우 벽을 짚거나 지지할 수 있는 것을 잡고 선다."
            ]
        },
        {
            "id": "MS/MS-Knee-0032",
            "title": "미니 스쿼트(Mini Squat, with Chair)",
            "thumb": "/assets/thumbs/MS-Knee-0032.png",
            "guide": [
                "다리를 어깨넓이로 벌리고 서서 양 손으로 의자 등받이를 잡는다.",
                "무릎을 가볍게 굽혀(15~30cm) 앉아 5~10초간 유지한다.",
                "10~15회 반복하여 2~3세트 실시한다.",
                "※ 90° 이상 무릎을 굽히지 않도록 한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0128",
            "title": "서서 고관절 외전/내전운동(standing hip abduction/adduction)",
            "thumb": "/assets/thumbs/MS-Knee-0128.png",
            "guide": [
                "한 손으로 의자를 잡고 옆으로 선다.",
                "바깥쪽 다리를 옆으로 들어 올렸다(고관절 외전) 천천히 시작 위치로 돌아온다.(고관절 내전)",
                "10~15회 반복 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0022",
            "title": "브릿지운동(Glute Bridge)",
            "thumb": "/assets/thumbs/PilatesMat-0022.png",
            "guide": [
                "등을 대고 바로 누워 무릎을 굽힌다.",
                "둔근을 수축시켜 골반을 들어올려 어깨부터 무릎까지 사선을 만들고 10초간 유지한다.(3회 반복)",
                "(이 때 발목을 족배굴곡(발등 굽힘)하면 더 효과적이다.)"
            ]
        },
        {
            "id": "MS/MS-Knee-0035",
            "title": "앉아 무릎 펴기(Terminal Knee Extension, Sitting)",
            "thumb": "/assets/thumbs/MS-Knee-0035.png",
            "guide": [
                "의자에 앉아 한 쪽 다리의 무릎 뒤쪽에 공을 놓는다.",
                "공 위에 올린 다리를 쭉 펴서 5초간 유지한 후 힘을 풀며 천천히 시작 위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0039",
            "title": "고정식 자전거운동(Stationary Bike)",
            "thumb": "/assets/thumbs/MS-Knee-0039.png",
            "guide": [
                "자전거를 탈 정도의 무릎 관절 각도가 나오면 무릎을 폈을 때 다리의 각도를 145°~160° 내외로 유지하면서 자전거를 탄다.",
                "5~20분까지 점진적으로 시간을 늘린다."
            ]
        },
        {
            "id": "MS/MS-Knee-0132",
            "title": "걷기(Treadmill Walking)",
            "thumb": "/assets/thumbs/MS-Knee-0132.png",
            "guide": [
                "점진적으로 걷기 운동(산책), 체중 부하 및 가벼운 기구 운동이 가능하다.",
                "2km/h 내외의 속도로 적응한 후 점차 4.8km/h 속도를 늘려 걷는다.",
                "시간은 처음에는 5분 부터 점차 20분까지 조절한다.",
                "※ 회복에 따라 걷기부터 조깅, 달리기까지 속도를 증가 시키고 시간은 20~40분까지 걷거나 뛸 수 있는 수준까지 늘린다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0041",
            "title": "밸런스패드 글쓰기(Single leg Balance pad)",
            "thumb": "/assets/thumbs/MS-Ankle-0041.png",
            "guide": [
                "밸런스 패드 위에 한 발로 선다. 다른 다리의 무릎을 가볍게 굽히고 균형을 유지하면서 알파벳 또는 이름을 쓴다.",
                "다리를 바꿔 같은 방법으로 실시한다."
            ]
        },
        {
            "id": "GB/GB-0001",
            "title": "대둔근 활성화(Glute maximus activation-Stability ball Wall Squat)",
            "thumb": "/assets/thumbs/GB-0001.png",
            "guide": [
                "벽과 등 사이에 짐볼을 두고 기대어 선다.",
                "무릎을 굽혀 엉덩이를 수직으로 내렸다 무릎을 펴며 올라온다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0037",
            "title": "앞으로 계단오르기(Front Step up)",
            "thumb": "/assets/thumbs/MS-Knee-0037.png",
            "guide": [
                "계단을 오르듯 한 발씩 스텝박스 위에 올라 섰다 뒤로 내려온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0038",
            "title": "옆으로 계단 오르기(Lateral step up)",
            "thumb": "/assets/thumbs/MS-Knee-0038.png",
            "guide": [
                "스텝박스를 옆에 두고 선다.",
                "안 쪽 발부터 스텝박스 위에 올라 섰다가 바깥쪽 다리부터 내려온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0041",
            "title": "계단 내리기(Step Down)",
            "thumb": "/assets/thumbs/MS-Knee-0041.png",
            "guide": [
                "스텝박스 위에 서서 한 발을 내려 바닥을 밟았다 다시 올라선다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
    ],
    "knee-rehab-1": [
        {
            "id": "FR/FR-0015",
            "title": "내전근 자가근막이완-폼롤러(Adductor Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0015.png",
            "guide": [
                "한 쪽 무릎을 굽혀 허벅지 안쪽에 폼롤러를 두고 엎드린다.",
                "폼롤러에 체중을 싣고 30초~1분간 좌우로 굴려 내전근을 압박이완한다.",
                "반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0047",
            "title": "서혜부 스트레치(Groin stretch, lotus)",
            "thumb": "/assets/thumbs/Stretch-0047.png",
            "guide": [
                "발바닥을 붙이고 앉아 무릎을 양 옆으로 벌린다.",
                "팔꿈치로 다리를 누르거나 상체를 앞으로 숙여 15초 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "FMS/FMS-OH-0008",
            "title": "내전근 스트레치-짐볼(Adductor stretch, Stability ball)",
            "thumb": "/assets/thumbs/FMS-OH-0008.png",
            "guide": [
                "짐볼에 앉아 한 쪽 다리를 옆으로 쭉 펴고 발을 족배굴곡(발등 굽힘)한다.",
                "무릎을 굽힌 다리쪽으로 체중을 옮겨 15초간 유지한다.",
                "3회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0141",
            "title": "고관절굴곡근 스트레치-누워서(Hip Flexor stretch, supine)",
            "thumb": "/assets/thumbs/MS-Knee-0141.png",
            "guide": [
                "베드에 바로 누워 다리를 베드 가장자리 아래로 늘어 뜨린다.",
                "한 쪽 무릎을 굽혀 양손으로 깍지를 껴 가슴쪽으로 당긴다.",
                "15초간 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0048",
            "title": "고관절 굴곡근 & 대퇴부 스트레치(Hip Flexor & Quadriceps Stretch)",
            "thumb": "/assets/thumbs/Stretch-0048.png",
            "guide": [
                "왼발을 앞으로 보내 바닥을 밟고, 오른쪽 다리는 뒤로 보내 무릎을 굽혀 발등을 짐볼에 올린다.",
                "골반과 함께 몸을 앞쪽으로 밀어내고 15초간 유지한다.",
                "3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "FR/FR-0012",
            "title": "대퇴근막장근 자가근막이완-폼롤러(TFL Self Myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0012.png",
            "guide": [
                "옆으로 골반 쪽에 폼롤러들 두고 골반 아래 대퇴근막장근을 압박이완 한다. 30초~1분내외 3회반복한다. 양쪽 모두 수행한다"
            ]
        },
        {
            "id": "Static/Static-F-0177",
            "title": "햄스트링 자가근막이완-폼롤러(Hamstring Self Myofascial release, foam roller)",
            "thumb": "/assets/thumbs/Static-F-0177.png",
            "guide": [
                "허벅지 뒤쪽에 폼롤러를 가로로 두고 앚아 다리를 뻗고 엉덩이를 든다.",
                "팔로 지지하여 폼롤러를 굴리듯이 위아래로 움직여 30초~1분 내외로 햄스트링을 압박이완 한다.(3~5회 반복)"
            ]
        },
        {
            "id": "Stretch/Stretch-0055",
            "title": "햄스트링 스트레치-누워서(Hamstring stretch, supine)",
            "thumb": "/assets/thumbs/Stretch-0055.png",
            "guide": [
                "바로 누워 양 손으로 한 쪽 다리의 허벅지를 잡아 몸쪽으로 끌어당기고 무릎을 편다.",
                "15초간 유지하고 양쪽 모두 3회씩 반복하여 실시한다."
            ]
        },
        {
            "id": "TP/TP-0096",
            "title": "슬굴곡근 자가근막이완-공(Hamstring self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0096.png",
            "guide": [
                "엉덩이 아래쪽과 오금 중간 허벅지 밑에 마사지공을 두고 앉는다.",
                "엉덩이를 들어 체중을 실어 마사지볼을 위아래로 30초~1분간 굴려 슬굴곡근을 압박이완(마시지) 한다.",
                "같은 방법으로 반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0057",
            "title": "햄스트링 스트레치-스텝박스(Hamstring stretch, step)",
            "thumb": "/assets/thumbs/Stretch-0057.mp4_000005625.png",
            "guide": [
                "한 쪽 다리를 펴서 뒤꿈치를 스텝박스 위에 올리고 선다.",
                "무릎을 편 채 상체를 앞으로 숙여 15초 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0081",
            "title": "서서 한쪽 무릎 가슴 쪽 당기기(Single Knee to chest, standing)",
            "thumb": "/assets/thumbs/Stretch-0081.png",
            "guide": [
                "다리를 어깨넓이로 벌리고 선다.",
                "한 쪽 다리를 굽혀 양 손으로 무릎을 가슴쪽으로 끌어 당기고 10~15초 유지한다.",
                "같은 방법으로 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0089",
            "title": "능동보조 무릎 굴곡(벽, Active assisted hamstring curl, wall)",
            "thumb": "/assets/thumbs/MS-Knee-0089.png",
            "guide": [
                "등을 대고 누워 양쪽 다리를 위로 뻗어 벽에 기대고 건측 다리를 환측 발목에 올린다.",
                "건측 다리의 도움을 받아 참을 수 있는 통증범위까지 뒤꿈치를 천천히 엉덩이 쪽으로 끌어 내렸다 올린다.",
                "10~15회 반복하고, 3세트 실시한다.",
                "※ 무릎굴곡의 각도가 충분하지 않다면 수시로 반복하여 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0022",
            "title": "뒤꿈치 당기기(Heel Slide)",
            "thumb": "/assets/thumbs/MS-Knee-0022.png",
            "guide": [
                "다리를 펴고 누워 바닥을 쓸 듯 한 쪽 뒤꿈치를 엉덩이쪽으로 천천히 당겼다 내린다.",
                "10~15회 10세트 반복하여 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0049",
            "title": "뒤꿈치 수건받치고 무릎신전(Heel drop)",
            "thumb": "/assets/thumbs/MS-Knee-0049.png",
            "guide": [
                "수건을 말아 발목 밑에 받치고 무릎을 펴 10초 유지하고, 5~10세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0152",
            "title": "엎드려 능동보조 무릎 신전(Active assisted knee extension, prone)",
            "thumb": "/assets/thumbs/MS-Knee-0152.png",
            "guide": [
                "무릎 아래쪽이 배드 밖으로 나갈 수 있도록 엎드려 무릎을 굽힌다.",
                "건측 발을 환측 다리의 뒤꿈치에 올리고 힘을 주어 천천히 환측 무릎을 폈다(신전) 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다.",
                "※ 무릎신전이 완전하지 않다면 통증이 없는 범위 내에서 수시로 무릎신전을 반복한다."
            ]
        },
        {
            "id": "FR/FR-0010",
            "title": "고관절 굴곡근 자가근막이완-폼롤러(Hip Flexor Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0010.png",
            "guide": [
                "골반 밑(고관절 굴곡근)에 폼롤러를 두고 엎드린다.",
                "다리를 펴서 30초~1분간  폼롤러를 굴려 고관절 굴곡근을 압박이완 한다.",
                "3~5세트 반복한다."
            ]
        },
        {
            "id": "FMS/FMS-OH-0017",
            "title": "내측광근(VMO) 활성화(Vastus Medialis Oblique activation-Terminal Knee Extension, sitting)",
            "thumb": "/assets/thumbs/FMS-OH-0017.png",
            "guide": [
                "무릎 뒤(오금)에 공(배구공 크기)을 놓고 무릎을 쭉 펴서 대퇴부 근육을 수축시킨다.",
                "10~15회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0003",
            "title": "Q 세트(Quad Sets)",
            "thumb": "/assets/thumbs/MS-Knee-0003.png",
            "guide": [
                "무릎을 펴고 앉아 허벅지에 힘을 주고 5초간 유지한 후 힘을 뺀다.",
                "10~15회 10세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0013",
            "title": "다리 뻗어 들어올리기(Straight Leg Raise)",
            "thumb": "/assets/thumbs/MS-Knee-0013.png",
            "guide": [
                "바닥에 등을 대고 누워 한 쪽 무릎을 세우고 반대쪽 다리는 뻗는다.",
                "뻗은 다리의 발목을 발등쪽으로 굽히고(족배굴곡) 발가락은 발바닥쪽으로 굽힌 상태로 다리를 위로 들어 올렸다 내린다.",
                "15~20회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0035",
            "title": "앉아 무릎 펴기(Terminal Knee Extension, Sitting)",
            "thumb": "/assets/thumbs/MS-Knee-0035.png",
            "guide": [
                "의자에 앉아 한 쪽 다리의 무릎 뒤쪽에 공을 놓는다.",
                "공 위에 올린 다리를 쭉 펴서 5초간 유지한 후 힘을 풀며 천천히 시작 위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
    ],

    "knee-rehab-2": [
        {
            "id": "FMS/FMS-OH-0018",
            "title": "내측광근(VMO) 활성화(Vastus Medialis Oblique activation-Terminal Knee Extension, standing)",
            "thumb": "/assets/thumbs/FMS-OH-0018.png",
            "guide": [
                "한 쪽 다리를 앞으로 보내 무릎을 구부려 앞에서 뒤로 밴드를 걸고 선다.",
                "밴드의 저항을 느끼면서 무릎을 펴 대퇴부 근육을 수축한다.",
                "10회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0008",
            "title": "뒤꿈치 들기(Heel raise)",
            "thumb": "/assets/thumbs/FitBW-0008.png",
            "guide": [
                "무릎을 편 채 발가락 끝으로 지지하여 뒤꿈치를 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0075",
            "title": "싱글레그 밸런스(Single Leg Balance)",
            "thumb": "/assets/thumbs/MS-Lumbar-0075.png",
            "guide": [
                "서서 한 발을 들고 15초~30초 이상 유지한다. 발을 바꿔 같은 방법으로 실시한다.",
                "3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0037",
            "title": "앞으로 계단오르기(Front Step up)",
            "thumb": "/assets/thumbs/MS-Knee-0037.png",
            "guide": [
                "계단을 오르듯 한 발씩 스텝박스 위에 올라 섰다 뒤로 내려온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0022",
            "title": "브릿지운동(Glute Bridge)",
            "thumb": "/assets/thumbs/PilatesMat-0022.png",
            "guide": [
                "엉덩이를 수축하여 골반을 들어 올려 어깨에서 무릎까지 일직선이 되도록 만든다.",
                "5초~10초간 유지한다. 3~5세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0032",
            "title": "미니 스쿼트(Mini Squat, with Chair)",
            "thumb": "/assets/thumbs/MS-Knee-0032.png",
            "guide": [
                "다리를 어깨넓이로 벌리고 서서 양 손으로 의자 등받이를 잡는다.",
                "무릎을 가볍게 굽혀(15~30cm) 앉아 5~10초간 유지한다.",
                "10~15회 반복하여 2~3세트 실시한다.",
                "※ 90° 이상 무릎을 굽히지 않도록 한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0041",
            "title": "덤벨 스쿼트(Dumbbell Squat)",
            "thumb": "/assets/thumbs/Dumbbell-0041.mp4_000001591.png",
            "guide": [
                "양 손에 덤벨을 들고 다리를 어깨보다 약간 넓게 벌리고 선다.",
                "허리를 세운 채 무릎을 굽혀 대퇴부가 바닥과 수평이 될때까지 엉덩이를 수직으로 내려 앉는다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0168",
            "title": "서서 무릎 신전-공(Terminal Knee Extension, Ball)",
            "thumb": "/assets/thumbs/MS-Knee-0168.png",
            "guide": [
                "무릎 뒤에 쿠션볼을 두고 벽에 기대어 선다.",
                "무릎을 쭉 펴서 쿠션볼을 조이고 1~2초간 유지한 후 힘을 빼며 시작자세로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0034",
            "title": "한쪽 무릎 굽혀 체중지지하기(Knee Bend, Single Leg)",
            "thumb": "/assets/thumbs/MS-Knee-0034.png",
            "guide": [
                "의자 등받이를 잡고 서서 한 쪽 다리(건측)를 뒤로 보내거나 살짝 든다.",
                "앞에 있는 다리(환측)에 체중을 실어 무릎을 가볍게 굽힌다.",
                "10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0170",
            "title": "뒤꿈치 바닥 밀기(Heel Pushes, sitting)",
            "thumb": "/assets/thumbs/MS-Knee-0170.png",
            "guide": [
                "짐볼이나 의자에 앉아 한 쪽 뒤꿈치(환측) 밑에 작은 쿠션볼을 둔다.",
                "뒤꿈치를 수직으로 밀어내려 쿠션볼을 조이고 2~3초간 유지한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "GB/GB-0001",
            "title": "대둔근 활성화(Glute maximus activation-Stability ball Wall Squat)",
            "thumb": "/assets/thumbs/GB-0001.png",
            "guide": [
                "벽과 등 사이에 짐볼을 두고 기대어 선다.",
                "무릎을 굽혀 엉덩이를 수직으로 내렸다 무릎을 펴며 올라온다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0200",
            "title": "리버스 런지 스쿼트(Reverse Lunge Squat)",
            "thumb": "/assets/thumbs/MS-Knee-0200.png",
            "guide": [
                "발바닥으로 바닥을 쓸 듯 한 쪽 다리를 뒤로 뻗으면서 앞에 있는 다리의 무릎을 천천히 굽힌다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Band/Band-0016",
            "title": "밴드저항 한발 레그프레스(Single Leg Press with band)",
            "thumb": "/assets/thumbs/Band-0016.png",
            "guide": [
                "팔로 바닥을 짚고 앉아 무릎을 굽혀 한 발에 밴드를 고정한다.",
                "밴드를 고정한 다리를 쭉 뻗었다 힘을 빼며 시작자세로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0244",
            "title": "뒤로 계단내리기(Step Back reach)",
            "thumb": "/assets/thumbs/MS-Lumbar-0244.png",
            "guide": [
                "스텝박스 위에 한 발로 선다.",
                "지지한 다리의 무릎을 굽히면서 들고 있는 다리를 천천히 뒤로 보내 바닥을 내딛는다.",
                "10~15회 반복하고 3세트 실시한다."
            ]
        },
        {
            "id": "TRX/TRX-0011",
            "title": "TRX 스쿼트(TRX Squat)",
            "thumb": "/assets/thumbs/TRX-0011.png",
            "guide": [
                "어깨넓이 보다 약간 넓게 벌리고 서서 팔꿈치를 굽혀 양 손으로 TRX 손잡이를 잡는다.",
                "팔을 펴면서 무릎을 굽혀 대퇴부가 바닥과 수평이 될 때까지 앉았다 일어난다.",
                "10~15회 반복하여 3세트 실시한다.",
                "※ 근력수준에 따라 한 쪽 다리로 실시한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0012",
            "title": "보수볼 밸런스(BOSU Balance)",
            "thumb": "/assets/thumbs/BOSU-0012.png",
            "guide": [
                "보수볼 위에 한 발로 서서 무릎을 가볍게 굽히고 반대쪽 다리를 뒤로 보낸다.",
                "동시에 상체를 앞으로 숙여 20~30초간 자세를 유지한다.",
                "같은 방법으로 다리를 바꿔 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0152",
            "title": "모래주머니를 이용한 무릎 굴곡(Hamstring curl with weight)",
            "thumb": "/assets/thumbs/MS-Knee-0152.png",
            "guide": [
                "한 쪽 발목(환측)에 모래주머니(근력에 따라 1~5kg 내외)를 착용하고 엎드린다.",
                "천천히 무릎을 굽혀 엉덩이 쪽으로 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다.",
                "※ 모래주머니가 없을 경우 영상처럼 반대쪽 발을 활용한다."
            ]
        },
        {
            "id": "Band/Band-0021",
            "title": "대둔근 & 중둔근 활성화-밴드저항 브릿지 (Glute maximus, medius activation- Hip external rotation/Glute bridge)",
            "thumb": "/assets/thumbs/Band-0021.png",
            "guide": [
                "무릎을 굽혀 밴드를 묶고 눕는다.",
                "양쪽 무릎을 옆으로 벌린 후 엉덩이를 들어 올려 5초간 유지한다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0038",
            "title": "밴드저항 고관절 신전(Hip extension with band)",
            "thumb": "/assets/thumbs/CB-0038.png",
            "guide": [
                "한 쪽 발목에 밴드(또는 케이블)를 걸고 선다.",
                "무릎을 편 채 밴드를 당겨 다리를 뒤로 보냈다(고관절 신전) 힘을 빼며 천천히 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
    ],

    "knee-rehab-3": [
        {
            "id": "MS/MS-Knee-0196",
            "title": "보수볼 스쿼트(BOSU Squat)",
            "thumb": "/assets/thumbs/MS-Knee-0196.png",
            "guide": [
                "보수볼 바닥이 위로 가게 하여 두 발로 올라선다.",
                "균형을 유지하면서 무릎을 굽히면서 앉았다 펴면서 일어난다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0017",
            "title": "한발 의자 앉아 일어나기(Single Leg Balance Sit to stand)",
            "thumb": "/assets/thumbs/GolfCon-0017(편집).png",
            "guide": [
                "의자에 앉아 한 쪽 무릎을 90°로 굽리고 반대쪽 다리를 들어 무릎을 편다.",
                "바닥쪽 다리에 체중을 실어 일어났다 천천히 앉는다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0240",
            "title": "벽 기대고 고관절 외전근 운동(Hip Abduction with Ball)",
            "thumb": "/assets/thumbs/MS-Lumbar-0240.png",
            "guide": [
                "벽 옆으로 서서 안쪽 다리를 굽혀서 들고 대퇴부 바깥쪽과 벽 사이에 쿠션볼을 둔다.",
                "다리를 벽쪽으로 밀어 쿠션볼을 조인다. 10초간 유지하고 3세트 실시한다."
            ]
        },
        {
            "id": "KB/KB-0004",
            "title": "케틀벨 스쿼트(Front Squat with Kettlebell)",
            "thumb": "/assets/thumbs/KB-0004.png",
            "guide": [
                "팔꿈치를 굽혀 가슴 앞에서 두 손으로 케틀벨 손잡이를 잡고 선다.",
                "무릎을 굽혀 대퇴부가 바닥과 수평이 될 때까지 수직으로 앉았다 일어난다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0197",
            "title": "밴드저항 케틀벨 스쿼트(Kettlebell Squats with band)",
            "thumb": "/assets/thumbs/MS-Knee-0197.png",
            "guide": [
                "양쪽 무릎을 밴드로 고정하고 서서 팔꿈치를 굽혀 가슴 앞에서 두 손으로 케틀벨을 잡는다.",
                "무릎 사이의 간격을 어깨넓이로 벌리면서 무릎을 굽혀 대퇴부가 바닥과 수평이 될 때까지 수직으로 앉았다 일어난다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0184",
            "title": "햄스트링 컬-앉아서(Hamstring curl with band, sitting)",
            "thumb": "/assets/thumbs/MS-Knee-0184.png",
            "guide": [
                "의자에 앉아 한 쪽 발(환측)을 앞으로 보내 발목에 밴드를 고정한다.",
                "밴드로 고정한 발을 천천히 엉덩이 쪽으로 당겼다 시작자세로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "KB/KB-0002",
            "title": "케틀벨 루마니안 데드리프트(Romanian Deadlift, Kettlebell)",
            "thumb": "/assets/thumbs/KB-0002.png",
            "guide": [
                "두 손으로 케틀벨을 들고 선다.",
                "무릎을 굽히고 상체를 앞으로 숙여 케틀벨이 바닥에 닿을 정도로 내렸다 무릎을 펴며 올라온다.",
                "상체를 직접적으로 숙이는 것이 아니라 고관절(hinge joint)을 이용해 상체가 자연스럽게 숙여지도록 한다.",
                "10~15회 반복하여 3세트 실시한다.",
                "※ 케틀벨을 든 팔이 내려가는 정도는 바닥에서 약 20~30cm까지로 스텝박스 등을 활용한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0248",
            "title": "스케이터 스쿼트(Skator squat)",
            "thumb": "/assets/thumbs/MS-Lumbar-0248.png",
            "guide": [
                "한 발을 수건(또는 미끄러질 수 있는 소도구) 위에 올리고 선다.",
                "발을 바닥에서 떼지 않고 수건과 함께 옆으로 밀면서 뻗어내고 반대쪽 무릎은 굽힌다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0249",
            "title": "스텝박스 스키어 스쿼트(Skier Squat)",
            "thumb": "/assets/thumbs/MS-Lumbar-0249.png",
            "guide": [
                "스텝박스 위에 한 발로 선다.",
                "지지한 다리의 무릎을 굽히면서 반대쪽 다리를 옆으로 뻗어 내렸다 시작자세로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0250",
            "title": "스텝다운 토우 탭(Step Down, toe taps)",
            "thumb": "/assets/thumbs/MS-Lumbar-0250.png",
            "guide": [
                "스텝박스 위에 한 발로 선다.",
                "바닥을 지지한 다리의 무릎을 굽히고 반대쪽 다리를 아래로 뻗어 내려 발끝(또는 뒤꿈치)으로 바닥을 터치한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0205",
            "title": "밴드저항 TKE 스텝다운(Step down -TKE, Band)",
            "thumb": "/assets/thumbs/MS-Knee-0205.png",
            "guide": [
                "스텝박스 위에 두 발로 서서 한 쪽 무릎(환측) 뒤에 밴드를 고정한다.",
                "밴드를 고정한 다리의 무릎을 굽히고 반대쪽 다리는 뒤로 뻗어 내렸다 시작자세로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0191",
            "title": "TRX 크로치(TRX Crouch)",
            "thumb": "/assets/thumbs/MS-Knee-0191.png",
            "guide": [
                "무릎을 굽히고 쪼그려 앉아 양 팔을 위로 뻗어 TRX 손잡이를 잡는다.",
                "자세를 유지한 채 양 쪽 뒤꿈치만 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0012",
            "title": "보수볼 밸런스(BOSU Balance)",
            "thumb": "/assets/thumbs/BOSU-0012.png",
            "guide": [
                "보수볼 위에 한 발로 서서 무릎을 가볍게 굽히고 반대쪽 다리를 뒤로 보낸다.",
                "동시에 상체를 앞으로 숙여 20~30초간 자세를 유지한다.",
                "같은 방법으로 다리를 바꿔 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0001",
            "title": "싱글레그 밸런스 리치(Single leg balance reach)",
            "thumb": "/assets/thumbs/FitFunction-0001.png",
            "guide": [
                "한 발로 균형을 잡고 선다.",
                "지지한 다리의 무릎을 굽히면서 들고 있는 다리를 여러 방향으로 뻗어 바닥을 터치한다.",
                "3~5회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "GB/GB-0034",
            "title": "짐볼 벽 기대고 정적 한발 스쿼트 (Static Single Leg Ball Squat)",
            "thumb": "/assets/thumbs/GB-0034.png",
            "guide": [
                "벽을 옆에 두고 서서 안쪽 다리를 굽혀서 들어 올리고 무릎과 벽 사이에 짐볼을 고정한다.",
                "지지한 다리의 무릎을 굽히면서 앉았다 일어난다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0195",
            "title": "보수볼 사이드스텝(BOSU Side Step)",
            "thumb": "/assets/thumbs/MS-Knee-0195.png",
            "guide": [
                "한 발을 보수볼 위에 올려 무릎을 가볍게 굽히고 반대쪽 다리는 옆으로 뻗어 바닥에 내린다.",
                "바닥에 있는 다리를 다시 보수볼 위로 올려 무릎을 굽히고, 보수볼에 위에 있던 다리는 옆으로 뻗어 바닥에 내린다.",
                "다리를 바꿔가며 10~15회 반복하고, 3세트 실시한다."
            ]
        },
        {
            "id": "GB/GB-0020",
            "title": "둔근 활성화-짐볼 브릿지 앤 컬(Glute activation-Bridge & Curl with Stability ball)",
            "thumb": "/assets/thumbs/GB-0020.png",
            "guide": [
                "짐볼에 두 발을 올리고 눕는다.",
                "엉덩이를 들어올려 무릎을 폈다 굽히면서 짐볼을 몸쪽으로 끌어온다.",
                "10회 3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0024",
            "title": "밴드저항 싱글 레그익스텐션 & 브릿지(Single Leg Extension & Bridge, band)",
            "thumb": "/assets/thumbs/Band-0024.png",
            "guide": [
                "바닥에 등을 대고 누워 한 다리를 펴서 발바닥에 밴드를 고정하고, 반대쪽 다리는 무릎을 세운다.",
                "골반을 들어 올린 후 밴드에 고정된 다리를 위로 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "KB/KB-0016",
            "title": "한발 데드리프트(Single Leg Deadlift)",
            "thumb": "/assets/thumbs/KB-0016.png",
            "guide": [
                "한 발로 서서 반대쪽 손에 케틀벨을 들고 팔을 아래로 내린다.",
                "바닥을 지지한 다리를 가볍게 굽히고 상체를 앞으로 기울이면서 반대쪽 다리는 엉덩이 높이까지 뒤로 뻗는다.",
                "단, 상체는 고관절(hinge joint)의 움직임에 의해 자연스럽게 숙여지도록 한다.",
                "10~15회 반복하여 3세트 실시한다.",
                "※ 케틀벨을 든 팔이 내려가는 정도는 바닥에서 약 20~30cm까지로 스텝박스 등을 활용한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0203",
            "title": "메디슨 볼 스쿼트 피벗(Squat and Pivot, ball)",
            "thumb": "/assets/thumbs/MS-Knee-0203.png",
            "guide": [
                "메디신 볼을 두 손으로 들고 서서 무릎을 굽혀 스쿼트 자세를 만든다.",
                "한 쪽 발을 축으로 반대쪽 발을 들고 일어나면서 회전하고 다시 원위치로 돌아와 스쿼트 자세를 만든다.",
                "10회 반복 후 반대쪽으로 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0204",
            "title": "밴드저항 스쿼트 피벗(Squat and Pivot, band)",
            "thumb": "/assets/thumbs/MS-Knee-0204.png",
            "guide": [
                "밴드를 두 손으로 잡고 서서 무릎을 굽혀 스쿼트 자세를 만든다.",
                "한 쪽 발을 축으로 반대쪽 발을 들고 일어서면서 회전하고 다시 원위치로 돌아와 스쿼트 자세를 만든다.",
                "10회 반복 후 반대쪽으로 실시하고, 2~3세트 반복한다."
            ]
        },
    ],

    "knee-rehab-4": [
        {
            "id": "Band/Band-0033",
            "title": "밴드저항 사이드워킹(Sidewalking with Band)",
            "thumb": "/assets/thumbs/Band-0033.png",
            "guide": [
                "무릎 아래 또는 발목에 밴드를 걸어 저항을 느끼며 오른쪽으로 5~10보, 왼쪽으로 5~10보씩 옆으로 걷는다.(3회 3세트 반복)"
            ]
        },
        {
            "id": "MS/MS-Knee-0213",
            "title": "보수볼 케틀벨 스쿼트(Front Squat Kettlebell, BOSU)",
            "thumb": "/assets/thumbs/MS-Knee-0213.png",
            "guide": [
                "보수볼 바닥이 위로 가게 하여 두 발로 올라선다.",
                "두 손으로 케틀벨을 잡아 가슴 앞에 두고 균형을 유지하면서 무릎을 굽혀 앉았다 일어난다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0215",
            "title": "밴드 저항 옆으로 계단 오르기(Lateral Step Up, band)",
            "thumb": "/assets/thumbs/MS-Knee-0215.png",
            "guide": [
                "옆으로 서서 바깥쪽 다리의 무릎 외측에 밴드를 걸고 발 옆에는 스텝박스를 둔다.",
                "밴드의 저항을 느끼며 바깥쪽 다리부터 차례로 스텝박스 위에 올려 섰다가 원위치로 돌아온다.",
                "10~15회 3세트 반복하고, 반대쪽으로도 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0216",
            "title": "케틀벨 한발 스쿼트(Single Leg Squat, Kettlebell)",
            "thumb": "/assets/thumbs/MS-Knee-0216.png",
            "guide": [
                "한 발로 서서 양 손에 케틀벨을 든다.",
                "바닥을 지지한 다리의 무릎을 굽히면서 앉았다 일어선다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0217",
            "title": "보수볼 케틀벨 데드리프트(Single Leg Deadlift, BOSU)",
            "thumb": "/assets/thumbs/MS-Knee-0217.png",
            "guide": [
                "보수볼을 거꾸로 하여 왼발로 올라 서서 오른손에 케틀벨을 든다.",
                "왼쪽 무릎을 굽히고 오른쪽 다리를 뒤로 뻗으면서 상체를 앞으로 숙여 5~10초간 균형을 유지한다.",
                "10~15회 반복 후 반대쪽으로 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0006",
            "title": "한발 네방향 뜀뛰기(Single Leg Hop, plus pattern)",
            "thumb": "/assets/thumbs/FitFunction-0006.png",
            "guide": [
                "한 발로 서서 앞, 뒤, 옆, 대각선 방향으로 가볍게 점프(Hop)한다.",
                "10~15회 반복 후 발을 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0219",
            "title": "보수볼 스키어 스쿼트(Skier Squat, BOSU)",
            "thumb": "/assets/thumbs/MS-Knee-0219.png",
            "guide": [
                "보수볼 바닥이 위로 가게 하여 한 발로 올라선다.",
                "지지한 다리의 무릎을 굽혀 앉으면서 들고 있는 다리를 보수볼 옆으로 뻗어 내린다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0220",
            "title": "보수볼 스텝 백(Step Back, BOSU)",
            "thumb": "/assets/thumbs/MS-Knee-0220.png",
            "guide": [
                "보수볼 바닥이 위로 가게 하여 한 발로 올라선다.",
                "지지한 다리의 무릎을 굽혀 앉으면서 들고 있는 다리를 뒤로 뻗는다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0222",
            "title": "스쿼트 점프 턴(Squat Jump Turns)",
            "thumb": "/assets/thumbs/MS-Knee-0222.png",
            "guide": [
                "스쿼트 자세로 점프하여 몸을 180° 회전시켜 착지한다.",
                "10회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0221",
            "title": "케틀벨 스텝 백(Step Back with Kettlebell)",
            "thumb": "/assets/thumbs/MS-Knee-0221.png",
            "guide": [
                "양 손에 케틀벨을 들고 스텝박스 위에 선다.",
                "한 쪽 무릎을 굽히면서 반대쪽 발을 뒤로 보내 바닥으로 내렸다 돌아온다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0034",
            "title": "짐볼 벽 기대고 정적 한발 스쿼트 (Static Single Leg Ball Squat)",
            "thumb": "/assets/thumbs/GB-0034.png",
            "guide": [
                "벽을 옆에 두고 서서 안쪽 다리를 굽혀서 들어 올리고 무릎과 벽 사이에 짐볼을 고정한다.",
                "지지한 다리의 무릎을 굽히면서 앉았다 일어난다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0207",
            "title": "한발 스텝박스 점프/다운(Single Leg Hop Up/Down)",
            "thumb": "/assets/thumbs/MS-Knee-0207.png",
            "guide": [
                "스텝박스를 앞에 두고 한 발을 들고 선다.",
                "스텝박스 위로 점프하여 한 발로 올라선 후 다시 점프하여 원위치로 돌아온다.",
                "10회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0208",
            "title": "한발 서서 두발 점프 다운(1 to 2 Leg Hop Down)",
            "thumb": "/assets/thumbs/MS-Knee-0208.png",
            "guide": [
                "한 발로 스텝박스 위에 올라 선다.",
                "한 발로 점프하여 두 발로 바닥에 착지 한 후 시작위치로 돌아온다.",
                "10회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0209",
            "title": "한발서서 두발 점프 업(1 to 2 Leg Hop Up)",
            "thumb": "/assets/thumbs/MS-Knee-0209.png",
            "guide": [
                "스텝박스를 앞에 두고 한 발로 선다.",
                "한 발로 점프하여 두 발로 스텝박스 위에 착지한 후 시작위치로 돌아온다.",
                "10회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0195",
            "title": "보수볼 사이드스텝(BOSU Side Step)",
            "thumb": "/assets/thumbs/MS-Knee-0195.png",
            "guide": [
                "한 발을 보수볼 위에 올려 무릎을 가볍게 굽히고 반대쪽 다리는 옆으로 뻗어 바닥에 내린다.",
                "바닥에 있는 다리를 다시 보수볼 위로 올려 무릎을 굽히고, 보수볼에 위에 있던 다리는 옆으로 뻗어 바닥에 내린다.",
                "다리를 바꿔가며 10~15회 반복하고, 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0211",
            "title": "박스점프(Box Jump)",
            "thumb": "/assets/thumbs/MS-Knee-0211.png",
            "guide": [
                "스텝박스를 앞에 두고 두 발로 서서 점프하여 스텝박스 위에 두 발로 착지한다.",
                "10회 2~3세트 반복한다.",
                "* 근력에 따라 스텝박스의 높이를 조절한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0212",
            "title": "박스 회전점프(Box Jump, Rotation)",
            "thumb": "/assets/thumbs/MS-Knee-0212.png",
            "guide": [
                "스텝박스를 옆에 두고 선다.",
                "두 발로 점프하여 몸을 90° 회전하여 스텝박스 위에 두 발로 착지한다.",
                "10회 반복 후 반대쪽으로 실시하고, 2~3세트 반복한다."
            ]
        },
    ],
    "hip-pelvis-rehab-1": [
        {
            "id": "FR/FR-0010",
            "title": "고관절 굴곡근 자가근막이완-폼롤러(Hip Flexor Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0010.png",
            "guide": [
                "골반 밑(고관절 굴곡근)에 폼롤러를 두고 엎드린다.",
                "다리를 펴서 30초~1분간  폼롤러를 굴려 고관절 굴곡근을 압박이완 한다.",
                "3~5세트 반복한다."
            ]
        },
        {
            "id": "Static/Static-F-0177",
            "title": "햄스트링 자가근막이완-폼롤러(Hamstring Self Myofascial release, foam roller)",
            "thumb": "/assets/thumbs/Static-F-0177.png",
            "guide": [
                "허벅지 뒤쪽에 폼롤러를 가로로 두고 앚아 다리를 뻗고 엉덩이를 든다.",
                "팔로 지지하여 폼롤러를 굴리듯이 위아래로 움직여 30초~1분 내외로 햄스트링을 압박이완 한다.(3~5회 반복)"
            ]
        },
        {
            "id": "FR/FR-0012",
            "title": "대퇴근막장근 자가근막이완-폼롤러(TFL Self Myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0012.png",
            "guide": [
                "옆으로 골반 쪽에 폼롤러들 두고 골반 아래 대퇴근막장근을 압박이완 한다. 30초~1분내외 3회반복한다. 양쪽 모두 수행한다"
            ]
        },
        {
            "id": "FR/FR-0011",
            "title": "요추신전근 자가근막이완-폼롤러(Lumbar Erector Spinae Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0011.png",
            "guide": [
                "허리(요추부) 아래에 폼롤러를 두고 누워 30초~1분 내외로 위아래로 굴려 압박이완 한다.(3~5회 반복)"
            ]
        },
        {
            "id": "FR/FR-0018",
            "title": "이상근 자가근막이완-폼롤러(Piriformis Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0018.png",
            "guide": [
                "팔을 뒤로 보내 바닥을 짚고 폼롤러 위에 앉아 한 쪽 다리를 반대쪽 무릎 위에 올린다.",
                "올린 다리의 엉덩이 아래쪽 이상근을 압박하면서 30초~1분 내외로 폼롤러를 굴린다.",
                "3~5회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "FR/FR-0015",
            "title": "내전근 자가근막이완-폼롤러(Adductor Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0015.png",
            "guide": [
                "한 쪽 무릎을 굽혀 허벅지 안쪽에 폼롤러를 두고 엎드린다.",
                "폼롤러에 체중을 싣고 30초~1분간 좌우로 굴려 내전근을 압박이완한다.",
                "반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0044",
            "title": "90도 90도 고관절 스트레치(90/90 degree Hip stretch)",
            "thumb": "/assets/thumbs/Stretch-0044.png",
            "guide": [
                "한 쪽 다리를 뒤로 90°, 반대쪽 다리를 앞으로 90° 굽히고 앉는다.",
                "상체를 앞으로 숙여 15초간 유지하여 3회 반복 후 다리를 바꿔 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0041",
            "title": "고관절 굴곡근 스트레치(Hip Flexor stretch)",
            "thumb": "/assets/thumbs/Stretch-0041.png",
            "guide": [
                "무릎을 굽혀 오른쪽 다리를 뒤로 보내고, 왼쪽 발을 앞으로 보내 바닥을 밟는다.",
                "오른팔을 위로 뻗어 상체와 함께 왼쪽으로 측굴 후 몸통을 오른쪽으로 회전하고 골반을 뒤로 기울인다.(후방전위)",
                "15초간 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0047",
            "title": "서혜부 스트레치(Groin stretch, lotus)",
            "thumb": "/assets/thumbs/Stretch-0047.png",
            "guide": [
                "발바닥을 붙이고 앉아 무릎을 양 옆으로 벌린다.",
                "팔꿈치로 다리를 누르거나 상체를 앞으로 숙여 15초 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0043",
            "title": "고관절 내전근 스트레치(Hip Adductor stretch)",
            "thumb": "/assets/thumbs/Stretch-0043.png",
            "guide": [
                "다리를 넓게 벌리고 서서 오른발을 바깥쪽으로 회전한다.(고관절 외전, 외회전)",
                "왼쪽 무릎을 굽히고 앉으면서 체중을 실어 15초간 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0024",
            "title": "앉아 요추기립근 스트레치(Lumbar Erector Spinae stretch-Forward Bending Fold)",
            "thumb": "/assets/thumbs/Stretch-0024.png",
            "guide": [
                "의자 끝에 앉아 양쪽 무릎을 어깨 넓이보다 넓게 벌린다.",
                "무릎 사이로 상체를 숙여 15초간 유지한다.(3회 반복)"
            ]
        },
        {
            "id": "Stretch/Stretch-0039",
            "title": "이상근 스트레치-누워서(Piriformis stretch, supine)",
            "thumb": "/assets/thumbs/Stretch-0039.png",
            "guide": [
                "무릎을 굽히고 바로 누워 한 쪽 다리를 반대쪽 무릎 위에 올린다.",
                "바닥에 둔 다리의 무릎 뒤(슬와부)로 깎지를 껴서 다리를 가슴쪽으로 당긴다.",
                "15초간 유지하여 3회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0042",
            "title": "서서 대퇴근막장근 스트레치(TFL stretch, stand)",
            "thumb": "/assets/thumbs/Stretch-0042.png",
            "guide": [
                "한 쪽 다리를 뒤로 보내고 같은 쪽 팔을 위로 뻗어 올려 몸과 함께 반대방향으로 측굴하여 15초간 유지한다.",
                "3회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0055",
            "title": "햄스트링 스트레치-누워서(Hamstring stretch, supine)",
            "thumb": "/assets/thumbs/Stretch-0055.png",
            "guide": [
                "바로 누워 양 손으로 한 쪽 다리의 허벅지를 잡아 몸쪽으로 끌어당기고 무릎을 편다.",
                "15초간 유지하고 양쪽 모두 3회씩 반복하여 실시한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0065",
            "title": "런지 스트레치(Lunge Stretch)",
            "thumb": "/assets/thumbs/PilatesMat-0065.png",
            "guide": [
                "네 발 기기 자세에서 왼쪽 다리를 앞으로 보내 발을 왼손 바깥에 두고 발끝을  45° 외회전시킨다.",
                "오른쪽 발끝으로 지지하여 무릎을 편다. 10초간 유지하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0225",
            "title": "고관절 굴곡 외회전(Hip Flexion External Rotation)",
            "thumb": "/assets/thumbs/MS-Lumbar-0225.png",
            "guide": [
                "무릎을 굽혀 한 발을 앞으로 보내고 앉아 몸을 앞쪽으로 비스듬히 기울여 한 손으로 바닥을 짚는다.",
                "팔꿈치로 앞으로 보낸 다리를 바깥쪽으로 밀어 천천히 고관절을 외회전시킨다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0226",
            "title": "짐볼 기대고 고관절 굴곡 외회전(Hip Flexion External Rotation -ball)",
            "thumb": "/assets/thumbs/MS-Lumbar-0226.png",
            "guide": [
                "짐볼을 앞에 두고 무릎을 굽혀 한 발을 앞으로 보내고 앉는다.",
                "몸을 앞쪽으로 기울이면서 팔꿈치로 앞으로 보낸 다리를 바깥방향으로 밀어 천천히 고관절을 외회전시킨다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0021",
            "title": "기도 스트레치(Prayer Stretch)",
            "thumb": "/assets/thumbs/Stretch-0021.png",
            "guide": [
                "네 발 기기 자세로 엎드린다.",
                "엉덩이를 뒤로 보내고 상체를 아래로 내려 15초간 유지하고, 2~3세트 반복한다."
            ]
        },
    ],

    "hip-pelvis-rehab-2": [
        {
            "id": "PilatesMat/PilatesMat-0016",
            "title": "무릎 사이 공 조이면서 브릿지(Pillow squeeze bridge)",
            "thumb": "/assets/thumbs/PilatesMat-0016.png",
            "guide": [
                "바닥에 등을 대고 누워 무릎을 굽히고 어깨넓이로 벌려 양 무릎사이에 쿠션볼(또는 베개)을 끼운다.",
                "골반을 들어 올리면서 다리 사이의 공을 조이고 힘을 빼면서 시작자세로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0055",
            "title": "옆으로 누워 고관절 외회전운동(Sidelying Hip external rotation-Clamshell)",
            "thumb": "/assets/thumbs/PilatesMat-0055.png",
            "guide": [
                "머리에 쿠션을 대고 옆으로 누워 다리를 모아 무릎을 90° 정도로 구부린다.",
                "골반을 고정한 채 두 발은 붙이고 위 쪽 다리를 서서히 벌려 무릎사이가 멀어지도록 한다.",
                "10~15회 2~3세트 반복하고, 반대쪽으로 실시한다."
            ]
        },
        {
            "id": "Band/Band-0021",
            "title": "대둔근 & 중둔근 활성화-밴드저항 브릿지 (Glute maximus, medius activation- Hip external rotation/Glute bridge)",
            "thumb": "/assets/thumbs/Band-0021.png",
            "guide": [
                "무릎을 굽혀 밴드를 묶고 눕는다.",
                "양쪽 무릎을 옆으로 벌린 후 엉덩이를 들어 올려 5초간 유지한다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0056",
            "title": "중둔근 활성화-옆으로 누워 다리올리기(Glute medius activation-Sidelying leg raise)",
            "thumb": "/assets/thumbs/PilatesMat-0056.png",
            "guide": [
                "옆으로 누워 위쪽 다리를 펴서 옆으로 들어 올린다.",
                "10회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0116",
            "title": "서서 골반 올리고 내리기(Hip Hike, Standing)",
            "thumb": "/assets/thumbs/MS-Lumbar-0116.png",
            "guide": [
                "스텝박스 가장자리에 한 다리로 올라선다.",
                "지지한 다리의 무릎을 편 채 반대쪽 골반을 내려 발을 바닥쪽으로 내렸다 다시 골반을 끌어 올린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Static/Static-S-0064",
            "title": "코어강화 운동-정적 데드버그운동(Core activation-Static Dead Bug exercise)",
            "thumb": "/assets/thumbs/Static-S-0064.png",
            "guide": [
                "한 쪽 무릎을 가슴쪽으로 올리려는 힘을 쓰고 반대손으로 저항하여 버티고, 동시에 반대쪽 팔과 다리는 바닥과 수평하게 뻗는다.",
                "5~10초간 유지한 후 팔과 다리를 바꿔 실시한다.(3~5세트 반복)"
            ]
        },
        {
            "id": "MS/MS-Lumbar-0181",
            "title": "봉을 이용한 힙 힌지(Hip Hinge with stick)",
            "thumb": "/assets/thumbs/MS-Lumbar-0181.png",
            "guide": [
                "등에 긴 바(Bar)를 수직으로 세워 양 손으로 위 아래를 잡고 선다.",
                "무릎을 굽히고 골반을 기울이면서 상체를 앞으로 숙였다 원위치로 돌아온다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0068",
            "title": "네발기기자세 고관절 신전(Hip Extension, Quadruped)",
            "thumb": "/assets/thumbs/PilatesMat-0068.png",
            "guide": [
                "네 발 기기 자세로 엎드려 자세를 유지한 채 한 쪽 다리를 펴서 엉덩이 높이로 들어 올린다.",
                "시작자세로 돌아와 다시 반대쪽 다리를 펴서 들어 올린다.",
                "양쪽 다리를 번갈아 가며 10~15반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Static/Static-S-0131",
            "title": "고관절 외회전 운동(Hip external rotator activation-Clamshell with Band)",
            "thumb": "/assets/thumbs/Static-S-0131.png",
            "guide": [
                "두 다리에 밴드를 걸고 옆으로 누워 발을 붙인 상태로 무릎을 옆으로 벌린다.(고관절 외회전)",
                "10회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0022",
            "title": "브릿지운동(Glute Bridge)",
            "thumb": "/assets/thumbs/PilatesMat-0022.png",
            "guide": [
                "등을 대고 바로 누워 무릎을 굽힌다.",
                "둔근을 수축시켜 골반을 들어올려 어깨부터 무릎까지 사선을 만들고 10초간 유지한다.(3회 반복)",
                "(이 때 발목을 족배굴곡(발등 굽힘)하면 더 효과적이다.)"
            ]
        },
        {
            "id": "CB/CB-0036",
            "title": "밴드저항 고관절 외전(Hip Abduction with band, Standing)",
            "thumb": "/assets/thumbs/CB-0036.png",
            "guide": [
                "옆으로 서서 바깥쪽 다리의 발목에 밴드를 걸고 다리를 옆으로 들어 올린다.(외전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0161",
            "title": "보수볼 허리 신전(Back Extension-BOSU)",
            "thumb": "/assets/thumbs/MS-Lumbar-0161.png",
            "guide": [
                "보수볼에 배를 대고 엎드려 다리를 뻗는다.",
                "상체를 가볍게 들어 올리고 1~3초간 자세를 유지한다.",
                "10회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0041",
            "title": "엎드려 두 다리들기(Prone Glute Leg Lifts)",
            "thumb": "/assets/thumbs/PilatesMat-0041.png",
            "guide": [
                "바닥에 엎드려 다리를 펴서 어깨넓이로 벌린다.",
                "골반을 고정한 채 엉덩이 근육을 수축시키면서 두 다리를 동시에 들어 올렸다 내린다.",
                "10~15회 반복하고 3세트 실시한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0057",
            "title": "옆으로 누워 고관절 내전(Hip adduction, sidelying)",
            "thumb": "/assets/thumbs/PilatesMat-0057.png",
            "guide": [
                "다리를 펴고 옆으로 누워 위쪽 다리를 앞으로 보내 무릎을 굽혀 90°로 세운다.",
                "아래쪽 다리를 위로 들어올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
    ],
    "hip-pelvis-rehab-3": [
        {
            "id": "PilatesCadillac/PilatesCadillac-0061",
            "title": "내전근 활성화(Adductor activation-Hip Adduction with Band, standing)",
            "thumb": "/assets/thumbs/PilatesCadillac-0061.mp4_000011425.png",
            "guide": [
                "옆으로 서서 밖에서 안으로 한 쪽 발목에 밴드(케이블)를 건다.",
                "밴드를 건 다리를 안쪽으로 끌어온다.",
                "10회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0186",
            "title": "사이드플랭크 고관절 외회전(Side Plank Clamshell)",
            "thumb": "/assets/thumbs/MS-Lumbar-0186.png",
            "guide": [
                "옆으로 누워 아래쪽 팔을 굽혀 어깨와 수직이 되도록 바닥을 지지하고 무릎을 굽힌다.",
                "골반을 들어 올린 상태에서 발목을 붙이고 위쪽 무릎을 위로 들어 올렸다(고관절 외회전) 내린다.",
                "10~15회 반복하고 시작자세로 돌아온다. 3세트 실시한다."
            ]
        },
        {
            "id": "Band/Band-0021",
            "title": "대둔근 & 중둔근 활성화-밴드저항 브릿지 (Glute maximus, medius activation- Hip external rotation/Glute bridge)",
            "thumb": "/assets/thumbs/Band-0021.png",
            "guide": [
                "무릎을 굽혀 밴드를 묶고 눕는다.",
                "양쪽 무릎을 옆으로 벌린 후 엉덩이를 들어 올려 5초간 유지한다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0034",
            "title": "한발 브릿지(Single Leg Glute Bridge, leg straight)",
            "thumb": "/assets/thumbs/PilatesMat-0034.png",
            "guide": [
                "바닥에 등을 대고 누워 양 팔은 가슴앞으로 뻗고 무릎을 세운다.",
                "골반을 들어 올려 어깨부터 무릎까지 사선을 만든다.",
                "골반의 높이와 수평을 유지한 채 한 쪽 다리를 펴서 가슴쪽으로 뻗어 올렸다 내린다.",
                "5~10회 반복 후 다리를 바꿔 같은 방법으로 실시한다. 2~3세트 실시한다."
            ]
        },
        {
            "id": "Band/Band-0034",
            "title": "밴드저항 고관절 굴곡(Hip Flexor with band, Stand)",
            "thumb": "/assets/thumbs/Band-0034.png",
            "guide": [
                "링밴드를 양 발에 걸고 서서 한 쪽 다리의 무릎을 굽혀 가슴까지 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0050",
            "title": "네발기기자세 고관절 신전(Hip Extension-Quadruped, Dumbbell)",
            "thumb": "/assets/thumbs/Dumbbell-0050.png",
            "guide": [
                "네 발 기기 자세로 엎드려 한 쪽 무릎 뒤에 덤벨을 올린다.",
                "무릎을 90°로 유지한 채 다리를 엉덩이 높이로 들어 올린다.(고관절 신전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0039",
            "title": "스모 스쿼트(Sumo Squat)",
            "thumb": "/assets/thumbs/Dumbbell-0039.png",
            "guide": [
                "두 손으로 덤벨을 잡고 서서 다리를 어깨넓이 보다 넓게 벌리고 발을 45° 외회전시킨다.",
                "상체를 세우고 무릎을 굽히면서 수직으로 앉았다 일어선다.",
                "10~15회 반복하여 3세트 실시한다.",
                "※ 양 발의 간격 : 무릎을 굽혀 앉을 때 직각이 될 정도"
            ]
        },
        {
            "id": "MS/MS-Lumbar-0193",
            "title": "밴드저항 사이드플랭크 고관절 외회전(Side Plank Clamshell, band)",
            "thumb": "/assets/thumbs/MS-Lumbar-0193.png",
            "guide": [
                "옆으로 누워 아래쪽 팔을 굽혀 어깨와 수직이 되도록 바닥을 지지하고 무릎을 굽혀 밴드로 고정한다.",
                "골반을 들어 올린 후 발목을 붙인 채 위쪽 무릎을 위로 벌렸다(고관절 외회전) 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0240",
            "title": "벽 기대고 고관절 외전근 운동(Hip Abduction with Ball)",
            "thumb": "/assets/thumbs/MS-Lumbar-0240.png",
            "guide": [
                "벽 옆으로 서서 안쪽 다리를 굽혀서 들고 대퇴부 바깥쪽과 벽 사이에 쿠션볼을 둔다.",
                "다리를 벽쪽으로 밀어 쿠션볼을 조인다. 10초간 유지하고 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0244",
            "title": "뒤로 계단내리기(Step Back reach)",
            "thumb": "/assets/thumbs/MS-Lumbar-0244.png",
            "guide": [
                "스텝박스 위에 한 발로 선다.",
                "지지한 다리의 무릎을 굽히면서 들고 있는 다리를 천천히 뒤로 보내 바닥을 내딛는다.",
                "10~15회 반복하고 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0204",
            "title": "밴드저항 스쿼트 피벗(Squat and Pivot, band)",
            "thumb": "/assets/thumbs/MS-Knee-0204.png",
            "guide": [
                "밴드를 두 손으로 잡고 서서 무릎을 굽혀 스쿼트 자세를 만든다.",
                "한 쪽 발을 축으로 반대쪽 발을 들고 일어서면서 회전하고 다시 원위치로 돌아와 스쿼트 자세를 만든다.",
                "10회 반복 후 반대쪽으로 실시하고, 2~3세트 반복한다."
            ]
        },
    ],
    "hip-pelvis-rehab-4": [
        {
            "id": "MS/MS-Lumbar-0187",
            "title": "무릎대고 사이드플랭크 & 외전 (Knee Side Plank & Abduction)",
            "thumb": "/assets/thumbs/MS-Lumbar-0187.png",
            "guide": [
                "옆으로 누워 아래쪽 팔을 굽혀 어깨와 수직이 되도록 바닥을 지지하고 무릎을 굽힌다.",
                "골반을 들어 올리고 위쪽 다리를 골반높이로 펴서(외전) 10초간 유지한 후 시작자세로 돌아온다.",
                "3~5회 반복한다."
            ]
        },
        {
            "id": "Band/Band-0033",
            "title": "밴드저항 사이드워킹(Sidewalking with Band)",
            "thumb": "/assets/thumbs/Band-0033.png",
            "guide": [
                "무릎 아래 또는 발목에 밴드를 걸어 저항을 느끼며 오른쪽으로 5~10보, 왼쪽으로 5~10보씩 옆으로 걷는다.(3회 3세트 반복)"
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0034",
            "title": "한발 브릿지(Single Leg Glute Bridge, leg straight)",
            "thumb": "/assets/thumbs/PilatesMat-0034.png",
            "guide": [
                "바닥에 등을 대고 누워 양 팔은 가슴앞으로 뻗고 무릎을 세운다.",
                "골반을 들어 올려 어깨부터 무릎까지 사선을 만든다.",
                "골반의 높이와 수평을 유지한 채 한 쪽 다리를 펴서 가슴쪽으로 뻗어 올렸다 내린다.",
                "5~10회 반복 후 다리를 바꿔 같은 방법으로 실시한다. 2~3세트 실시한다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0025",
            "title": "짐볼 브릿지(Glute Bridge, Stability ball)",
            "thumb": "/assets/thumbs/GolfCon-0025.png",
            "guide": [
                "바닥에 등을 대고 누워 다리를 펴서 짐볼 위에 올린다.",
                "둔근을 수축시키면서 골반을 들어 올려 발부터 어깨까지 사선을 만들어 10초간 유지한다.",
                "10회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0005",
            "title": "대둔근 활성화-한발 브릿지(Glute maximus activation-Single Leg Bridge)",
            "thumb": "/assets/thumbs/FitBW-0005.png",
            "guide": [
                "무릎을 굽혀 한 쪽 발로 지지하고 누워 골반이 기울지 않게 유지하면서 엉덩이를 들어 올린다.",
                "이 때 바닥을 지지한 발을 족배굴곡(발등 굽힘)하여 강도를 높일 수 있다.",
                "10~15회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "GB/GB-0020",
            "title": "둔근 활성화-짐볼 브릿지 앤 컬(Glute activation-Bridge & Curl with Stability ball)",
            "thumb": "/assets/thumbs/GB-0020.png",
            "guide": [
                "짐볼에 두 발을 올리고 눕는다.",
                "엉덩이를 들어올려 무릎을 폈다 굽히면서 짐볼을 몸쪽으로 끌어온다.",
                "10회 3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0044",
            "title": "한발 스쿼트(Single Leg Squat, dumbbell)",
            "thumb": "/assets/thumbs/Dumbbell-0044.png",
            "guide": [
                "양 손에 덤벨을 들고 한 발로 지지하고 선다.",
                "지지한 다리의 무릎을 굽히고 들고 있는 다리는 뒤로 보내며 앉았다 일어선다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "CB/CB-0028",
            "title": "싱글레그 스쿼트 & 로우(Single Leg Squat & Row)",
            "thumb": "/assets/thumbs/CB-0028.png",
            "guide": [
                "한발로 서서 반대쪽 손으로 케이블을 잡는다.",
                "지지한 다리의 무릎을 굽히면서 동시에 상체를 기울이며 케이블을 잡은 팔을 앞으로 뻗는다.",
                "무릎을 펴고 상체를 세우며 동시에 팔꿈치를 굽히며 케이블을 당긴다.",
                "10회 2~3세트 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "KB/KB-0002",
            "title": "케틀벨 루마니안 데드리프트(Romanian Deadlift, Kettlebell)",
            "thumb": "/assets/thumbs/KB-0002.png",
            "guide": [
                "두 손으로 케틀벨을 들고 선다.",
                "무릎을 굽히고 상체를 앞으로 숙여 케틀벨이 바닥에 닿을 정도로 내렸다 무릎을 펴며 올라온다.",
                "상체를 직접적으로 숙이는 것이 아니라 고관절(hinge joint)을 이용해 상체가 자연스럽게 숙여지도록 한다.",
                "10~15회 반복하여 3세트 실시한다.",
                "※ 케틀벨을 든 팔이 내려가는 정도는 바닥에서 약 20~30cm까지로 스텝박스 등을 활용한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0248",
            "title": "스케이터 스쿼트(Skator squat)",
            "thumb": "/assets/thumbs/MS-Lumbar-0248.png",
            "guide": [
                "한 발을 수건(또는 미끄러질 수 있는 소도구) 위에 올리고 선다.",
                "발을 바닥에서 떼지 않고 수건과 함께 옆으로 밀면서 뻗어내고 반대쪽 무릎은 굽힌다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0249",
            "title": "스텝박스 스키어 스쿼트(Skier Squat)",
            "thumb": "/assets/thumbs/MS-Lumbar-0249.png",
            "guide": [
                "스텝박스 위에 한 발로 선다.",
                "지지한 다리의 무릎을 굽히면서 반대쪽 다리를 옆으로 뻗어 내렸다 시작자세로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0250",
            "title": "스텝다운 토우 탭(Step Down, toe taps)",
            "thumb": "/assets/thumbs/MS-Lumbar-0250.png",
            "guide": [
                "스텝박스 위에 한 발로 선다.",
                "바닥을 지지한 다리의 무릎을 굽히고 반대쪽 다리를 아래로 뻗어 내려 발끝(또는 뒤꿈치)으로 바닥을 터치한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "KB/KB-0016",
            "title": "싱글레그 데드리프트(Single Leg Deadlift)",
            "thumb": "/assets/thumbs/KB-0016.png",
            "guide": [
                "한 발로 서서 반대쪽 손에 케틀벨을 들고 팔을 아래로 내린다.",
                "바닥을 지지한 다리를 가볍게 굽히고 상체를 앞으로 기울이면서 반대쪽 다리는 엉덩이 높이까지 뒤로 뻗는다.",
                "단, 상체는 고관절(hinge joint)의 움직임에 의해 자연스럽게 숙여지도록 한다.",
                "10~15회 반복하여 3세트 실시한다.",
                "※ 케틀벨을 든 팔이 내려가는 정도는 바닥에서 약 20~30cm까지로 스텝박스 등을 활용한다."
            ]
        },
    ],

    "achilles-surgery-rehab": [
        {
            "id": "MS/MS-Ankle-0001",
            "title": "발목 족저굴곡(Plantar flexion)",
            "thumb": "/assets/thumbs/MS-Ankle-0001.png",
            "guide": [
                "다리를 일자로 펴고 앉아 발목 밑에 수건을 받친다.",
                "다리를 편 채 발목을 최대한 발바닥 쪽으로 내렸다(족적굴곡) 힘을 빼며 원위치로 돌아온다.",
                "15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0002",
            "title": "발목 배측굴곡(Dosiflexion)",
            "thumb": "/assets/thumbs/MS-Ankle-0002.png",
            "guide": [
                "다리를 일자로 펴고 앉아 발목 밑에 수건을 받친다.",
                "다리를 편 채 발목을 발등쪽으로 최대한 굽혔다(족배굴곡) 힘을 빼며 원위치로 돌아온다.",
                "15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0003",
            "title": "발목 내반(Inversion)",
            "thumb": "/assets/thumbs/MS-Ankle-0003.png",
            "guide": [
                "다리를 일자로 펴서 발목 밑에 수건을 받친다.",
                "다리를 편 채 발목을 안쪽 방향으로 말듯이 젖혔다(내반) 힘을 빼며 원위치로 돌아온다.",
                "15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0004",
            "title": "발목 외반(Eversion)",
            "thumb": "/assets/thumbs/MS-Ankle-0004.png",
            "guide": [
                "다리를 일자로 펴서 발목 아래에 수건을 받친다.",
                "다리를 편 채 발목을 바깥쪽으로 젖혔다(외반) 힘을 빼며 원위치로 돌아온다.",
                "15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0005",
            "title": "워블보드에 발 올려 발목회전(Wobble Board Ankle Circle)",
            "thumb": "/assets/thumbs/MS-Ankle-0005.png",
            "guide": [
                "의자에 앉아 한 발을 워블보드(Wobble Board)에 올린다.",
                "위(배측굴곡), 아래(족저굴곡), 안쪽(내반), 바깥쪽(외반)으로 발목을 능동적으로 움직인다.",
                "15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0006",
            "title": "등척성 발목 내반(Isometric Inversion)",
            "thumb": "/assets/thumbs/MS-Ankle-0006.png",
            "guide": [
                "발목을 안쪽(내측)으로 젖히려고 하고 팔로 저항하는 힘을 주면서 5초간 유지한 후 힘을 뺀다.",
                "10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0007",
            "title": "등척성 발목 외반(Isometric Eversion)",
            "thumb": "/assets/thumbs/MS-Ankle-0007.png",
            "guide": [
                "발목을 바깥쪽(외측)으로 젖히려고 하고 팔로 저항하는 힘을 주면서 5초간 유지한 후 힘을 뺀다.",
                "10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0008",
            "title": "등척성 족저굴곡(Isometric Plantar flexion)",
            "thumb": "/assets/thumbs/MS-Ankle-0008.png",
            "guide": [
                "발목을 밑으로 밀어내려는 힘(족저굴곡)을 쓰고 손으로 저항하여 5초간 유지한 후 힘을 뺀다.",
                "10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0009",
            "title": "등척성 족배굴곡(Isometric Dorsiflexion)",
            "thumb": "/assets/thumbs/MS-Ankle-0009.png",
            "guide": [
                "발목의 발등을 당기려는 하는 힘(족배굴곡)에 대한 저항을 주어 중립 위치를 유지 시킨다.",
                "5초간 힘에 대한 저항을 유지하고 힘을 푸는 형태로 10회 3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0027",
            "title": "밴드저항 족저굴곡(Plantar flexion with band)",
            "thumb": "/assets/thumbs/Band-0027.png",
            "guide": [
                "밴드를 발의 바닥에 고정하고 발을 뻗고 앉는다.",
                "발을 바닥 쪽으로 밀어낸다(족저굴곡).",
                "시작 위치로 돌아온다. 10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0028",
            "title": "밴드저항 족배굴곡(Dorsiflexion with band)",
            "thumb": "/assets/thumbs/Band-0028.png",
            "guide": [
                "한 쪽 다리를 펴서 발등에 밴드를 고정하고 발목을 발등쪽으로 굽힌다.(족배굴곡)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Band/Band-0029",
            "title": "밴드저항 발목 외반(Eversion with band)",
            "thumb": "/assets/thumbs/Band-0029.mp4_000001291.png",
            "guide": [
                "다리를 펴고 앉아 발 바깥쪽에 밴드를 고정한다.",
                "무릎을 편 채 발목을 밖으로 젖혔다 힘을 빼며 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Band/Band-0030",
            "title": "밴드저항 발목 내반(Inversion with band)",
            "thumb": "/assets/thumbs/Band-0030.mp4_000001558.png",
            "guide": [
                "다리를 펴고 앉아 발 안쪽에 밴드를 고정한다.",
                "무릎을 편 채 발목을 안으로 젖혔다 힘을 빼며 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0014",
            "title": "발목 신전이 강조된 굴곡 저항운동(Eccentric Plantar flexion)",
            "thumb": "/assets/thumbs/MS-Ankle-0014.png",
            "guide": [
                "한 쪽 무릎을 가볍게 굽히고 뒤꿈치를 들어 발가락으로 바닥을 딛고 선다.",
                "뒤꿈치를 천천히 바닥으로 내린다.(굴곡저항)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0008",
            "title": "뒤꿈치 들기(Heel raise)",
            "thumb": "/assets/thumbs/FitBW-0008.png",
            "guide": [
                "무릎을 편 채 발가락 끝으로 지지하여 뒤꿈치를 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0075",
            "title": "싱글레그 밸런스(Single Leg Balance)",
            "thumb": "/assets/thumbs/MS-Lumbar-0075.png",
            "guide": [
                "서서 한 발을 들고 15초~30초 이상 유지한다. 발을 바꿔 같은 방법으로 실시한다.",
                "3세트 반복한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0010",
            "title": "싱글레그 밸런스 리치(Single leg balance reach)",
            "thumb": "/assets/thumbs/FitFunction-0010.png",
            "guide": [
                "한 발로 균형을 잡고 서서 무릎을 굽히면서 들고 있는 다리를 여러 방향으로 뻗어 바닥 또는 콘(cone)을 터치하고 돌아온다.",
                "2회 반복하고 반대쪽도 실시한다."
            ]
        },
    ],
    "ankle-sprain-rehab": [
        {
            "id": "MS/MS-Ankle-0008",
            "title": "등척성 족저굴곡(Isometric Plantar flexion)",
            "thumb": "/assets/thumbs/MS-Ankle-0008.png",
            "guide": [
                "발목을 밑으로 밀어내려는 힘(족저굴곡)을 쓰고 손으로 저항하여 5초간 유지한 후 힘을 뺀다.",
                "10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0009",
            "title": "등척성 족배굴곡(Isometric Dorsiflexion)",
            "thumb": "/assets/thumbs/MS-Ankle-0009.png",
            "guide": [
                "발목의 발등을 당기려는 하는 힘(족배굴곡)에 대한 저항을 주어 중립 위치를 유지 시킨다.",
                "5초간 힘에 대한 저항을 유지하고 힘을 푸는 형태로 10회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0006",
            "title": "등척성 발목 내반(Isometric Inversion)",
            "thumb": "/assets/thumbs/MS-Ankle-0006.png",
            "guide": [
                "발목을 안쪽(내측)으로 젖히려고 하고 팔로 저항하는 힘을 주면서 5초간 유지한 후 힘을 뺀다.",
                "10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0007",
            "title": "등척성 발목 외반(Isometric Eversion)",
            "thumb": "/assets/thumbs/MS-Ankle-0007.png",
            "guide": [
                "발목을 바깥쪽(외측)으로 젖히려고 하고 팔로 저항하는 힘을 주면서 5초간 유지한 후 힘을 뺀다.",
                "10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0064",
            "title": "수건을 이용한 아킬레스 스트레치(Achilles stretch, towel)",
            "thumb": "/assets/thumbs/Stretch-0064.png",
            "guide": [
                "다리를 펴고 앉아 한 쪽 발에 수건을 걸고 양 끝을 손으로 잡는다.",
                "수건을 당겨 발목을 발등쪽으로 굽혀(족배굴곡) 15초 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0055",
            "title": "햄스트링 스트레치-누워서(Hamstring stretch, supine)",
            "thumb": "/assets/thumbs/Stretch-0055.png",
            "guide": [
                "바로 누워 양 손으로 한 쪽 다리의 허벅지를 잡아 몸쪽으로 끌어당기고 무릎을 편다.",
                "15초간 유지하고 양쪽 모두 3회씩 반복하여 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0053",
            "title": "옆으로 누워 대퇴부 스트레치(Quadricep, lying)",
            "thumb": "/assets/thumbs/Stretch-0053(편집).png",
            "guide": [
                "옆으로 누워 위쪽 무릎을 굽혀 뒤쪽에서 손으로 발목을 잡아 당긴다.",
                "15초 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0027",
            "title": "뱁스보드 발목회전(Baps Board Ankle circle)",
            "thumb": "/assets/thumbs/MS-Ankle-0027.png",
            "guide": [
                "다리를 어깨넓이로 벌리고 서서 한 발을 뱁스보드(워블보드)에 올린다.",
                "위(배측굴곡), 아래(족저굴곡), 안쪽(내반), 바깥쪽(외반)으로 발목을 능동적으로 움직인다.",
                "15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Static/Static-F-0225",
            "title": "발가락 신전(Toe Extension, Windlass Mechanism)",
            "thumb": "/assets/thumbs/Static-F-0225.png",
            "guide": [
                "양쪽 다리를 일자로 펴고 앉아 발목을 고정한 채 발가락을 최대한 아래로 굽혔다 편다.",
                "15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0061",
            "title": "비복근 스트레치(Gastrocnemius stretch)",
            "thumb": "/assets/thumbs/Stretch-0061.png",
            "guide": [
                "벽에 양 손을 짚고 기대어 선다.",
                "한 발을 앞으로 보내 무릎을 구부리고, 뒤쪽 다리는 무릎을 펴고 뒤꿈치를 바닥에 붙여 15초간 유지한다.",
                "양쪽 모두 실시하고, 3회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0062",
            "title": "가자미근 스트레치(Soleus stretch)",
            "thumb": "/assets/thumbs/Stretch-0062.png",
            "guide": [
                "양 손으로 벽을 짚거나 Bar를 잡고 선다.",
                "스트레치 하려는 다리를 뒤로 보내 뒤꿈치를 바닥에 붙인 상태에서 무릎을 최대한 굽힌다.",
                "15초간 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0063",
            "title": "가자미근 스트레치-앉아서(Soleus stretch, sitting)",
            "thumb": "/assets/thumbs/Stretch-0063.png",
            "guide": [
                "스트레치 하려는 다리를 앞으로 보내 무릎을 90°로 굽혀 세운다.",
                "뒤꿈치를 붙인 채 무릎을 앞쪽으로 최대한 밀어 가자미근을 스트레치 한다.",
                "15초간 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0065",
            "title": "벽 기대고 아킬레스 스트레치(Achilles stretch, wall)",
            "thumb": "/assets/thumbs/Stretch-0065.png",
            "guide": [
                "스텝박스 가장자리에 발끝으로 올라 서서 손으로 벽을 짚는다.",
                "무릎을 편 채 뒤꿈치를 아래로 늘어뜨려 15초 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0027",
            "title": "밴드저항 족저굴곡(Plantar flexion with band)",
            "thumb": "/assets/thumbs/Band-0027.png",
            "guide": [
                "밴드를 발의 바닥에 고정하고 발을 뻗고 앉는다.",
                "발을 바닥 쪽으로 밀어낸다(족저굴곡).",
                "시작 위치로 돌아온다. 10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0028",
            "title": "밴드저항 족배굴곡(Dorsiflexion with band)",
            "thumb": "/assets/thumbs/Band-0028.png",
            "guide": [
                "한 쪽 다리를 펴서 발등에 밴드를 고정하고 발목을 발등쪽으로 굽힌다.(족배굴곡)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Band/Band-0029",
            "title": "밴드저항 발목 외반(Eversion with band)",
            "thumb": "/assets/thumbs/Band-0029.mp4_000001291.png",
            "guide": [
                "다리를 펴고 앉아 발 바깥쪽에 밴드를 고정한다.",
                "무릎을 편 채 발목을 밖으로 젖혔다 힘을 빼며 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Band/Band-0030",
            "title": "밴드저항 발목 내반(Inversion with band)",
            "thumb": "/assets/thumbs/Band-0030.mp4_000001558.png",
            "guide": [
                "다리를 펴고 앉아 발 안쪽에 밴드를 고정한다.",
                "무릎을 편 채 발목을 안으로 젖혔다 힘을 빼며 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0010",
            "title": "싱글레그 밸런스 리치(Single leg balance reach)",
            "thumb": "/assets/thumbs/FitFunction-0010.png",
            "guide": [
                "한 발로 균형을 잡고 서서 무릎을 굽히면서 들고 있는 다리를 여러 방향으로 뻗어 바닥 또는 콘(cone)을 터치하고 돌아온다.",
                "2회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0039",
            "title": "발목 내반 수건끌기(Inversion with towel)",
            "thumb": "/assets/thumbs/MS-Ankle-0039.png",
            "guide": [
                "의자에 앉아 수건을 펼쳐 안쪽 가장자리를 발바닥으로 밟는다.",
                "뒤꿈치를 고정한 채 발가락으로 수건을 잡고 발목을 안쪽으로 젖혀(내반)혀 수건을 안쪽으로 끌어간다.",
                "10~15회 반복하여 2~3세트 실시한다.",
                "※ 운동강도를 높이기 위해 수건의 반대쪽 끝에 원반이나 덤벨을 올린다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0018",
            "title": "토구 밸런스(Togu balance)",
            "thumb": "/assets/thumbs/GolfCon-0018(편집).png",
            "guide": [
                "토구(Togu) 위에 한 발로 서서 무릎을 가볍게 굽히고 10~30초 균형을 유지한다.",
                "3회 반복하고, 발을 바꿔 같은 방법으로 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0041",
            "title": "밸런스패드 글쓰기(Single leg Balance pad)",
            "thumb": "/assets/thumbs/MS-Ankle-0041.png",
            "guide": [
                "밸런스 패드 위에 한 발로 선다. 다른 다리의 무릎을 가볍게 굽히고 균형을 유지하면서 알파벳 또는 이름을 쓴다.",
                "다리를 바꿔 같은 방법으로 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0042",
            "title": "한발 박스 점프(Single Leg Box Jump)",
            "thumb": "/assets/thumbs/MS-Ankle-0042.png",
            "guide": [
                "한 발로 점프하여 스텝박스 위로 올라섰다 내려온다.",
                "10회 반복 후 다리를 바꿔 같은 방법으로 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0043",
            "title": "한발 밸런스-폼롤러(Single leg balance with foam roller)",
            "thumb": "/assets/thumbs/MS-Ankle-0043.png",
            "guide": [
                "폼롤러 위에 한 발로 올라 서서 10~30초간 균형을 유지한다.",
                "3세트 반복하고, 같은 방법으로 발을 바꿔 실시한다.",
                "※ 근력 수준이나 균형을 유지하는 능력에 따라 폼롤러를 반원, 작은 것, 큰 것으로 대체한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0044",
            "title": "한발 힙 힌지(Single Leg hip Hinge)",
            "thumb": "/assets/thumbs/MS-Ankle-0044.png",
            "guide": [
                "한 발로 서서 상체를 숙이고 들고 있는 다리를 뒤로 보내며 균형을 유지한다.",
                "10회 3세트 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0045",
            "title": "폼롤러 한발 스쿼트(Single leg squate with foam roller)",
            "thumb": "/assets/thumbs/MS-Ankle-0045.png",
            "guide": [
                "폼롤러 위에 한 발로 서 균형을 유지하면서 무릎을 굽혀 앉았다 일어선다.",
                "10회 반복 후 다리를 바꿔 같은 방법으로 실시하고, 3세트 반복한다.",
                "* 근력, 균형 능력에 따라 폼롤러를 반원형태, 작은 것, 큰 것으로 바꿔 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0046",
            "title": "폼롤러 짐볼 밸런스(Stability ball control with foam roller)",
            "thumb": "/assets/thumbs/MS-Ankle-0046.png",
            "guide": [
                "다리를 어깨넓이로 벌리고 폼롤러 위에 서서 양 팔을 뻗어 짐볼을 든다.",
                "무릎을 가볍게 굽히고 균형을 유지하면서 짐볼을 머리 위로 들어 올렸다 무릎 높이로 내린다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0005",
            "title": "런지 트위스트(Lunge Twist)",
            "thumb": "/assets/thumbs/FitFunction-0005.png",
            "guide": [
                "한 발을 충분히 앞으로 보내 무릎을 90°로 굽혀 앉으면서 손을 모아 팔을 가슴앞으로 뻗는다.",
                "몸통과 함께 팔을 앞으로 보낸 다리 방향으로 회전시킨다.",
                "다리를 바꿔가며 10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0248",
            "title": "스케이터 스쿼트(Skator squat)",
            "thumb": "/assets/thumbs/MS-Lumbar-0248.png",
            "guide": [
                "한 발을 수건(또는 미끄러질 수 있는 소도구) 위에 올리고 선다.",
                "발을 바닥에서 떼지 않고 수건과 함께 옆으로 밀면서 뻗어내고 반대쪽 무릎은 굽힌다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0244",
            "title": "뒤로 계단내리기(Step Back reach)",
            "thumb": "/assets/thumbs/MS-Lumbar-0244.png",
            "guide": [
                "스텝박스 위에 한 발로 선다.",
                "지지한 다리의 무릎을 굽히면서 들고 있는 다리를 천천히 뒤로 보내 바닥을 내딛는다.",
                "10~15회 반복하고 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0195",
            "title": "보수볼 사이드스텝(BOSU Side Step)",
            "thumb": "/assets/thumbs/MS-Knee-0195.png",
            "guide": [
                "한 발을 보수볼 위에 올려 무릎을 가볍게 굽히고 반대쪽 다리는 옆으로 뻗어 바닥에 내린다.",
                "바닥에 있는 다리를 다시 보수볼 위로 올려 무릎을 굽히고, 보수볼에 위에 있던 다리는 옆으로 뻗어 바닥에 내린다.",
                "다리를 바꿔가며 10~15회 반복하고, 3세트 실시한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0006",
            "title": "한발 네방향 뜀뛰기(Single Leg Hop, plus pattern)",
            "thumb": "/assets/thumbs/FitFunction-0006.png",
            "guide": [
                "한 발로 서서 앞, 뒤, 옆, 대각선 방향으로 가볍게 점프(Hop)한다.",
                "10~15회 반복 후 발을 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0207",
            "title": "한발 스텝박스 점프/다운(Single Leg Hop Up/Down)",
            "thumb": "/assets/thumbs/MS-Knee-0207.png",
            "guide": [
                "스텝박스를 앞에 두고 한 발을 들고 선다.",
                "스텝박스 위로 점프하여 한 발로 올라선 후 다시 점프하여 원위치로 돌아온다.",
                "10회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0208",
            "title": "한발 서서 두발 점프 다운(1 to 2 Leg Hop Down)",
            "thumb": "/assets/thumbs/MS-Knee-0208.png",
            "guide": [
                "한 발로 스텝박스 위에 올라 선다.",
                "한 발로 점프하여 두 발로 바닥에 착지 한 후 시작위치로 돌아온다.",
                "10회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
    ],
    "ankle-rehab-1": [
        {
            "id": "MS/MS-Ankle-0055",
            "title": "발목회전(Ankle Circumduction",
            "thumb": "/assets/thumbs/MS-Ankle-0055.png",
            "guide": [
                "의자에 앉아 발목을 시계방향, 반시계방향으로 회전한다.",
                "15회 반복하여 3~5세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0056",
            "title": "발목 굴곡/신전(Ankle Dorsiflexion /Plantarflexion)",
            "thumb": "/assets/thumbs/MS-Ankle-0056.png",
            "guide": [
                "무릎을 펴서 폼롤러 위에 다리를 올린다.",
                "발목을 바닥쪽으로 폈다(족저굴곡) 발등쪽으로 굽힌다.(족배굴곡)",
                "15회 반복하여 3~5세트 실시한다."
            ]
        },
        {
            "id": "FR/FR-0021",
            "title": "전경골근 자가근막이완-폼롤러(Anterior Shin, Foam Roller)",
            "thumb": "/assets/thumbs/FR-0021.png",
            "guide": [
                "무릎 아래 정강이뼈(경골)에 폼롤러를 가로로 두고 푸쉬업 자세로 엎드린다.",
                "폼롤러를 위 아래쪽으로 굴려 앞정강이 근육(전경골근)을 압박이완 한다.",
                "30초~1분간 반복하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0019",
            "title": "비복근 자가근막이완-폼롤러(Gastrocnemius Self Myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0019.png",
            "guide": [
                "폼롤러 위에 한발의 종아리를 올리고 다른 다리를 겹쳐 위에 두고 비복근을 압박 이완한다. 30초~1분내외 3회반복한다. 양쪽모두 수행한다."
            ]
        },
        {
            "id": "TP/TP-0100",
            "title": "비복근 자가근막이완-공(Gastrocnemius self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0100.png",
            "guide": [
                "다리를 펴고 앉아 한 쪽 다리를 반대쪽 다리 위로 올린다.",
                "10cm높이의 받침대 위에 마사지볼을 두고 볼 위에 종아리를 올린다.",
                "공을 가볍게 압박하면서 30초간 굴려준 후 다리를 바꿔 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0060",
            "title": "밴드 글라이드 족배굴곡 (Dorsiflexion AP Glide with band)",
            "thumb": "/assets/thumbs/MS-Ankle-0060.png",
            "guide": [
                "한 쪽 발목에 밴드를 걸어 스텝박스 위에 올리고 선다.",
                "뒤꿈치를 붙인 채 밴드의 탄성에 저항하며 무릎을 굽히고 몸을 앞으로 기울여 발등을 최대한 굽히고 5초 유지한다.",
                "10회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0063",
            "title": "가자미근 스트레치-앉아서(Soleus stretch, sitting)",
            "thumb": "/assets/thumbs/Stretch-0063.png",
            "guide": [
                "무릎을 구부리고 앉아 스트레치 하려는 다리를 90°로 굽혀 앞으로 보낸다.",
                "뒤꿈치를 바닥에 붙인 채 앞으로 보낸 다리의 무릎을 최대한 앞쪽으로 밀어낸다.",
                "15초간 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0061",
            "title": "비복근 스트레치(Gastrocnemius stretch)",
            "thumb": "/assets/thumbs/Stretch-0061.png",
            "guide": [
                "벽에 양 손을 짚고 기대어 선다.",
                "한 발을 앞으로 보내 무릎을 구부리고, 뒤쪽 다리는 무릎을 펴고 뒤꿈치를 바닥에 붙여 15초간 유지한다.",
                "양쪽 모두 실시하고 3회씩 반복한다."
            ]
        },
        {
            "id": "Static/Static-F-0218",
            "title": "족저근막 자가근막이완-공(Plantar Fascia Self Myofascial Release, ball)",
            "thumb": "/assets/thumbs/Static-F-0218.png",
            "guide": [
                "발바닥의 아치 부분에 테니스공 또는 골프공을 두고 가볍게 체중을 실어 30초~1분 내외로 압박이완 한다.",
                "양쪽 발 모두 실시하고 3회씩 반복한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0064",
            "title": "족저근막 자가근막이완-폼롤러(Plantar Fascia Self myofascial release, Foam Roller)",
            "thumb": "/assets/thumbs/MS-Ankle-0064.png",
            "guide": [
                "발바닥 아치에 작은 폼롤러를 두고 서서 가볍게 체중을 실으며 압박 이완 한다.",
                "30초~1분간 3~5회 반복한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0065",
            "title": "무릎 꿇고 족배굴곡(Plantar Flexion-kneeling)",
            "thumb": "/assets/thumbs/MS-Ankle-0065.png",
            "guide": [
                "무릎으로 앉는다. 뒤꿈치가 엉덩이에 닿도록 천천히 무릎을 꿇고 않는다.",
                "5~10초 유지하고 처음 위치로 돌아온다. 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0062",
            "title": "가자미근 스트레치(Soleus stretch)",
            "thumb": "/assets/thumbs/Stretch-0062.png",
            "guide": [
                "손으로 벽을 짚거나 Bar를 잡고 선다.",
                "스트레치 하고자 하는 다리를 뒤로 보내 뒤꿈치를 붙인 상태에서 무릎을 최대한 굽혀 가자미근을 스트레치한다.",
                "15초간 유지하여 3회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0064",
            "title": "수건을 이용한 아킬레스 스트레치(Achilles stretch, towel)",
            "thumb": "/assets/thumbs/Stretch-0064.png",
            "guide": [
                "다리를 펴고 앉아 발바닥을 수건으로 감싸고 양 끝을 손으로 잡는다.",
                "수건을 당겨 발목을 몸쪽으로 굽힌다.(족배굴곡)",
                "15초 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0003",
            "title": "발목 내반(Inversion)",
            "thumb": "/assets/thumbs/MS-Ankle-0003.png",
            "guide": [
                "다리를 일자로 펴서 발목 밑에 수건을 받친다.",
                "다리를 편 채 발목을 안쪽 방향으로 말듯이 젖혔다(내반) 힘을 빼며 원위치로 돌아온다.",
                "15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0004",
            "title": "발목 외반(Eversion)",
            "thumb": "/assets/thumbs/MS-Ankle-0004.png",
            "guide": [
                "다리를 일자로 펴서 발목 아래에 수건을 받친다.",
                "다리를 편 채 발목을 바깥쪽으로 젖혔다(외반) 힘을 빼며 원위치로 돌아온다.",
                "15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Static/Static-F-0222",
            "title": "발 내재근 강화 및 족궁만들기(Foot intrinsic muscle activation -Short Foot Exercise)",
            "thumb": "/assets/thumbs/Static-F-0222.png",
            "guide": [
                "물건을 잡듯 발가락을 뒤꿈치쪽으로 끌어당겨 발바닥을 수축켜(아치를 만들어) 5초간 유지한다.",
                "10~15회 반복하여 실시한다."
            ]
        },
    ],
    "ankle-rehab-2": [
        {
            "id": "FitBW/FitBW-0008",
            "title": "뒤꿈치 들기(Heel raise)",
            "thumb": "/assets/thumbs/FitBW-0008.png",
            "guide": [
                "무릎을 편 채 발가락 끝으로 지지하여 뒤꿈치를 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0007",
            "title": "등척성 발목 외반(Isometric Eversion)",
            "thumb": "/assets/thumbs/MS-Ankle-0007.png",
            "guide": [
                "발목을 바깥쪽(외측)으로 젖히려고 하고 팔로 저항하는 힘을 주면서 5초간 유지한 후 힘을 뺀다.",
                "10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0006",
            "title": "등척성 발목 내반(Isometric Inversion)",
            "thumb": "/assets/thumbs/MS-Ankle-0006.png",
            "guide": [
                "발목을 안쪽(내측)으로 젖히려고 하고 팔로 저항하는 힘을 주면서 5초간 유지한 후 힘을 뺀다.",
                "10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0075",
            "title": "싱글레그 밸런스(Single Leg Balance)",
            "thumb": "/assets/thumbs/MS-Lumbar-0075.png",
            "guide": [
                "서서 한 발을 들고 15초~30초 이상 유지한다. 발을 바꿔 같은 방법으로 실시한다.",
                "3세트 반복한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0010",
            "title": "싱글레그 밸런스 리치(Single leg balance reach)",
            "thumb": "/assets/thumbs/FitFunction-0010.png",
            "guide": [
                "한 발로 균형을 잡고 서서 무릎을 굽히면서 들고 있는 다리를 여러 방향으로 뻗어 바닥 또는 콘(cone)을 터치하고 돌아온다.",
                "2회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Band/Band-0028",
            "title": "밴드저항 족배굴곡(Dorsiflexion with band)",
            "thumb": "/assets/thumbs/Band-0028.png",
            "guide": [
                "한 쪽 다리를 펴서 발등에 밴드를 고정하고 발목을 발등쪽으로 굽힌다.(족배굴곡)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Band/Band-0027",
            "title": "밴드저항 족저굴곡(Plantar flexion with band)",
            "thumb": "/assets/thumbs/Band-0027.png",
            "guide": [
                "밴드를 발의 바닥에 고정하고 발을 뻗고 앉는다.",
                "발을 바닥 쪽으로 밀어낸다(족저굴곡).",
                "시작 위치로 돌아온다. 10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0030",
            "title": "밴드저항 발목 내반(Inversion with band)",
            "thumb": "/assets/thumbs/Band-0030.mp4_000001558.png",
            "guide": [
                "다리를 펴고 앉아 발 안쪽에 밴드를 고정한다.",
                "무릎을 편 채 발목을 안으로 젖혔다 힘을 빼며 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Band/Band-0029",
            "title": "밴드저항 발목 외반(Eversion with band)",
            "thumb": "/assets/thumbs/Band-0029.mp4_000001291.png",
            "guide": [
                "다리를 펴고 앉아 발 바깥쪽에 밴드를 고정한다.",
                "무릎을 편 채 발목을 밖으로 젖혔다 힘을 빼며 원위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0012",
            "title": "보수볼 밸런스(BOSU Balance)",
            "thumb": "/assets/thumbs/BOSU-0012.png",
            "guide": [
                "보수볼 위에 한 발로 서서 무릎을 가볍게 굽히고 반대쪽 다리를 뒤로 보낸다.",
                "동시에 상체를 앞으로 숙여 20~30초간 자세를 유지한다.",
                "같은 방법으로 다리를 바꿔 실시하고, 3~5세트 반복한다."
            ]
        },
    ],
    "ankle-rehab-3": [
        {
            "id": "MS/MS-Ankle-0082",
            "title": "두발 뒤꿈치 들고 한 발 내리기(Heel raises, Gastrocnemius eccentric)",
            "thumb": "/assets/thumbs/MS-Ankle-0082.png",
            "guide": [
                "두 발로 서서 양 쪽 뒤꿈치를 들어 올린다. 한 발을 든 상태에서 반대쪽 발의 뒤꿈치를 천천히 아래로 내린다.10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0083",
            "title": "무릎굽혀 두발 뒤꿈치 들고 한발 내리기(Heel raise, soleus eccentric)",
            "thumb": "/assets/thumbs/MS-Ankle-0083.png",
            "guide": [
                "무릎을 굽히고 두 발 뒤꿈치를 들어 올린다. 한 발을 들고 다른 한 발의 뒤꿈치를 천천히 내린다. 시작 위치로 돌아와서 같은 방법을 10회~15회 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0084",
            "title": "스텝박스 뒤꿈치 들기(Heel Raises, step)",
            "thumb": "/assets/thumbs/MS-Ankle-0084.png",
            "guide": [
                "스텝박스 가장자리에 두 발로 서서 뒤꿈치를 들어 올렸다 내린다.",
                "10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0085",
            "title": "밸런스 공 던져 받기(Balance ball toss)",
            "thumb": "/assets/thumbs/MS-Ankle-0085.png",
            "guide": [
                "밸런스 패드(stability pad)에 한 발로 서서 한 손에 테니스공(기타 작은 공)을 잡는다.",
                "균형을 유지하면서 공을 위로 던져 반대쪽 손으로 받는다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0086",
            "title": "등척성 뒤꿈치 들기(Isometric Single Leg Heel Raise)",
            "thumb": "/assets/thumbs/MS-Ankle-0086.png",
            "guide": [
                "벽을 짚고 두 발로 서서 양 쪽 뒤꿈치를 들어 올린다.",
                "한 발을 들어 반대쪽 발에 체중을 실어 5초간 유지한 후 천천히 뒤꿈치를 바닥으로 내린다.",
                "10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0087",
            "title": "무릎 굽혀 뒤꿈치 들기(Soleus Single Leg Raise)",
            "thumb": "/assets/thumbs/MS-Ankle-0087.png",
            "guide": [
                "벽을 짚고 한 발로 선다.",
                "바닥을 지지한 다리의 무릎을 가볍게 굽히고 뒤꿈치를 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0090",
            "title": "서서 발목 족배굴곡(Tibialis Anterior Raise, standing)",
            "thumb": "/assets/thumbs/MS-Ankle-0090.png",
            "guide": [
                "벽에 기대 서서 양 쪽 발 앞부분을 정강이 쪽으로 들어 올리고(족배굴곡) 5초간 유지한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0010",
            "title": "싱글레그 밸런스 리치(Single leg balance reach)",
            "thumb": "/assets/thumbs/FitFunction-0010.png",
            "guide": [
                "한 발로 균형을 잡고 서서 무릎을 굽히면서 들고 있는 다리를 여러 방향으로 뻗어 바닥 또는 콘(cone)을 터치하고 돌아온다.",
                "2회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0011",
            "title": "보수볼 스텝다운(BOSU Step down)",
            "thumb": "/assets/thumbs/BOSU-0011.mp4_000006691.png",
            "guide": [
                "보수볼 위에 한발로 서서 무릎을 굽혀 앉으면서 반대쪽 다리를 앞으로 뻗어 내린다.",
                "이 때 발이 바닥에 완전히 닿지 않는 범위까지 최대한 내렸다 올린다.",
                "10~15회 반복 후 다리를 바꿔 같은 방법으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0091",
            "title": "BAPS보드 고유신경촉진 운동(BAPS Board PNF)",
            "thumb": "/assets/thumbs/MS-Ankle-0091.png",
            "guide": [
                "워블보드(Wobble Board) 위에 한 발로 서서 5~10초간 균형을 유지한다.",
                "2~3세트 반복 후 다리를 바꿔 같은 방법으로 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0209",
            "title": "한발서서 두발 점프 업(1 to 2 Leg Hop Up)",
            "thumb": "/assets/thumbs/MS-Knee-0209.png",
            "guide": [
                "스텝박스를 앞에 두고 한 발로 선다.",
                "한 발로 점프하여 두 발로 스텝박스 위에 착지한 후 시작위치로 돌아온다.",
                "10회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0208",
            "title": "한발 서서 두발 점프 다운(1 to 2 Leg Hop Down)",
            "thumb": "/assets/thumbs/MS-Knee-0208.png",
            "guide": [
                "한 발로 스텝박스 위에 올라 선다.",
                "한 발로 점프하여 두 발로 바닥에 착지 한 후 시작위치로 돌아온다.",
                "10회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
    ],
    "ankle-rehab-4": [
        {
            "id": "MS/MS-Ankle-0094",
            "title": "서서 밴드저항 내반(Standing Inversion, band)",
            "thumb": "/assets/thumbs/MS-Ankle-0094.png",
            "guide": [
                "한 발로 서서 발목 바깥쪽에 밴드를 고정하고 발목을 안쪽(내반)으로 젖힌다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0095",
            "title": "스텝박스 두발 뒤꿈치 들고 한발 내리기(Heel Raises, Gastrocneimus eccentric, step)",
            "thumb": "/assets/thumbs/MS-Ankle-0095.png",
            "guide": [
                "스텝박스 가장자리에 두 발로 서서 양 쪽 뒤꿈치를 들어 올린다.",
                "한 발을 든 상태에서 반대쪽 발의 뒤꿈치를 천천히 아래로 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0096",
            "title": "스텝박스 무릎 굽히고 두발 뒤꿈치들고 한발 내리기(Heel Raises, soleus–eccentric, step)",
            "thumb": "/assets/thumbs/MS-Ankle-0096.png",
            "guide": [
                "두 발로 스텝박스 또는 계단에 올라선다. 무릎을 굽히고 두 발 뒤꿈치를 들어 올린다.",
                "한 발을 스텝박스(계단)에서 들어 올리고 스텝박스에 남은 한 발의 뒤꿈치를 천천히 내린다.",
                "시작 위치로 돌아와서 같은 방법을 10회~15회 3세트 반복한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0012",
            "title": "뒤꿈치 걷기(Heel Walks)",
            "thumb": "/assets/thumbs/FitBW-0012.png",
            "guide": [
                "무릎을 펴고 양 쪽 발의 앞부분을 들어 뒤꿈치로 5~10초간 걷는다.",
                "3세트 반복하여 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0098",
            "title": "서서 밴드저항 외반(Standing Eversion, band)",
            "thumb": "/assets/thumbs/MS-Ankle-0098.png",
            "guide": [
                "한 발로 서서 발목 바깥쪽에 밴드를 고정하고 발목을 바깥쪽(외반)으로 젖힌다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0099",
            "title": "케틀벨 들고 한발 뒤꿈치들기(Single Leg Calf Raise, Kettlebell)",
            "thumb": "/assets/thumbs/MS-Ankle-0099.png",
            "guide": [
                "케틀벨을 들고 한 발로 서서 뒤꿈치를 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0100",
            "title": "케틀벨 들고 스텝박스 한발 뒤꿈치들기(Single Leg Calf Raise with Kettlebell, Stepbox)",
            "thumb": "/assets/thumbs/MS-Ankle-0100.png",
            "guide": [
                "케틀벨을 들고 스텝박스 가장자리에 한 발로 서서 뒤꿈치를 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0017",
            "title": "메디신 볼 들고 보수볼 밸런스(Single Leg balance with medicine ball)",
            "thumb": "/assets/thumbs/BOSU-0017.png",
            "guide": [
                "보수볼 위에 한 발로 서서 두 손으로 메디슨 볼을 든다.",
                "지지한 다리의 무릎을 가볍게 굽히고 양 팔을 가슴앞으로 뻗어 20~30초간 균형을 유지한다.",
                "3~5회 반복 후 다리를 바꿔 같은 방법으로 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0195",
            "title": "보수볼 사이드스텝(BOSU Side Step)",
            "thumb": "/assets/thumbs/MS-Knee-0195.png",
            "guide": [
                "한 발을 보수볼 위에 올려 무릎을 가볍게 굽히고 반대쪽 다리는 옆으로 뻗어 바닥에 내린다.",
                "바닥에 있는 다리를 다시 보수볼 위로 올려 무릎을 굽히고, 보수볼에 위에 있던 다리는 옆으로 뻗어 바닥에 내린다.",
                "다리를 바꿔가며 10~15회 반복하고, 3세트 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0212",
            "title": "박스 회전점프(Box Jump, Rotation)",
            "thumb": "/assets/thumbs/MS-Knee-0212.png",
            "guide": [
                "스텝박스를 옆에 두고 선다.",
                "두 발로 점프하여 몸을 90° 회전하여 스텝박스 위에 두 발로 착지한다.",
                "10회 반복 후 반대쪽으로 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0210",
            "title": "보수볼 사이드 점프(BOSU Side Jumps)",
            "thumb": "/assets/thumbs/MS-Knee-0210.png",
            "guide": [
                "보수볼을 옆에 두고 선다.",
                "한 다리로 점프하여 보수볼 위에 올라서서 균형을 잡은 후 다시 처음위치로 돌아온다.",
                "10~15회 반복 후 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0006",
            "title": "한발 네방향 뜀뛰기(Single Leg Hop, plus pattern)",
            "thumb": "/assets/thumbs/FitFunction-0006.png",
            "guide": [
                "한 발로 서서 앞, 뒤, 옆, 대각선 방향으로 가볍게 점프(Hop)한다.",
                "10~15회 반복 후 발을 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0011",
            "title": "스탠딩 리치(Standing Reach)",
            "thumb": "/assets/thumbs/FitFunction-0011.png",
            "guide": [
                "한 발로 서서 무릎을 굽히며 동시에 반대쪽 다리는 뒤로 뻗고 손으로 바닥 또는 콘(cone)을 터치한다.",
                "10회 3세트 반복하고, 발을 바꿔 실시한다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0018",
            "title": "토구 밸런스(Togu balance)",
            "thumb": "/assets/thumbs/GolfCon-0018.mp4_000005291.png",
            "guide": [
                "토구(Togu) 위에 한 발로 서서 무릎을 가볍게 굽히고 10~30초간 균형을 유지한다.",
                "3세트 반복하고, 발을 바꿔 같은 방법으로 실시한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0220",
            "title": "보수볼 스텝 백(Step Back, BOSU)",
            "thumb": "/assets/thumbs/MS-Knee-0220.png",
            "guide": [
                "보수볼 바닥이 위로 가게 하여 한 발로 올라선다.",
                "지지한 다리의 무릎을 굽혀 앉으면서 들고 있는 다리를 뒤로 뻗는다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0017",
            "title": "메디신 볼 들고 보수볼 밸런스(Single Leg balance with medicine ball)",
            "thumb": "/assets/thumbs/BOSU-0017.png",
            "guide": [
                "보수볼 위에 한 발로 서서 두 손으로 메디슨 볼을 든다.",
                "지지한 다리의 무릎을 가볍게 굽히고 양 팔을 가슴앞으로 뻗어 20~30초간 균형을 유지한다.",
                "3~5회 반복 후 다리를 바꿔 같은 방법으로 실시한다."
            ]
        },
        {
            "id": "MS/MS-Ankle-0108",
            "title": "메디신볼 들고 토구에서 한발서기(Single leg balance on togu)",
            "thumb": "/assets/thumbs/MS-Ankle-0108.png",
            "guide": [
                "토구(Togu) 위에 한 발로 서서 두 손으로 메디슨볼을 든다.",
                "지지한 다리의 무릎을 가볍게 굽히고 팔을 앞으로 뻗어 20~30초간 균형을 유지한다.",
                "3~5세트 반복 후 다리를 바꿔 같은 방법으로 실시한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0014",
            "title": "싱글레그 디스크 콘 터치(Single leg Disc Exercise with Cone Touch)",
            "thumb": "/assets/thumbs/FitFunction-0014.png",
            "guide": [
                "토구(togu)에 한 발로 서서 콘(Cone)을 앞, 오른쪽, 왼쪽에 둔다.",
                "지지한 다리의 무릎을 굽혀 앉으면서 팔을 뻗어 앞쪽 콘을 터치하고 일어선다.",
                "같은 방법으로 오른쪽, 왼쪽 콘을 터치한다.",
                "10회 2세트 반복 후 다리를 바꿔 같은 방법으로 실시한다."
            ]
        },
    ],
};

export const TITLES = {
    /* ---- 목 운동 ---- */
    "straight-neck": "일자목 운동",
    "cervical-disc": "경추디스크 운동",
    "opf": "후종인대골화증 운동",
    "neck-rehab-1": "목 재활 운동 1단계",
    "neck-rehab-2": "목 재활 운동 2단계",
    "neck-rehab-3": "목 재활 운동 3단계",
    "neck-rehab-4": "목 재활 운동 4단계",

    /* ---- 어깨 운동 ---- */
    "rotator-cuff-tear": "회전근개 손상",
    "impingement-calcific": "충돌증후군(석회화건염)",
    "frozen-shoulder": "오십견",
    "shoulder-instability-sublux": "어깨 불안정성(어깨 아탈구)",
    "functional-shoulder": "기능적 어깨",
    "throwers-shoulder": "투구선수 어깨",
    "postop-shoulder-rehab-1": "어깨수술 후 재활 1단계",
    "postop-shoulder-rehab-2": "어깨수술 후 재활 2단계",
    "postop-shoulder-rehab-3": "어깨수술 후 재활 3단계",
    "postop-shoulder-rehab-4": "어깨수술 후 재활 4단계",

    /* ---- 허리 운동 ---- */
    "herniation": "허리디스크 운동",
    "stenosis": "척추관협착증 운동",
    "facet-syndrome": "과절면 증후군 운동",
    "sciatica": "좌골신견통 운동",
    "lumbar-rehab-1": "허리 재활 운동 1단계",
    "lumbar-rehab-2": "허리 재활 운동 2단계",
    "lumbar-rehab-3": "허리 재활 운동 3단계",
    "lumbar-rehab-4": "허리 재활 운동 4단계",

    /* ---- 팔 팔꿈치 손목 운동 ---- */
    "medial-epicondylitis": "내측상과염",
    "lateral-epicondylitis": "외측상과염",
    "mcl-surgery-rehab": "내측측부인대 수술 후 재활",
    "elbow-fracture-rehab": "주관절 골절 후 재활",
    "elbow-surgery-rehab-1": "팔꿈치 수술 후 재활 1단계",
    "elbow-surgery-rehab-2": "팔꿈치 수술 후 재활 2단계",
    "elbow-surgery-rehab-3": "팔꿈치 수술 후 재활 3단계",
    "elbow-surgery-rehab-4": "팔꿈치 수술 후 재활 4단계",


    /* ---- 무릎 운동 ---- */
    "patellofemoral-pain-syndrome": "슬개대퇴통증 증후군",
    "knee-arthroscopy-rehab": "관절내시경 후 재활",
    "meniscus-surgery-rehab": "반월상연골판 수술 후 재활",
    "acl-surgery-rehab": "전방십자인대 수술 후 재활",
    "knee-arthroplasty-rehab": "인공관절 수술 후 재활",
    "knee-rehab-1": "무릎 재활 1단계",
    "knee-rehab-2": "무릎 재활 2단계",
    "knee-rehab-3": "무릎 재활 3단계",
    "knee-rehab-4": "무릎 재활 4단계",

    /* ---- 고관절 ---- */
    "hip-pelvis-rehab-1": "힙+골반재활운동 1단계",
    "hip-pelvis-rehab-2": "힙+골반재활운동 2단계",
    "hip-pelvis-rehab-3": "힙+골반재활운동 3단계",
    "hip-pelvis-rehab-4": "힙+골반재활운동 4단계",

    /* ---- 발 & 발목 ---- */
    "achilles-surgery-rehab": "아킬레스 수술 후 재활",
    "ankle-sprain-rehab": "발목 인대손상(염좌) 후 재활",
    "ankle-rehab-1": "발목재활 1단계",
    "ankle-rehab-2": "발목재활 2단계",
    "ankle-rehab-3": "발목재활 3단계",
    "ankle-rehab-4": "발목재활 4단계",
};


// 한글 제목 → key 역매핑
export const TITLE_TO_KEY = Object.fromEntries(
    Object.entries(TITLES).map(([k, v]) => [v, k])
);
